// AUTO-GENERATED from user-uploaded Acute Condition dataset (225 rows).
// Rich clinical fields (pathognomonic, definitiveTest, supportiveTests, ddx,
// positive/negative signs) are surfaced by AcuteSuggestionPanel.jsx.

const mk = (brand, generic, dose, freq, duration, instructions = '') => ({
  brand_name: brand, generic_name: generic, composition: generic, strength: dose,
  route: instructions.match(/\b(IV|IM|SC|Inj|neb\w*)\b/)?.[0] || 'Oral',
  dosage_form: instructions.toLowerCase().includes('inj') ? 'Injection' : 'Tablet',
  frequency: freq, duration, instructions, notes: '', quantity: '', type: 'acute',
});

export const ACUTE_GROUPS = ['Bacterial', 'Viral', 'Parasitic', 'Fungal', 'Immunological', 'Gynecology', 'Gastroenterology', 'Rheumatology', 'Other'];

export const ACUTE_CONDITIONS = [
  {
    id: 'ac-1',
    label: 'Typhoid (Enteric Fever)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Typhoid (Enteric Fever)', 'Enteric Fever', 'Typhoid'],
    pathognomonic: 'Relative Bradycardia (Faget Sign) & Rose Spots on trunk',
    definitiveTest: 'Blood Culture (BACTEC) in the 1st week',
    supportiveTests: ['Widal Test (significant after 7 days)', 'CBC (shows Leucopenia)', 'Stool Culture'],
    ddx: ['Malaria', 'Dengue', 'Leptospirosis', 'Amoebic Liver Abscess'],
    positiveSigns: ['Step-ladder pattern high-grade fever', 'Significant abdominal pain with distension'],
    negativeSigns: ['Absence of tachycardia (Relative Bradycardia)', 'Absence of productive cough'],
    definitiveTreatment: 'Ceftriaxone 2g IV/IM OD for 7-10 days OR Azithromycin 500mg PO OD',
    supportiveTreatment: 'Aggressive ORS/IV Fluids, Paracetamol for fever, Bland soft diet',
    redFlags: ['Relative Bradycardia (Faget Sign) & Rose Spots on trunk'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', '1g - 0 - 1g (IV)', '7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Azee 500', 'Azithromycin', '0 - 0 - 1', '0 - 0 - 1', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-2',
    label: 'Dengue Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Dengue Fever'],
    pathognomonic: 'Herman\'s Rash (Islands of white in a sea of red) on recovery',
    definitiveTest: 'Dengue NS1 Antigen (Day 1-5) or IgM ELISA (after Day 5)',
    supportiveTests: ['CBC (Rising Hematocrit, Thrombocytopenia)', 'Liver Function Test (elevated SGOT/SGPT)'],
    ddx: ['Chikungunya', 'Zika Virus', 'Leptospirosis', 'Malaria'],
    positiveSigns: ['Severe retro-orbital pain', 'Intense myalgia (Breakbone fever)'],
    negativeSigns: ['Absence of Splenomegaly', 'Absence of significant leucocytosis'],
    definitiveTreatment: 'No specific antiviral; focus on strict volume replacement',
    supportiveTreatment: 'Oral/IV Hydration (target 0.5ml/kg/hr urine), Paracetamol 650mg TDS/QID (Avoid NSAIDs)',
    redFlags: ['Herman\'s Rash (Islands of white in a sea of red) on recovery'],
    cautions: ['Paracetamol 650mg TDS/QID (Avoid NSAIDs)'],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'Ad libitum', 'Ad libitum', '5', 'जेव्हा तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-3',
    label: 'Malaria (P. vivax)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Malaria (P. vivax)', 'P. vivax', 'Malaria'],
    pathognomonic: 'Cyclical Paroxysms (Fever peaks every 48 hours)',
    definitiveTest: 'Peripheral Blood Smear (Thin/Thick) for Malarial Parasite',
    supportiveTests: ['Rapid Diagnostic Test (RDT) for Pf/Pv Ag', 'CBC (Anemia, Thrombocytopenia)'],
    ddx: ['Enteric Fever', 'Dengue', 'Kala-azar', 'Viral Hepatitis'],
    positiveSigns: ['Periodic Chills and Rigors', 'Tender Splenomegaly on palpation'],
    negativeSigns: ['Absence of skin rash', 'Absence of significant leucocytosis'],
    definitiveTreatment: 'Chloroquine for 3 days + Primaquine for 14 days',
    supportiveTreatment: 'Antipyretics for fever, Hydration, Monitor for hypoglycemia',
    redFlags: ['Monitor for hypoglycemia'],
    cautions: [],
    meds: [
      mk('Lariago', 'Chloroquine 250mg', '2 - 1 - 1 (Day 1), then 1-0-1', '2 - 1 - 1 (Day 1), then 1-0-1', '3', 'जेवणानंतर'),
      mk('Malirid 15', 'Primaquine', '0 - 0 - 1', '0 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-4',
    label: 'Pulmonary Tuberculosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pulmonary Tuberculosis'],
    pathognomonic: 'Apical Cavitary lesions on Chest X-ray',
    definitiveTest: 'CBNAAT / GeneXpert (Sputum)',
    supportiveTests: ['Sputum AFB Staining', 'Chest X-ray (Upper lobe infiltrates)', 'Mantoux Test (TST)'],
    ddx: ['Bacterial Pneumonia', 'Lung Cancer', 'Bronchiectasis', 'Sarcoidosis'],
    positiveSigns: ['Chronic cough lasting > 2 weeks', 'Evening rise of temperature with night sweats'],
    negativeSigns: ['Absence of acute high-grade fever', 'Absence of weight gain'],
    definitiveTreatment: 'Standard ATT (Rifampicin, Isoniazid, Pyrazinamide, Ethambutol)',
    supportiveTreatment: 'High protein diet, Pyridoxine (Vit B6) to prevent neuropathy',
    redFlags: ['Pyridoxine (Vit B6) to prevent neuropathy'],
    cautions: [],
    meds: [
      mk('Akt-4 Kit', 'FDC (R+H+Z+E)', 'As per weight band', 'As per weight band', '60', 'जेवणापूर्वी रिकाम्या पोटी'),
      mk('Pyridoxine 10mg', 'Vitamin B6', '10mg', '0 - 0 - 1', '180', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-5',
    label: 'Malaria (Falciparum)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Malaria (Falciparum)', 'Falciparum', 'Malaria'],
    pathognomonic: 'Banana-shaped gametocytes or multiple ring forms in RBCs on smear',
    definitiveTest: 'Peripheral Blood Smear (Thick and Thin) & RDT for Pf (HRP-2 antigen)',
    supportiveTests: ['CBC (Anemia, Thrombocytopenia)', 'LFT/KFT (for organ dysfunction)'],
    ddx: ['Dengue', 'Typhoid', 'Meningitis', 'Sepsis'],
    positiveSigns: ['High-grade continuous or irregular fever', 'Altered sensorium or seizures (in severe cases)'],
    negativeSigns: ['Absence of rash', 'Absence of significant lymphadenopathy'],
    definitiveTreatment: 'Artemisinin-based Combination Therapy (ACT) e.g., Artemether + Lumefantrine',
    supportiveTreatment: 'IV fluids, antipyretics, monitor for hypoglycemia and severe anemia',
    redFlags: ['monitor for hypoglycemia and severe anemia'],
    cautions: [],
    meds: [
      mk('Lumerax 80/480', 'Artemether + Lumefantrine', '1 - 1 (0, 8, 24, 36, 48, 60 hrs)', '1 - 1 (0, 8, 24, 36, 48, 60 hrs)', '3', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-6',
    label: 'Amoebic Liver Abscess',
    group: 'Parasitic',
    category: 'Protozoal',
    aliases: ['Amoebic Liver Abscess'],
    pathognomonic: 'Anchovy paste-like aspirate from liver abscess',
    definitiveTest: 'USG Abdomen showing hypoechoic lesion in right lobe',
    supportiveTests: ['Amoebic Serology (IgG)', 'CBC (Leucocytosis)'],
    ddx: ['Pyogenic Liver Abscess', 'Hepatocellular Carcinoma', 'Cholecystitis', 'Hydatid Cyst'],
    positiveSigns: ['Right upper quadrant pain', 'Fever with chills and profuse sweating'],
    negativeSigns: ['Absence of significant jaundice', 'Absence of generalized lymphadenopathy'],
    definitiveTreatment: 'Metronidazole 800mg TDS for 10-14 days followed by Diloxanide furoate',
    supportiveTreatment: 'Bed rest, adequate nutrition, pain management',
    redFlags: ['Anchovy paste-like aspirate from liver abscess'],
    cautions: [],
    meds: [
      mk('Flagyl 400', 'Metronidazole', '1 - 1 - 1', '1 - 1 - 1', '14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-7',
    label: 'Acute Gastroenteritis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Acute Gastroenteritis'],
    pathognomonic: 'Hyperactive bowel sounds with voluminous watery diarrhea',
    definitiveTest: 'Clinical diagnosis (Stool routine usually normal)',
    supportiveTests: ['Serum Electrolytes (if severe dehydration)', 'Stool hanging drop (to rule out cholera)'],
    ddx: ['Food Poisoning', 'Cholera', 'Bacillary Dysentery', 'Amoebiasis'],
    positiveSigns: ['Frequent watery loose stools', 'Nausea and vomiting'],
    negativeSigns: ['Absence of blood in stool', 'Absence of high-grade persistent fever'],
    definitiveTreatment: 'Self-limiting; focus on ORS and Zinc supplementation',
    supportiveTreatment: 'Aggressive oral rehydration, bland diet, probiotics',
    redFlags: ['Hyperactive bowel sounds with voluminous watery diarrhea'],
    cautions: [],
    meds: [
      mk('Electral', 'ORS', '1 packet in 1L water', '1 packet in 1L water', '3', 'प्रत्येक जुलाबानंतर'),
      mk('Econorm', 'Saccharomyces boulardii', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-8',
    label: 'Cholera',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Cholera'],
    pathognomonic: 'Rice-water stools with fishy odor',
    definitiveTest: 'Stool Culture (TCBS agar) or Hanging drop showing darting motility',
    supportiveTests: ['Serum Electrolytes (Hypokalemia)', 'ABG (Metabolic acidosis)'],
    ddx: ['Severe Viral Gastroenteritis', 'Food Poisoning (Staph/Bacillus)', 'ETEC Infection'],
    positiveSigns: ['Painless, voluminous "rice-water" stools', 'Rapid onset of severe dehydration'],
    negativeSigns: ['Absence of fever', 'Absence of abdominal cramps/pain'],
    definitiveTreatment: 'Doxycycline 300mg stat OR Azithromycin 1g stat',
    supportiveTreatment: 'Aggressive IV fluid resuscitation (Ringer Lactate) followed by ORS',
    redFlags: ['Rice-water stools with fishy odor'],
    cautions: [],
    meds: [
      mk('Doxypal', 'Doxycycline 100mg', '3 tablets at once', '3 tablets at once', '1', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'Ad libitum', 'Ad libitum', '5', 'सतत पीत राहा'),
    ],
  },
  {
    id: 'ac-9',
    label: 'Bacillary Dysentery (Shigellosis)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Bacillary Dysentery (Shigellosis)', 'Shigellosis', 'Bacillary Dysentery'],
    pathognomonic: 'Fever + Bloody diarrhea with severe tenesmus',
    definitiveTest: 'Stool Culture (MacConkey agar)',
    supportiveTests: ['Stool Routine (Numerous pus cells and RBCs)', 'CBC (Leucocytosis)'],
    ddx: ['Amoebic Dysentery', 'Campylobacter enteritis', 'Ulcerative Colitis', 'EHEC Infection'],
    positiveSigns: ['Frequent passage of small volume bloody/mucoid stools', 'Severe tenesmus (cramping rectal pain)'],
    negativeSigns: ['Absence of voluminous watery stools', 'Absence of relative bradycardia'],
    definitiveTreatment: 'Ciprofloxacin 500mg BD for 3 days OR Azithromycin 500mg OD for 3 days',
    supportiveTreatment: 'ORS, Paracetamol for fever, avoid anti-motility agents (Loperamide)',
    redFlags: ['Fever + Bloody diarrhea with severe tenesmus'],
    cautions: ['avoid anti-motility agents (Loperamide)'],
    meds: [
      mk('Ciplox 500', 'Ciprofloxacin', '1 - 0 - 1', '1 - 0 - 1', '3', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-10',
    label: 'Giardiasis',
    group: 'Parasitic',
    category: 'Protozoal',
    aliases: ['Giardiasis'],
    pathognomonic: 'Greasy, malodorous stools that float',
    definitiveTest: 'Stool microscopy (Cysts or trophozoites of Giardia)',
    supportiveTests: ['Stool Antigen Enzyme Immunoassay (EIA)'],
    ddx: ['Amoebiasis', 'Celiac Disease', 'Tropical Sprue', 'Chronic Pancreatitis'],
    positiveSigns: ['Foul-smelling, greasy, floating stools (steatorrhea)', 'Excessive flatulence and bloating'],
    negativeSigns: ['Absence of blood or pus in stool', 'Absence of high fever'],
    definitiveTreatment: 'Metronidazole 400mg TDS for 5-7 days OR Tinidazole 2g single dose',
    supportiveTreatment: 'Lactose-free diet temporarily, hydration',
    redFlags: ['Greasy, malodorous stools that float'],
    cautions: [],
    meds: [
      mk('Flagyl 400', 'Metronidazole', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Econorm', 'Probiotic', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-11',
    label: 'Viral Hepatitis A',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Viral Hepatitis A'],
    pathognomonic: 'Icterus with tender hepatomegaly following a prodrome of fever/anorexia',
    definitiveTest: 'Anti-HAV IgM antibodies in serum',
    supportiveTests: ['LFT (Markedly elevated AST/ALT > 1000 U/L)', 'Serum Bilirubin (Elevated direct & indirect)'],
    ddx: ['Hepatitis E', 'Hepatitis B', 'Leptospirosis', 'Drug-induced Liver Injury'],
    positiveSigns: ['Yellowish discoloration of eyes and dark urine', 'Profound anorexia and nausea'],
    negativeSigns: ['Absence of chronic liver stigmata (spider angioma)', 'Absence of high-grade fever during icteric phase'],
    definitiveTreatment: 'Self-limiting; no specific antiviral therapy required',
    supportiveTreatment: 'Strict bed rest, high carbohydrate & low fat diet, avoid hepatotoxic drugs',
    redFlags: ['Icterus with tender hepatomegaly following a prodrome of fever/anorexia'],
    cautions: ['avoid hepatotoxic drugs'],
    meds: [
      mk('Udapa 150', 'Ursodeoxycholic Acid', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Silybon 140', 'Silymarin', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-12',
    label: 'Leptospirosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Leptospirosis'],
    pathognomonic: 'Conjunctival suffusion + Calf tenderness + History of wading in flood water',
    definitiveTest: 'Microscopic Agglutination Test (MAT) or Leptospira IgM ELISA',
    supportiveTests: ['CBC (Neutrophilic leucocytosis)', 'KFT (Elevated Creatinine)', 'LFT (Elevated Bilirubin)'],
    ddx: ['Dengue Fever', 'Malaria', 'Viral Hepatitis', 'Scrub Typhus'],
    positiveSigns: ['High fever with severe calf muscle tenderness', 'Conjunctival suffusion (red eyes without exudate)'],
    negativeSigns: ['Absence of purulent eye discharge', 'Absence of generalized rash'],
    definitiveTreatment: 'Doxycycline 100mg BD for 7 days OR Ceftriaxone 1g IV OD (if severe)',
    supportiveTreatment: 'IV fluids, monitor urine output, dialysis if acute kidney injury develops',
    redFlags: ['dialysis if acute kidney injury develops'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-13',
    label: 'Scrub Typhus',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Scrub Typhus'],
    pathognomonic: 'Painless necrotic Eschar (often in groin, axilla, or under breasts)',
    definitiveTest: 'Scrub Typhus IgM ELISA',
    supportiveTests: ['Weil-Felix Test (OXK positive)', 'CBC (Thrombocytopenia)', 'LFT (Elevated transaminases)'],
    ddx: ['Dengue', 'Leptospirosis', 'Malaria', 'Typhoid'],
    positiveSigns: ['High-grade fever with severe headache', 'Eschar (painless black necrotic scab) at bite site'],
    negativeSigns: ['Absence of productive cough', 'Absence of joint swelling'],
    definitiveTreatment: 'Doxycycline 100mg BD for 7-14 days OR Azithromycin 500mg OD',
    supportiveTreatment: 'Antipyretics, hydration, monitor for ARDS or multi-organ failure',
    redFlags: ['monitor for ARDS or multi-organ failure'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Pan 40', 'Pantoprazole', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-14',
    label: 'Brucellosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Brucellosis'],
    pathognomonic: 'Undulant fever + History of raw milk consumption or animal contact',
    definitiveTest: 'Blood Culture (Hold for 21 days) or Bone Marrow Culture',
    supportiveTests: ['Standard Agglutination Test (SAT)', 'Rose Bengal Test'],
    ddx: ['Tuberculosis', 'Typhoid', 'Malaria', 'Infective Endocarditis'],
    positiveSigns: ['Undulant (wave-like) fever, worse at night', 'Profuse malodorous sweating'],
    negativeSigns: ['Absence of acute severe respiratory distress', 'Absence of typical rash'],
    definitiveTreatment: 'Doxycycline 100mg BD + Rifampicin 600mg OD for 6 weeks',
    supportiveTreatment: 'Pain management for osteoarticular involvement, adequate rest',
    redFlags: ['Pain management for osteoarticular involvement'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '42', 'जेवणानंतर'),
      mk('RCin 600', 'Rifampicin', '1 - 0 - 0', '1 - 0 - 0', '42', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-15',
    label: 'Viral Hepatitis E',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Viral Hepatitis E'],
    pathognomonic: 'Acute icteric hepatitis, especially severe/fulminant in pregnant women',
    definitiveTest: 'Anti-HEV IgM antibodies',
    supportiveTests: ['LFT (Markedly elevated AST/ALT)', 'Prothrombin Time (PT/INR)'],
    ddx: ['Hepatitis A', 'Hepatitis B', 'Drug-induced Liver Injury', 'Leptospirosis'],
    positiveSigns: ['Deep jaundice with dark urine', 'Nausea and severe anorexia'],
    negativeSigns: ['Absence of chronic liver disease stigmata', 'Absence of high fever in icteric phase'],
    definitiveTreatment: 'Self-limiting; supportive care only',
    supportiveTreatment: 'Bed rest, high carbohydrate diet, avoid hepatotoxic drugs (e.g., Paracetamol)',
    redFlags: ['Acute icteric hepatitis, especially severe/fulminant in pregnant women'],
    cautions: ['avoid hepatotoxic drugs (e'],
    meds: [
      mk('Udapa 150', 'Ursodeoxycholic Acid', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Silybon 140', 'Silymarin', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-16',
    label: 'Viral Hepatitis B',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Viral Hepatitis B'],
    pathognomonic: 'HBsAg positivity persisting > 6 months (for chronic)',
    definitiveTest: 'HBsAg, Anti-HBc IgM (acute), HBV DNA quantitative',
    supportiveTests: ['LFT', 'USG Abdomen (to check for cirrhosis/HCC)'],
    ddx: ['Hepatitis C', 'Alcoholic Hepatitis', 'Autoimmune Hepatitis'],
    positiveSigns: ['Fatigue and right upper quadrant discomfort', 'Jaundice (in acute flare)'],
    negativeSigns: ['Absence of high-grade fever', 'Absence of severe diarrhea'],
    definitiveTreatment: 'Tenofovir or Entecavir (for chronic active hepatitis)',
    supportiveTreatment: 'Hepatocellular carcinoma screening (AFP, USG), avoid alcohol',
    redFlags: ['HBsAg positivity persisting > 6 months (for chronic)'],
    cautions: ['avoid alcohol'],
    meds: [
      mk('Tenvir 300', 'Tenofovir Disoproxil Fumarate', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणानंतर'),
      mk('Entavir 0.5', 'Entecavir', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-17',
    label: 'Meningococcal Meningitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Meningococcal Meningitis'],
    pathognomonic: 'Rapidly spreading petechial or purpuric rash with meningism',
    definitiveTest: 'CSF Culture and Gram stain (Gram-negative diplococci)',
    supportiveTests: ['CSF Analysis (High protein, low glucose, neutrophilic pleocytosis)', 'Blood Culture'],
    ddx: ['Pneumococcal Meningitis', 'Viral Meningoencephalitis', 'Tuberculous Meningitis'],
    positiveSigns: ['Sudden onset high fever with severe headache', 'Nuchal rigidity (Neck stiffness)'],
    negativeSigns: ['Absence of normal sensorium', 'Absence of gradual onset'],
    definitiveTreatment: 'Ceftriaxone 2g IV BD for 7 days',
    supportiveTreatment: 'IV fluids, Dexamethasone (before 1st antibiotic dose), isolation',
    redFlags: ['Rapidly spreading petechial or purpuric rash with meningism'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', '1g - 0 - 1g (IV)', '7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dexona', 'Dexamethasone', 'As per weight (IV)', 'As per weight (IV)', '4', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-18',
    label: 'Japanese Encephalitis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Japanese Encephalitis'],
    pathognomonic: 'Acute encephalitis syndrome with Parkinsonian features (mask-like facies, tremors)',
    definitiveTest: 'CSF JE-specific IgM ELISA',
    supportiveTests: ['MRI Brain (Thalamic/Basal ganglia hyperintensities)', 'EEG'],
    ddx: ['Herpes Simplex Encephalitis', 'Cerebral Malaria', 'Tuberculous Meningitis', 'Nipah Virus'],
    positiveSigns: ['Altered sensorium or coma', 'New-onset seizures'],
    negativeSigns: ['Absence of purpuric rash', 'Absence of low CSF glucose'],
    definitiveTreatment: 'No specific antiviral; purely supportive',
    supportiveTreatment: 'Airway management, anti-epileptics (Phenytoin/Levetiracetam), control of ICT (Mannitol)',
    redFlags: ['Airway management'],
    cautions: [],
    meds: [
      mk('Eptoin 100', 'Phenytoin', '1 - 0 - 1', '1 - 0 - 1', '30', 'जेवणानंतर'),
      mk('Manitol 20%', 'Mannitol', '20%', 'IV infusion', '5', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-19',
    label: 'Rabies',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Rabies'],
    pathognomonic: 'Hydrophobia and Aerophobia following an animal bite',
    definitiveTest: 'RT-PCR of saliva or nuchal skin biopsy (Post-mortem: Negri bodies in brain)',
    supportiveTests: ['Corneal impression smear for direct fluorescent antibody (DFA)'],
    ddx: ['Tetanus', 'Encephalitis', 'Guillain-Barré Syndrome (in paralytic rabies)', 'Psychiatric hysteria'],
    positiveSigns: ['Hydrophobia (fear of water/spasms on drinking)', 'Aerophobia (spasms on feeling a breeze)'],
    negativeSigns: ['Absence of altered sensorium in early stages', 'Absence of purulent wound discharge'],
    definitiveTreatment: '100% fatal once symptomatic; Palliative care only (Milwaukee protocol rarely successful)',
    supportiveTreatment: 'Heavy sedation, analgesia, quiet dark room, airway protection',
    redFlags: ['airway protection'],
    cautions: [],
    meds: [
      mk('Midazolam', 'Midazolam', 'IV infusion', 'IV infusion', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Morphine', 'Morphine', 'IV PRN', 'IV PRN', '1', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-20',
    label: 'Tetanus',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Tetanus'],
    pathognomonic: 'Risus sardonicus (sustained spasm of facial muscles) with clear sensorium',
    definitiveTest: 'Clinical diagnosis (Spatula test positive)',
    supportiveTests: ['Wound culture (rarely helpful)'],
    ddx: ['Strychnine poisoning', 'Dental abscess (causing trismus)', 'Rabies', 'Dystonic drug reaction'],
    positiveSigns: ['Trismus (Lockjaw)', 'Opisthotonus (severe back spasms)'],
    negativeSigns: ['Absence of altered sensorium (patient is fully conscious)', 'Absence of high fever'],
    definitiveTreatment: 'Human Tetanus Immunoglobulin (HTIG) + Metronidazole 500mg IV TDS',
    supportiveTreatment: 'Wound debridement, Diazepam for spasms, mechanical ventilation if needed, dark quiet room',
    redFlags: ['mechanical ventilation if needed'],
    cautions: [],
    meds: [
      mk('Tetglob', 'Human Tetanus Immunoglobulin', 'Single IM dose', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Calmpose 5', 'Diazepam', '1 - 1 - 1', '1 - 1 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-21',
    label: 'Leprosy (Hansen\'s Disease)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Leprosy (Hansen\'s Disease)', 'Hansen\'s Disease', 'Leprosy'],
    pathognomonic: 'Anesthetic hypopigmented patch with thickened regional nerve',
    definitiveTest: 'Slit-skin smear for Acid Fast Bacilli (AFB) or Skin Biopsy',
    supportiveTests: ['Nerve conduction studies'],
    ddx: ['Tinea Versicolor', 'Vitiligo', 'Pityriasis Alba', 'Sarcoidosis'],
    positiveSigns: ['Hypopigmented skin patches with loss of sensation', 'Thickened, tender peripheral nerves'],
    negativeSigns: ['Absence of itching in the skin lesions', 'Absence of acute systemic toxicity'],
    definitiveTreatment: 'Multi-Drug Therapy (MDT): Rifampicin + Dapsone + Clofazimine',
    supportiveTreatment: 'Physiotherapy, protective footwear, reconstructive surgery for deformities',
    redFlags: ['Anesthetic hypopigmented patch with thickened regional nerve'],
    cautions: [],
    meds: [
      mk('MDT-MB Blister Pack', 'Rifampicin+Dapsone+Clofazimine', 'As per blister pack', 'As per blister pack', '365', 'जेवणानंतर'),
      mk('Dapsone 100', 'Dapsone', '1 - 0 - 0', '1 - 0 - 0', '365', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-22',
    label: 'Lymphatic Filariasis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Lymphatic Filariasis'],
    pathognomonic: 'Unilateral elephantiasis of lower limb or massive hydrocele in endemic area',
    definitiveTest: 'Night blood smear (midnight) for Microfilariae',
    supportiveTests: ['Circulating Filarial Antigen (CFA) test', 'USG (Filarial dance sign)'],
    ddx: ['Deep Vein Thrombosis', 'Congestive Heart Failure', 'Milroy Disease', 'Cellulitis'],
    positiveSigns: ['Non-pitting edema of lower limbs (Elephantiasis)', 'Hydrocele in males'],
    negativeSigns: ['Absence of acute pain (in chronic stage)', 'Absence of generalized anasarca'],
    definitiveTreatment: 'Diethylcarbamazine (DEC) 6mg/kg/day for 12 days + Albendazole 400mg stat',
    supportiveTreatment: 'Limb elevation, meticulous skin hygiene, surgical correction of hydrocele',
    redFlags: ['meticulous skin hygiene'],
    cautions: [],
    meds: [
      mk('Banocide Forte', 'Diethylcarbamazine 100mg', '1 - 1 - 1', '1 - 1 - 1', '12', 'जेवणानंतर'),
      mk('Zentel 400', 'Albendazole', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-23',
    label: 'Visceral Leishmaniasis (Kala-azar)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Visceral Leishmaniasis (Kala-azar)', 'Kala-azar', 'Visceral Leishmaniasis'],
    pathognomonic: 'Massive splenomegaly with pancytopenia and hypergammaglobulinemia',
    definitiveTest: 'rK39 Rapid Diagnostic Test OR Bone Marrow/Splenic aspirate for LD bodies',
    supportiveTests: ['CBC (Pancytopenia)', 'A:G ratio reversal'],
    ddx: ['Malaria', 'Enteric Fever', 'Leukemia', 'Disseminated Tuberculosis'],
    positiveSigns: ['Massive splenomegaly', 'Prolonged irregular fever (> 2 weeks)'],
    negativeSigns: ['Absence of significant lymphadenopathy (in Indian variant)', 'Absence of rash'],
    definitiveTreatment: 'Liposomal Amphotericin B (Single dose 10mg/kg IV) OR Miltefosine',
    supportiveTreatment: 'Nutritional support, blood transfusion if severe anemia, treat secondary infections',
    redFlags: ['Massive splenomegaly with pancytopenia and hypergammaglobulinemia'],
    cautions: [],
    meds: [
      mk('AmBisome', 'Liposomal Amphotericin B', 'Single IV infusion', 'Single IV infusion', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Impavido 50', 'Miltefosine', '1 - 0 - 1', '1 - 0 - 1', '28', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-24',
    label: 'Oral Candidiasis (Thrush)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Oral Candidiasis (Thrush)', 'Thrush', 'Oral Candidiasis'],
    pathognomonic: 'White plaques that can be scraped off, leaving a raw, bleeding erythematous base',
    definitiveTest: 'KOH mount of scraping showing budding yeast and pseudohyphae',
    supportiveTests: ['HIV screening (if severe or recurrent in adults)', 'Fasting Blood Sugar (to rule out Diabetes)'],
    ddx: ['Leukoplakia', 'Oral Lichen Planus', 'Diphtheria', 'Aphthous Ulcers'],
    positiveSigns: ['White, curd-like patches on tongue and buccal mucosa', 'Pain or difficulty swallowing'],
    negativeSigns: ['Absence of high fever', 'Absence of neck stiffness'],
    definitiveTreatment: 'Clotrimazole mouth paint OR Fluconazole 100mg PO OD for 7-14 days',
    supportiveTreatment: 'Good oral hygiene, chlorhexidine mouthwash, control underlying diabetes/HIV',
    redFlags: ['White plaques that can be scraped off, leaving a raw, bleeding erythematous base'],
    cautions: [],
    meds: [
      mk('Candid Mouth Paint', 'Clotrimazole 1%', 'Apply locally 3-4 times/day', 'Apply locally 3-4 times/day', '7', 'लावण्यासाठी'),
      mk('Zocon 100', 'Fluconazole', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-25',
    label: 'Tinea Corporis (Ringworm)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Tinea Corporis (Ringworm)', 'Ringworm', 'Tinea Corporis'],
    pathognomonic: 'Annular lesion with central clearing and an active, raised, erythematous border',
    definitiveTest: 'KOH mount of skin scrapings showing branching septate hyphae',
    supportiveTests: ['Fungal culture (rarely needed)'],
    ddx: ['Nummular Eczema', 'Pityriasis Rosea', 'Psoriasis', 'Granuloma Annulare'],
    positiveSigns: ['Annular (ring-shaped) scaly plaques', 'Intense pruritus (itching)'],
    negativeSigns: ['Absence of systemic symptoms (no fever)', 'Absence of deep tissue involvement'],
    definitiveTreatment: 'Topical Luliconazole 1% OR Oral Terbinafine 250mg OD for 2-4 weeks',
    supportiveTreatment: 'Keep area dry, wear loose cotton clothes, avoid sharing towels, DO NOT use topical steroids',
    redFlags: ['Annular lesion with central clearing and an active, raised, erythematous border'],
    cautions: ['avoid sharing towels'],
    meds: [
      mk('Lulican Cream', 'Luliconazole 1%', 'Apply locally 1-2 times/day', 'Apply locally 1-2 times/day', '14', 'लावण्यासाठी'),
      mk('Terbinaforce 250', 'Terbinafine', '1 - 0 - 0', '1 - 0 - 0', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-26',
    label: 'Scabies',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Scabies'],
    pathognomonic: 'Burrows in the web spaces of fingers, wrists, and genitalia with nocturnal itching',
    definitiveTest: 'Microscopic examination of skin scraping (identifying mite, eggs, or scybala)',
    supportiveTests: ['Clinical diagnosis usually sufficient'],
    ddx: ['Atopic Dermatitis', 'Contact Dermatitis', 'Insect Bites', 'Papular Urticaria'],
    positiveSigns: ['Intense nocturnal pruritus (itching worse at night)', 'Papules/vesicles in interdigital web spaces'],
    negativeSigns: ['Absence of facial involvement (in adults)', 'Absence of fever'],
    definitiveTreatment: 'Permethrin 5% cream (apply neck down, wash off after 8-12 hrs) OR Oral Ivermectin',
    supportiveTreatment: 'Treat all close contacts simultaneously, wash all clothes/bedding in hot water, antihistamines for itch',
    redFlags: ['Burrows in the web spaces of fingers, wrists, and genitalia with nocturnal itching'],
    cautions: [],
    meds: [
      mk('Permite 5% Cream', 'Permethrin', '5%', 'Apply once neck to toe, wash after 12 hrs', '1', 'लावण्यासाठी'),
      mk('Atarax 25', 'Hydroxyzine', '0 - 0 - 1', '0 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-27',
    label: 'Chickenpox (Varicella)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Chickenpox (Varicella)', 'Varicella', 'Chickenpox'],
    pathognomonic: '"Dew drop on a rose petal" appearance of vesicles with lesions in multiple stages of evolution',
    definitiveTest: 'Clinical diagnosis (Tzanck smear shows multinucleated giant cells)',
    supportiveTests: ['Varicella PCR from vesicular fluid (if atypical)'],
    ddx: ['Disseminated Herpes Zoster', 'Hand, Foot, and Mouth Disease', 'Smallpox (eradicated)', 'Impetigo'],
    positiveSigns: ['Pleomorphic rash (macules, papules, vesicles, crusts simultaneously)', 'Fever and malaise'],
    negativeSigns: ['Absence of rash in a single stage of development', 'Absence of deep-seated firm nodules'],
    definitiveTreatment: 'Self-limiting in children; Oral Acyclovir 800mg 5 times/day for adults/immunocompromised',
    supportiveTreatment: 'Calamine lotion, antihistamines for itching, Paracetamol (AVOID Aspirin due to Reye syndrome)',
    redFlags: ['"Dew drop on a rose petal" appearance of vesicles with lesions in multiple stages of evolution'],
    cautions: ['Paracetamol (AVOID Aspirin due to Reye syndrome)'],
    meds: [
      mk('Zovirax 800', 'Acyclovir', '1 tab 5 times a day', '1 tab 5 times a day', '7', 'जेवणानंतर'),
      mk('Caladryl Lotion', 'Calamine + Diphenhydramine', 'Apply locally BD', 'Apply locally BD', '7', 'लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-28',
    label: 'Measles (Rubeola)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Measles (Rubeola)', 'Rubeola', 'Measles'],
    pathognomonic: 'Koplik spots (white spots on buccal mucosa) appearing 1-2 days before rash',
    definitiveTest: 'Measles specific IgM antibodies in serum',
    supportiveTests: ['CBC (Leucopenia)'],
    ddx: ['Rubella', 'Roseola Infantum', 'Dengue Fever', 'Drug Rash'],
    positiveSigns: ['Maculopapular rash starting from face/hairline spreading downwards', 'Cough, Coryza, Conjunctivitis (3 Cs)'],
    negativeSigns: ['Absence of vesicular/fluid-filled lesions', 'Absence of itchy rash'],
    definitiveTreatment: 'Supportive care; Vitamin A supplementation is critical to prevent complications',
    supportiveTreatment: 'Hydration, antipyretics, treat secondary bacterial pneumonia/otitis media if they occur',
    redFlags: ['Koplik spots (white spots on buccal mucosa) appearing 1-2 days before rash'],
    cautions: [],
    meds: [
      mk('Vitamin A Syrup', 'Vitamin A', 'Age-appropriate stat dose', 'Age-appropriate stat dose', '2', 'जेवणानंतर'),
      mk('Dolo 250 Syrup', 'Paracetamol', 'As per weight TDS', 'As per weight TDS', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-29',
    label: 'Neurocysticercosis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Neurocysticercosis'],
    pathognomonic: '"Starry sky" appearance or cystic lesions with a scolex on MRI/CT Brain',
    definitiveTest: 'MRI Brain (preferred) or CT Head with contrast',
    supportiveTests: ['Serum/CSF ELISA for Taenia solium antibodies', 'Stool routine (for Taenia eggs)'],
    ddx: ['Tuberculoma', 'Brain Tumor', 'Brain Abscess', 'Idiopathic Epilepsy'],
    positiveSigns: ['New-onset focal or generalized seizures', 'Headache and signs of raised ICP'],
    negativeSigns: ['Absence of high-grade fever', 'Absence of meningeal signs (usually)'],
    definitiveTreatment: 'Albendazole 15mg/kg/day for 14-28 days + Corticosteroids (Dexamethasone) BEFORE starting Albendazole',
    supportiveTreatment: 'Anti-epileptic drugs (Levetiracetam/Phenytoin) to control seizures',
    redFlags: ['Anti-epileptic drugs (Levetiracetam/Phenytoin) to control seizures'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Wysolone 10', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-30',
    label: 'Mumps',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Mumps'],
    pathognomonic: 'Bilateral or unilateral parotid swelling obscuring the angle of the mandible',
    definitiveTest: 'Clinical diagnosis (Mumps IgM if atypical)',
    supportiveTests: ['Serum Amylase (Elevated)'],
    ddx: ['Suppurative Parotitis', 'Salivary Gland Stone', 'Diphtheria (Bull neck)', 'EBV Infection'],
    positiveSigns: ['Painful swelling of parotid glands', 'Fever and pain on chewing'],
    negativeSigns: ['Absence of purulent discharge from Stensen duct', 'Absence of severe rash'],
    definitiveTreatment: 'Self-limiting; purely supportive',
    supportiveTreatment: 'Warm/cold compresses, soft diet (avoid sour/acidic foods), analgesics',
    redFlags: ['Bilateral or unilateral parotid swelling obscuring the angle of the mandible'],
    cautions: ['soft diet (avoid sour/acidic foods)'],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Chymoral Forte', 'Trypsin Chymotrypsin', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-31',
    label: 'Rubella (German Measles)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Rubella (German Measles)', 'German Measles', 'Rubella'],
    pathognomonic: 'Forchheimer spots (petechiae on soft palate) with postauricular adenopathy',
    definitiveTest: 'Rubella-specific IgM antibodies',
    supportiveTests: ['CBC (Mild leucopenia)'],
    ddx: ['Measles', 'Roseola', 'Scarlet Fever', 'Drug Rash'],
    positiveSigns: ['Mild maculopapular rash starting on face', 'Tender postauricular/suboccipital lymphadenopathy'],
    negativeSigns: ['Absence of high-grade fever', 'Absence of Koplik spots'],
    definitiveTreatment: 'Self-limiting; supportive care',
    supportiveTreatment: 'Antipyretics, isolation (especially from pregnant women to prevent CRS)',
    redFlags: ['isolation (especially from pregnant women to prevent CRS)'],
    cautions: [],
    meds: [
      mk('Crocin 500', 'Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '3', 'जेवणानंतर'),
      mk('Caladryl Lotion', 'Calamine', 'Apply locally', 'Apply locally', '3', 'लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-32',
    label: 'Hand, Foot, and Mouth Disease (HFMD)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Hand, Foot, and Mouth Disease (HFMD)', 'HFMD', 'Hand, Foot, and Mouth Disease'],
    pathognomonic: 'Oval vesicles on palms, soles, and buttocks with oral aphthae',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Coxsackievirus PCR (rarely needed)'],
    ddx: ['Chickenpox', 'Herpes Simplex', 'Aphthous Stomatitis', 'Erythema Multiforme'],
    positiveSigns: ['Vesicular rash on palms and soles', 'Painful oral ulcers'],
    negativeSigns: ['Absence of crusting/weeping lesions (unlike chickenpox)', 'Absence of high fever'],
    definitiveTreatment: 'Self-limiting; symptomatic relief',
    supportiveTreatment: 'Hydration, soft/cold diet, topical oral anesthetics for mouth pain',
    redFlags: ['Oval vesicles on palms, soles, and buttocks with oral aphthae'],
    cautions: [],
    meds: [
      mk('Mucopain Gel', 'Benzocaine', 'Apply to oral ulcers before meals', 'Apply to oral ulcers before meals', '5', 'लावण्यासाठी'),
      mk('Dolo 250 Syrup', 'Paracetamol', 'As per weight', 'As per weight', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-33',
    label: 'Ascariasis (Roundworm)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Ascariasis (Roundworm)', 'Roundworm', 'Ascariasis'],
    pathognomonic: 'Passing a 15-30 cm cylindrical earthworm-like parasite',
    definitiveTest: 'Stool microscopy for Ascaris lumbricoides eggs',
    supportiveTests: ['CBC (Eosinophilia)', 'USG Abdomen (may show worms in biliary tract)'],
    ddx: ['Biliary Colic', 'Intestinal Obstruction', 'Hookworm', 'Peptic Ulcer'],
    positiveSigns: ['Colicky abdominal pain', 'Passing of large worms in stool or vomit'],
    negativeSigns: ['Absence of bloody diarrhea', 'Absence of chronic high fever'],
    definitiveTreatment: 'Albendazole 400mg single dose OR Mebendazole',
    supportiveTreatment: 'Nutritional support, hygiene education',
    redFlags: ['Passing a 15-30 cm cylindrical earthworm-like parasite'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
      mk('Dexorange', 'Hematinic Syrup', '2 tsp BD', '2 tsp BD', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-34',
    label: 'Hookworm Infection',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Hookworm Infection'],
    pathognomonic: 'Microcytic hypochromic anemia with eosinophilia in a barefoot agricultural worker',
    definitiveTest: 'Stool microscopy for Hookworm eggs',
    supportiveTests: ['CBC (Eosinophilia, low Hb)', 'Stool for Occult Blood (Positive)'],
    ddx: ['Nutritional Iron Deficiency', 'Ascariasis', 'Peptic Ulcer Bleed', 'Celiac Disease'],
    positiveSigns: ['Fatigue and pallor (Iron deficiency anemia)', 'Pruritic rash at site of larval entry (Ground itch)'],
    negativeSigns: ['Absence of acute diarrhea', 'Absence of large visible worms in stool'],
    definitiveTreatment: 'Albendazole 400mg single dose',
    supportiveTreatment: 'Iron and Folic Acid supplementation, advise wearing footwear',
    redFlags: ['Microcytic hypochromic anemia with eosinophilia in a barefoot agricultural worker'],
    cautions: [],
    meds: [
      mk('Bandy 400', 'Albendazole', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
      mk('Orofer XT', 'Ferrous Ascorbate + Folic Acid', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-35',
    label: 'Pinworm (Enterobiasis)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Pinworm (Enterobiasis)', 'Enterobiasis', 'Pinworm'],
    pathognomonic: 'Nocturnal perianal pruritus with visible thread-like worms',
    definitiveTest: 'Scotch tape (Cellophane tape) test for eggs in the morning',
    supportiveTests: ['Visual inspection of perianal area at night'],
    ddx: ['Hemorrhoids', 'Perianal Candidiasis', 'Poor hygiene', 'Fissure in ano'],
    positiveSigns: ['Intense perianal itching, especially at night', 'Restless sleep in children'],
    negativeSigns: ['Absence of systemic fever', 'Absence of anemia'],
    definitiveTreatment: 'Albendazole 400mg stat, repeat dose after 2 weeks',
    supportiveTreatment: 'Treat all family members, wash bed linens in hot water, keep fingernails short',
    redFlags: ['Nocturnal perianal pruritus with visible thread-like worms'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 tab stat, repeat after 14 days', '1 tab stat, repeat after 14 days', '1', 'जेवणानंतर'),
      mk('Candid Cream', 'Clotrimazole (if secondary fungal infection)', 'Apply locally', 'Apply locally', '5', 'लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-36',
    label: 'Strongyloidiasis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Strongyloidiasis'],
    pathognomonic: 'Larva currens (rapidly moving linear urticarial tract on skin)',
    definitiveTest: 'Stool routine showing rhabditiform larvae (not eggs)',
    supportiveTests: ['CBC (Eosinophilia)', 'Agar plate culture for larvae'],
    ddx: ['Hookworm', 'Peptic Ulcer Disease', 'Cutaneous Larva Migrans', 'Asthma (if pulmonary phase)'],
    positiveSigns: ['Epigastric pain and diarrhea', 'Serpiginous urticarial rash (Larva currens)'],
    negativeSigns: ['Absence of large worms in stool', 'Absence of high fever'],
    definitiveTreatment: 'Ivermectin 200 mcg/kg/day for 2 days',
    supportiveTreatment: 'Screen for HTLV-1 or immunosuppression if hyperinfection syndrome is suspected',
    redFlags: ['Larva currens (rapidly moving linear urticarial tract on skin)'],
    cautions: [],
    meds: [
      mk('Ivecop 12', 'Ivermectin', '1 tablet OD', '1 tablet OD', '2', 'जेवणानंतर'),
      mk('Pan 40', 'Pantoprazole', '1 - 0 - 0', '1 - 0 - 0', '5', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-37',
    label: 'Hydatid Disease (Echinococcosis)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Hydatid Disease (Echinococcosis)', 'Echinococcosis', 'Hydatid Disease'],
    pathognomonic: 'Cystic lesion with "Water lily sign" or daughter cysts on USG/CT',
    definitiveTest: 'USG or CT Abdomen',
    supportiveTests: ['Echinococcus IgG ELISA', 'CBC (Eosinophilia)'],
    ddx: ['Amoebic Liver Abscess', 'Simple Hepatic Cyst', 'Hepatocellular Carcinoma', 'Polycystic Liver'],
    positiveSigns: ['Dull ache in right upper quadrant', 'Palpable hepatomegaly'],
    negativeSigns: ['Absence of acute high fever', 'Absence of jaundice (unless biliary obstruction)'],
    definitiveTreatment: 'Albendazole (prolonged course) + PAIR (Puncture, Aspiration, Injection, Re-aspiration) or Surgery',
    supportiveTreatment: 'Monitor liver enzymes during prolonged Albendazole therapy',
    redFlags: ['Cystic lesion with "Water lily sign" or daughter cysts on USG/CT'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1 (28 day cycles)', '1 - 0 - 1 (28 day cycles)', '28', 'जेवणानंतर'),
      mk('Udapa 150', 'Ursodeoxycholic Acid', '1 - 0 - 1', '1 - 0 - 1', '28', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-38',
    label: 'Streptococcal Pharyngitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Streptococcal Pharyngitis'],
    pathognomonic: 'Centor Criteria: Fever, Tonsillar exudates, Tender cervical adenopathy, NO cough',
    definitiveTest: 'Throat swab culture or Rapid Antigen Detection Test (RADT)',
    supportiveTests: ['CBC (Leucocytosis)'],
    ddx: ['Viral Pharyngitis', 'Infectious Mononucleosis (EBV)', 'Diphtheria', 'Epiglottitis'],
    positiveSigns: ['Sudden onset severe sore throat', 'Tonsillar exudates and tender cervical nodes'],
    negativeSigns: ['Absence of cough', 'Absence of rhinorrhea (runny nose)'],
    definitiveTreatment: 'Amoxicillin 500mg TDS for 10 days OR Azithromycin 500mg OD for 5 days (if allergic)',
    supportiveTreatment: 'Warm saline gargles, Paracetamol for pain/fever, complete full antibiotic course to prevent Rheumatic Fever',
    redFlags: ['complete full antibiotic course to prevent Rheumatic Fever'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', '10', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-39',
    label: 'Acute Rheumatic Fever',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Acute Rheumatic Fever'],
    pathognomonic: 'Jones Criteria (e.g., Migratory arthritis + Carditis + Sydenham chorea + Erythema marginatum)',
    definitiveTest: 'Evidence of preceding Strep infection (Elevated ASO titer) + Jones Criteria',
    supportiveTests: ['Echocardiography (Valvulitis)', 'ECG (Prolonged PR interval)', 'ESR/CRP (Elevated)'],
    ddx: ['Septic Arthritis', 'Juvenile Idiopathic Arthritis', 'Infective Endocarditis', 'Lyme Disease'],
    positiveSigns: ['Migratory polyarthritis (large joints)', 'New-onset heart murmur (Carditis)'],
    negativeSigns: ['Absence of purulent joint effusion', 'Absence of positive blood culture'],
    definitiveTreatment: 'Benzathine Penicillin G 1.2 million units IM stat (to eradicate carriage)',
    supportiveTreatment: 'High-dose Aspirin or NSAIDs for arthritis, Corticosteroids for severe carditis, long-term Penicillin prophylaxis',
    redFlags: ['Jones Criteria (e.g., Migratory arthritis + Carditis + Sydenham chorea + Erythema marginatum)'],
    cautions: [],
    meds: [
      mk('Penidure LA 12', 'Benzathine Penicillin G', 'Single IM dose', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Ecosprin 150', 'Aspirin', 'As per weight/protocol', 'As per weight/protocol', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-40',
    label: 'Infective Endocarditis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Infective Endocarditis'],
    pathognomonic: 'Vegetation on Echocardiography with persistently positive blood cultures',
    definitiveTest: 'Blood Culture (3 sets from different sites) + Echocardiography (TEE preferred)',
    supportiveTests: ['CBC (Anemia, Leucocytosis)', 'ESR/CRP (Highly elevated)', 'Urine routine (Microscopic hematuria)'],
    ddx: ['Rheumatic Fever', 'Systemic Lupus Erythematosus (Libman-Sacks)', 'Atrial Myxoma', 'Occult Malignancy'],
    positiveSigns: ['Fever of unknown origin with a new/changing heart murmur', 'Osler nodes or Janeway lesions'],
    negativeSigns: ['Absence of clear alternative source of infection', 'Absence of normal echocardiogram'],
    definitiveTreatment: 'Prolonged IV Antibiotics (e.g., Ceftriaxone + Gentamicin) based on culture sensitivity',
    supportiveTreatment: 'Dental evaluation, monitor for embolic events, surgical valve replacement if indicated',
    redFlags: ['monitor for embolic events'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', '1g - 0 - 1g (IV)', '28', 'Inj. (Hospital Use) (Inj.)'),
      mk('Garamycin', 'Gentamicin', 'IV as per weight', 'IV as per weight', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-41',
    label: 'Pneumococcal Pneumonia',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pneumococcal Pneumonia'],
    pathognomonic: 'Rust-colored sputum with lobar consolidation on X-ray',
    definitiveTest: 'Sputum Gram stain (Gram-positive lancet-shaped diplococci) and Culture',
    supportiveTests: ['Chest X-ray (Lobar consolidation)', 'CBC (High neutrophilic leucocytosis)'],
    ddx: ['Atypical Pneumonia', 'Pulmonary Tuberculosis', 'Pulmonary Embolism', 'Viral Pneumonia'],
    positiveSigns: ['Sudden onset high fever with shaking chills', 'Productive cough with rust-colored sputum'],
    negativeSigns: ['Absence of gradual/insidious onset', 'Absence of generalized wheezing'],
    definitiveTreatment: 'Amoxicillin-Clavulanate 625mg TDS OR Ceftriaxone 1g IV BD',
    supportiveTreatment: 'Oxygen therapy if hypoxic, adequate hydration, antipyretics',
    redFlags: ['Rust-colored sputum with lobar consolidation on X-ray'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-42',
    label: 'Mycoplasma Pneumonia (Walking Pneumonia)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Mycoplasma Pneumonia (Walking Pneumonia)', 'Walking Pneumonia', 'Mycoplasma Pneumonia'],
    pathognomonic: 'Clinical signs are mild but Chest X-ray shows patchy infiltrates out of proportion to exam',
    definitiveTest: 'Mycoplasma pneumoniae IgM or PCR (Sputum/Throat swab)',
    supportiveTests: ['Chest X-ray (Patchy interstitial infiltrates)', 'Cold Agglutinin Test'],
    ddx: ['Viral Pneumonia', 'Chlamydial Pneumonia', 'Asthma exacerbation', 'Pertussis'],
    positiveSigns: ['Prolonged dry, hacking cough', 'Low-grade fever and malaise'],
    negativeSigns: ['Absence of severe respiratory distress', 'Absence of dense lobar consolidation'],
    definitiveTreatment: 'Azithromycin 500mg OD for 5 days OR Doxycycline 100mg BD for 7 days',
    supportiveTreatment: 'Cough suppressants, rest, hydration',
    redFlags: ['Clinical signs are mild but Chest X-ray shows patchy infiltrates out of proportion to exam'],
    cautions: [],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '5', 'जेवणानंतर'),
      mk('Ascoril D Plus', 'Dextromethorphan + CPM', '2 tsp TDS', '2 tsp TDS', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-43',
    label: 'Influenza (H1N1 / Swine Flu)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Influenza (H1N1 / Swine Flu)', 'H1N1 / Swine Flu', 'Influenza'],
    pathognomonic: 'Sudden onset severe flu-like illness during an epidemic season',
    definitiveTest: 'RT-PCR of throat/nasopharyngeal swab for Influenza A (H1N1)',
    supportiveTests: ['Chest X-ray (to rule out secondary bacterial pneumonia)', 'CBC'],
    ddx: ['COVID-19', 'Dengue Fever', 'Malaria', 'Atypical Pneumonia'],
    positiveSigns: ['Abrupt onset of high fever and severe myalgia', 'Dry cough and sore throat'],
    negativeSigns: ['Absence of purulent sputum (initially)', 'Absence of chronic weight loss'],
    definitiveTreatment: 'Oseltamivir 75mg BD for 5 days (start within 48 hours of onset)',
    supportiveTreatment: 'Isolation, hydration, Paracetamol (Avoid Aspirin in children)',
    redFlags: ['Sudden onset severe flu-like illness during an epidemic season'],
    cautions: ['Paracetamol (Avoid Aspirin in children)'],
    meds: [
      mk('Antiflu 75', 'Oseltamivir', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-44',
    label: 'COVID-19',
    group: 'Viral',
    category: 'Viral',
    aliases: ['COVID-19'],
    pathognomonic: 'Sudden loss of taste and smell with ground-glass opacities on HRCT Chest',
    definitiveTest: 'SARS-CoV-2 RT-PCR (Nasopharyngeal swab)',
    supportiveTests: ['HRCT Chest (CORADS scoring)', 'CRP, D-Dimer, Ferritin, LDH (Inflammatory markers)'],
    ddx: ['Influenza', 'Viral Pneumonia', 'Mycoplasma Pneumonia', 'Acute Bronchitis'],
    positiveSigns: ['Fever, dry cough, and fatigue', 'Anosmia (loss of smell) and Ageusia (loss of taste)'],
    negativeSigns: ['Absence of copious purulent sputum', 'Absence of localized lobar consolidation (usually bilateral)'],
    definitiveTreatment: 'Supportive care for mild; Remdesivir/Dexamethasone for moderate to severe cases with hypoxia',
    supportiveTreatment: 'Isolation, Paracetamol, prone positioning, monitor SpO2, prophylactic anticoagulation if indicated',
    redFlags: ['Sudden loss of taste and smell with ground-glass opacities on HRCT Chest'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Limcee 500', 'Vitamin C', '1 - 0 - 0', '1 - 0 - 0', '10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-45',
    label: 'Pertussis (Whooping Cough)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pertussis (Whooping Cough)', 'Whooping Cough', 'Pertussis'],
    pathognomonic: 'Severe paroxysms of cough followed by a high-pitched inspiratory whoop',
    definitiveTest: 'Nasopharyngeal swab for Bordetella pertussis PCR or Culture',
    supportiveTests: ['CBC (Marked lymphocytosis)'],
    ddx: ['Mycoplasma Pneumonia', 'Viral Bronchiolitis', 'Asthma', 'Foreign Body Aspiration'],
    positiveSigns: ['Paroxysmal severe cough', 'Inspiratory "whoop" sound and post-tussive vomiting'],
    negativeSigns: ['Absence of high-grade fever', 'Absence of significant wheezing between attacks'],
    definitiveTreatment: 'Azithromycin 500mg OD for 5 days (to reduce infectivity, not symptoms)',
    supportiveTreatment: 'Adequate hydration, nutrition, avoid cough suppressants (ineffective)',
    redFlags: ['Severe paroxysms of cough followed by a high-pitched inspiratory whoop'],
    cautions: ['avoid cough suppressants (ineffective)'],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '5', 'जेवणानंतर'),
      mk('Asthalin', 'Salbutamol Nebulization', 'SOS for severe bronchospasm', 'SOS for severe bronchospasm', '5', 'जेव्हा श्वास घेण्यास त्रास होईल'),
    ],
  },
  {
    id: 'ac-46',
    label: 'Diphtheria',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Diphtheria'],
    pathognomonic: 'Tough pharyngeal membrane that bleeds on attempted scraping',
    definitiveTest: 'Throat swab culture on Loeffler\'s medium or Albert stain (Chinese letter pattern)',
    supportiveTests: ['ECG (to monitor for diphtheritic myocarditis)'],
    ddx: ['Streptococcal Pharyngitis', 'Infectious Mononucleosis', 'Epiglottitis', 'Oral Candidiasis'],
    positiveSigns: ['Greyish-white pseudomembrane on tonsils/pharynx', 'Bull neck (massive cervical lymphadenopathy)'],
    negativeSigns: ['Absence of productive cough', 'Absence of generalized rash'],
    definitiveTreatment: 'Diphtheria Antitoxin (DAT) immediately + Erythromycin or Penicillin',
    supportiveTreatment: 'Strict isolation, airway management, cardiac monitoring',
    redFlags: ['airway management'],
    cautions: [],
    meds: [
      mk('Erythro 500', 'Erythromycin', '1 - 1 - 1 - 1', '1 - 1 - 1 - 1', '14', 'जेवणानंतर'),
      mk('Diphtheria Antitoxin', 'DAT', 'IV/IM stat dose', 'IV/IM stat dose', '1', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-47',
    label: 'Gonorrhea',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Gonorrhea'],
    pathognomonic: 'Thick, yellow-green purulent discharge from urethra/cervix',
    definitiveTest: 'NAAT (Nucleic Acid Amplification Test) of discharge or urine',
    supportiveTests: ['Gram stain of discharge (Gram-negative intracellular diplococci)'],
    ddx: ['Chlamydia Urethritis', 'Trichomoniasis', 'Mycoplasma genitalium infection'],
    positiveSigns: ['Profuse purulent urethral or cervical discharge', 'Severe dysuria'],
    negativeSigns: ['Absence of genital ulcers', 'Absence of systemic fever (unless disseminated)'],
    definitiveTreatment: 'Ceftriaxone 500mg IM single dose + Azithromycin 1g PO single dose (for co-infection)',
    supportiveTreatment: 'Treat sexual partners, abstain from intercourse until cured',
    redFlags: ['Thick, yellow-green purulent discharge from urethra/cervix'],
    cautions: [],
    meds: [
      mk('Monocef 1g', 'Ceftriaxone', '1g', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Azee 1000', 'Azithromycin', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-48',
    label: 'Syphilis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Syphilis'],
    pathognomonic: 'Painless, clean-based, indurated ulcer (Chancre) with painless lymphadenopathy',
    definitiveTest: 'Treponemal tests (TPHA or FTA-ABS)',
    supportiveTests: ['Non-treponemal tests (VDRL or RPR for screening and monitoring)'],
    ddx: ['Chancroid', 'Genital Herpes', 'Donovanosis', 'LGV'],
    positiveSigns: ['Painless indurated genital ulcer (Chancre)', 'Maculopapular rash on palms and soles (Secondary)'],
    negativeSigns: ['Absence of pain in the primary ulcer', 'Absence of purulent discharge'],
    definitiveTreatment: 'Benzathine Penicillin G 2.4 million units IM single dose (for early syphilis)',
    supportiveTreatment: 'Monitor for Jarisch-Herxheimer reaction, treat partners',
    redFlags: ['Monitor for Jarisch-Herxheimer reaction'],
    cautions: [],
    meds: [
      mk('Penidure LA 24', 'Benzathine Penicillin G', 'Single IM dose', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dolo 650', 'Paracetamol', 'SOS for fever/pain', 'SOS for fever/pain', '2', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-49',
    label: 'Chancroid',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Chancroid'],
    pathognomonic: 'Painful, non-indurated ulcer with ragged, undermined edges and a necrotic base',
    definitiveTest: 'Culture for Haemophilus ducreyi (difficult)',
    supportiveTests: ['Gram stain of ulcer exudate ("School of fish" appearance)'],
    ddx: ['Genital Herpes', 'Syphilis', 'LGV', 'Donovanosis'],
    positiveSigns: ['Multiple painful genital ulcers', 'Tender, suppurative inguinal lymphadenopathy (Buboes)'],
    negativeSigns: ['Absence of induration (ulcers are soft)', 'Absence of systemic rash'],
    definitiveTreatment: 'Azithromycin 1g PO single dose OR Ceftriaxone 250mg IM single dose',
    supportiveTreatment: 'Needle aspiration of fluctuant buboes (do not incise and drain)',
    redFlags: ['Painful, non-indurated ulcer with ragged, undermined edges and a necrotic base'],
    cautions: [],
    meds: [
      mk('Azee 1000', 'Azithromycin', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
      mk('Monocef 250', 'Ceftriaxone', 'Single IM dose', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-50',
    label: 'Lymphogranuloma Venereum (LGV)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Lymphogranuloma Venereum (LGV)', 'LGV', 'Lymphogranuloma Venereum'],
    pathognomonic: '"Groove sign" (adenopathy above and below the Poupart ligament)',
    definitiveTest: 'NAAT for Chlamydia trachomatis (L1, L2, L3 serovars)',
    supportiveTests: ['Chlamydia serology'],
    ddx: ['Chancroid', 'Syphilis', 'Genital Herpes', 'Inguinal Hernia'],
    positiveSigns: ['Tender unilateral inguinal/femoral lymphadenopathy', 'Proctocolitis (if rectal exposure)'],
    negativeSigns: ['Absence of persistent large genital ulcers (primary ulcer is transient)', 'Absence of generalized rash'],
    definitiveTreatment: 'Doxycycline 100mg BD for 21 days',
    supportiveTreatment: 'Aspiration of fluctuant buboes, treat partners',
    redFlags: ['"Groove sign" (adenopathy above and below the Poupart ligament)'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '21', 'जेवणानंतर'),
      mk('Pan 40', 'Pantoprazole', '1 - 0 - 0', '1 - 0 - 0', '21', 'जेवणापूर्वी'),
    ],
  },
  {
    id: 'ac-51',
    label: 'Donovanosis (Granuloma Inguinale)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Donovanosis (Granuloma Inguinale)', 'Granuloma Inguinale', 'Donovanosis'],
    pathognomonic: 'Painless, beefy-red, bleeding ulcers without true inguinal lymphadenopathy',
    definitiveTest: 'Tissue crush preparation or biopsy showing Donovan bodies',
    supportiveTests: ['Clinical diagnosis in endemic areas'],
    ddx: ['Syphilis', 'Chancroid', 'Squamous Cell Carcinoma', 'LGV'],
    positiveSigns: ['Painless, beefy-red, highly vascular genital ulcers', 'Ulcers bleed easily on contact'],
    negativeSigns: ['Absence of regional lymphadenopathy (pseudobuboes may form)', 'Absence of systemic symptoms'],
    definitiveTreatment: 'Azithromycin 1g once weekly OR 500mg daily until all lesions heal (min 3 weeks)',
    supportiveTreatment: 'Good local hygiene, monitor for malignant transformation',
    redFlags: ['monitor for malignant transformation'],
    cautions: [],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '21', 'जेवणानंतर'),
      mk('Betadine Ointment', 'Povidone Iodine', 'Apply locally', 'Apply locally', '21', 'लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-52',
    label: 'Genital Herpes',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Genital Herpes'],
    pathognomonic: 'Grouped painful vesicles on an erythematous base that rupture to form shallow ulcers',
    definitiveTest: 'HSV PCR from vesicle fluid or ulcer swab',
    supportiveTests: ['Tzanck smear (Multinucleated giant cells - low sensitivity)', 'HSV Type-specific serology'],
    ddx: ['Chancroid', 'Syphilis', 'Candidiasis', 'Drug Eruption'],
    positiveSigns: ['Multiple painful vesicular lesions on genitalia', 'Tender inguinal lymphadenopathy'],
    negativeSigns: ['Absence of painless indurated ulcers', 'Absence of purulent urethral discharge'],
    definitiveTreatment: 'Acyclovir 400mg TDS for 7-10 days (for primary episode)',
    supportiveTreatment: 'Saline bathing, topical anesthetics, suppressive therapy for frequent recurrences',
    redFlags: ['Grouped painful vesicles on an erythematous base that rupture to form shallow ulcers'],
    cautions: [],
    meds: [
      mk('Zovirax 400', 'Acyclovir', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Lox 2% Jelly', 'Lignocaine Gel', '2%', 'Apply locally for pain', '5', 'लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-53',
    label: 'Genital Warts (Condyloma Acuminata)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Genital Warts (Condyloma Acuminata)', 'Condyloma Acuminata', 'Genital Warts'],
    pathognomonic: 'Verrucous, exophytic, cauliflower-like lesions on anogenital skin',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Pap smear (for cervical warts/dysplasia)', 'HPV DNA testing (for high-risk strains)'],
    ddx: ['Condyloma Lata (Secondary Syphilis)', 'Molluscum Contagiosum', 'Squamous Cell Carcinoma', 'Skin Tags'],
    positiveSigns: ['Fleshy, cauliflower-like growths on genitalia/perianal area', 'Painless but may cause pruritus'],
    negativeSigns: ['Absence of ulceration', 'Absence of systemic fever'],
    definitiveTreatment: 'Podophyllin resin, Imiquimod cream, or Cryotherapy/Surgical excision',
    supportiveTreatment: 'Counseling regarding HPV transmission and vaccination (Gardasil)',
    redFlags: ['Verrucous, exophytic, cauliflower-like lesions on anogenital skin'],
    cautions: [],
    meds: [
      mk('Podowart', 'Podophyllum Resin', 'Apply strictly on warts (wash after 4 hrs)', 'Apply strictly on warts (wash after 4 hrs)', 'Weekly', 'डॉक्टरांच्या सल्ल्याने'),
      mk('Imiquad 5%', 'Imiquimod Cream', '5%', 'Apply 3 times a week at bedtime', '16 weeks', 'झोपताना'),
    ],
  },
  {
    id: 'ac-54',
    label: 'Trichomoniasis',
    group: 'Parasitic',
    category: 'Protozoal',
    aliases: ['Trichomoniasis'],
    pathognomonic: '"Strawberry cervix" (Colpitis macularis) on speculum examination',
    definitiveTest: 'Wet mount microscopy showing motile, flagellated trichomonads',
    supportiveTests: ['NAAT (highly sensitive)', 'Vaginal pH > 4.5'],
    ddx: ['Bacterial Vaginosis', 'Vulvovaginal Candidiasis', 'Chlamydia/Gonorrhea Cervicitis'],
    positiveSigns: ['Frothy, yellow-green, malodorous vaginal discharge', 'Vulvar itching and dysuria'],
    negativeSigns: ['Absence of thick, curdy white discharge', 'Absence of genital ulcers'],
    definitiveTreatment: 'Metronidazole 2g PO single dose OR 400mg BD for 7 days',
    supportiveTreatment: 'Treat sexual partners simultaneously, abstain from alcohol during treatment (Disulfiram-like reaction)',
    redFlags: ['"Strawberry cervix" (Colpitis macularis) on speculum examination'],
    cautions: [],
    meds: [
      mk('Flagyl 400', 'Metronidazole', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Candid-V3', 'Clotrimazole Vaginal Tab', 'Insert 1 tab vaginally at night', 'Insert 1 tab vaginally at night', '3', 'झोपताना'),
    ],
  },
  {
    id: 'ac-55',
    label: 'Bacterial Vaginosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Bacterial Vaginosis'],
    pathognomonic: 'Fishy odor on adding 10% KOH to discharge (Positive Whiff Test)',
    definitiveTest: 'Amsel Criteria (Discharge, pH >4.5, Clue cells, Positive Whiff test)',
    supportiveTests: ['Gram stain of vaginal smear (Nugent score > 7)'],
    ddx: ['Trichomoniasis', 'Vulvovaginal Candidiasis', 'Normal physiologic discharge'],
    positiveSigns: ['Thin, grayish-white, homogeneous vaginal discharge', 'Strong "fishy" odor, especially after intercourse'],
    negativeSigns: ['Absence of severe vulvar inflammation/erythema', 'Absence of frothy yellow discharge'],
    definitiveTreatment: 'Metronidazole 400mg BD for 7 days OR Clindamycin 2% vaginal cream',
    supportiveTreatment: 'Avoid douching, use mild soaps, partner treatment usually not required',
    redFlags: ['Fishy odor on adding 10% KOH to discharge (Positive Whiff Test)'],
    cautions: ['Avoid douching'],
    meds: [
      mk('Flagyl 400', 'Metronidazole', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Cleocin Vaginal Cream', 'Clindamycin 2%', 'Apply vaginally at bedtime', 'Apply vaginally at bedtime', '7', 'झोपताना'),
    ],
  },
  {
    id: 'ac-56',
    label: 'Pelvic Inflammatory Disease (PID)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pelvic Inflammatory Disease (PID)', 'PID', 'Pelvic Inflammatory Disease'],
    pathognomonic: 'Cervical motion tenderness + Uterine/Adnexal tenderness + Purulent cervical discharge',
    definitiveTest: 'Clinical diagnosis; Laparoscopy is gold standard but rarely done',
    supportiveTests: ['TVS (Tubo-ovarian abscess, thickened tubes)', 'CBC (Leucocytosis)', 'High vaginal swab'],
    ddx: ['Ectopic Pregnancy', 'Acute Appendicitis', 'Endometriosis', 'Ovarian Cyst Torsion'],
    positiveSigns: ['Lower abdominal/pelvic pain', 'Cervical motion tenderness (Chandelier sign)'],
    negativeSigns: ['Absence of missed period/positive pregnancy test (rules out ectopic)', 'Absence of isolated right iliac fossa pain (rules out appendicitis)'],
    definitiveTreatment: 'Ceftriaxone 500mg IM stat + Doxycycline 100mg BD x 14 days + Metronidazole 400mg BD x 14 days',
    supportiveTreatment: 'Bed rest, analgesics, remove IUD if present, treat partners',
    redFlags: ['Cervical motion tenderness + Uterine/Adnexal tenderness + Purulent cervical discharge'],
    cautions: [],
    meds: [
      mk('Monocef 500', 'Ceftriaxone', 'Single IM dose', 'Single IM dose', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Flagyl 400', 'Metronidazole', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-57',
    label: 'Urinary Tract Infection (UTI - E. coli)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Urinary Tract Infection (UTI - E. coli)', 'UTI - E. coli', 'Urinary Tract Infection'],
    pathognomonic: 'Suprapubic tenderness with severe dysuria and cloudy urine',
    definitiveTest: 'Urine Culture and Sensitivity (>10^5 CFU/ml)',
    supportiveTests: ['Urine Routine (Pus cells > 5/HPF, Positive Nitrites/LE)'],
    ddx: ['Pyelonephritis', 'Vaginitis', 'Urethritis (STI)', 'Interstitial Cystitis'],
    positiveSigns: ['Dysuria (burning micturition)', 'Increased urinary frequency and urgency'],
    negativeSigns: ['Absence of high fever with chills', 'Absence of flank/CVA tenderness'],
    definitiveTreatment: 'Nitrofurantoin 100mg BD for 5 days OR Fosfomycin 3g single sachet',
    supportiveTreatment: 'Plenty of oral fluids, urinary alkalizers (Syrup Cital) for symptomatic relief',
    redFlags: ['Suprapubic tenderness with severe dysuria and cloudy urine'],
    cautions: [],
    meds: [
      mk('Niftas 100', 'Nitrofurantoin', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Cital Syrup', 'Disodium Hydrogen Citrate', '2 tsp in half glass water TDS', '2 tsp in half glass water TDS', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-58',
    label: 'Pyelonephritis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pyelonephritis'],
    pathognomonic: 'Fever + Chills + Flank pain + WBC casts in urine',
    definitiveTest: 'Urine Culture and Blood Culture',
    supportiveTests: ['Urine Routine (Pus cells, WBC casts)', 'USG KUB (to rule out obstruction/stones)', 'CBC (Leucocytosis)'],
    ddx: ['Lower UTI (Cystitis)', 'Renal Colic (Stones)', 'Pelvic Inflammatory Disease', 'Acute Appendicitis'],
    positiveSigns: ['High fever with chills and rigors', 'Flank pain / Costovertebral angle (CVA) tenderness'],
    negativeSigns: ['Absence of normal urine routine', 'Absence of severe respiratory symptoms'],
    definitiveTreatment: 'Ciprofloxacin 500mg BD for 7 days OR Ceftriaxone 1g IV OD (if severe/hospitalized)',
    supportiveTreatment: 'IV hydration, antipyretics, monitor renal function',
    redFlags: ['Fever + Chills + Flank pain + WBC casts in urine'],
    cautions: [],
    meds: [
      mk('Ciplox 500', 'Ciprofloxacin', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-59',
    label: 'Prostatitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Prostatitis'],
    pathognomonic: 'Exquisitely tender, swollen, "boggy" prostate on Digital Rectal Exam (DRE)',
    definitiveTest: 'Urine culture (pre and post-prostatic massage - avoid massage in acute phase)',
    supportiveTests: ['Urine Routine', 'USG KUB with Post-Void Residual (PVR)'],
    ddx: ['BPH (Benign Prostatic Hyperplasia)', 'UTI', 'Prostate Cancer', 'Interstitial Cystitis'],
    positiveSigns: ['Perineal, pelvic, or lower back pain', 'Dysuria and fever (if acute)'],
    negativeSigns: ['Absence of painless hematuria', 'Absence of normal DRE'],
    definitiveTreatment: 'Ciprofloxacin 500mg BD or Levofloxacin 500mg OD for 4-6 weeks',
    supportiveTreatment: 'Alpha-blockers (Tamsulosin) to improve urine flow, NSAIDs for pain, sitz baths',
    redFlags: ['Exquisitely tender, swollen, "boggy" prostate on Digital Rectal Exam (DRE)'],
    cautions: [],
    meds: [
      mk('Loxof 500', 'Levofloxacin', '1 - 0 - 0', '1 - 0 - 0', '28', 'जेवणानंतर'),
      mk('Veltam 0.4', 'Tamsulosin', '0 - 0 - 1', '0 - 0 - 1', '28', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-60',
    label: 'Orbital Cellulitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Orbital Cellulitis'],
    pathognomonic: 'Unilateral periorbital swelling with proptosis and painful ophthalmoplegia',
    definitiveTest: 'CT Scan of Orbit and Paranasal Sinuses (with contrast)',
    supportiveTests: ['CBC (High Leucocytosis)', 'Blood Culture'],
    ddx: ['Preseptal Cellulitis', 'Cavernous Sinus Thrombosis', 'Mucormycosis', 'Thyroid Eye Disease'],
    positiveSigns: ['Proptosis (bulging eye)', 'Painful and restricted eye movements (Ophthalmoplegia)'],
    negativeSigns: ['Absence of normal eye movements (differentiates from preseptal cellulitis)', 'Absence of painless swelling'],
    definitiveTreatment: 'Urgent IV Antibiotics (Ceftriaxone + Vancomycin + Metronidazole)',
    supportiveTreatment: 'ENT/Ophthalmology consultation, surgical drainage of abscess or sinuses if needed',
    redFlags: ['Unilateral periorbital swelling with proptosis and painful ophthalmoplegia'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', 'IV BD', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Vancocin', 'Vancomycin', 'IV as per weight', 'IV as per weight', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-61',
    label: 'Conjunctivitis (Pink Eye)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Conjunctivitis (Pink Eye)', 'Pink Eye', 'Conjunctivitis'],
    pathognomonic: 'Matting of eyelashes in the morning (bacterial) or gritty sensation with watery discharge (viral)',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Eye swab culture (only if severe or non-responsive)'],
    ddx: ['Acute Glaucoma', 'Uveitis', 'Corneal Ulcer', 'Allergic Conjunctivitis'],
    positiveSigns: ['Redness of conjunctiva (hyperemia)', 'Watery (viral) or purulent (bacterial) discharge'],
    negativeSigns: ['Absence of severe eye pain', 'Absence of decreased visual acuity'],
    definitiveTreatment: 'Moxifloxacin 0.5% eye drops (if bacterial); Cold compresses and artificial tears (if viral)',
    supportiveTreatment: 'Strict hand hygiene, avoid sharing towels, do not rub eyes',
    redFlags: ['Matting of eyelashes in the morning (bacterial) or gritty sensation with watery discharge (viral)'],
    cautions: ['avoid sharing towels'],
    meds: [
      mk('Moxicip Eye Drops', 'Moxifloxacin 0.5%', '1 drop 4 times a day', '1 drop 4 times a day', '5', 'डोळ्यात टाकण्यासाठी'),
      mk('Refresh Tears', 'Carboxymethylcellulose', '1 drop 4 times a day', '1 drop 4 times a day', '7', 'डोळ्यात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-62',
    label: 'Trachoma',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Trachoma'],
    pathognomonic: 'Arlt\'s line (conjunctival scarring) and Herbert\'s pits (limbal depressions)',
    definitiveTest: 'Clinical grading (WHO criteria: TF, TI, TS, TT, CO)',
    supportiveTests: ['NAAT for Chlamydia trachomatis (rarely needed in endemic areas)'],
    ddx: ['Viral Conjunctivitis', 'Allergic Conjunctivitis', 'Bacterial Conjunctivitis'],
    positiveSigns: ['Follicular conjunctivitis (upper tarsal conjunctiva)', 'Trichiasis (in-turned eyelashes rubbing cornea)'],
    negativeSigns: ['Absence of acute profuse purulent discharge', 'Absence of sudden vision loss'],
    definitiveTreatment: 'Azithromycin 20mg/kg single dose (SAFE strategy: Surgery, Antibiotics, Facial cleanliness, Environmental improvement)',
    supportiveTreatment: 'Surgical correction of trichiasis to prevent blindness',
    redFlags: ['Surgical correction of trichiasis to prevent blindness'],
    cautions: [],
    meds: [
      mk('Azee 1000', 'Azithromycin', '1 tablet stat', '1 tablet stat', '1', 'जेवणानंतर'),
      mk('Tetracycline Eye Ointment', 'Tetracycline 1%', 'Apply BD', 'Apply BD', '42', 'डोळ्यात लावण्यासाठी'),
    ],
  },
  {
    id: 'ac-63',
    label: 'Endophthalmitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Endophthalmitis'],
    pathognomonic: 'Hypopyon and severe vitritis following recent eye surgery or penetrating trauma',
    definitiveTest: 'Vitreous tap/aspirate for Gram stain and Culture',
    supportiveTests: ['B-scan Ultrasonography (shows vitreous opacities)'],
    ddx: ['Severe Uveitis', 'Acute Angle Closure Glaucoma', 'Corneal Ulcer'],
    positiveSigns: ['Severe eye pain and sudden profound loss of vision', 'Hypopyon (pus in the anterior chamber)'],
    negativeSigns: ['Absence of normal visual acuity', 'Absence of painless red eye'],
    definitiveTreatment: 'Urgent Intravitreal Antibiotics (Vancomycin + Ceftazidime/Amikacin)',
    supportiveTreatment: 'Vitrectomy (if vision is light perception only), systemic antibiotics, topical steroids',
    redFlags: ['Hypopyon and severe vitritis following recent eye surgery or penetrating trauma'],
    cautions: [],
    meds: [
      mk('Intravitreal Vancocin', 'Vancomycin', 'Intravitreal injection', 'Intravitreal injection', '1', 'Inj. (Hospital Use) (Inj.)'),
      mk('Moxicip Eye Drops', 'Moxifloxacin', '1 drop every 1-2 hours', '1 drop every 1-2 hours', '14', 'डोळ्यात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-64',
    label: 'Acute Otitis Media (AOM)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Acute Otitis Media (AOM)', 'AOM', 'Acute Otitis Media'],
    pathognomonic: 'Bulging, erythematous, opaque tympanic membrane with loss of light reflex on otoscopy',
    definitiveTest: 'Otoscopic examination',
    supportiveTests: ['Tympanometry (shows flat Type B curve)'],
    ddx: ['Otitis Externa', 'Otitis Media with Effusion', 'Referred pain (dental/TMJ)', 'Mastoiditis'],
    positiveSigns: ['Severe ear pain (otalgia)', 'Fever and irritability (especially in children)'],
    negativeSigns: ['Absence of pain on pulling the pinna (differentiates from Otitis Externa)', 'Absence of clear ear canal'],
    definitiveTreatment: 'Amoxicillin 500mg TDS for 5-7 days (High dose in children)',
    supportiveTreatment: 'Analgesics (Paracetamol/Ibuprofen), warm compresses, nasal decongestants',
    redFlags: ['Bulging, erythematous, opaque tympanic membrane with loss of light reflex on otoscopy'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Otrivin Nasal Drops', 'Xylometazoline', '2 drops in each nostril BD', '2 drops in each nostril BD', '5', 'नाकात टाकण्यासाठी'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-65',
    label: 'Sinusitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Sinusitis'],
    pathognomonic: 'Tender paranasal sinuses with purulent post-nasal drip',
    definitiveTest: 'Clinical diagnosis (CT PNS if chronic/refractory)',
    supportiveTests: ['Nasal endoscopy'],
    ddx: ['Viral URI', 'Allergic Rhinitis', 'Nasal Polyps', 'Dental Abscess'],
    positiveSigns: ['Facial pain or pressure (worse on bending forward)', 'Purulent nasal discharge'],
    negativeSigns: ['Absence of visual changes', 'Absence of altered mental status'],
    definitiveTreatment: 'Amoxicillin-Clavulanate 625mg TDS for 5-7 days (if bacterial)',
    supportiveTreatment: 'Nasal saline irrigation, decongestants, steam inhalation',
    redFlags: ['Tender paranasal sinuses with purulent post-nasal drip'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Otrivin Nasal Drops', 'Xylometazoline', '2 drops BD', '2 drops BD', '5', 'नाकात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-66',
    label: 'Mastoiditis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Mastoiditis'],
    pathognomonic: 'Tender, fluctuant post-auricular swelling with a history of recent AOM',
    definitiveTest: 'CT Temporal Bone (shows opacification of mastoid air cells)',
    supportiveTests: ['Ear swab culture (if discharging)'],
    ddx: ['Otitis Externa', 'Lymphadenitis', 'Mumps', 'Sebaceous Cyst'],
    positiveSigns: ['Post-auricular swelling and erythema', 'Protrusion of the auricle (ear pushed forward)'],
    negativeSigns: ['Absence of normal tympanic membrane', 'Absence of painless swelling'],
    definitiveTreatment: 'IV Ceftriaxone 1g BD + IV Clindamycin',
    supportiveTreatment: 'Myringotomy, Mastoidectomy (if abscess forms or refractory)',
    redFlags: ['Tender, fluctuant post-auricular swelling with a history of recent AOM'],
    cautions: [],
    meds: [
      mk('Monocef 1g', 'Ceftriaxone', '1g', 'IV BD', '7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dalacin C 300', 'Clindamycin', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-67',
    label: 'Brain Abscess',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Brain Abscess'],
    pathognomonic: 'Ring-enhancing lesion with central necrosis and surrounding edema on contrast CT/MRI',
    definitiveTest: 'MRI Brain with Contrast',
    supportiveTests: ['Stereotactic aspiration for culture (Aerobic, Anaerobic, Fungal, AFB)'],
    ddx: ['Brain Tumor (Glioblastoma)', 'Neurocysticercosis', 'Tuberculoma', 'Toxoplasmosis'],
    positiveSigns: ['Focal neurological deficit', 'Headache with signs of raised ICP (vomiting, papilledema)'],
    negativeSigns: ['Absence of sudden onset (usually subacute)', 'Absence of clear CSF (lumbar puncture is contraindicated)'],
    definitiveTreatment: 'IV Ceftriaxone + IV Metronidazole + IV Vancomycin (empirical) for 4-8 weeks',
    supportiveTreatment: 'Surgical aspiration/excision, Dexamethasone (if severe edema), Anti-epileptics',
    redFlags: ['Ring-enhancing lesion with central necrosis and surrounding edema on contrast CT/MRI'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', 'IV BD', '28', 'Inj. (Hospital Use) (Inj.)'),
      mk('Flagyl IV', 'Metronidazole', 'IV TDS', 'IV TDS', '28', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-68',
    label: 'Herpes Simplex Encephalitis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Herpes Simplex Encephalitis'],
    pathognomonic: 'Acute encephalitis with temporal lobe involvement on MRI/EEG',
    definitiveTest: 'CSF HSV PCR',
    supportiveTests: ['MRI Brain (Temporal/Inferior frontal lobe hyperintensities)', 'EEG (PLEDS)'],
    ddx: ['Japanese Encephalitis', 'Tuberculous Meningitis', 'Brain Abscess', 'Autoimmune Encephalitis'],
    positiveSigns: ['Altered sensorium and confusion', 'Focal seizures or neurological deficits'],
    negativeSigns: ['Absence of purpuric rash', 'Absence of low CSF glucose'],
    definitiveTreatment: 'IV Acyclovir 10mg/kg TDS for 14-21 days (Start empirically immediately)',
    supportiveTreatment: 'Anti-epileptics, manage raised ICP, supportive ICU care',
    redFlags: ['supportive ICU care'],
    cautions: [],
    meds: [
      mk('Zovirax IV', 'Acyclovir', 'IV TDS', 'IV TDS', '21', 'Inj. (Hospital Use) (Inj.)'),
      mk('Eptoin 100', 'Phenytoin', '1 - 0 - 1', '1 - 0 - 1', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-69',
    label: 'Tuberculous Meningitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Tuberculous Meningitis'],
    pathognomonic: 'Thick basal exudates on contrast MRI Brain with hydrocephalus',
    definitiveTest: 'CSF CBNAAT / GeneXpert or AFB Culture',
    supportiveTests: ['CSF Analysis (High protein, low glucose, lymphocytic pleocytosis)', 'Chest X-ray'],
    ddx: ['Fungal Meningitis (Cryptococcal)', 'Viral Meningoencephalitis', 'Neurosyphilis', 'Carcinomatous Meningitis'],
    positiveSigns: ['Subacute/chronic headache and low-grade fever', 'Cranial nerve palsies (especially CN VI)'],
    negativeSigns: ['Absence of sudden, hyperacute onset', 'Absence of normal CSF protein'],
    definitiveTreatment: 'Standard ATT (HRZE) for 2 months, followed by HR for 7-10 months',
    supportiveTreatment: 'Adjunctive Corticosteroids (Dexamethasone) for 6-8 weeks, VP shunt if severe hydrocephalus',
    redFlags: ['Thick basal exudates on contrast MRI Brain with hydrocephalus'],
    cautions: [],
    meds: [
      mk('Akt-4 Kit', 'FDC (R+H+Z+E)', 'As per weight band', 'As per weight band', '60', 'जेवणापूर्वी रिकाम्या पोटी'),
      mk('Dexona', 'Dexamethasone', 'Tapering dose', 'Tapering dose', '42', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-70',
    label: 'Cryptococcal Meningitis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Cryptococcal Meningitis'],
    pathognomonic: 'Encapsulated budding yeast cells on India Ink preparation of CSF',
    definitiveTest: 'CSF Cryptococcal Antigen (CrAg) test',
    supportiveTests: ['CSF Fungal Culture (Sabouraud Dextrose Agar)'],
    ddx: ['Tuberculous Meningitis', 'Toxoplasmosis', 'Lymphoma', 'Viral Encephalitis'],
    positiveSigns: ['Gradual onset headache and confusion', 'High opening pressure on Lumbar Puncture'],
    negativeSigns: ['Absence of prominent meningeal signs (neck stiffness may be mild)', 'Absence of normal immune status (usually HIV CD4 < 100)'],
    definitiveTreatment: 'Induction: IV Liposomal Amphotericin B + Flucytosine for 2 weeks',
    supportiveTreatment: 'Consolidation/Maintenance: Oral Fluconazole, therapeutic LPs for raised ICP, delay ART initiation by 4-6 weeks',
    redFlags: ['Encapsulated budding yeast cells on India Ink preparation of CSF'],
    cautions: [],
    meds: [
      mk('AmBisome', 'Liposomal Amphotericin B', 'IV OD', 'IV OD', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Zocon 400', 'Fluconazole', '1 - 0 - 0', '1 - 0 - 0', '56', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-71',
    label: 'Toxoplasmosis (Cerebral)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Toxoplasmosis (Cerebral)', 'Cerebral', 'Toxoplasmosis'],
    pathognomonic: 'Multiple ring-enhancing lesions in basal ganglia/corticomedullary junction on MRI',
    definitiveTest: 'Brain biopsy (rarely done); usually a presumptive clinical/radiological diagnosis',
    supportiveTests: ['Toxoplasma IgG (positive in serum)', 'Response to empiric therapy within 10-14 days'],
    ddx: ['Primary CNS Lymphoma', 'Tuberculoma', 'Brain Abscess', 'Neurocysticercosis'],
    positiveSigns: ['Focal neurological deficits (hemiparesis, speech issues)', 'Headache and seizures in an immunocompromised patient'],
    negativeSigns: ['Absence of normal CD4 count (usually < 100 in HIV)', 'Absence of solitary large lesion (usually multiple)'],
    definitiveTreatment: 'Sulfadiazine + Pyrimethamine + Leucovorin for 6 weeks',
    supportiveTreatment: 'Maintenance therapy until CD4 > 200, Corticosteroids for severe edema, Anti-epileptics',
    redFlags: ['Multiple ring-enhancing lesions in basal ganglia/corticomedullary junction on MRI'],
    cautions: [],
    meds: [
      mk('Pyrimethamine 25', 'Pyrimethamine', 'As per protocol', 'As per protocol', '42', 'जेवणानंतर'),
      mk('Folinic Acid', 'Leucovorin', '1 - 0 - 0', '1 - 0 - 0', '42', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-72',
    label: 'Osteomyelitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Osteomyelitis'],
    pathognomonic: 'Bone destruction with periosteal reaction and sequestrum/involucrum formation',
    definitiveTest: 'Bone biopsy and culture (Gold standard)',
    supportiveTests: ['MRI (most sensitive early test)', 'Blood Culture', 'ESR/CRP'],
    ddx: ['Septic Arthritis', 'Ewing Sarcoma', 'Bone Infarction (Sickle Cell)', 'Cellulitis'],
    positiveSigns: ['Localized bone pain and tenderness', 'Overlying erythema, swelling, and warmth'],
    negativeSigns: ['Absence of normal ESR/CRP', 'Absence of immediate X-ray changes (takes 10-14 days to appear)'],
    definitiveTreatment: 'Prolonged IV/Oral Antibiotics (e.g., Cefazolin, Vancomycin, Clindamycin) for 4-6 weeks',
    supportiveTreatment: 'Surgical debridement of necrotic bone, immobilization, pain management',
    redFlags: ['Bone destruction with periosteal reaction and sequestrum/involucrum formation'],
    cautions: [],
    meds: [
      mk('Dalacin C 300', 'Clindamycin', '1 - 1 - 1 - 1', '1 - 1 - 1 - 1', '42', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-73',
    label: 'Septic Arthritis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Septic Arthritis'],
    pathognomonic: 'Purulent synovial fluid with WBC > 50,000/mm3 (predominantly neutrophils)',
    definitiveTest: 'Synovial fluid aspiration for Gram stain and Culture',
    supportiveTests: ['Blood Culture', 'USG of joint (to detect effusion)', 'ESR/CRP'],
    ddx: ['Gout', 'Pseudogout', 'Rheumatoid Arthritis flare', 'Traumatic Hemarthrosis'],
    positiveSigns: ['Acutely hot, swollen, and exquisitely tender joint', 'Severe restriction of both active and passive movement'],
    negativeSigns: ['Absence of multiple joint involvement (usually monoarticular)', 'Absence of normal synovial fluid'],
    definitiveTreatment: 'Urgent IV Antibiotics (Ceftriaxone + Vancomycin) + Joint drainage/washout',
    supportiveTreatment: 'Immobilization initially, followed by early physiotherapy to prevent contractures',
    redFlags: ['followed by early physiotherapy to prevent contractures'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', 'IV OD', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Vancocin', 'Vancomycin', 'IV BD', 'IV BD', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-74',
    label: 'Gas Gangrene (Clostridial Myonecrosis)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Gas Gangrene (Clostridial Myonecrosis)', 'Clostridial Myonecrosis', 'Gas Gangrene'],
    pathognomonic: 'Rapidly spreading muscle necrosis with gas in soft tissues on X-ray',
    definitiveTest: 'Surgical exploration (muscle does not bleed or contract) + Gram stain (Gram-positive rods, no spores/WBCs)',
    supportiveTests: ['X-ray/CT showing gas in fascial planes', 'Blood Culture'],
    ddx: ['Necrotizing Fasciitis', 'Severe Cellulitis', 'Crush Injury', 'Compartment Syndrome'],
    positiveSigns: ['Severe pain out of proportion to visible injury', 'Crepitus (crackling feeling under skin)'],
    negativeSigns: ['Absence of purulent discharge (usually thin, sweet-smelling, "dishwater" exudate)', 'Absence of slow progression'],
    definitiveTreatment: 'EMERGENCY Surgical Debridement/Amputation + IV Penicillin G + Clindamycin',
    supportiveTreatment: 'Hyperbaric oxygen therapy (if available), aggressive fluid resuscitation, ICU care',
    redFlags: ['ICU care'],
    cautions: [],
    meds: [
      mk('Penidure', 'Penicillin G', 'High dose IV', 'High dose IV', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dalacin C', 'Clindamycin', 'IV TDS', 'IV TDS', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-75',
    label: 'Necrotizing Fasciitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Necrotizing Fasciitis'],
    pathognomonic: '"Dishwater" pus and easy separation of fascial planes on blunt dissection (finger sweep test)',
    definitiveTest: 'Surgical exploration (Gold standard)',
    supportiveTests: ['LRINEC Score (High CRP, WBC, low Na)', 'CT/MRI (fascial thickening/gas)'],
    ddx: ['Cellulitis', 'Gas Gangrene', 'Deep Vein Thrombosis', 'Pyoderma Gangrenosum'],
    positiveSigns: ['Pain out of proportion to physical findings', 'Rapidly spreading erythema with hemorrhagic bullae/necrosis'],
    negativeSigns: ['Absence of sharp demarcation (margins are poorly defined)', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'EMERGENCY extensive surgical debridement + Broad-spectrum IV Antibiotics (Meropenem + Vancomycin + Clindamycin)',
    supportiveTreatment: 'Hemodynamic support, nutritional support, wound care/VAC dressing',
    redFlags: ['"Dishwater" pus and easy separation of fascial planes on blunt dissection (finger sweep test)'],
    cautions: [],
    meds: [
      mk('Meromac 1g', 'Meropenem', '1g', 'IV TDS', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dalacin C', 'Clindamycin', 'IV TDS', 'IV TDS', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-76',
    label: 'Cellulitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Cellulitis'],
    pathognomonic: 'Unilateral, ill-defined erythema and edema of the deep dermis and subcutaneous tissue',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['CBC (Leucocytosis)', 'Blood culture (if systemic toxicity)'],
    ddx: ['Erysipelas', 'Deep Vein Thrombosis (DVT)', 'Stasis Dermatitis', 'Necrotizing Fasciitis'],
    positiveSigns: ['Spreading area of red, swollen, tender, and warm skin', 'Fever and chills'],
    negativeSigns: ['Absence of sharp, raised borders (unlike Erysipelas)', 'Absence of deep fascial necrosis'],
    definitiveTreatment: 'Oral/IV Antibiotics covering Strep/Staph (e.g., Cephalexin, Amoxicillin-Clavulanate, or Clindamycin)',
    supportiveTreatment: 'Elevation of the affected limb, treat underlying conditions (e.g., Tinea pedis, edema)',
    redFlags: ['Unilateral, ill-defined erythema and edema of the deep dermis and subcutaneous tissue'],
    cautions: [],
    meds: [
      mk('Phexin 500', 'Cephalexin', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-77',
    label: 'Erysipelas',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Erysipelas'],
    pathognomonic: 'Well-demarcated, raised erythematous plaque (often on face or legs) with "peau d\'orange" appearance',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['CBC (High Leucocytosis)', 'ASO Titer (may be elevated)'],
    ddx: ['Cellulitis', 'Contact Dermatitis', 'Systemic Lupus Erythematosus (Butterfly rash)', 'Herpes Zoster'],
    positiveSigns: ['Sharply demarcated, raised, fiery-red plaque', 'Rapid onset with high fever and chills'],
    negativeSigns: ['Absence of deep subcutaneous involvement', 'Absence of gradual onset'],
    definitiveTreatment: 'Penicillin V or Amoxicillin (Oral) OR Ceftriaxone (IV if severe)',
    supportiveTreatment: 'Cold compresses, limb elevation, antipyretics',
    redFlags: ['Well-demarcated, raised erythematous plaque (often on face or legs) with "peau d\'orange" appearance'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-78',
    label: 'Impetigo',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Impetigo'],
    pathognomonic: 'Golden or honey-colored crusts overlying a superficial erosion',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Swab for Gram stain and Culture (if MRSA suspected)'],
    ddx: ['Herpes Simplex', 'Varicella', 'Contact Dermatitis', 'Tinea Corporis'],
    positiveSigns: ['Honey-colored crusted lesions', 'Usually on face (around nose/mouth) or extremities in children'],
    negativeSigns: ['Absence of systemic toxicity/fever', 'Absence of deep scarring'],
    definitiveTreatment: 'Topical Mupirocin 2% ointment OR Oral Cephalexin/Amoxicillin-Clavulanate (if widespread)',
    supportiveTreatment: 'Gentle washing with soap and water to remove crusts, good hand hygiene',
    redFlags: ['Golden or honey-colored crusts overlying a superficial erosion'],
    cautions: [],
    meds: [
      mk('T-Bact Ointment', 'Mupirocin 2%', 'Apply locally TDS', 'Apply locally TDS', '7', 'लावण्यासाठी'),
      mk('Augmentin Duo Syrup', 'Amoxicillin + Clavulanic Acid', 'As per weight BD', 'As per weight BD', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-79',
    label: 'Folliculitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Folliculitis'],
    pathognomonic: 'Superficial pustules pierced by a hair',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Pus swab for culture (if recurrent/refractory)'],
    ddx: ['Acne Vulgaris', 'Pseudofolliculitis Barbae', 'Furunculosis', 'Candidiasis'],
    positiveSigns: ['Multiple small pustules centered around hair follicles', 'Mild pruritus or tenderness'],
    negativeSigns: ['Absence of deep abscess formation', 'Absence of systemic fever'],
    definitiveTreatment: 'Topical Antibiotics (Mupirocin or Clindamycin gel) OR Antibacterial soap (Chlorhexidine)',
    supportiveTreatment: 'Avoid shaving the affected area, wear loose clothing, warm compresses',
    redFlags: ['Superficial pustules pierced by a hair'],
    cautions: ['Avoid shaving the affected area'],
    meds: [
      mk('Clindac A Gel', 'Clindamycin 1%', 'Apply locally BD', 'Apply locally BD', '7', 'लावण्यासाठी'),
      mk('Savlon Soap', 'Chlorhexidine', 'Use for bathing', 'Use for bathing', 'Routine', 'आंघोळीसाठी'),
    ],
  },
  {
    id: 'ac-80',
    label: 'Furunculosis (Boil)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Furunculosis (Boil)', 'Boil', 'Furunculosis'],
    pathognomonic: 'Deep-seated inflammatory nodule developing around a hair follicle with a central pustule',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Pus culture and sensitivity (to check for MRSA)'],
    ddx: ['Epidermoid Cyst (infected)', 'Carbuncle', 'Hidradenitis Suppurativa', 'Sporotrichosis'],
    positiveSigns: ['Tender, erythematous, firm nodule that becomes fluctuant', 'Central necrotic plug (pus pointing)'],
    negativeSigns: ['Absence of multiple interconnected draining sinuses', 'Absence of massive systemic toxicity'],
    definitiveTreatment: 'Incision and Drainage (I&D) once fluctuant + Oral Antibiotics (e.g., Amoxicillin-Clavulanate or Linezolid if MRSA)',
    supportiveTreatment: 'Warm compresses to promote pointing, good personal hygiene',
    redFlags: ['Deep-seated inflammatory nodule developing around a hair follicle with a central pustule'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('LNZ 600', 'Linezolid', '1 - 0 - 1 (if MRSA suspected)', '1 - 0 - 1 (if MRSA suspected)', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-81',
    label: 'Carbuncle',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Carbuncle'],
    pathognomonic: 'Coalescence of multiple furuncles with multiple sieve-like draining sinuses, typically on the nape of the neck',
    definitiveTest: 'Clinical diagnosis + Pus Culture',
    supportiveTests: ['Fasting Blood Sugar / HbA1c (crucial to check for underlying Diabetes)', 'CBC'],
    ddx: ['Furuncle', 'Anthrax (Eschar)', 'Deep Fungal Infection', 'Actinomycosis'],
    positiveSigns: ['Large, extremely painful, indurated inflammatory mass', 'Multiple draining sinus tracts discharging pus'],
    negativeSigns: ['Absence of superficial, easily ruptured vesicles', 'Absence of normal blood sugar (highly associated with Diabetes)'],
    definitiveTreatment: 'Cruciate Incision and Drainage + Systemic IV/Oral Antibiotics (covering Staph/MRSA)',
    supportiveTreatment: 'Strict glycemic control, daily wound dressing, pain management',
    redFlags: ['Coalescence of multiple furuncles with multiple sieve-like draining sinuses, typically on the nape of the neck'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-82',
    label: 'Anthrax',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Anthrax'],
    pathognomonic: 'Painless, necrotic black eschar with extensive non-pitting edema',
    definitiveTest: 'Culture of vesicular fluid/blood (Gram-positive, spore-forming rods, "Medusa head" colonies)',
    supportiveTests: ['PCR for B. anthracis', 'Chest X-ray (for inhalational)'],
    ddx: ['Scrub Typhus (Eschar)', 'Brown Recluse Spider Bite', 'Tularemia', 'Plague'],
    positiveSigns: ['Painless black eschar with massive surrounding edema (Cutaneous)', 'Widened mediastinum on X-ray (Inhalational)'],
    negativeSigns: ['Absence of pain in the cutaneous ulcer', 'Absence of purulent exudate'],
    definitiveTreatment: 'Ciprofloxacin 500mg BD OR Doxycycline 100mg BD for 60 days (for bioterrorism/inhalational)',
    supportiveTreatment: 'Raxibacumab (antitoxin) if available, supportive ICU care for inhalational',
    redFlags: ['supportive ICU care for inhalational'],
    cautions: [],
    meds: [
      mk('Ciplox 500', 'Ciprofloxacin', '1 - 0 - 1', '1 - 0 - 1', '60', 'जेवणानंतर'),
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '60', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-83',
    label: 'Plague',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Plague'],
    pathognomonic: 'Exquisitely tender bubo with history of flea bite or rodent exposure',
    definitiveTest: 'Aspirate of bubo for Gram stain (Gram-negative coccobacilli with "Safety pin" appearance) and Culture',
    supportiveTests: ['Rapid diagnostic test (F1 antigen)', 'Blood Culture'],
    ddx: ['Tularemia', 'Lymphogranuloma Venereum (LGV)', 'Chancroid', 'Cat-scratch disease'],
    positiveSigns: ['Extremely painful, swollen lymph node (Bubo) usually in groin/axilla', 'Sudden onset high fever and extreme exhaustion'],
    negativeSigns: ['Absence of painless ulcer', 'Absence of gradual onset'],
    definitiveTreatment: 'Streptomycin 1g IM BD OR Gentamicin IV OR Doxycycline 100mg BD',
    supportiveTreatment: 'Strict isolation (especially for pneumonic plague), notify public health authorities',
    redFlags: ['Exquisitely tender bubo with history of flea bite or rodent exposure'],
    cautions: [],
    meds: [
      mk('Ambistryn-S', 'Streptomycin', '1g IM BD', '1g IM BD', '10', 'Inj. (Hospital Use) (Inj.)'),
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-84',
    label: 'Q Fever',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Q Fever'],
    pathognomonic: 'Pneumonia + Hepatitis + Culture-negative endocarditis with livestock exposure',
    definitiveTest: 'Serology (IFA for Phase I and Phase II antibodies to Coxiella burnetii)',
    supportiveTests: ['PCR of blood or tissue', 'Echocardiography (if endocarditis suspected)'],
    ddx: ['Brucellosis', 'Legionnaires\' Disease', 'Mycoplasma Pneumonia', 'Viral Hepatitis'],
    positiveSigns: ['High fever, severe headache, and atypical pneumonia', 'Hepatitis (elevated transaminases)'],
    negativeSigns: ['Absence of rash (usually)', 'Absence of positive routine blood cultures (Culture-negative endocarditis)'],
    definitiveTreatment: 'Doxycycline 100mg BD for 14 days (Acute); Doxycycline + Hydroxychloroquine for 18 months (Chronic/Endocarditis)',
    supportiveTreatment: 'Antipyretics, monitor liver enzymes and cardiac function',
    redFlags: ['Pneumonia + Hepatitis + Culture-negative endocarditis with livestock exposure'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('HCQS 200', 'Hydroxychloroquine', '1 - 0 - 1 (if chronic)', '1 - 0 - 1 (if chronic)', 'Months', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-85',
    label: 'Lyme Disease',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Lyme Disease'],
    pathognomonic: 'Erythema migrans rash following a tick bite',
    definitiveTest: 'Two-tier testing: ELISA followed by Western Blot',
    supportiveTests: ['Joint fluid analysis (if Lyme arthritis)'],
    ddx: ['Cellulitis', 'Rheumatoid Arthritis', 'Syphilis', 'Fibromyalgia'],
    positiveSigns: ['Erythema migrans (expanding bullseye rash)', 'Facial nerve palsy (Bell\'s palsy) or arthritis'],
    negativeSigns: ['Absence of necrotic eschar', 'Absence of severe hemorrhagic manifestations'],
    definitiveTreatment: 'Doxycycline 100mg BD for 14-21 days',
    supportiveTreatment: 'NSAIDs for joint pain, tick bite prevention education',
    redFlags: ['tick bite prevention education'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-86',
    label: 'Rocky Mountain Spotted Fever',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Rocky Mountain Spotted Fever'],
    pathognomonic: 'Centripetally spreading rash that involves palms and soles after tick exposure',
    definitiveTest: 'Indirect Immunofluorescence Assay (IFA) for Rickettsia rickettsii',
    supportiveTests: ['CBC (Thrombocytopenia)', 'LFT (Elevated transaminases)'],
    ddx: ['Meningococcemia', 'Syphilis (Secondary)', 'Measles', 'Dengue'],
    positiveSigns: ['High fever and severe headache', 'Maculopapular rash starting on wrists/ankles and spreading centrally'],
    negativeSigns: ['Absence of painless ulcer', 'Absence of initial truncal rash'],
    definitiveTreatment: 'Doxycycline 100mg BD for 7-14 days (Start empirically, do not wait for labs)',
    supportiveTreatment: 'IV fluids, intensive care for severe cases',
    redFlags: ['Centripetally spreading rash that involves palms and soles after tick exposure'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-87',
    label: 'Psittacosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Psittacosis'],
    pathognomonic: 'Severe atypical pneumonia with hepatosplenomegaly and bird exposure',
    definitiveTest: 'Microimmunofluorescence (MIF) test',
    supportiveTests: ['Chest X-ray (Patchy infiltrates)', 'LFT (Elevated enzymes)'],
    ddx: ['Mycoplasma Pneumonia', 'Legionnaires\' Disease', 'Q Fever', 'Viral Pneumonia'],
    positiveSigns: ['Atypical pneumonia symptoms (dry cough, fever)', 'History of exposure to birds (parrots, pigeons)'],
    negativeSigns: ['Absence of copious purulent sputum', 'Absence of typical lobar consolidation'],
    definitiveTreatment: 'Doxycycline 100mg BD for 14-21 days',
    supportiveTreatment: 'Oxygen therapy if hypoxic, antipyretics',
    redFlags: ['Severe atypical pneumonia with hepatosplenomegaly and bird exposure'],
    cautions: [],
    meds: [
      mk('Doxypal 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-88',
    label: 'Histoplasmosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Histoplasmosis'],
    pathognomonic: 'Small yeast cells within macrophages on bone marrow or tissue biopsy',
    definitiveTest: 'Histoplasma urine or serum antigen enzyme immunoassay (EIA)',
    supportiveTests: ['Fungal culture (takes weeks)', 'Chest X-ray (calcified granulomas)'],
    ddx: ['Tuberculosis', 'Sarcoidosis', 'Pneumocystis Pneumonia (PCP)', 'Lymphoma'],
    positiveSigns: ['Pulmonary infiltrates with hilar lymphadenopathy', 'Exposure to bat or bird droppings (caves, coops)'],
    negativeSigns: ['Absence of rapid cavitation (usually)', 'Absence of response to antibacterial drugs'],
    definitiveTreatment: 'Itraconazole 200mg TDS for 3 days, then BD for weeks/months (Mild/Moderate); Liposomal Amphotericin B (Severe)',
    supportiveTreatment: 'Monitor liver enzymes during azole therapy, treat underlying immunosuppression',
    redFlags: ['Small yeast cells within macrophages on bone marrow or tissue biopsy'],
    cautions: [],
    meds: [
      mk('Itramac 200', 'Itraconazole', '1 - 0 - 1', '1 - 0 - 1', '90', 'जेवणानंतर'),
      mk('AmBisome', 'Liposomal Amphotericin B', 'IV OD (if severe)', 'IV OD (if severe)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-89',
    label: 'Aspergillosis (Invasive)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Aspergillosis (Invasive)', 'Invasive', 'Aspergillosis'],
    pathognomonic: '"Halo sign" (nodule with surrounding ground-glass opacity) or "Air crescent sign" on HRCT Chest',
    definitiveTest: 'Serum or BAL Galactomannan assay + Fungal Culture',
    supportiveTests: ['HRCT Chest', 'Tissue biopsy showing acutely branching septate hyphae'],
    ddx: ['Mucormycosis', 'Pulmonary Embolism', 'Tuberculosis', 'Bacterial Abscess'],
    positiveSigns: ['Pleuritic chest pain and hemoptysis', 'Occurs in severely neutropenic or immunocompromised patients'],
    negativeSigns: ['Absence of response to broad-spectrum antibiotics', 'Absence of normal WBC count (usually neutropenic)'],
    definitiveTreatment: 'Voriconazole (IV followed by oral) is the drug of choice',
    supportiveTreatment: 'Reversal of immunosuppression (e.g., G-CSF for neutropenia), surgical resection of aspergilloma if massive hemoptysis',
    redFlags: ['"Halo sign" (nodule with surrounding ground-glass opacity) or "Air crescent sign" on HRCT Chest'],
    cautions: [],
    meds: [
      mk('Voritrol 200', 'Voriconazole', '1 - 0 - 1', '1 - 0 - 1', '42', 'जेवणानंतर'),
      mk('AmBisome', 'Liposomal Amphotericin B', 'IV OD (Alternative)', 'IV OD (Alternative)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-90',
    label: 'Mucormycosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Mucormycosis'],
    pathognomonic: 'Broad, non-septate hyphae branching at right angles (90 degrees) on KOH mount/biopsy',
    definitiveTest: 'Tissue biopsy with histopathology and fungal culture',
    supportiveTests: ['MRI PNS and Brain (to assess extent of invasion)', 'Blood Sugar/Ketones'],
    ddx: ['Invasive Aspergillosis', 'Orbital Cellulitis', 'Cavernous Sinus Thrombosis', 'Wegener\'s Granulomatosis'],
    positiveSigns: ['Black necrotic eschar on nasal turbinates or hard palate', 'Severe unilateral facial pain and swelling'],
    negativeSigns: ['Absence of slow progression (highly fulminant and rapid)', 'Absence of normal blood sugar (classic in DKA)'],
    definitiveTreatment: 'EMERGENCY Surgical Debridement + Liposomal Amphotericin B (High dose)',
    supportiveTreatment: 'Strict control of blood sugar and ketoacidosis, step down to Posaconazole/Isavuconazole',
    redFlags: ['Broad, non-septate hyphae branching at right angles (90 degrees) on KOH mount/biopsy'],
    cautions: [],
    meds: [
      mk('AmBisome', 'Liposomal Amphotericin B', 'IV OD (High Dose)', 'IV OD (High Dose)', '28', 'Inj. (Hospital Use) (Inj.)'),
      mk('Posaforce 300', 'Posaconazole', '1 - 0 - 0', '1 - 0 - 0', '60', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-91',
    label: 'Cryptosporidiosis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Cryptosporidiosis'],
    pathognomonic: 'Intractable watery diarrhea in an HIV patient with CD4 < 100',
    definitiveTest: 'Modified Acid-Fast Stain of stool showing red oocysts',
    supportiveTests: ['Stool Antigen EIA', 'Stool PCR'],
    ddx: ['Microsporidiosis', 'Cystoisosporiasis', 'Giardiasis', 'CMV Colitis'],
    positiveSigns: ['Profuse, watery, non-bloody diarrhea', 'Profound weight loss in immunocompromised (e.g., HIV/AIDS)'],
    negativeSigns: ['Absence of bloody stool', 'Absence of high fever'],
    definitiveTreatment: 'Nitazoxanide 500mg BD for 3 days (in immunocompetent); ART initiation is crucial in HIV',
    supportiveTreatment: 'Aggressive fluid and electrolyte replacement, anti-motility agents (Loperamide)',
    redFlags: ['Intractable watery diarrhea in an HIV patient with CD4 < 100'],
    cautions: [],
    meds: [
      mk('Nizonide 500', 'Nitazoxanide', '1 - 0 - 1', '1 - 0 - 1', '3', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'Ad libitum', 'Ad libitum', '5', 'सतत पीत राहा'),
    ],
  },
  {
    id: 'ac-92',
    label: 'Legionellosis (Legionnaires\' Disease)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Legionellosis (Legionnaires\' Disease)', 'Legionnaires\' Disease', 'Legionellosis'],
    pathognomonic: 'Pneumonia + Diarrhea + Confusion + Hyponatremia',
    definitiveTest: 'Legionella Urinary Antigen Test (detects Serogroup 1)',
    supportiveTests: ['Sputum culture on BCYE agar', 'Serum Electrolytes (Hyponatremia)'],
    ddx: ['Mycoplasma Pneumonia', 'Pneumococcal Pneumonia', 'Viral Pneumonia', 'Q Fever'],
    positiveSigns: ['Atypical pneumonia with prominent GI symptoms (diarrhea, nausea)', 'Neurological signs (confusion, lethargy)'],
    negativeSigns: ['Absence of organisms on standard Gram stain of sputum', 'Absence of response to beta-lactams'],
    definitiveTreatment: 'Azithromycin 500mg OD OR Levofloxacin 750mg OD for 7-14 days',
    supportiveTreatment: 'Oxygen therapy, correct electrolyte imbalances (sodium)',
    redFlags: ['Pneumonia + Diarrhea + Confusion + Hyponatremia'],
    cautions: [],
    meds: [
      mk('Loxof 750', 'Levofloxacin', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-93',
    label: 'Chikungunya Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Chikungunya Fever'],
    pathognomonic: 'Stooped posture due to severe joint pain ("that which bends up") with fever',
    definitiveTest: 'Chikungunya IgM ELISA (after day 5) or RT-PCR (early)',
    supportiveTests: ['CBC (Mild lymphopenia)', 'CRP (Elevated)'],
    ddx: ['Dengue Fever', 'Zika Virus', 'Rheumatoid Arthritis', 'Malaria'],
    positiveSigns: ['Severe, debilitating, symmetric polyarthralgia', 'High fever and maculopapular rash'],
    negativeSigns: ['Absence of severe thrombocytopenia or bleeding (unlike Dengue)', 'Absence of purulent joint effusion'],
    definitiveTreatment: 'Self-limiting; purely supportive',
    supportiveTreatment: 'NSAIDs (Ibuprofen/Naproxen) for severe joint pain, Paracetamol for fever, hydration',
    redFlags: ['Stooped posture due to severe joint pain ("that which bends up") with fever'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Lornoxi 8', 'Lornoxicam', '1 - 0 - 1 (for joint pain)', '1 - 0 - 1 (for joint pain)', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-94',
    label: 'Zika Virus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Zika Virus Infection'],
    pathognomonic: 'Mild dengue-like illness with conjunctivitis; causes Microcephaly in neonates if infected during pregnancy',
    definitiveTest: 'Zika Virus RT-PCR (blood or urine)',
    supportiveTests: ['Zika IgM ELISA (cross-reacts with Dengue)'],
    ddx: ['Dengue Fever', 'Chikungunya', 'Rubella', 'Measles'],
    positiveSigns: ['Low-grade fever, maculopapular rash, and non-purulent conjunctivitis', 'Mild arthralgia'],
    negativeSigns: ['Absence of severe, debilitating joint pain (unlike Chikungunya)', 'Absence of hemorrhagic signs'],
    definitiveTreatment: 'Self-limiting; supportive care',
    supportiveTreatment: 'Rest, hydration, Paracetamol. Avoid NSAIDs until Dengue is ruled out. Pregnant women need fetal USG monitoring.',
    redFlags: ['Mild dengue-like illness with conjunctivitis; causes Microcephaly in neonates if infected during pregnancy'],
    cautions: ['Avoid NSAIDs until Dengue is ruled out'],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'Ad libitum', 'Ad libitum', '3', 'सतत पीत राहा'),
    ],
  },
  {
    id: 'ac-95',
    label: 'Kyasanur Forest Disease (KFD)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Kyasanur Forest Disease (KFD)', 'KFD', 'Kyasanur Forest Disease'],
    pathognomonic: 'Biphasic hemorrhagic fever in a forest worker/farmer from the Western Ghats (Karnataka) after tick exposure',
    definitiveTest: 'KFD RT-PCR (blood) or KFD IgM ELISA',
    supportiveTests: ['CBC (Leucopenia, Thrombocytopenia)', 'LFT (Elevated transaminases)'],
    ddx: ['Dengue Hemorrhagic Fever', 'Scrub Typhus', 'Leptospirosis', 'Malaria'],
    positiveSigns: ['Sudden onset high fever, frontal headache, and severe myalgia', 'Hemorrhagic manifestations (bleeding gums, epistaxis)'],
    negativeSigns: ['Absence of eschar (unlike Scrub Typhus)', 'Absence of urban transmission (strictly forest/rural)'],
    definitiveTreatment: 'No specific antiviral; purely supportive',
    supportiveTreatment: 'Strict fluid management, blood/platelet transfusion if bleeding occurs, analgesics',
    redFlags: ['Biphasic hemorrhagic fever in a forest worker/farmer from the Western Ghats (Karnataka) after tick exposure'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '5', 'जेवणानंतर'),
      mk('IV Fluids', 'Normal Saline / RL', 'As required', 'As required', '5', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-96',
    label: 'Nipah Virus Encephalitis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Nipah Virus Encephalitis'],
    pathognomonic: 'Rapidly fatal encephalitis and respiratory failure with history of exposure to bats or infected pigs',
    definitiveTest: 'Nipah Virus RT-PCR (throat swab, CSF, urine, blood) - usually done at NIV Pune',
    supportiveTests: ['MRI Brain (Multiple small asymmetric lesions in subcortical white matter)'],
    ddx: ['Japanese Encephalitis', 'Rabies', 'Herpes Simplex Encephalitis', 'Severe COVID-19'],
    positiveSigns: ['Acute rapidly progressive encephalitis', 'Severe atypical pneumonia / ARDS'],
    negativeSigns: ['Absence of rash', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'Supportive intensive care; Ribavirin is sometimes used but efficacy is unproven',
    supportiveTreatment: 'Strict barrier nursing (high human-to-human transmission risk), mechanical ventilation, anti-epileptics',
    redFlags: ['mechanical ventilation'],
    cautions: [],
    meds: [
      mk('Ribavirin 200', 'Ribavirin', 'As per protocol', 'As per protocol', '10', 'डॉक्टरांच्या सल्ल्याने'),
      mk('Eptoin 100', 'Phenytoin', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-97',
    label: 'Crimean-Congo Hemorrhagic Fever (CCHF)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Crimean-Congo Hemorrhagic Fever (CCHF)', 'CCHF', 'Crimean-Congo Hemorrhagic Fever'],
    pathognomonic: 'Massive bleeding with profound thrombocytopenia and transaminitis following livestock/tick exposure',
    definitiveTest: 'CCHF RT-PCR or IgM ELISA',
    supportiveTests: ['CBC (Profound thrombocytopenia and leucopenia)', 'Coagulation profile (Prolonged PT/aPTT)'],
    ddx: ['Dengue Hemorrhagic Fever', 'KFD', 'Leptospirosis', 'Ebola/Marburg (if travel history)'],
    positiveSigns: ['Severe hemorrhagic manifestations (ecchymosis, melena, hematemesis)', 'History of tick bite or crushing ticks on livestock'],
    negativeSigns: ['Absence of prominent respiratory symptoms', 'Absence of eschar'],
    definitiveTreatment: 'Oral or IV Ribavirin (started early)',
    supportiveTreatment: 'Aggressive blood product replacement (Platelets, FFP, PRBCs), strict isolation',
    redFlags: ['Massive bleeding with profound thrombocytopenia and transaminitis following livestock/tick exposure'],
    cautions: [],
    meds: [
      mk('Ribavirin 200', 'Ribavirin', 'Loading dose followed by maintenance', 'Loading dose followed by maintenance', '10', 'डॉक्टरांच्या सल्ल्याने'),
      mk('Tranostat', 'Tranexamic Acid', 'IV TDS', 'IV TDS', '5', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-98',
    label: 'Melioidosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Melioidosis'],
    pathognomonic: 'Disseminated abscesses with "safety pin" appearance of Burkholderia pseudomallei on Gram stain',
    definitiveTest: 'Culture of blood, pus, or sputum (Ashdown\'s agar)',
    supportiveTests: ['USG/CT Abdomen (showing "honeycomb" or "Swiss cheese" abscesses in liver/spleen)'],
    ddx: ['Tuberculosis', 'Staphylococcal Sepsis', 'Amoebic Liver Abscess', 'Klebsiella infection'],
    positiveSigns: ['Multiple abscesses (lungs, liver, spleen, prostate)', 'Fever in a diabetic patient exposed to soil/water (e.g., paddy farmer)'],
    negativeSigns: ['Absence of response to standard empirical antibiotics (like Ceftriaxone)', 'Absence of sterile cultures'],
    definitiveTreatment: 'Intensive phase: IV Ceftazidime or Meropenem for 10-14 days. Eradication phase: Oral Cotrimoxazole for 3-6 months.',
    supportiveTreatment: 'Surgical drainage of large abscesses, strict glycemic control',
    redFlags: ['Disseminated abscesses with "safety pin" appearance of Burkholderia pseudomallei on Gram stain'],
    cautions: [],
    meds: [
      mk('Tazid 1g', 'Ceftazidime', '1g', 'IV TDS', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Septran DS', 'Cotrimoxazole', '1 - 0 - 1', '1 - 0 - 1', '90', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-99',
    label: 'Rhinosporidiosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Rhinosporidiosis'],
    pathognomonic: 'Strawberry-like nasal mass that bleeds easily on touch, often with history of bathing in stagnant ponds',
    definitiveTest: 'Histopathology of excised mass (shows large sporangia filled with endospores)',
    supportiveTests: ['Clinical appearance is highly suggestive'],
    ddx: ['Nasal Polyps (Allergic)', 'Inverted Papilloma', 'Hemangioma', 'Squamous Cell Carcinoma'],
    positiveSigns: ['Friable, vascular, strawberry-like polyp in the nasal cavity', 'Epistaxis (nosebleed) and nasal obstruction'],
    negativeSigns: ['Absence of pain (usually painless)', 'Absence of systemic fever'],
    definitiveTreatment: 'Wide surgical excision with electrocautery of the base',
    supportiveTreatment: 'Oral Dapsone for several months post-surgery to prevent recurrence',
    redFlags: ['Oral Dapsone for several months post-surgery to prevent recurrence'],
    cautions: [],
    meds: [
      mk('Dapsone 100', 'Dapsone', '1 - 0 - 0', '1 - 0 - 0', '180', 'जेवणानंतर'),
      mk('Otrivin', 'Xylometazoline', 'SOS for bleeding', 'SOS for bleeding', '3', 'नाकात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-100',
    label: 'Mycetoma (Madura Foot)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Mycetoma (Madura Foot)', 'Madura Foot', 'Mycetoma'],
    pathognomonic: 'Classic triad: Tumefaction (swelling), Draining sinuses, and Macroscopic grains in exudate',
    definitiveTest: 'Deep tissue biopsy and culture of the grains (to differentiate Actinomycetoma from Eumycetoma)',
    supportiveTests: ['X-ray of the affected part (shows bone destruction/cavities in late stages)', 'KOH mount of grains'],
    ddx: ['Chronic Osteomyelitis', 'Tuberculosis of bone', 'Squamous Cell Carcinoma', 'Kaposi Sarcoma'],
    positiveSigns: ['Painless, massive, indurated swelling of the foot', 'Multiple discharging sinuses extruding colored grains'],
    negativeSigns: ['Absence of acute systemic toxicity/fever', 'Absence of rapid progression (takes years)'],
    definitiveTreatment: 'Actinomycetoma: Welsh regimen (Amikacin + Cotrimoxazole). Eumycetoma: Itraconazole + Surgical excision.',
    supportiveTreatment: 'Prolonged therapy (months to years), amputation in severe refractory cases',
    redFlags: ['Classic triad: Tumefaction (swelling), Draining sinuses, and Macroscopic grains in exudate'],
    cautions: [],
    meds: [
      mk('Septran DS', 'Cotrimoxazole', '1 - 0 - 1', '1 - 0 - 1', 'Months', 'जेवणानंतर'),
      mk('Itramac 200', 'Itraconazole', '1 - 0 - 1 (if Eumycetoma)', '1 - 0 - 1 (if Eumycetoma)', 'Months', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-101',
    label: 'Hepatitis C',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Hepatitis C'],
    pathognomonic: 'Often silent until cirrhosis develops (spider angiomas, palmar erythema)',
    definitiveTest: 'HCV RNA PCR (Quantitative)',
    supportiveTests: ['Anti-HCV Antibodies', 'Liver Function Test (fluctuating ALT)', 'FibroScan'],
    ddx: ['Hepatitis B', 'Autoimmune Hepatitis', 'Alcoholic Liver Disease', 'NASH'],
    positiveSigns: ['Chronic fatigue', 'Mild right upper quadrant discomfort'],
    negativeSigns: ['Often asymptomatic in acute phase', 'Absence of high fever'],
    definitiveTreatment: 'Direct-Acting Antivirals (DAAs) like Sofosbuvir + Velpatasvir for 12 weeks',
    supportiveTreatment: 'Abstinence from alcohol, Hepatitis A and B vaccination',
    redFlags: ['Often silent until cirrhosis develops (spider angiomas, palmar erythema)'],
    cautions: [],
    meds: [
      mk('Velpanat', 'Sofosbuvir + Velpatasvir', '1 - 0 - 0', '1 - 0 - 0', '84', 'जेवणानंतर'),
      mk('Hepcvel', 'Sofosbuvir + Velpatasvir', '1 - 0 - 0', '1 - 0 - 0', '84', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-102',
    label: 'Acute Retroviral Syndrome (HIV)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Acute Retroviral Syndrome (HIV)', 'HIV', 'Acute Retroviral Syndrome'],
    pathognomonic: 'Mononucleosis-like illness 2-4 weeks post high-risk exposure',
    definitiveTest: 'HIV-1/2 Antigen/Antibody Combo Assay (4th Gen ELISA) & HIV RNA PCR',
    supportiveTests: ['CD4 Count', 'CBC (Atypical lymphocytes, leukopenia)'],
    ddx: ['Infectious Mononucleosis (EBV)', 'Secondary Syphilis', 'CMV Infection', 'Toxoplasmosis'],
    positiveSigns: ['Fever, sore throat, and generalized lymphadenopathy', 'Maculopapular rash on trunk'],
    negativeSigns: ['Absence of exudative tonsillitis (differentiates from Strep)', 'Absence of significant jaundice'],
    definitiveTreatment: 'Antiretroviral Therapy (ART) - e.g., Tenofovir + Lamivudine + Dolutegravir (TLD regimen)',
    supportiveTreatment: 'Symptomatic relief for fever and sore throat, counseling',
    redFlags: ['Mononucleosis-like illness 2-4 weeks post high-risk exposure'],
    cautions: [],
    meds: [
      mk('Instgra', 'Dolutegravir', '1 - 0 - 0', '1 - 0 - 0', '30', 'जेवणानंतर'),
      mk('Tenvir-EM', 'Tenofovir + Emtricitabine', '1 - 0 - 0', '1 - 0 - 0', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-103',
    label: 'Cytomegalovirus (CMV) Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Cytomegalovirus (CMV) Infection', 'CMV', 'Cytomegalovirus Infection'],
    pathognomonic: 'Owl\'s eye inclusion bodies on tissue biopsy (in severe/immunocompromised cases)',
    definitiveTest: 'CMV DNA PCR (Quantitative)',
    supportiveTests: ['CMV IgM and IgG', 'CBC (relative lymphocytosis with atypical lymphocytes)'],
    ddx: ['Epstein-Barr Virus (EBV)', 'Acute HIV infection', 'Toxoplasmosis', 'Viral Hepatitis'],
    positiveSigns: ['Prolonged fever and profound fatigue', 'Mild hepatitis and lymphadenopathy'],
    negativeSigns: ['Heterophile antibody test is negative (unlike EBV)', 'Absence of severe pharyngitis'],
    definitiveTreatment: 'Usually self-limiting in immunocompetent. Valganciclovir for severe/immunocompromised cases.',
    supportiveTreatment: 'Rest, hydration, antipyretics',
    redFlags: ['Owl\'s eye inclusion bodies on tissue biopsy (in severe/immunocompromised cases)'],
    cautions: [],
    meds: [
      mk('Valcyte 450', 'Valganciclovir', '1 - 0 - 1', '1 - 0 - 1', '21', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-104',
    label: 'Infectious Mononucleosis (EBV)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Infectious Mononucleosis (EBV)', 'EBV', 'Infectious Mononucleosis'],
    pathognomonic: 'Classic triad: Fever, Pharyngitis, Lymphadenopathy + Heterophile antibodies',
    definitiveTest: 'Monospot test (Heterophile antibody test) or EBV specific antibodies (VCA IgM)',
    supportiveTests: ['CBC (>50% lymphocytes with >10% atypical lymphocytes)', 'LFT (mildly elevated transaminases)'],
    ddx: ['Streptococcal Pharyngitis', 'CMV Infection', 'Acute HIV', 'Toxoplasmosis'],
    positiveSigns: ['Severe exudative pharyngitis/tonsillitis', 'Posterior cervical lymphadenopathy', 'Splenomegaly'],
    negativeSigns: ['Absence of response to standard antibiotics', 'Rash often appears if given ampicillin/amoxicillin'],
    definitiveTreatment: 'Supportive care only; no specific antiviral is highly effective',
    supportiveTreatment: 'Rest, hydration, NSAIDs for pain/fever. Avoid contact sports (risk of splenic rupture).',
    redFlags: ['Classic triad: Fever, Pharyngitis, Lymphadenopathy + Heterophile antibodies'],
    cautions: ['Avoid contact sports (risk of splenic rupture)'],
    meds: [
      mk('Brufen 400', 'Ibuprofen', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Betadine Gargle', 'Povidone Iodine', 'TDS', 'TDS', '5', 'गुळण्या करण्यासाठी'),
    ],
  },
  {
    id: 'ac-105',
    label: 'Rotavirus Diarrhea',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Rotavirus Diarrhea'],
    pathognomonic: 'Severe dehydrating watery diarrhea in unvaccinated children < 5 years',
    definitiveTest: 'Stool enzyme immunoassay (EIA) for Rotavirus antigen',
    supportiveTests: ['Serum electrolytes (to check for hyper/hyponatremia)', 'Stool routine (no RBCs/WBCs)'],
    ddx: ['Norovirus', 'Adenovirus enteritis', 'Cholera', 'E. coli gastroenteritis'],
    positiveSigns: ['Watery, non-bloody diarrhea in infants/children', 'Vomiting preceding diarrhea'],
    negativeSigns: ['Absence of blood or mucus in stool', 'Absence of high-grade sustained fever'],
    definitiveTreatment: 'Self-limiting; focus entirely on rehydration',
    supportiveTreatment: 'Aggressive ORS, IV fluids if severe dehydration, Zinc supplementation for 14 days',
    redFlags: ['Severe dehydrating watery diarrhea in unvaccinated children < 5 years'],
    cautions: [],
    meds: [
      mk('Electral', 'ORS', 'After every loose stool', 'After every loose stool', '5', 'जेव्हा तहान लागेल'),
      mk('Z&D Drops/Syrup', 'Zinc Sulfate', '1 - 0 - 0', '1 - 0 - 0', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-106',
    label: 'Norovirus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Norovirus Infection'],
    pathognomonic: 'Explosive outbreaks of gastroenteritis in closed communities (cruise ships, schools)',
    definitiveTest: 'RT-PCR of stool or vomitus (usually reserved for outbreak investigation)',
    supportiveTests: ['Clinical diagnosis usually sufficient', 'Electrolytes if severely dehydrated'],
    ddx: ['Rotavirus', 'Food poisoning (Staph aureus/Bacillus cereus)', 'Viral gastroenteritis'],
    positiveSigns: ['Sudden onset of severe, projectile vomiting', 'Watery diarrhea and stomach cramps'],
    negativeSigns: ['Absence of blood in stool', 'Usually short duration (24-72 hours)'],
    definitiveTreatment: 'Self-limiting; no specific antiviral therapy',
    supportiveTreatment: 'Oral rehydration, antiemetics (Ondansetron) if severe vomiting prevents ORS intake',
    redFlags: ['antiemetics (Ondansetron) if severe vomiting prevents ORS intake'],
    cautions: [],
    meds: [
      mk('Emeset 4', 'Ondansetron', 'SOS', 'SOS', '3', 'उलटी आल्यास'),
      mk('Econorm', 'Saccharomyces boulardii', '1 - 0 - 1', '1 - 0 - 1', '5', 'पाण्यातून'),
    ],
  },
  {
    id: 'ac-107',
    label: 'Adenovirus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Adenovirus Infection'],
    pathognomonic: 'Simultaneous upper respiratory tract infection and conjunctivitis',
    definitiveTest: 'Viral culture or PCR from respiratory secretions/conjunctival swab',
    supportiveTests: ['Rapid antigen testing', 'CBC (normal or mild viral picture)'],
    ddx: ['Streptococcal Pharyngitis', 'Influenza', 'Allergic Conjunctivitis', 'RSV'],
    positiveSigns: ['Pharyngoconjunctival fever (sore throat + red eyes)', 'Coryza and cough'],
    negativeSigns: ['Absence of purulent eye discharge (usually watery)', 'Absence of response to antibiotics'],
    definitiveTreatment: 'Supportive care; self-limiting',
    supportiveTreatment: 'Antipyretics, lubricating eye drops, adequate hydration',
    redFlags: ['Simultaneous upper respiratory tract infection and conjunctivitis'],
    cautions: [],
    meds: [
      mk('Crocin 500', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '3', 'जेवणानंतर'),
      mk('Refresh Tears', 'Carboxymethylcellulose', '1 drop QID', '1 drop QID', '7', 'डोळ्यात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-108',
    label: 'Respiratory Syncytial Virus (RSV) / Bronchiolitis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Respiratory Syncytial Virus (RSV) / Bronchiolitis', 'RSV', 'Respiratory Syncytial Virus / Bronchiolitis'],
    pathognomonic: 'First episode of wheezing in a child < 2 years during winter months',
    definitiveTest: 'RSV Rapid Antigen Test or Multiplex PCR from nasopharyngeal swab',
    supportiveTests: ['Pulse Oximetry (to check hypoxia)', 'Chest X-ray (hyperinflation, peribronchial thickening)'],
    ddx: ['Asthma exacerbation', 'Viral pneumonia', 'Foreign body aspiration', 'Croup'],
    positiveSigns: ['Expiratory wheezing in an infant', 'Tachypnea and chest retractions'],
    negativeSigns: ['Absence of high fever', 'Absence of response to bronchodilators (often)'],
    definitiveTreatment: 'Supportive care; Ribavirin only in severely immunocompromised',
    supportiveTreatment: 'Supplemental oxygen if SpO2 < 92%, IV fluids if unable to feed, nasal suctioning',
    redFlags: ['First episode of wheezing in a child < 2 years during winter months'],
    cautions: [],
    meds: [
      mk('Nasivion S', 'Saline Nasal Drops', '2 drops SOS', '2 drops SOS', '5', 'नाक बंद असल्यास'),
      mk('Calpol Paediatric', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-109',
    label: 'Croup (Laryngotracheobronchitis)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Croup (Laryngotracheobronchitis)', 'Laryngotracheobronchitis', 'Croup'],
    pathognomonic: 'Steeple sign on AP neck X-ray (subglottic narrowing)',
    definitiveTest: 'Clinical diagnosis; Parainfluenza virus PCR if needed',
    supportiveTests: ['Neck X-ray (AP view)'],
    ddx: ['Acute Epiglottitis', 'Bacterial Tracheitis', 'Foreign body aspiration', 'Laryngomalacia'],
    positiveSigns: ['Barking (seal-like) cough', 'Inspiratory stridor at rest or when agitated'],
    negativeSigns: ['Absence of drooling (differentiates from Epiglottitis)', 'Absence of toxic appearance'],
    definitiveTreatment: 'Single dose of oral or IM Dexamethasone',
    supportiveTreatment: 'Nebulized Adrenaline (Epinephrine) for severe stridor at rest, cool mist/humidified air',
    redFlags: ['Steeple sign on AP neck X-ray (subglottic narrowing)'],
    cautions: [],
    meds: [
      mk('Dexona', 'Dexamethasone', '0.15-0.6 mg/kg single dose', '0.15-0.6 mg/kg single dose', '1', 'Stat'),
      mk('Asthalin Respules', 'Salbutamol (Alternative if wheeze)', 'SOS', 'SOS', '3', 'नेब्युलायझेशन'),
    ],
  },
  {
    id: 'ac-110',
    label: 'Poliomyelitis',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Poliomyelitis'],
    pathognomonic: 'Acute, asymmetric, flaccid paralysis without sensory loss in an unvaccinated child',
    definitiveTest: 'Isolation of Poliovirus from stool samples (2 samples 24h apart)',
    supportiveTests: ['CSF analysis (lymphocytic pleocytosis, normal glucose)', 'EMG (denervation)'],
    ddx: ['Guillain-Barré Syndrome (symmetric)', 'Transverse Myelitis (sensory level present)', 'Traumatic neuritis'],
    positiveSigns: ['Asymmetrical acute flaccid paralysis', 'Decreased or absent deep tendon reflexes'],
    negativeSigns: ['Absence of sensory loss (purely motor)', 'Absence of upper motor neuron signs (no spasticity)'],
    definitiveTreatment: 'No specific antiviral treatment available',
    supportiveTreatment: 'Strict bed rest, analgesics, physical therapy (after acute phase), respiratory support if bulbar involvement',
    redFlags: ['Acute, asymmetric, flaccid paralysis without sensory loss in an unvaccinated child'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'दुखीसाठी'),
      mk('Neurobion Forte', 'B-Complex Vitamins', '1 - 0 - 0', '1 - 0 - 0', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-111',
    label: 'Herpes Zoster (Shingles)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Herpes Zoster (Shingles)', 'Shingles', 'Herpes Zoster'],
    pathognomonic: 'Unilateral, dermatomal, painful vesicular eruption',
    definitiveTest: 'Clinical diagnosis; VZV PCR from vesicle swab if atypical',
    supportiveTests: ['Tzanck smear (shows multinucleated giant cells - not specific to VZV)'],
    ddx: ['Herpes Simplex', 'Contact Dermatitis', 'Cellulitis (before vesicles appear)', 'Coxsackievirus'],
    positiveSigns: ['Painful, unilateral vesicular rash', 'Rash strictly follows a single dermatome'],
    negativeSigns: ['Absence of rash crossing the midline', 'Absence of bilateral involvement'],
    definitiveTreatment: 'Acyclovir 800mg 5 times daily OR Valacyclovir 1g TDS for 7 days (start within 72h)',
    supportiveTreatment: 'Gabapentin or Pregabalin for post-herpetic neuralgia, Calamine lotion, NSAIDs',
    redFlags: ['Unilateral, dermatomal, painful vesicular eruption'],
    cautions: [],
    meds: [
      mk('Valcivir 1000', 'Valacyclovir', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
      mk('Pregalin 50', 'Pregabalin', '0 - 0 - 1', '0 - 0 - 1', '14', 'झोपताना'),
    ],
  },
  {
    id: 'ac-112',
    label: 'Roseola Infantum (Sixth Disease / HHV-6)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Roseola Infantum (Sixth Disease / HHV-6)', 'Sixth Disease / HHV-6', 'Roseola Infantum'],
    pathognomonic: 'Sudden defervescence (fever drops) followed immediately by a rosy pink rash on the trunk',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['CBC (may show relative neutropenia/lymphocytosis)'],
    ddx: ['Measles', 'Rubella', 'Drug eruption', 'Enterovirus infection'],
    positiveSigns: ['High fever (often >40°C) for 3-5 days', 'Maculopapular rash appears *after* fever breaks'],
    negativeSigns: ['Absence of severe toxicity despite high fever', 'Absence of Koplik spots'],
    definitiveTreatment: 'Self-limiting; no antiviral required',
    supportiveTreatment: 'Antipyretics for fever, reassurance to parents (benign course)',
    redFlags: ['Sudden defervescence (fever drops) followed immediately by a rosy pink rash on the trunk'],
    cautions: [],
    meds: [
      mk('Crocin Drops', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
      mk('Meftal-P', 'Mefenamic Acid', 'SOS', 'SOS', '3', 'तीव्र तापासाठी'),
    ],
  },
  {
    id: 'ac-113',
    label: 'Erythema Infectiosum (Fifth Disease / Parvovirus B19)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Erythema Infectiosum (Fifth Disease / Parvovirus B19)', 'Fifth Disease / Parvovirus B19', 'Erythema Infectiosum'],
    pathognomonic: '"Slapped cheek" facial erythema followed by lacy body rash',
    definitiveTest: 'Clinical diagnosis; Parvovirus B19 IgM if needed (e.g., in pregnant contacts)',
    supportiveTests: ['CBC (may show mild anemia or reticulocytopenia)'],
    ddx: ['Rubella', 'Measles', 'Scarlet Fever', 'Systemic Lupus Erythematosus (SLE)'],
    positiveSigns: ['Bright red rash on cheeks ("Slapped cheek" appearance)', 'Lacy, reticular rash on extremities'],
    negativeSigns: ['Absence of high fever (usually mild or no fever)', 'Absence of severe systemic illness in healthy kids'],
    definitiveTreatment: 'Self-limiting; no specific treatment',
    supportiveTreatment: 'Symptomatic relief, avoid sun exposure (can exacerbate rash)',
    redFlags: ['"Slapped cheek" facial erythema followed by lacy body rash'],
    cautions: ['avoid sun exposure (can exacerbate rash)'],
    meds: [
      mk('Calpol', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
      mk('Atarax 10mg', 'Hydroxyzine', '10mg', 'SOS', '3', 'खाज आल्यास'),
    ],
  },
  {
    id: 'ac-114',
    label: 'Molluscum Contagiosum',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Molluscum Contagiosum'],
    pathognomonic: 'Umbilicated, flesh-colored or pearly papules containing caseous material',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Microscopy of expressed core (shows Henderson-Paterson bodies)'],
    ddx: ['Warts (HPV)', 'Varicella', 'Cryptococcosis (in HIV)', 'Basal Cell Carcinoma (if single)'],
    positiveSigns: ['Firm, dome-shaped, pearly papules', 'Central umbilication (dimple in the center)'],
    negativeSigns: ['Absence of pain or severe itching', 'Absence of systemic symptoms'],
    definitiveTreatment: 'Often self-limiting (months to years). Cryotherapy, curettage, or topical Cantharidin.',
    supportiveTreatment: 'Avoid scratching to prevent autoinoculation, topical Salicylic acid or Potassium Hydroxide (KOH) 5%',
    redFlags: ['Avoid scratching to prevent autoinoculation'],
    cautions: ['Avoid scratching to prevent autoinoculation'],
    meds: [
      mk('Molutrex', 'Potassium Hydroxide 5%', 'Apply OD', 'Apply OD', 'Until inflamed', 'फक्त फोडांवर'),
      mk('Salicylix 6%', 'Salicylic Acid', '6%', 'Apply OD', '14', 'फक्त फोडांवर'),
    ],
  },
  {
    id: 'ac-115',
    label: 'Pityriasis Versicolor (Tinea Versicolor)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Pityriasis Versicolor (Tinea Versicolor)', 'Tinea Versicolor', 'Pityriasis Versicolor'],
    pathognomonic: '"Spaghetti and meatballs" appearance on KOH mount',
    definitiveTest: 'KOH mount of skin scrapings',
    supportiveTests: ['Wood\'s lamp examination (shows yellow-green fluorescence)'],
    ddx: ['Vitiligo', 'Pityriasis Alba', 'Seborrheic Dermatitis', 'Secondary Syphilis'],
    positiveSigns: ['Hypopigmented or hyperpigmented macules on chest/back', 'Fine, branny scale upon scraping (Besnier\'s sign)'],
    negativeSigns: ['Absence of severe itching', 'Absence of inflammation/redness'],
    definitiveTreatment: 'Topical Ketoconazole 2% shampoo or Clotrimazole cream',
    supportiveTreatment: 'Oral Itraconazole or Fluconazole for widespread/recurrent cases',
    redFlags: ['"Spaghetti and meatballs" appearance on KOH mount'],
    cautions: [],
    meds: [
      mk('KZ Lotion', 'Ketoconazole 2%', 'Apply and wash after 5 mins', 'Apply and wash after 5 mins', '14', 'आंघोळीच्या वेळी'),
      mk('Canditral 100', 'Itraconazole', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-116',
    label: 'Tinea Pedis (Athlete\'s Foot)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Tinea Pedis (Athlete\'s Foot)', 'Athlete\'s Foot', 'Tinea Pedis'],
    pathognomonic: 'Pruritic, scaling, and maceration in the 4th and 5th toe web spaces',
    definitiveTest: 'KOH mount of skin scrapings (shows branching hyphae)',
    supportiveTests: ['Fungal culture (Sabouraud dextrose agar)'],
    ddx: ['Contact Dermatitis', 'Candidiasis', 'Erythrasma', 'Psoriasis'],
    positiveSigns: ['Maceration and scaling between the toes (web spaces)', 'Intense itching and burning'],
    negativeSigns: ['Absence of systemic symptoms', 'Absence of deep tissue involvement (unless secondary infection)'],
    definitiveTreatment: 'Topical Terbinafine 1% or Luliconazole 1% cream for 2-4 weeks',
    supportiveTreatment: 'Keep feet dry, wear cotton socks, antifungal dusting powder',
    redFlags: ['Pruritic, scaling, and maceration in the 4th and 5th toe web spaces'],
    cautions: [],
    meds: [
      mk('Lulifin', 'Luliconazole 1%', 'Apply OD', 'Apply OD', '14', 'झोपताना'),
      mk('Abzorb Dusting Powder', 'Clotrimazole', 'Apply BD', 'Apply BD', '30', 'पायात मोजे घालण्यापूर्वी'),
    ],
  },
  {
    id: 'ac-117',
    label: 'Tinea Capitis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Tinea Capitis'],
    pathognomonic: 'Scaly patches of hair loss with broken hairs near the scalp surface',
    definitiveTest: 'KOH mount of plucked hairs and scales',
    supportiveTests: ['Wood\'s lamp (Microsporum species fluoresce green)', 'Fungal culture'],
    ddx: ['Alopecia Areata', 'Seborrheic Dermatitis', 'Psoriasis', 'Trichotillomania'],
    positiveSigns: ['Patches of alopecia with scaling', 'Broken hairs ("black dot" appearance) or boggy mass (Kerion)'],
    negativeSigns: ['Absence of scarring (usually non-scarring alopecia)', 'Absence of total baldness'],
    definitiveTreatment: 'Oral Griseofulvin (drug of choice for children) or Oral Terbinafine',
    supportiveTreatment: 'Ketoconazole 2% shampoo twice weekly to reduce shedding of spores',
    redFlags: ['Scaly patches of hair loss with broken hairs near the scalp surface'],
    cautions: [],
    meds: [
      mk('Grisovin FP', 'Griseofulvin', '1 - 0 - 1', '1 - 0 - 1', '42', 'जेवणानंतर (दुधासोबत)'),
      mk('Terbinaforce 250', 'Terbinafine', '1 - 0 - 0', '1 - 0 - 0', '28', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-118',
    label: 'Onychomycosis (Tinea Unguium)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Onychomycosis (Tinea Unguium)', 'Tinea Unguium', 'Onychomycosis'],
    pathognomonic: 'Distal and lateral subungual thickening and discoloration of the nail plate',
    definitiveTest: 'KOH mount and fungal culture of nail clippings/subungual debris',
    supportiveTests: ['PAS stain of nail clippings'],
    ddx: ['Nail Psoriasis', 'Lichen Planus', 'Trauma', 'Candida Paronychia'],
    positiveSigns: ['Thickened, discolored (yellow/brown) nails', 'Subungual hyperkeratosis and nail crumbling'],
    negativeSigns: ['Absence of acute paronychia (redness/swelling of nail fold - more common in Candida)', 'Absence of pitting (seen in psoriasis)'],
    definitiveTreatment: 'Oral Terbinafine 250mg OD for 6 weeks (fingernails) or 12 weeks (toenails)',
    supportiveTreatment: 'Topical Amorolfine 5% nail lacquer applied weekly',
    redFlags: ['Distal and lateral subungual thickening and discoloration of the nail plate'],
    cautions: [],
    meds: [
      mk('Terbinaforce 250', 'Terbinafine', '1 - 0 - 0', '1 - 0 - 0', '84', 'जेवणानंतर'),
      mk('Loceryl Nail Lacquer', 'Amorolfine 5%', 'Apply once a week', 'Apply once a week', 'Months', 'नखांवर'),
    ],
  },
  {
    id: 'ac-119',
    label: 'Sporotrichosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Sporotrichosis'],
    pathognomonic: 'Nodular lymphangitis (sporotrichoid spread) following minor trauma',
    definitiveTest: 'Fungal culture of aspirated pus or tissue biopsy',
    supportiveTests: ['Biopsy showing asteroid bodies (Splendore-Hoeppli phenomenon)'],
    ddx: ['Nontuberculous Mycobacteria (M. marinum)', 'Leishmaniasis', 'Nocardiosis', 'Cat Scratch Disease'],
    positiveSigns: ['Painless papule at site of trauma (often a rose thorn prick)', 'Nodules developing along lymphatic drainage tract'],
    negativeSigns: ['Absence of high fever or systemic toxicity', 'Absence of rapid spread (develops over weeks)'],
    definitiveTreatment: 'Oral Itraconazole 200mg/day for 3-6 months',
    supportiveTreatment: 'Saturated Solution of Potassium Iodide (SSKI) is an older alternative',
    redFlags: ['Nodular lymphangitis (sporotrichoid spread) following minor trauma'],
    cautions: [],
    meds: [
      mk('Canditral 200', 'Itraconazole', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणानंतर'),
      mk('Sporanox', 'Itraconazole', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-120',
    label: 'Chromoblastomycosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Chromoblastomycosis'],
    pathognomonic: 'Presence of Medlar bodies (copper pennies / sclerotic bodies) on KOH or biopsy',
    definitiveTest: 'Skin biopsy or deep scraping showing Medlar bodies',
    supportiveTests: ['Fungal culture (slow growing, dark colonies)'],
    ddx: ['Tuberculosis Verrucosa Cutis', 'Squamous Cell Carcinoma', 'Mycetoma', 'Leishmaniasis'],
    positiveSigns: ['Warty, cauliflower-like plaques on lower limbs', 'Slowly progressive over years'],
    negativeSigns: ['Absence of lymphatic spread (unlike Sporotrichosis)', 'Absence of pain (usually painless unless infected)'],
    definitiveTreatment: 'Oral Itraconazole or Terbinafine for several months to years',
    supportiveTreatment: 'Surgical excision or cryotherapy for small, localized lesions',
    redFlags: ['Presence of Medlar bodies (copper pennies / sclerotic bodies) on KOH or biopsy'],
    cautions: [],
    meds: [
      mk('Itramac 200', 'Itraconazole', '1 - 0 - 1', '1 - 0 - 1', '180', 'जेवणानंतर'),
      mk('Terbinaforce 250', 'Terbinafine', '1 - 0 - 0', '1 - 0 - 0', '180', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-121',
    label: 'Coccidioidomycosis (Valley Fever)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Coccidioidomycosis (Valley Fever)', 'Valley Fever', 'Coccidioidomycosis'],
    pathognomonic: 'Spherules containing endospores on tissue biopsy or sputum cytology',
    definitiveTest: 'Fungal culture or identification of spherules in tissue/sputum',
    supportiveTests: ['Coccidioides serology (IgM/IgG)', 'Chest X-ray (nodules, cavities, infiltrates)'],
    ddx: ['Community-Acquired Pneumonia', 'Tuberculosis', 'Histoplasmosis', 'Lung Cancer'],
    positiveSigns: ['Fever, cough, chest pain, and fatigue', 'Erythema nodosum or Erythema multiforme'],
    negativeSigns: ['Absence of response to antibacterial pneumonia treatments', 'Often asymptomatic in many'],
    definitiveTreatment: 'Mild cases: observation. Severe/disseminated: Fluconazole or Itraconazole. Amphotericin B if life-threatening.',
    supportiveTreatment: 'Rest, analgesics for joint pain/erythema nodosum',
    redFlags: ['Spherules containing endospores on tissue biopsy or sputum cytology'],
    cautions: [],
    meds: [
      mk('Zocon 400', 'Fluconazole', '1 - 0 - 0', '1 - 0 - 0', '90', 'जेवणानंतर'),
      mk('Canditral 200', 'Itraconazole', '1 - 0 - 1', '1 - 0 - 1', '90', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-122',
    label: 'Blastomycosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Blastomycosis'],
    pathognomonic: 'Broad-based budding yeast on KOH mount or biopsy',
    definitiveTest: 'Fungal culture or direct visualization of broad-based budding yeast',
    supportiveTests: ['Urine antigen test', 'Chest X-ray (mass-like infiltrates)'],
    ddx: ['Tuberculosis', 'Squamous Cell Carcinoma', 'Histoplasmosis', 'Bacterial Pneumonia'],
    positiveSigns: ['Pneumonia-like symptoms (cough, fever)', 'Verrucous or ulcerated skin lesions with heaped-up borders'],
    negativeSigns: ['Absence of person-to-person transmission', 'Often mimics TB or cancer'],
    definitiveTreatment: 'Mild/Moderate: Itraconazole for 6-12 months. Severe: Liposomal Amphotericin B.',
    supportiveTreatment: 'Surgical debridement rarely needed, supportive respiratory care',
    redFlags: ['Broad-based budding yeast on KOH mount or biopsy'],
    cautions: [],
    meds: [
      mk('Itaspor 200', 'Itraconazole', '1 - 0 - 1', '1 - 0 - 1', '180', 'जेवणानंतर'),
      mk('Amphotret', 'Amphotericin B', 'IV Infusion', 'IV Infusion', '14', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-123',
    label: 'Paracoccidioidomycosis',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Paracoccidioidomycosis'],
    pathognomonic: '"Mariner\'s wheel" or "Pilot wheel" appearance (multiple budding yeast) on microscopy',
    definitiveTest: 'Direct microscopy (KOH/Calcofluor) showing multiple budding yeast',
    supportiveTests: ['Fungal culture', 'Serology (immunodiffusion)'],
    ddx: ['Tuberculosis', 'Leishmaniasis (mucocutaneous)', 'Histoplasmosis', 'Squamous Cell Carcinoma'],
    positiveSigns: ['Painful mucosal ulcers (mouth, nose)', 'Cervical lymphadenopathy and pulmonary infiltrates'],
    negativeSigns: ['Absence of disease in females (estrogen inhibits yeast transition)', 'Rare outside Latin America'],
    definitiveTreatment: 'Itraconazole is the drug of choice for mild/moderate disease (6-12 months)',
    supportiveTreatment: 'Cotrimoxazole is an alternative. Amphotericin B for severe cases.',
    redFlags: ['"Mariner\'s wheel" or "Pilot wheel" appearance (multiple budding yeast) on microscopy'],
    cautions: [],
    meds: [
      mk('Canditral 200', 'Itraconazole', '1 - 0 - 0', '1 - 0 - 0', '180', 'जेवणानंतर'),
      mk('Septran DS', 'Cotrimoxazole', '1 - 0 - 1', '1 - 0 - 1', '180', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-124',
    label: 'Pneumocystis jirovecii Pneumonia (PCP)',
    group: 'Fungal',
    category: 'Fungal',
    aliases: ['Pneumocystis jirovecii Pneumonia (PCP)', 'PCP', 'Pneumocystis jirovecii Pneumonia'],
    pathognomonic: 'Bilateral "bat-wing" ground-glass opacities on HRCT in an immunocompromised (HIV) patient',
    definitiveTest: 'Demonstration of cysts/trophozoites in induced sputum or BAL fluid (Silver stain/Immunofluorescence)',
    supportiveTests: ['Elevated LDH', 'Arterial Blood Gas (Hypoxemia, increased A-a gradient)'],
    ddx: ['Viral Pneumonia (CMV, COVID-19)', 'Miliary Tuberculosis', 'Mycoplasma Pneumonia', 'Heart Failure'],
    positiveSigns: ['Progressive exertional dyspnea and dry cough', 'Significant hypoxia out of proportion to clinical findings'],
    negativeSigns: ['Absence of productive/purulent cough', 'Absence of pleural effusions (usually)'],
    definitiveTreatment: 'High-dose Cotrimoxazole (TMP-SMX) for 21 days',
    supportiveTreatment: 'Adjunctive Corticosteroids (Prednisolone) if PaO2 < 70 mmHg or A-a gradient > 35 mmHg',
    redFlags: ['Bilateral "bat-wing" ground-glass opacities on HRCT in an immunocompromised (HIV) patient'],
    cautions: [],
    meds: [
      mk('Septran DS', 'Cotrimoxazole', '2 tabs TDS', '2 tabs TDS', '21', 'जेवणानंतर'),
      mk('Wysolone 40', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '5 (then taper)', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-125',
    label: 'Toxocariasis (Visceral Larva Migrans)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Toxocariasis (Visceral Larva Migrans)', 'Visceral Larva Migrans', 'Toxocariasis'],
    pathognomonic: 'Marked eosinophilia with hepatomegaly in a child with a history of pica/puppy exposure',
    definitiveTest: 'ELISA for Toxocara excretory-secretory (TES) antigens',
    supportiveTests: ['CBC (Eosinophilia often >30%)', 'Elevated total IgE', 'Ultrasound abdomen (liver granulomas)'],
    ddx: ['Ascaris pneumonitis (Loeffler\'s syndrome)', 'Strongyloidiasis', 'Asthma', 'Fascioliasis'],
    positiveSigns: ['Hepatomegaly, fever, and wheezing', 'Profound eosinophilia'],
    negativeSigns: ['Absence of eggs in stool (humans are dead-end hosts)', 'Absence of adult worms'],
    definitiveTreatment: 'Albendazole 400mg BD for 5 days',
    supportiveTreatment: 'Corticosteroids for severe inflammatory symptoms (e.g., severe wheezing or ocular involvement)',
    redFlags: ['Marked eosinophilia with hepatomegaly in a child with a history of pica/puppy exposure'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Wysolone 10', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-126',
    label: 'Trichinellosis (Trichinosis)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Trichinellosis (Trichinosis)', 'Trichinosis', 'Trichinellosis'],
    pathognomonic: 'Periorbital edema, myositis, and marked eosinophilia after eating undercooked meat',
    definitiveTest: 'Muscle biopsy showing encysted larvae (rarely needed now)',
    supportiveTests: ['Trichinella serology (ELISA)', 'CBC (Eosinophilia)', 'Elevated CPK and LDH'],
    ddx: ['Polymyositis', 'Dermatomyositis', 'Typhoid fever', 'Eosinophilic granulomatosis with polyangiitis'],
    positiveSigns: ['Periorbital edema and severe myalgia', 'History of eating undercooked pork or wild game'],
    negativeSigns: ['Absence of chronic diarrhea (GI phase is brief)', 'Absence of significant joint swelling'],
    definitiveTreatment: 'Albendazole or Mebendazole (most effective during enteral phase)',
    supportiveTreatment: 'Corticosteroids for severe myositis or myocarditis, analgesics',
    redFlags: ['Periorbital edema, myositis, and marked eosinophilia after eating undercooked meat'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Wysolone 20', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-127',
    label: 'Schistosomiasis (Bilharzia)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Schistosomiasis (Bilharzia)', 'Bilharzia', 'Schistosomiasis'],
    pathognomonic: 'Terminal hematuria in a patient with freshwater exposure in endemic areas',
    definitiveTest: 'Microscopy of urine (S. haematobium - terminal spine) or stool (S. mansoni - lateral spine) for eggs',
    supportiveTests: ['Serology (ELISA)', 'CBC (Eosinophilia)', 'Ultrasound (bladder/liver fibrosis)'],
    ddx: ['Urinary Tract Infection', 'Bladder Cancer', 'Amoebiasis', 'Inflammatory Bowel Disease'],
    positiveSigns: ['Terminal hematuria (S. haematobium) or bloody diarrhea (S. mansoni)', 'Swimmer\'s itch followed by Katayama fever (acute phase)'],
    negativeSigns: ['Absence of immediate symptoms post-exposure (takes weeks to develop)', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'Praziquantel (single dose or divided doses for 1 day)',
    supportiveTreatment: 'Corticosteroids for acute Katayama fever, surgical management for late complications',
    redFlags: ['Terminal hematuria in a patient with freshwater exposure in endemic areas'],
    cautions: [],
    meds: [
      mk('Biltricide', 'Praziquantel', '40 mg/kg in 2 divided doses', '40 mg/kg in 2 divided doses', '1', 'जेवणानंतर (Inj.)'),
      mk('Distocide 600', 'Praziquantel', '40 mg/kg in 2 divided doses', '40 mg/kg in 2 divided doses', '1', 'जेवणानंतर (Inj.)'),
    ],
  },
  {
    id: 'ac-128',
    label: 'Fascioliasis (Liver Fluke)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Fascioliasis (Liver Fluke)', 'Liver Fluke', 'Fascioliasis'],
    pathognomonic: 'RUQ pain, fever, and marked eosinophilia after eating watercress',
    definitiveTest: 'Stool microscopy for eggs (chronic phase) or Serology (Fasciola ELISA)',
    supportiveTests: ['CBC (Eosinophilia)', 'Ultrasound/CT abdomen (hypodense liver tracts)'],
    ddx: ['Amoebic Liver Abscess', 'Ascariasis (biliary)', 'Cholecystitis', 'Toxocariasis'],
    positiveSigns: ['Right upper quadrant pain and hepatomegaly', 'History of eating aquatic plants (watercress)'],
    negativeSigns: ['Absence of jaundice in early (acute) phase', 'Absence of response to Albendazole/Praziquantel'],
    definitiveTreatment: 'Triclabendazole (drug of choice, often single dose)',
    supportiveTreatment: 'Nitazoxanide is an alternative if Triclabendazole is unavailable',
    redFlags: ['RUQ pain, fever, and marked eosinophilia after eating watercress'],
    cautions: [],
    meds: [
      mk('Egaten', 'Triclabendazole', '10 mg/kg single dose', '10 mg/kg single dose', '1', 'जेवणानंतर'),
      mk('Nizonide 500', 'Nitazoxanide', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-129',
    label: 'Taeniasis (Tapeworm Infection)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Taeniasis (Tapeworm Infection)', 'Tapeworm Infection', 'Taeniasis'],
    pathognomonic: 'Visible motile segments (proglottids) in feces or undergarments',
    definitiveTest: 'Stool microscopy for Taenia eggs or proglottids',
    supportiveTests: ['Cellophane tape swab (can sometimes catch eggs)'],
    ddx: ['Ascariasis', 'Enterobiasis', 'Irritable Bowel Syndrome', 'Malabsorption'],
    positiveSigns: ['Passage of proglottids (worm segments) in stool', 'Mild abdominal discomfort or weight loss'],
    negativeSigns: ['Absence of severe acute abdominal pain', 'Absence of high fever'],
    definitiveTreatment: 'Praziquantel (single dose) or Niclosamide',
    supportiveTreatment: 'Good hygiene, proper cooking of pork/beef',
    redFlags: ['Visible motile segments (proglottids) in feces or undergarments'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '5-10 mg/kg single dose', '5-10 mg/kg single dose', '1', 'जेवणानंतर'),
      mk('Niclosan', 'Niclosamide', '2g single dose (chewed)', '2g single dose (chewed)', '1', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-130',
    label: 'Diphyllobothriasis (Fish Tapeworm)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Diphyllobothriasis (Fish Tapeworm)', 'Fish Tapeworm', 'Diphyllobothriasis'],
    pathognomonic: 'Megaloblastic anemia in a patient consuming raw freshwater fish',
    definitiveTest: 'Stool microscopy for operculated eggs',
    supportiveTests: ['CBC (Macrocytic anemia)', 'Low serum Vitamin B12 levels'],
    ddx: ['Pernicious Anemia', 'Taeniasis', 'Dietary B12 deficiency', 'Ascariasis'],
    positiveSigns: ['Megaloblastic anemia (Vitamin B12 deficiency)', 'History of eating raw/undercooked freshwater fish'],
    negativeSigns: ['Absence of severe GI symptoms (often asymptomatic)', 'Absence of iron deficiency anemia'],
    definitiveTreatment: 'Praziquantel (single dose)',
    supportiveTreatment: 'Vitamin B12 supplementation (IM injections if severe anemia)',
    redFlags: ['Megaloblastic anemia in a patient consuming raw freshwater fish'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '5-10 mg/kg single dose', '5-10 mg/kg single dose', '1', 'जेवणानंतर'),
      mk('Neurobion Forte', 'Vitamin B12', '1 - 0 - 0', '1 - 0 - 0', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-131',
    label: 'Onchocerciasis (River Blindness)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Onchocerciasis (River Blindness)', 'River Blindness', 'Onchocerciasis'],
    pathognomonic: 'Microfilariae in skin snips + "Leopard skin" (depigmentation) + Sclerosing keratitis',
    definitiveTest: 'Skin snip biopsy (bloodless) showing microfilariae',
    supportiveTests: ['Slit-lamp examination of the eye (microfilariae in anterior chamber)', 'Mazzotti test (rarely used now)'],
    ddx: ['Scabies', 'Leprosy', 'Trachoma', 'Loiasis'],
    positiveSigns: ['Intensely itchy skin rash (leopard skin)', 'Subcutaneous nodules (onchocercomata) and visual changes'],
    negativeSigns: ['Absence of acute fever', 'Absence of rapid progression (takes years)'],
    definitiveTreatment: 'Ivermectin (single dose, repeated every 6-12 months)',
    supportiveTreatment: 'Doxycycline for 6 weeks (targets Wolbachia endosymbiont), surgical nodulectomy',
    redFlags: ['Microfilariae in skin snips + "Leopard skin" (depigmentation) + Sclerosing keratitis'],
    cautions: [],
    meds: [
      mk('Ivecop 12', 'Ivermectin', '150 mcg/kg single dose', '150 mcg/kg single dose', '1', 'उपाशी पोटी'),
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '42', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-132',
    label: 'Loiasis (African Eye Worm)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Loiasis (African Eye Worm)', 'African Eye Worm', 'Loiasis'],
    pathognomonic: 'Visible migration of an adult worm across the eye (subconjunctival space)',
    definitiveTest: 'Identification of microfilariae in daytime blood smear or extraction of adult worm from eye',
    supportiveTests: ['CBC (Eosinophilia)', 'Loa loa serology'],
    ddx: ['Onchocerciasis', 'Lymphatic Filariasis', 'Allergic angioedema', 'Trichinellosis'],
    positiveSigns: ['Transient, localized subcutaneous swellings (Calabar swellings)', 'Visible worm migrating across the conjunctiva'],
    negativeSigns: ['Absence of blindness (unlike Onchocerciasis)', 'Absence of severe skin changes (no leopard skin)'],
    definitiveTreatment: 'Diethylcarbamazine (DEC) - requires slow dose escalation to prevent encephalopathy',
    supportiveTreatment: 'Albendazole (if DEC contraindicated due to high microfilarial load), surgical removal of eye worm',
    redFlags: ['Visible migration of an adult worm across the eye (subconjunctival space)'],
    cautions: [],
    meds: [
      mk('Banocide Forte', 'Diethylcarbamazine', 'Dose escalation over 3-4 days', 'Dose escalation over 3-4 days', '21', 'जेवणानंतर'),
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '21', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-133',
    label: 'Dracunculiasis (Guinea Worm Disease)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Dracunculiasis (Guinea Worm Disease)', 'Guinea Worm Disease', 'Dracunculiasis'],
    pathognomonic: 'Visible adult worm emerging from a painful skin ulcer',
    definitiveTest: 'Clinical diagnosis (visualizing the worm)',
    supportiveTests: ['X-ray (may show calcified dead worms)'],
    ddx: ['Cellulitis', 'Deep Vein Thrombosis', 'Mycetoma', 'Cutaneous Larva Migrans'],
    positiveSigns: ['Painful blister on lower extremity', 'Emergence of a long white worm from the ulcer upon contact with water'],
    negativeSigns: ['Absence of systemic illness before blister formation', 'Absence of response to anthelminthics'],
    definitiveTreatment: 'Slow, controlled mechanical extraction of the worm over days/weeks',
    supportiveTreatment: 'Wound care, Tetanus toxoid, antibiotics for secondary bacterial infection',
    redFlags: ['Visible adult worm emerging from a painful skin ulcer'],
    cautions: [],
    meds: [
      mk('Augmentin 625', 'Amoxicillin + Clavulanate', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Betadine Ointment', 'Povidone Iodine', 'Apply BD', 'Apply BD', '14', 'जखमेवर'),
    ],
  },
  {
    id: 'ac-134',
    label: 'Cutaneous Larva Migrans (Creeping Eruption)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Cutaneous Larva Migrans (Creeping Eruption)', 'Creeping Eruption', 'Cutaneous Larva Migrans'],
    pathognomonic: 'Migratory, serpiginous, pruritic cutaneous tracks (advancing mm to cm per day)',
    definitiveTest: 'Clinical diagnosis based on characteristic appearance and history',
    supportiveTests: ['None usually required'],
    ddx: ['Scabies', 'Contact Dermatitis', 'Tinea Corporis', 'Loiasis'],
    positiveSigns: ['Intensely itchy, serpiginous (snake-like) red tracks on skin', 'History of walking barefoot on sandy beaches'],
    negativeSigns: ['Absence of systemic symptoms', 'Absence of deep tissue involvement'],
    definitiveTreatment: 'Oral Ivermectin (single dose) or Oral Albendazole for 3-7 days',
    supportiveTreatment: 'Topical Thiabendazole (if available), antihistamines for itching',
    redFlags: ['Migratory, serpiginous, pruritic cutaneous tracks (advancing mm to cm per day)'],
    cautions: [],
    meds: [
      mk('Ivecop 12', 'Ivermectin', '12mg single dose', '12mg single dose', '1', 'उपाशी पोटी'),
      mk('Zentel 400', 'Albendazole', '1 - 0 - 0', '1 - 0 - 0', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-135',
    label: 'Babesiosis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Babesiosis'],
    pathognomonic: 'Maltese cross appearance (tetrads) inside RBCs on peripheral smear',
    definitiveTest: 'Peripheral blood smear (Giemsa stain) showing intraerythrocytic rings/tetrads',
    supportiveTests: ['Babesia PCR', 'CBC (Hemolytic anemia, thrombocytopenia)'],
    ddx: ['Malaria', 'Lyme Disease', 'Ehrlichiosis', 'Anaplasmosis'],
    positiveSigns: ['Fever, chills, and hemolytic anemia', 'History of tick bite (Ixodes tick)'],
    negativeSigns: ['Absence of cyclical fever (unlike Malaria)', 'Absence of rash (unlike Lyme disease, though co-infection occurs)'],
    definitiveTreatment: 'Atovaquone + Azithromycin OR Clindamycin + Quinine (for severe cases)',
    supportiveTreatment: 'Exchange transfusion in severe disease with high parasitemia',
    redFlags: ['Maltese cross appearance (tetrads) inside RBCs on peripheral smear'],
    cautions: [],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
      mk('Dalacin C 300', 'Clindamycin', '1 - 1 - 1', '1 - 1 - 1', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-136',
    label: 'Chagas Disease (American Trypanosomiasis)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Chagas Disease (American Trypanosomiasis)', 'American Trypanosomiasis', 'Chagas Disease'],
    pathognomonic: 'Romaña\'s sign (acute) or Apical aneurysm of the left ventricle (chronic)',
    definitiveTest: 'Acute: Blood smear for Trypanosoma cruzi. Chronic: Serology (ELISA/IFA).',
    supportiveTests: ['ECG (Right bundle branch block is common)', 'Echocardiogram', 'Barium enema (for megacolon)'],
    ddx: ['Leishmaniasis', 'Idiopathic Dilated Cardiomyopathy', 'Achalasia', 'Malaria'],
    positiveSigns: ['Unilateral painless periorbital swelling (Romaña\'s sign) in acute phase', 'Cardiomyopathy or Megacolon in chronic phase'],
    negativeSigns: ['Absence of rapid progression in chronic phase', 'Rare outside the Americas'],
    definitiveTreatment: 'Benznidazole or Nifurtimox (most effective in acute/early chronic phase)',
    supportiveTreatment: 'Heart failure management (ACE inhibitors, beta-blockers), pacemakers, surgery for megacolon',
    redFlags: ['Romaña\'s sign (acute) or Apical aneurysm of the left ventricle (chronic)'],
    cautions: [],
    meds: [
      mk('Benznidazole', 'Benznidazole', '5-7 mg/kg/day in 2 doses', '5-7 mg/kg/day in 2 doses', '60', 'जेवणानंतर'),
      mk('Cardivas 3.125', 'Carvedilol', '1 - 0 - 1 (for HF)', '1 - 0 - 1 (for HF)', 'Long term', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-137',
    label: 'African Trypanosomiasis (Sleeping Sickness)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['African Trypanosomiasis (Sleeping Sickness)', 'Sleeping Sickness', 'African Trypanosomiasis'],
    pathognomonic: 'Daytime somnolence and nighttime insomnia (reversal of sleep cycle) in late stage',
    definitiveTest: 'Microscopy of blood, lymph node aspirate, or CSF for Trypanosomes',
    supportiveTests: ['Card Agglutination Test for Trypanosomiasis (CATT) for T. b. gambiense', 'CSF analysis (WBCs, protein)'],
    ddx: ['Malaria', 'HIV/AIDS', 'Tuberculous Meningitis', 'Viral Encephalitis'],
    positiveSigns: ['Painful chancre at tsetse fly bite site', 'Winterbottom\'s sign (posterior cervical lymphadenopathy)'],
    negativeSigns: ['Absence of response to standard antimalarials', 'Absence of rapid recovery'],
    definitiveTreatment: 'Early stage: Pentamidine (gambiense) or Suramin (rhodesiense). Late stage: Eflornithine or Melarsoprol.',
    supportiveTreatment: 'Fexinidazole (newer oral option for T. b. gambiense)',
    redFlags: ['Daytime somnolence and nighttime insomnia (reversal of sleep cycle) in late stage'],
    cautions: [],
    meds: [
      mk('Pentam 300', 'Pentamidine', '4 mg/kg IM OD', '4 mg/kg IM OD', '7', 'Hospital Use'),
      mk('Suramin', 'Suramin', 'IV Infusion', 'IV Infusion', '21', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-138',
    label: 'Primary Amoebic Meningoencephalitis (Naegleria fowleri)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Primary Amoebic Meningoencephalitis (Naegleria fowleri)', 'Naegleria fowleri', 'Primary Amoebic Meningoencephalitis'],
    pathognomonic: 'Motile trophozoites on wet mount of fresh, un-refrigerated CSF',
    definitiveTest: 'CSF wet mount showing motile amoebae or CSF PCR',
    supportiveTests: ['CSF analysis (purulent profile: high PMNs, low glucose, high protein)'],
    ddx: ['Bacterial Meningitis', 'Viral Encephalitis', 'Tuberculous Meningitis', 'Subarachnoid Hemorrhage'],
    positiveSigns: ['Rapid onset of severe headache, fever, and stiff neck', 'History of swimming in warm freshwater'],
    negativeSigns: ['Absence of bacteria on CSF Gram stain', 'Absence of response to standard meningitis antibiotics'],
    definitiveTreatment: 'Investigational/Aggressive: Amphotericin B + Miltefosine + Azithromycin + Rifampin + Fluconazole',
    supportiveTreatment: 'Therapeutic hypothermia, management of elevated intracranial pressure',
    redFlags: ['Motile trophozoites on wet mount of fresh, un-refrigerated CSF'],
    cautions: [],
    meds: [
      mk('Amphotret', 'Amphotericin B', 'IV and Intrathecal', 'IV and Intrathecal', '14', 'Hospital Use (Inj.)'),
      mk('Miltefos', 'Miltefosine', '1 - 0 - 1', '1 - 0 - 1', '28', 'Hospital Use'),
    ],
  },
  {
    id: 'ac-139',
    label: 'Granulomatous Amoebic Encephalitis (Acanthamoeba / Balamuthia)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Granulomatous Amoebic Encephalitis (Acanthamoeba / Balamuthia)', 'Acanthamoeba / Balamuthia', 'Granulomatous Amoebic Encephalitis'],
    pathognomonic: 'Subacute/chronic encephalitis with granulomas in an immunocompromised patient',
    definitiveTest: 'Brain biopsy showing cysts and trophozoites',
    supportiveTests: ['MRI Brain (multiple ring-enhancing lesions)', 'Skin biopsy (if lesions present)'],
    ddx: ['Toxoplasmosis', 'CNS Lymphoma', 'Tuberculous Meningitis', 'Neurocysticercosis'],
    positiveSigns: ['Slowly progressive altered mental status and focal neurologic deficits', 'Chronic skin ulcers or keratitis (Acanthamoeba)'],
    negativeSigns: ['Absence of rapid onset (unlike Naegleria)', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'Combination therapy: Miltefosine + Fluconazole + Pentamidine + Sulfadiazine (often fatal despite treatment)',
    supportiveTreatment: 'Seizure management, reduction of immunosuppression if possible',
    redFlags: ['Seizure management'],
    cautions: [],
    meds: [
      mk('Miltefos', 'Miltefosine', '1 - 0 - 1', '1 - 0 - 1', 'Months', 'Hospital Use'),
      mk('Zocon 400', 'Fluconazole', '1 - 0 - 0', '1 - 0 - 0', 'Months', 'Hospital Use'),
    ],
  },
  {
    id: 'ac-140',
    label: 'Acanthamoeba Keratitis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Acanthamoeba Keratitis'],
    pathognomonic: 'Ring infiltrate on the cornea in a contact lens wearer',
    definitiveTest: 'Corneal scraping for culture (on non-nutrient agar with E. coli overlay) or PCR',
    supportiveTests: ['Confocal microscopy (can visualize cysts in vivo)'],
    ddx: ['Herpes Simplex Keratitis', 'Bacterial Keratitis (Pseudomonas)', 'Fungal Keratitis', 'Corneal Abrasion'],
    positiveSigns: ['Severe eye pain out of proportion to clinical findings', 'History of contact lens use (especially with tap water)'],
    negativeSigns: ['Absence of response to antibacterial/antiviral eye drops', 'Absence of typical bacterial ulcer appearance initially'],
    definitiveTreatment: 'Topical Biguanides (PHMB or Chlorhexidine) + Diamidines (Propamidine)',
    supportiveTreatment: 'Cycloplegics for pain, penetrating keratoplasty (corneal transplant) if medical therapy fails',
    redFlags: ['Ring infiltrate on the cornea in a contact lens wearer'],
    cautions: [],
    meds: [
      mk('Brolene', 'Propamidine Isethionate', '1 drop every hour', '1 drop every hour', 'Weeks', 'डोळ्यात टाकण्यासाठी'),
      mk('Homide', 'Homatropine', '1 drop BD', '1 drop BD', '7', 'डोळ्यात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-141',
    label: 'Listeriosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Listeriosis'],
    pathognomonic: 'Tumbling motility on wet mount; Gram-positive rods in CSF of a neonate/elderly',
    definitiveTest: 'Blood or CSF Culture',
    supportiveTests: ['CSF analysis (pleocytosis, can be neutrophil or lymphocyte predominant)'],
    ddx: ['Group B Strep Meningitis', 'E. coli Meningitis', 'Viral Encephalitis', 'Food Poisoning (Salmonella/Campylobacter)'],
    positiveSigns: ['Fever, muscle aches, and diarrhea', 'Meningitis or sepsis in pregnant women, neonates, or elderly'],
    negativeSigns: ['Absence of typical Gram-negative rods (it is a Gram-positive rod)', 'Absence of response to Cephalosporins'],
    definitiveTreatment: 'Intravenous Ampicillin (Drug of Choice) + Gentamicin for synergy',
    supportiveTreatment: 'Trimethoprim-Sulfamethoxazole (Cotrimoxazole) if penicillin-allergic',
    redFlags: ['Tumbling motility on wet mount; Gram-positive rods in CSF of a neonate/elderly'],
    cautions: [],
    meds: [
      mk('Campicillin 500', 'Ampicillin', '2g IV every 4 hours', '2g IV every 4 hours', '14-21', 'Hospital Use (Inj.)'),
      mk('Garamycin', 'Gentamicin', '5 mg/kg IV OD', '5 mg/kg IV OD', '7', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-142',
    label: 'Campylobacteriosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Campylobacteriosis'],
    pathognomonic: 'Curved, "seagull-wing" shaped Gram-negative rods in stool',
    definitiveTest: 'Stool culture on specialized media (Campylobacter agar) at 42°C',
    supportiveTests: ['Stool routine (shows RBCs and WBCs)'],
    ddx: ['Salmonellosis', 'Shigellosis', 'E. coli O157:H7', 'Inflammatory Bowel Disease'],
    positiveSigns: ['Bloody diarrhea, abdominal cramps, and fever', 'History of eating undercooked poultry'],
    negativeSigns: ['Absence of vomiting (less common than in viral gastroenteritis)', 'Absence of prolonged course (usually self-limiting in a week)'],
    definitiveTreatment: 'Usually self-limiting. Azithromycin 500mg OD for 3 days if severe/dysentery.',
    supportiveTreatment: 'Oral rehydration. Avoid anti-motility agents (Loperamide). Associated with Guillain-Barré Syndrome post-infection.',
    redFlags: ['Curved, "seagull-wing" shaped Gram-negative rods in stool'],
    cautions: ['Avoid anti-motility agents (Loperamide)'],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '3', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'After every loose stool', 'After every loose stool', '5', 'जेव्हा तहान लागेल'),
    ],
  },
  {
    id: 'ac-143',
    label: 'Helicobacter pylori Infection',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Helicobacter pylori Infection'],
    pathognomonic: 'Urease-producing spiral bacteria in gastric mucosa causing peptic ulcers',
    definitiveTest: 'Urea Breath Test or Endoscopic Biopsy (Rapid Urease Test / Histology)',
    supportiveTests: ['Stool Antigen Test (good for confirming eradication)', 'H. pylori Serology (indicates past/present exposure)'],
    ddx: ['GERD', 'NSAID-induced ulcer', 'Gastric Cancer', 'Biliary Colic'],
    positiveSigns: ['Epigastric pain (burning/gnawing)', 'Pain improves with eating (Duodenal ulcer) or worsens (Gastric ulcer)'],
    negativeSigns: ['Absence of lower GI symptoms (diarrhea)', 'Absence of acute high fever'],
    definitiveTreatment: 'Triple Therapy: PPI (Pantoprazole) + Clarithromycin + Amoxicillin for 14 days',
    supportiveTreatment: 'Quadruple therapy (Bismuth + Metronidazole + Tetracycline + PPI) if macrolide resistance is high',
    redFlags: ['Urease-producing spiral bacteria in gastric mucosa causing peptic ulcers'],
    cautions: [],
    meds: [
      mk('HP-Kit', 'Pantoprazole + Clarithromycin + Amoxicillin', '1 kit BD', '1 kit BD', '14', 'जेवणानंतर'),
      mk('Pan 40', 'Pantoprazole', '1 - 0 - 0', '1 - 0 - 0', '30', 'उपाशी पोटी'),
    ],
  },
  {
    id: 'ac-144',
    label: 'Tetanus',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Tetanus'],
    pathognomonic: 'Descending spastic paralysis with preserved consciousness after a contaminated wound',
    definitiveTest: 'Clinical diagnosis (spatula test - biting down instead of gagging)',
    supportiveTests: ['Wound culture (rarely positive for C. tetani)', 'Serum anti-tetanus IgG (low levels indicate susceptibility)'],
    ddx: ['Strychnine poisoning', 'Dental abscess (causes trismus)', 'Dystonic drug reaction', 'Rabies'],
    positiveSigns: ['Trismus (lockjaw) and Risus sardonicus (facial spasm)', 'Opisthotonus (severe back spasms) triggered by stimuli'],
    negativeSigns: ['Absence of altered sensorium (patient is fully conscious)', 'Absence of purulent meningitis signs'],
    definitiveTreatment: 'Human Tetanus Immune Globulin (HTIG) + Metronidazole or Penicillin G',
    supportiveTreatment: 'Wound debridement, Diazepam for spasms, mechanical ventilation in dark/quiet room',
    redFlags: ['mechanical ventilation in dark/quiet room'],
    cautions: [],
    meds: [
      mk('Tetglob', 'Tetanus Immunoglobulin', '3000-6000 units IM', '3000-6000 units IM', '1', 'Stat'),
      mk('Flagyl 400', 'Metronidazole', '1 - 1 - 1', '1 - 1 - 1', '10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-145',
    label: 'Botulism',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Botulism'],
    pathognomonic: 'Acute, symmetric, descending flaccid paralysis with clear sensorium after eating canned food',
    definitiveTest: 'Detection of Botulinum toxin in serum, stool, or food (Mouse bioassay)',
    supportiveTests: ['EMG (shows presynaptic neuromuscular blockade)'],
    ddx: ['Guillain-Barré Syndrome (ascending)', 'Myasthenia Gravis', 'Tick paralysis', 'Stroke'],
    positiveSigns: ['Descending flaccid paralysis', 'Diplopia, dysarthria, dysphagia, and dry mouth (4 Ds)'],
    negativeSigns: ['Absence of fever', 'Absence of sensory deficits (purely motor/autonomic)'],
    definitiveTreatment: 'Equine Botulinum Antitoxin (Heptavalent) immediately (do not wait for lab confirmation)',
    supportiveTreatment: 'Mechanical ventilation, enemas/gastric lavage to remove unabsorbed toxin',
    redFlags: ['Mechanical ventilation'],
    cautions: [],
    meds: [
      mk('Botulinum Antitoxin', 'Antitoxin', 'IV Infusion', 'IV Infusion', '1', 'Stat (Inj.)'),
      mk('Supportive Care', 'Ventilation/Fluids', 'Continuous', 'Continuous', 'Weeks', 'ICU'),
    ],
  },
  {
    id: 'ac-146',
    label: 'Actinomycosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Actinomycosis'],
    pathognomonic: 'Yellow "sulfur granules" in the exudate from draining sinuses',
    definitiveTest: 'Anaerobic culture and histopathology of tissue/pus showing branching Gram-positive rods',
    supportiveTests: ['CT/MRI (to assess extent of tissue/bone involvement)'],
    ddx: ['Nocardiosis', 'Tuberculosis', 'Squamous Cell Carcinoma', 'Mycetoma'],
    positiveSigns: ['Slowly progressive, painless, indurated mass (often cervicofacial "lumpy jaw")', 'Multiple draining sinus tracts'],
    negativeSigns: ['Absence of acute inflammation/fever', 'Absence of response to short-course antibiotics'],
    definitiveTreatment: 'High-dose IV Penicillin G for 2-6 weeks, followed by oral Amoxicillin for 6-12 months',
    supportiveTreatment: 'Surgical drainage of abscesses and excision of sinus tracts',
    redFlags: ['Yellow "sulfur granules" in the exudate from draining sinuses'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', 'Months', 'जेवणानंतर'),
      mk('Penidure LA 12', 'Benzathine Penicillin', '1.2 MU IM', '1.2 MU IM', 'Months', 'Weekly'),
    ],
  },
  {
    id: 'ac-147',
    label: 'Nocardiosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Nocardiosis'],
    pathognomonic: 'Weakly acid-fast, branching, beaded Gram-positive filaments in sputum or pus',
    definitiveTest: 'Culture of sputum, pus, or tissue (slow-growing, aerobic)',
    supportiveTests: ['Modified acid-fast stain (Kinyoun stain)', 'CT Chest/Brain'],
    ddx: ['Tuberculosis', 'Actinomycosis', 'Invasive Aspergillosis', 'Lung Cancer'],
    positiveSigns: ['Pulmonary infiltrates/cavities in an immunocompromised patient', 'Brain abscesses (focal neurologic signs)'],
    negativeSigns: ['Absence of sulfur granules (usually)', 'Absence of response to standard pneumonia treatments'],
    definitiveTreatment: 'Trimethoprim-Sulfamethoxazole (Cotrimoxazole) for 6-12 months',
    supportiveTreatment: 'Imipenem or Amikacin for severe/CNS involvement, surgical drainage of abscesses',
    redFlags: ['Weakly acid-fast, branching, beaded Gram-positive filaments in sputum or pus'],
    cautions: [],
    meds: [
      mk('Septran DS', 'Cotrimoxazole', '2 tabs BD', '2 tabs BD', 'Months', 'जेवणानंतर'),
      mk('Amicin 500', 'Amikacin', '15 mg/kg IV OD', '15 mg/kg IV OD', '14', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-148',
    label: 'Bartonellosis (Cat Scratch Disease)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Bartonellosis (Cat Scratch Disease)', 'Cat Scratch Disease', 'Bartonellosis'],
    pathognomonic: 'Primary inoculation papule followed by tender regional lymphadenopathy after cat contact',
    definitiveTest: 'Bartonella henselae Serology (IFA) or PCR of lymph node aspirate',
    supportiveTests: ['Lymph node biopsy (Warthin-Starry silver stain shows bacilli)'],
    ddx: ['Tuberculous Lymphadenitis', 'Lymphoma', 'Toxoplasmosis', 'Tularemia'],
    positiveSigns: ['Regional lymphadenopathy (axillary/cervical)', 'History of a cat scratch or bite 1-3 weeks prior'],
    negativeSigns: ['Absence of generalized lymphadenopathy', 'Absence of severe systemic illness in healthy individuals'],
    definitiveTreatment: 'Usually self-limiting. Azithromycin 500mg day 1, then 250mg days 2-5 for severe/painful nodes.',
    supportiveTreatment: 'Needle aspiration of suppurative lymph nodes (avoid incision and drainage)',
    redFlags: ['Primary inoculation papule followed by tender regional lymphadenopathy after cat contact'],
    cautions: ['Needle aspiration of suppurative lymph nodes (avoid incision and drainage)'],
    meds: [
      mk('Azee 500', 'Azithromycin', '1 - 0 - 0', '1 - 0 - 0', '5', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '3', 'दुखीसाठी'),
    ],
  },
  {
    id: 'ac-149',
    label: 'Tularemia (Rabbit Fever)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Tularemia (Rabbit Fever)', 'Rabbit Fever', 'Tularemia'],
    pathognomonic: 'Indolent ulcer with massive, tender regional lymphadenopathy after rabbit exposure',
    definitiveTest: 'Serology (tube agglutination) or PCR. (Culture is hazardous to lab workers).',
    supportiveTests: ['CBC (normal WBC or mild leukocytosis)', 'Chest X-ray (if pneumonic form)'],
    ddx: ['Plague', 'Cat Scratch Disease', 'Anthrax', 'Sporotrichosis'],
    positiveSigns: ['Ulceroglandular form: Skin ulcer at entry site + massive regional lymphadenopathy', 'History of tick bite or handling infected rabbits'],
    negativeSigns: ['Absence of response to Beta-lactams (requires Aminoglycosides/Tetracyclines)', 'Absence of person-to-person transmission'],
    definitiveTreatment: 'Streptomycin or Gentamicin (Drug of Choice) for 10-14 days',
    supportiveTreatment: 'Doxycycline or Ciprofloxacin are oral alternatives for milder cases',
    redFlags: ['Indolent ulcer with massive, tender regional lymphadenopathy after rabbit exposure'],
    cautions: [],
    meds: [
      mk('Garamycin', 'Gentamicin', '5 mg/kg IV OD', '5 mg/kg IV OD', '10', 'Hospital Use (Inj.)'),
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-150',
    label: 'Q Fever (Coxiella burnetii)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Q Fever (Coxiella burnetii)', 'Coxiella burnetii', 'Q Fever'],
    pathognomonic: 'Culture-negative endocarditis in chronic form; Pneumonia + Hepatitis in acute form',
    definitiveTest: 'Serology (IFA) - Phase II antibodies for acute, Phase I for chronic',
    supportiveTests: ['PCR of blood/tissue', 'Liver Function Test (elevated AST/ALT)'],
    ddx: ['Brucellosis', 'Legionnaires\' Disease', 'Mycoplasma Pneumonia', 'Viral Hepatitis'],
    positiveSigns: ['Atypical pneumonia and/or Hepatitis (elevated transaminases)', 'History of exposure to livestock (sheep, goats, cattle) or their birthing products'],
    negativeSigns: ['Absence of skin rash (unlike other rickettsial diseases)', 'Absence of significant leukocytosis'],
    definitiveTreatment: 'Acute: Doxycycline 100mg BD for 14 days. Chronic (Endocarditis): Doxycycline + Hydroxychloroquine for 18 months.',
    supportiveTreatment: 'Echocardiogram to screen for endocarditis in high-risk patients',
    redFlags: ['Culture-negative endocarditis in chronic form; Pneumonia + Hepatitis in acute form'],
    cautions: [],
    meds: [
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('HCQS 200', 'Hydroxychloroquine', '1 - 0 - 1 (for chronic)', '1 - 0 - 1 (for chronic)', 'Months', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-151',
    label: 'Clostridioides difficile Infection (CDI)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Clostridioides difficile Infection (CDI)', 'CDI', 'Clostridioides difficile Infection'],
    pathognomonic: 'Pseudomembranous colitis seen on sigmoidoscopy/colonoscopy',
    definitiveTest: 'Stool test for C. difficile toxins A and B (EIA or PCR)',
    supportiveTests: ['CBC (marked leukocytosis)', 'Stool routine (fecal leukocytes positive)'],
    ddx: ['Antibiotic-associated diarrhea (non-CDI)', 'Inflammatory Bowel Disease', 'Salmonellosis', 'Ischemic colitis'],
    positiveSigns: ['Profuse, foul-smelling watery diarrhea', 'Recent history of broad-spectrum antibiotic use'],
    negativeSigns: ['Absence of bloody diarrhea (usually)', 'Absence of significant vomiting'],
    definitiveTreatment: 'Oral Vancomycin or Oral Fidaxomicin',
    supportiveTreatment: 'Discontinue offending antibiotic, aggressive oral/IV rehydration, avoid anti-motility agents',
    redFlags: ['Pseudomembranous colitis seen on sigmoidoscopy/colonoscopy'],
    cautions: ['avoid anti-motility agents'],
    meds: [
      mk('Vanco', 'Vancomycin (Oral)', '125mg QID', '125mg QID', '10', 'जेवणानंतर'),
      mk('Fidax', 'Fidaxomicin', '200mg BD', '200mg BD', '10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-152',
    label: 'Non-typhoidal Salmonellosis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Non-typhoidal Salmonellosis'],
    pathognomonic: 'Acute gastroenteritis 12-72 hours after consuming contaminated food',
    definitiveTest: 'Stool culture growing Salmonella enterica (non-Typhi serotypes)',
    supportiveTests: ['Stool routine (WBCs present)', 'Blood culture (if bacteremia suspected)'],
    ddx: ['Campylobacteriosis', 'Staphylococcal food poisoning', 'Viral gastroenteritis', 'Shigellosis'],
    positiveSigns: ['Nausea, vomiting, and non-bloody diarrhea', 'History of eating contaminated poultry, eggs, or dairy'],
    negativeSigns: ['Absence of rose spots (seen in Typhoid)', 'Absence of prolonged step-ladder fever'],
    definitiveTreatment: 'Usually self-limiting. Ciprofloxacin or Azithromycin only for severe cases or immunocompromised.',
    supportiveTreatment: 'Oral Rehydration Solution (ORS), rest, avoid anti-motility drugs',
    redFlags: ['Acute gastroenteritis 12-72 hours after consuming contaminated food'],
    cautions: ['avoid anti-motility drugs'],
    meds: [
      mk('Ciplox 500', 'Ciprofloxacin', '1 - 0 - 1', '1 - 0 - 1', '3-5', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'After every loose stool', 'After every loose stool', '3', 'जेव्हा तहान लागेल'),
    ],
  },
  {
    id: 'ac-153',
    label: 'Vibrio vulnificus Infection',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Vibrio vulnificus Infection'],
    pathognomonic: 'Hemorrhagic bullae and necrotizing fasciitis in a patient with liver disease after seawater exposure',
    definitiveTest: 'Blood or wound culture growing Vibrio vulnificus',
    supportiveTests: ['CBC (leukocytosis, thrombocytopenia in sepsis)', 'LFTs (often underlying cirrhosis)'],
    ddx: ['Necrotizing fasciitis (Strep/Staph)', 'Aeromonas infection', 'Severe cellulitis', 'Gas gangrene'],
    positiveSigns: ['Rapidly progressive cellulitis with hemorrhagic bullae', 'History of raw oyster consumption or seawater exposure to a wound'],
    negativeSigns: ['Absence of purulent discharge initially', 'Absence of slow progression (it is extremely rapid)'],
    definitiveTreatment: 'Intravenous Doxycycline + Ceftriaxone (or Cefotaxime)',
    supportiveTreatment: 'Urgent surgical debridement of necrotic tissue, ICU support for sepsis',
    redFlags: ['ICU support for sepsis'],
    cautions: [],
    meds: [
      mk('Monocef 1g', 'Ceftriaxone', '1g', '1g IV BD', '7-14', 'Hospital Use (Inj.)'),
      mk('Doxiva 100', 'Doxycycline', '100mg IV/PO BD', '100mg IV/PO BD', '7-14', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-154',
    label: 'Yersiniosis (Yersinia enterocolitica)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Yersiniosis (Yersinia enterocolitica)', 'Yersinia enterocolitica', 'Yersiniosis'],
    pathognomonic: 'Pseudoappendicitis (mesenteric adenitis) mimicking acute appendicitis',
    definitiveTest: 'Stool culture on selective media (CIN agar) at room temperature',
    supportiveTests: ['Ultrasound abdomen (enlarged mesenteric lymph nodes, normal appendix)'],
    ddx: ['Acute Appendicitis', 'Campylobacteriosis', 'Salmonellosis', 'Crohn\'s Disease'],
    positiveSigns: ['Right lower quadrant abdominal pain and fever', 'Bloody diarrhea (especially in children)'],
    negativeSigns: ['Absence of inflamed appendix on ultrasound/CT (pseudoappendicitis)', 'Absence of response to standard macrolides'],
    definitiveTreatment: 'Usually self-limiting. Ciprofloxacin or Cotrimoxazole for severe/systemic cases.',
    supportiveTreatment: 'Hydration, NSAIDs for reactive arthritis (a common post-infectious complication)',
    redFlags: ['Pseudoappendicitis (mesenteric adenitis) mimicking acute appendicitis'],
    cautions: [],
    meds: [
      mk('Ciplox 500', 'Ciprofloxacin', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Septran DS', 'Cotrimoxazole', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-155',
    label: 'Pasteurella multocida Infection',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pasteurella multocida Infection'],
    pathognomonic: 'Rapidly developing cellulitis following a feline or canine bite',
    definitiveTest: 'Wound culture growing Pasteurella multocida',
    supportiveTests: ['X-ray of the affected area (to rule out tooth fragments or osteomyelitis)'],
    ddx: ['Staphylococcal cellulitis', 'Streptococcal cellulitis', 'Bartonellosis (Cat scratch disease)', 'Capnocytophaga infection'],
    positiveSigns: ['Rapid onset of intense pain, swelling, and erythema at bite site', 'History of a cat or dog bite/scratch within 24 hours'],
    negativeSigns: ['Absence of delayed onset (symptoms start within hours)', 'Absence of response to first-generation cephalosporins'],
    definitiveTreatment: 'Amoxicillin-Clavulanate (Drug of Choice)',
    supportiveTreatment: 'Wound irrigation, tetanus prophylaxis, rabies post-exposure prophylaxis (if indicated)',
    redFlags: ['Rapidly developing cellulitis following a feline or canine bite'],
    cautions: [],
    meds: [
      mk('Augmentin 625', 'Amoxicillin + Clavulanate', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Tetglob', 'Tetanus Immunoglobulin', 'Stat IM', 'Stat IM', '1', 'Hospital Use'),
    ],
  },
  {
    id: 'ac-156',
    label: 'Rat-Bite Fever',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Rat-Bite Fever'],
    pathognomonic: 'Fever, rash, and arthritis following a rat bite or exposure to rodents',
    definitiveTest: 'Blood or joint fluid culture (requires specialized media for Streptobacillus moniliformis)',
    supportiveTests: ['CBC (leukocytosis)', 'ESR/CRP (elevated)'],
    ddx: ['Rocky Mountain Spotted Fever', 'Secondary Syphilis', 'Lyme Disease', 'Meningococcemia'],
    positiveSigns: ['Relapsing fever, rigors, and migratory polyarthralgia', 'Maculopapular or petechial rash on extremities (palms/soles)'],
    negativeSigns: ['Absence of generalized lymphadenopathy (usually)', 'Absence of response to macrolides'],
    definitiveTreatment: 'Intravenous Penicillin G followed by oral Amoxicillin',
    supportiveTreatment: 'Doxycycline if penicillin-allergic, NSAIDs for joint pain',
    redFlags: ['Fever, rash, and arthritis following a rat bite or exposure to rodents'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', '14', 'जेवणानंतर'),
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-157',
    label: 'Relapsing Fever (Borrelia)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Relapsing Fever (Borrelia)', 'Borrelia', 'Relapsing Fever'],
    pathognomonic: 'Spirochetes visible on peripheral blood smear during febrile episodes',
    definitiveTest: 'Dark-field microscopy or Giemsa/Wright stain of peripheral blood showing spirochetes',
    supportiveTests: ['CBC (thrombocytopenia, normal to high WBC)', 'LFTs (mildly elevated)'],
    ddx: ['Malaria', 'Dengue Fever', 'Typhoid Fever', 'Brucellosis'],
    positiveSigns: ['Recurrent episodes of high fever lasting days, separated by afebrile periods', 'History of tick or louse exposure in endemic areas'],
    negativeSigns: ['Absence of continuous fever', 'Absence of typical malarial parasites on smear'],
    definitiveTreatment: 'Doxycycline or Erythromycin (for children/pregnant women)',
    supportiveTreatment: 'Monitor for Jarisch-Herxheimer reaction (fever, chills, hypotension) after starting antibiotics',
    redFlags: ['Monitor for Jarisch-Herxheimer reaction (fever'],
    cautions: [],
    meds: [
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Althrocin 500', 'Erythromycin', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-158',
    label: 'Murine Typhus (Endemic Typhus)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Murine Typhus (Endemic Typhus)', 'Endemic Typhus', 'Murine Typhus'],
    pathognomonic: 'Fever and rash with a history of exposure to rat fleas (often in urban/port areas)',
    definitiveTest: 'Serology (IFA) for Rickettsia typhi',
    supportiveTests: ['CBC (thrombocytopenia, mild leukopenia)', 'LFTs (elevated transaminases)'],
    ddx: ['Scrub Typhus', 'Dengue Fever', 'Measles', 'Epidemic Typhus'],
    positiveSigns: ['Fever, severe headache, and myalgia', 'Maculopapular rash spreading from trunk to extremities'],
    negativeSigns: ['Absence of eschar (unlike Scrub Typhus)', 'Absence of tick exposure (flea-borne)'],
    definitiveTreatment: 'Doxycycline (Drug of Choice)',
    supportiveTreatment: 'Antipyretics (Paracetamol), hydration',
    redFlags: ['Fever and rash with a history of exposure to rat fleas (often in urban/port areas)'],
    cautions: [],
    meds: [
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-159',
    label: 'Epidemic Typhus',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Epidemic Typhus'],
    pathognomonic: 'Severe febrile illness with rash in crowded, unhygienic conditions (louse-borne)',
    definitiveTest: 'Serology (IFA) for Rickettsia prowazekii',
    supportiveTests: ['Weil-Felix test (historical, non-specific)', 'Skin biopsy (immunohistochemistry)'],
    ddx: ['Meningococcemia', 'Typhoid Fever', 'Malaria', 'Murine Typhus'],
    positiveSigns: ['Abrupt onset of high fever, intractable headache, and prostration', 'Petechial rash starting on trunk and spreading (sparing face/palms/soles)'],
    negativeSigns: ['Absence of eschar', 'Absence of rash on face, palms, and soles (usually)'],
    definitiveTreatment: 'Doxycycline (Drug of Choice, highly effective)',
    supportiveTreatment: 'Delousing of patient and clothing, aggressive supportive care for severe cases',
    redFlags: ['Severe febrile illness with rash in crowded, unhygienic conditions (louse-borne)'],
    cautions: [],
    meds: [
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Permite 5%', 'Permethrin Cream', '5%', 'Single application', '1', 'अंघोळीनंतर'),
    ],
  },
  {
    id: 'ac-160',
    label: 'Yaws',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Yaws'],
    pathognomonic: 'Raspberry-like papillomas and bone lesions in a child from an endemic tropical region',
    definitiveTest: 'Dark-field microscopy of lesion exudate showing spirochetes (indistinguishable from Syphilis)',
    supportiveTests: ['VDRL/RPR and TPHA/FTA-ABS (both will be positive, just like Syphilis)'],
    ddx: ['Syphilis', 'Leishmaniasis', 'Leprosy', 'Scabies with secondary infection'],
    positiveSigns: ['Painless, raspberry-like skin papilloma (mother yaw)', 'Bone and joint pain with secondary skin lesions'],
    negativeSigns: ['Absence of sexual transmission (transmitted by skin-to-skin contact in children)', 'Absence of CNS/cardiovascular involvement (unlike Syphilis)'],
    definitiveTreatment: 'Single dose of Oral Azithromycin (Drug of Choice for eradication)',
    supportiveTreatment: 'Intramuscular Benzathine Penicillin G is the historical alternative',
    redFlags: ['Raspberry-like papillomas and bone lesions in a child from an endemic tropical region'],
    cautions: [],
    meds: [
      mk('Azee 500', 'Azithromycin', '30 mg/kg single dose', '30 mg/kg single dose', '1', 'जेवणानंतर'),
      mk('Penidure LA 12', 'Benzathine Penicillin', '1.2 MU IM single dose', '1.2 MU IM single dose', '1', 'Hospital Use'),
    ],
  },
  {
    id: 'ac-161',
    label: 'Mycoplasma genitalium Infection',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Mycoplasma genitalium Infection'],
    pathognomonic: 'Non-gonococcal urethritis (NGU) that fails to respond to Doxycycline',
    definitiveTest: 'Nucleic Acid Amplification Test (NAAT) for M. genitalium (urine or swab)',
    supportiveTests: ['Gram stain of urethral discharge (shows WBCs but no organisms)'],
    ddx: ['Chlamydia trachomatis', 'Gonorrhea', 'Trichomoniasis', 'Ureaplasma infection'],
    positiveSigns: ['Persistent or recurrent urethritis (dysuria, discharge)', 'Cervicitis or Pelvic Inflammatory Disease in women'],
    negativeSigns: ['Absence of Neisseria gonorrhoeae and Chlamydia trachomatis on testing', 'Absence of response to standard Doxycycline course'],
    definitiveTreatment: 'Moxifloxacin for 7 days (due to high macrolide resistance)',
    supportiveTreatment: 'Azithromycin (extended course) if macrolide-susceptible, treat sexual partners',
    redFlags: ['Non-gonococcal urethritis (NGU) that fails to respond to Doxycycline'],
    cautions: [],
    meds: [
      mk('Moxif 400', 'Moxifloxacin', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
      mk('Azee 500', 'Azithromycin', '500mg day 1, 250mg days 2-5', '500mg day 1, 250mg days 2-5', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-162',
    label: 'Chlamydia trachomatis (Urogenital)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Chlamydia trachomatis (Urogenital)', 'Urogenital', 'Chlamydia trachomatis'],
    pathognomonic: 'Most common cause of non-gonococcal urethritis (NGU)',
    definitiveTest: 'Nucleic Acid Amplification Test (NAAT) from urine or vaginal/urethral swab',
    supportiveTests: ['Urinalysis (pyuria without bacteriuria)'],
    ddx: ['Gonorrhea', 'Mycoplasma genitalium', 'Trichomoniasis', 'Urinary Tract Infection'],
    positiveSigns: ['Dysuria and clear/watery urethral discharge', 'Often asymptomatic, especially in women (cervicitis)'],
    negativeSigns: ['Absence of purulent/thick discharge (more typical of Gonorrhea)', 'Absence of organisms on Gram stain (intracellular)'],
    definitiveTreatment: 'Doxycycline 100mg BD for 7 days (Current CDC preferred)',
    supportiveTreatment: 'Azithromycin 1g single dose (alternative), treat sexual partners',
    redFlags: ['Most common cause of non-gonococcal urethritis (NGU)'],
    cautions: [],
    meds: [
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Azee 1000', 'Azithromycin', '1g single dose', '1g single dose', '1', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-163',
    label: 'Toxic Shock Syndrome (Staphylococcal)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Toxic Shock Syndrome (Staphylococcal)', 'Staphylococcal', 'Toxic Shock Syndrome'],
    pathognomonic: 'Fever, hypotension, and sunburn-like rash with multiorgan involvement',
    definitiveTest: 'Clinical criteria + isolation of S. aureus from mucosal site/wound',
    supportiveTests: ['CBC, CMP (renal/hepatic failure), Coagulation profile (DIC)'],
    ddx: ['Streptococcal Toxic Shock Syndrome', 'Kawasaki Disease', 'Scarlet Fever', 'Meningococcemia'],
    positiveSigns: ['Sudden onset high fever, hypotension, and diffuse macular erythroderma (sunburn-like rash)', 'Desquamation of palms and soles 1-2 weeks later'],
    negativeSigns: ['Absence of positive blood cultures (usually negative, toxin-mediated)', 'Absence of localized purulent infection (often associated with tampons or nasal packing)'],
    definitiveTreatment: 'Clindamycin (suppresses toxin production) + Vancomycin or Linezolid',
    supportiveTreatment: 'Aggressive IV fluids, vasopressors, removal of foreign body (tampon/packing)',
    redFlags: ['Fever, hypotension, and sunburn-like rash with multiorgan involvement'],
    cautions: [],
    meds: [
      mk('Dalacin C 600', 'Clindamycin', '600mg IV every 8 hours', '600mg IV every 8 hours', '10-14', 'Hospital Use (Inj.)'),
      mk('Vanco', 'Vancomycin', '15-20 mg/kg IV every 8-12 hours', '15-20 mg/kg IV every 8-12 hours', '10-14', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-164',
    label: 'Staphylococcal Scalded Skin Syndrome (SSSS)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Staphylococcal Scalded Skin Syndrome (SSSS)', 'SSSS', 'Staphylococcal Scalded Skin Syndrome'],
    pathognomonic: 'Widespread superficial blistering and exfoliation with a positive Nikolsky sign in an infant/child',
    definitiveTest: 'Clinical diagnosis; culture of distant focus (e.g., umbilicus, conjunctiva) for S. aureus',
    supportiveTests: ['Skin biopsy (cleavage at stratum granulosum) - rarely needed'],
    ddx: ['Stevens-Johnson Syndrome (SJS)', 'Toxic Epidermal Necrolysis (TEN)', 'Bullous Impetigo', 'Kawasaki Disease'],
    positiveSigns: ['Fever, irritability, and diffuse erythema', 'Flaccid blisters that rupture easily, leaving raw, red skin (positive Nikolsky sign)'],
    negativeSigns: ['Absence of mucosal involvement (spares mucous membranes, unlike SJS/TEN)', 'Absence of deep tissue necrosis'],
    definitiveTreatment: 'Intravenous anti-staphylococcal penicillins (Oxacillin/Nafcillin) or Cefazolin',
    supportiveTreatment: 'Vancomycin if MRSA suspected, gentle wound care, fluid/electrolyte management',
    redFlags: ['Widespread superficial blistering and exfoliation with a positive Nikolsky sign in an infant/child'],
    cautions: [],
    meds: [
      mk('Reflin', 'Cefazolin', 'IV every 8 hours', 'IV every 8 hours', '7-10', 'Hospital Use (Inj.)'),
      mk('Vanco', 'Vancomycin', 'IV every 6-8 hours', 'IV every 6-8 hours', '7-10', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-165',
    label: 'Scarlet Fever',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Scarlet Fever'],
    pathognomonic: 'Sandpaper rash with Pastia\'s lines (accentuation in skin folds) following Strep pharyngitis',
    definitiveTest: 'Rapid Strep Test (RADT) or Throat Culture positive for Group A Streptococcus',
    supportiveTests: ['ASO titer (elevated later)'],
    ddx: ['Kawasaki Disease', 'Measles', 'Rubella', 'Drug Eruption'],
    positiveSigns: ['Sore throat, fever, and "strawberry tongue"', 'Fine, sandpaper-like erythematous rash sparing the circumoral area (circumoral pallor)'],
    negativeSigns: ['Absence of conjunctivitis (unlike Kawasaki/Measles)', 'Absence of severe systemic toxicity (usually)'],
    definitiveTreatment: 'Oral Penicillin V or Amoxicillin for 10 days',
    supportiveTreatment: 'Azithromycin or Cephalexin if penicillin-allergic, antipyretics',
    redFlags: ['Sandpaper rash with Pastia\'s lines (accentuation in skin folds) following Strep pharyngitis'],
    cautions: [],
    meds: [
      mk('Novamox 500', 'Amoxicillin', '1 - 1 - 1', '1 - 1 - 1', '10', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-166',
    label: 'Post-Streptococcal Glomerulonephritis (PSGN)',
    group: 'Immunological',
    category: 'Autoimmune/Post-infectious',
    aliases: ['Post-Streptococcal Glomerulonephritis (PSGN)', 'PSGN', 'Post-Streptococcal Glomerulonephritis'],
    pathognomonic: 'Nephritic syndrome 1-3 weeks after a Group A Strep infection with low C3 complement',
    definitiveTest: 'Low serum C3 complement + Positive ASO or Anti-DNase B titers',
    supportiveTests: ['Urinalysis (RBC casts, mild proteinuria)', 'Renal function tests (elevated BUN/Creatinine)'],
    ddx: ['IgA Nephropathy', 'Lupus Nephritis', 'Membranoproliferative Glomerulonephritis', 'Alport Syndrome'],
    positiveSigns: ['Hematuria (cola-colored urine), edema (periorbital), and hypertension', 'History of Strep throat or skin infection (impetigo) 1-3 weeks prior'],
    negativeSigns: ['Absence of active bacterial infection in the kidneys', 'Absence of severe proteinuria (nephrotic range)'],
    definitiveTreatment: 'Supportive care (disease is usually self-limiting)',
    supportiveTreatment: 'Loop diuretics (Furosemide) for edema/hypertension, anti-hypertensives, treat active Strep if present',
    redFlags: ['Nephritic syndrome 1-3 weeks after a Group A Strep infection with low C3 complement'],
    cautions: [],
    meds: [
      mk('Lasix 40', 'Furosemide', '1 - 0 - 0', '1 - 0 - 0', 'As needed', 'सकाळी'),
      mk('Amlodac 5', 'Amlodipine', '1 - 0 - 0', '1 - 0 - 0', 'As needed', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-167',
    label: 'Trichuriasis (Whipworm)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Trichuriasis (Whipworm)', 'Whipworm', 'Trichuriasis'],
    pathognomonic: 'Barrel-shaped eggs with bipolar plugs in stool microscopy',
    definitiveTest: 'Stool microscopy for Trichuris trichiura eggs',
    supportiveTests: ['CBC (Eosinophilia, microcytic anemia from chronic blood loss)'],
    ddx: ['Ascariasis', 'Hookworm infection', 'Amoebiasis', 'Inflammatory Bowel Disease'],
    positiveSigns: ['Chronic abdominal pain, diarrhea, and weight loss', 'Rectal prolapse in severe infections (especially in children)'],
    negativeSigns: ['Absence of pulmonary migration phase (no Loeffler\'s syndrome, unlike Ascaris)', 'Absence of severe acute fever'],
    definitiveTreatment: 'Mebendazole or Albendazole for 3 days',
    supportiveTreatment: 'Iron supplementation for anemia, manual reduction of rectal prolapse',
    redFlags: ['Barrel-shaped eggs with bipolar plugs in stool microscopy'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 0', '1 - 0 - 0', '3', 'जेवणानंतर'),
      mk('Dexorange', 'Iron + Folic Acid', '1 tsp BD', '1 tsp BD', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-168',
    label: 'Clonorchiasis (Chinese Liver Fluke)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Clonorchiasis (Chinese Liver Fluke)', 'Chinese Liver Fluke', 'Clonorchiasis'],
    pathognomonic: 'Biliary obstruction/cholangitis associated with consumption of raw freshwater fish',
    definitiveTest: 'Stool microscopy for small, operculated eggs',
    supportiveTests: ['Ultrasound/CT (dilated intrahepatic bile ducts)', 'CBC (Eosinophilia)'],
    ddx: ['Opisthorchiasis', 'Fascioliasis', 'Cholangiocarcinoma (can be a complication)', 'Choledocholithiasis'],
    positiveSigns: ['Right upper quadrant pain, jaundice, and hepatomegaly', 'History of eating raw/undercooked freshwater fish in endemic areas (Asia)'],
    negativeSigns: ['Absence of acute severe sepsis (usually chronic/indolent)', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'Praziquantel (25 mg/kg TID for 1-2 days)',
    supportiveTreatment: 'Albendazole (alternative), surgical/endoscopic relief of biliary obstruction if severe',
    redFlags: ['Biliary obstruction/cholangitis associated with consumption of raw freshwater fish'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '25 mg/kg TID', '25 mg/kg TID', '2', 'जेवणानंतर'),
      mk('Zentel 400', 'Albendazole', '10 mg/kg/day', '10 mg/kg/day', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-169',
    label: 'Paragonimiasis (Lung Fluke)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Paragonimiasis (Lung Fluke)', 'Lung Fluke', 'Paragonimiasis'],
    pathognomonic: 'Hemoptysis and cavitary lung lesions mimicking TB, but with eosinophilia and raw crab consumption',
    definitiveTest: 'Microscopy of sputum or stool for large, operculated eggs',
    supportiveTests: ['Chest X-ray (ring shadows, cavities, pleural effusion)', 'CBC (Eosinophilia)', 'Serology'],
    ddx: ['Pulmonary Tuberculosis', 'Lung Cancer', 'Bronchiectasis', 'Histoplasmosis'],
    positiveSigns: ['Chronic cough with rusty-brown or blood-tinged sputum', 'History of eating raw/undercooked freshwater crabs or crayfish'],
    negativeSigns: ['Absence of response to anti-tuberculosis therapy', 'Absence of typical bacterial pneumonia signs'],
    definitiveTreatment: 'Praziquantel (25 mg/kg TID for 2-3 days)',
    supportiveTreatment: 'Triclabendazole (alternative), management of pleural effusions',
    redFlags: ['Hemoptysis and cavitary lung lesions mimicking TB, but with eosinophilia and raw crab consumption'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '25 mg/kg TID', '25 mg/kg TID', '3', 'जेवणानंतर'),
      mk('Egaten', 'Triclabendazole', '10 mg/kg BD', '10 mg/kg BD', '1', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-170',
    label: 'Capillariasis (Intestinal)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Capillariasis (Intestinal)', 'Intestinal', 'Capillariasis'],
    pathognomonic: 'Severe protein-losing enteropathy and cachexia after eating raw freshwater fish (Philippines/Thailand)',
    definitiveTest: 'Stool microscopy for peanut-shaped eggs with flattened bipolar plugs',
    supportiveTests: ['Serum albumin (profoundly low)', 'Electrolytes (hypokalemia)'],
    ddx: ['Strongyloidiasis', 'Giardiasis', 'Tropical Sprue', 'Celiac Disease'],
    positiveSigns: ['Chronic watery diarrhea, borborygmi, and severe weight loss', 'Protein-losing enteropathy (edema, cachexia)'],
    negativeSigns: ['Absence of bloody diarrhea', 'Absence of response to standard anti-diarrheals'],
    definitiveTreatment: 'Albendazole (400mg/day) or Mebendazole (200mg BD) for 20-30 days',
    supportiveTreatment: 'Aggressive correction of electrolytes and protein malnutrition',
    redFlags: ['Severe protein-losing enteropathy and cachexia after eating raw freshwater fish (Philippines/Thailand)'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 0', '1 - 0 - 0', '20-30', 'जेवणानंतर'),
      mk('Electral', 'ORS/Electrolytes', 'Frequent', 'Frequent', 'Weeks', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-171',
    label: 'Gnathostomiasis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Gnathostomiasis'],
    pathognomonic: 'Migratory panniculitis/subcutaneous swellings with marked eosinophilia',
    definitiveTest: 'Clinical diagnosis + Serology (Immunoblot). Biopsy rarely yields the worm.',
    supportiveTests: ['CBC (Marked eosinophilia)'],
    ddx: ['Cutaneous Larva Migrans', 'Loiasis', 'Sparganosis', 'Angioedema'],
    positiveSigns: ['Migratory, intermittent subcutaneous swellings', 'History of eating raw freshwater fish, poultry, or frogs'],
    negativeSigns: ['Absence of fixed lesions (swellings move over days/weeks)', 'Absence of adult worms in humans'],
    definitiveTreatment: 'Albendazole (400mg BD for 21 days) or Ivermectin (single dose)',
    supportiveTreatment: 'Surgical removal of the worm if it becomes superficial and visible',
    redFlags: ['Migratory panniculitis/subcutaneous swellings with marked eosinophilia'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '21', 'जेवणानंतर'),
      mk('Ivecop 12', 'Ivermectin', '200 mcg/kg single dose', '200 mcg/kg single dose', '1', 'उपाशी पोटी'),
    ],
  },
  {
    id: 'ac-172',
    label: 'Anisakiasis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Anisakiasis'],
    pathognomonic: 'Acute "gastric" or "intestinal" pain shortly after eating sushi, sometimes coughing up a worm',
    definitiveTest: 'Upper GI Endoscopy (visualizing and removing the larva)',
    supportiveTests: ['CBC (mild eosinophilia may develop later)', 'Ultrasound (bowel wall thickening)'],
    ddx: ['Peptic Ulcer Disease', 'Acute Appendicitis', 'Food Poisoning', 'Gastric Ulcer'],
    positiveSigns: ['Severe, acute epigastric pain, nausea, and vomiting', 'History of eating raw marine fish or squid (sushi/sashimi) within hours/days'],
    negativeSigns: ['Absence of prolonged incubation (symptoms start rapidly)', 'Absence of response to antacids'],
    definitiveTreatment: 'Endoscopic removal of the larva is curative',
    supportiveTreatment: 'Albendazole (if endoscopic removal is not possible or successful)',
    redFlags: ['Acute "gastric" or "intestinal" pain shortly after eating sushi, sometimes coughing up a worm'],
    cautions: [],
    meds: [
      mk('Zentel 400', 'Albendazole', '1 - 0 - 1', '1 - 0 - 1', '3-5', 'जेवणानंतर'),
      mk('Pan 40', 'Pantoprazole', '1 - 0 - 0', '1 - 0 - 0', '5', 'उपाशी पोटी'),
    ],
  },
  {
    id: 'ac-173',
    label: 'Angiostrongyliasis (Rat Lungworm)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Angiostrongyliasis (Rat Lungworm)', 'Rat Lungworm', 'Angiostrongyliasis'],
    pathognomonic: 'Eosinophilic meningitis following consumption of raw snails or unwashed lettuce',
    definitiveTest: 'CSF analysis showing eosinophilic pleocytosis (>10% eosinophils)',
    supportiveTests: ['Serology (if available)', 'CBC (Peripheral eosinophilia)'],
    ddx: ['Gnathostomiasis (CNS)', 'Neurocysticercosis', 'Tuberculous Meningitis', 'Viral Meningitis'],
    positiveSigns: ['Severe headache, neck stiffness, and paresthesias', 'History of eating raw snails, slugs, or contaminated produce'],
    negativeSigns: ['Absence of bacteria on CSF culture', 'Absence of purulent CSF profile'],
    definitiveTreatment: 'Supportive care (often self-limiting). Corticosteroids to reduce inflammation.',
    supportiveTreatment: 'Repeated therapeutic lumbar punctures for severe headache. (Anthelminthics are controversial as dying worms worsen inflammation).',
    redFlags: ['Eosinophilic meningitis following consumption of raw snails or unwashed lettuce'],
    cautions: [],
    meds: [
      mk('Wysolone 20', 'Prednisolone', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'दुखीसाठी'),
    ],
  },
  {
    id: 'ac-174',
    label: 'Fasciolopsiasis (Intestinal Fluke)',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Fasciolopsiasis (Intestinal Fluke)', 'Intestinal Fluke', 'Fasciolopsiasis'],
    pathognomonic: 'Intestinal symptoms and edema after consuming raw aquatic plants in Asia',
    definitiveTest: 'Stool microscopy for large, unembryonated, operculated eggs',
    supportiveTests: ['CBC (Eosinophilia)', 'Endoscopy (may visualize adult flukes attached to mucosa)'],
    ddx: ['Fascioliasis', 'Ascariasis', 'Peptic Ulcer Disease', 'Malabsorption syndromes'],
    positiveSigns: ['Abdominal pain, diarrhea, and facial/generalized edema', 'History of eating raw aquatic plants (water caltrop, water chestnut)'],
    negativeSigns: ['Absence of liver involvement (unlike Fasciola hepatica)', 'Absence of bloody diarrhea'],
    definitiveTreatment: 'Praziquantel (25 mg/kg TID for 1 day)',
    supportiveTreatment: 'Nutritional support, management of edema',
    redFlags: ['Intestinal symptoms and edema after consuming raw aquatic plants in Asia'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '25 mg/kg TID', '25 mg/kg TID', '1', 'जेवणानंतर'),
      mk('B-Complex', 'Multivitamins', '1 - 0 - 0', '1 - 0 - 0', '30', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-175',
    label: 'Echinostomiasis',
    group: 'Parasitic',
    category: 'Parasitic',
    aliases: ['Echinostomiasis'],
    pathognomonic: 'Intestinal symptoms associated with eating raw snails/clams, with operculated eggs in stool',
    definitiveTest: 'Stool microscopy for operculated eggs (difficult to distinguish from Fasciola/Fasciolopsis)',
    supportiveTests: ['CBC (Mild eosinophilia)'],
    ddx: ['Fasciolopsiasis', 'Giardiasis', 'Intestinal Amoebiasis', 'Food Poisoning'],
    positiveSigns: ['Mild abdominal pain, diarrhea, and fatigue', 'History of eating raw/undercooked freshwater snails, clams, or fish'],
    negativeSigns: ['Absence of severe systemic toxicity', 'Absence of tissue migration (remains in intestine)'],
    definitiveTreatment: 'Praziquantel (25 mg/kg TID for 1 day)',
    supportiveTreatment: 'Hydration, symptomatic relief',
    redFlags: ['Intestinal symptoms associated with eating raw snails/clams, with operculated eggs in stool'],
    cautions: [],
    meds: [
      mk('Distocide 600', 'Praziquantel', '25 mg/kg TID', '25 mg/kg TID', '1', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'As needed', 'As needed', '3', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-176',
    label: 'Hantavirus Pulmonary Syndrome (HPS)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Hantavirus Pulmonary Syndrome (HPS)', 'HPS', 'Hantavirus Pulmonary Syndrome'],
    pathognomonic: 'Severe unexplained respiratory distress with profound thrombocytopenia and hemoconcentration after rodent exposure',
    definitiveTest: 'Hantavirus IgM/IgG Serology or RT-PCR of blood/tissue',
    supportiveTests: ['Chest X-ray (bilateral interstitial infiltrates)', 'CBC (Thrombocytopenia, elevated hematocrit)'],
    ddx: ['ARDS from other causes', 'Pneumococcal Pneumonia', 'Influenza', 'Leptospirosis'],
    positiveSigns: ['Rapid onset of non-cardiogenic pulmonary edema', 'History of exposure to rodent droppings (especially deer mice)'],
    negativeSigns: ['Absence of purulent sputum', 'Absence of prior cardiac disease explaining the edema'],
    definitiveTreatment: 'Supportive care (No specific antiviral is FDA approved)',
    supportiveTreatment: 'Early ICU admission, mechanical ventilation, ECMO for severe refractory hypoxemia',
    redFlags: ['Early ICU admission', 'mechanical ventilation'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Oxygen Therapy', 'Oxygen', 'Continuous', 'Continuous', 'As needed', 'ICU'),
    ],
  },
  {
    id: 'ac-177',
    label: 'Ebola Virus Disease',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Ebola Virus Disease'],
    pathognomonic: 'Severe hemorrhagic fever with a history of travel to an endemic area (Sub-Saharan Africa) or contact with a known case',
    definitiveTest: 'Ebola virus RT-PCR (blood)',
    supportiveTests: ['CBC (Leukopenia, severe thrombocytopenia)', 'CMP (Elevated AST/ALT, renal failure)'],
    ddx: ['Marburg Virus Disease', 'Lassa Fever', 'Malaria', 'Typhoid Fever'],
    positiveSigns: ['Unexplained hemorrhage (bleeding gums, melena)', 'High fever, profound weakness, and severe GI symptoms (vomiting/diarrhea)'],
    negativeSigns: ['Absence of response to antimalarials/antibiotics', 'Absence of alternative explanation for severe hemorrhagic fever'],
    definitiveTreatment: 'Monoclonal antibodies (Inmazeb or Ebanga) if available',
    supportiveTreatment: 'Aggressive IV fluid resuscitation, electrolyte replacement, blood products',
    redFlags: ['Severe hemorrhagic fever with a history of travel to an endemic area (Sub-Saharan Africa) or contact with a known case'],
    cautions: [],
    meds: [
      mk('Electral', 'ORS', 'Aggressive', 'Aggressive', 'Weeks', 'तहान लागेल तेव्हा (Inj.)'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-178',
    label: 'Marburg Virus Disease',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Marburg Virus Disease'],
    pathognomonic: 'Hemorrhagic fever following exposure to African fruit bats (Rousettus aegyptiacus) or caves/mines',
    definitiveTest: 'Marburg virus RT-PCR',
    supportiveTests: ['CBC (Thrombocytopenia, leukopenia)', 'Coagulation profile (DIC)'],
    ddx: ['Ebola Virus Disease', 'Lassa Fever', 'Yellow Fever', 'Malaria'],
    positiveSigns: ['High fever, severe headache, and malaise', 'Maculopapular rash followed by severe hemorrhagic manifestations'],
    negativeSigns: ['Absence of specific antiviral response', 'Clinically indistinguishable from Ebola without lab testing'],
    definitiveTreatment: 'Supportive care (No specific approved antiviral)',
    supportiveTreatment: 'Aggressive IV fluids, maintenance of oxygen status and blood pressure, treatment of complicating infections',
    redFlags: ['Hemorrhagic fever following exposure to African fruit bats (Rousettus aegyptiacus) or caves/mines'],
    cautions: [],
    meds: [
      mk('Electral', 'ORS', 'Aggressive', 'Aggressive', 'Weeks', 'तहान लागेल तेव्हा (Inj.)'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-179',
    label: 'Lassa Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Lassa Fever'],
    pathognomonic: 'Hemorrhagic fever with sensorineural hearing loss (a common complication) in West Africa',
    definitiveTest: 'Lassa virus RT-PCR or ELISA for Lassa Antigen',
    supportiveTests: ['Urinalysis (Proteinuria)', 'LFTs (AST > ALT)'],
    ddx: ['Ebola Virus Disease', 'Malaria', 'Typhoid Fever', 'Yellow Fever'],
    positiveSigns: ['Gradual onset of fever, retrosternal pain, and sore throat', 'Facial swelling and mucosal bleeding in severe cases'],
    negativeSigns: ['Absence of massive hemorrhage (less common than in Ebola)', 'Absence of rapid onset (starts insidiously)'],
    definitiveTreatment: 'Intravenous Ribavirin (most effective if given within the first 6 days)',
    supportiveTreatment: 'Fluid and electrolyte balance, oxygenation, blood pressure support',
    redFlags: ['Hemorrhagic fever with sensorineural hearing loss (a common complication) in West Africa'],
    cautions: [],
    meds: [
      mk('Ribavin', 'Ribavirin', 'IV Protocol', 'IV Protocol', '10', 'Hospital Use (Inj.)'),
      mk('Electral', 'ORS', 'As needed', 'As needed', 'Weeks', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-180',
    label: 'Yellow Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Yellow Fever'],
    pathognomonic: 'Jaundice, hemorrhagic symptoms, and relative bradycardia (Faget sign) in an unvaccinated traveler to an endemic zone',
    definitiveTest: 'Yellow Fever virus RT-PCR (early) or IgM Serology (later)',
    supportiveTests: ['LFTs (Severe transaminitis)', 'Urinalysis (Albuminuria)'],
    ddx: ['Severe Malaria', 'Viral Hepatitis (A, B, C, E)', 'Dengue Hemorrhagic Fever', 'Leptospirosis'],
    positiveSigns: ['Sudden onset of fever, chills, and severe back pain', 'Jaundice and hematemesis ("black vomit") in the toxic phase'],
    negativeSigns: ['Absence of tachycardia (Faget sign: relative bradycardia despite high fever)', 'Absence of response to antibiotics'],
    definitiveTreatment: 'Supportive care (No specific antiviral)',
    supportiveTreatment: 'Avoid NSAIDs/Aspirin (bleeding risk). IV fluids, dialysis for renal failure, FFP for bleeding.',
    redFlags: ['dialysis for renal failure'],
    cautions: ['Avoid NSAIDs/Aspirin (bleeding risk)'],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Pantocid IV', 'Pantoprazole', '40mg IV OD', '40mg IV OD', '5', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-181',
    label: 'West Nile Virus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['West Nile Virus Infection'],
    pathognomonic: 'Acute asymmetric flaccid paralysis (polio-like) with encephalitis during mosquito season',
    definitiveTest: 'WNV IgM in CSF or serum',
    supportiveTests: ['CSF analysis (lymphocytic pleocytosis, elevated protein)', 'MRI Brain (leptomeningeal enhancement)'],
    ddx: ['Enterovirus Encephalitis', 'Herpes Simplex Encephalitis', 'Guillain-Barré Syndrome', 'Poliomyelitis'],
    positiveSigns: ['Fever, headache, and maculopapular rash', 'Flaccid paralysis or encephalitis in severe neuroinvasive cases'],
    negativeSigns: ['Absence of purulent CSF', 'Absence of sensory loss in paralyzed limbs (it is a pure motor anterior horn cell process)'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Pain control, IV fluids, respiratory support for severe paralysis',
    redFlags: ['Acute asymmetric flaccid paralysis (polio-like) with encephalitis during mosquito season'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Mannitol', 'Mannitol 20%', 'IV', 'IV', 'As needed', 'Hospital Use (for ICP) (Inj.)'),
    ],
  },
  {
    id: 'ac-182',
    label: 'Rift Valley Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Rift Valley Fever'],
    pathognomonic: 'Acute febrile illness with macular retinal lesions following exposure to infected livestock/mosquitoes',
    definitiveTest: 'RVF virus RT-PCR or IgM Serology',
    supportiveTests: ['Fundoscopy (retinal hemorrhages/exudates)', 'LFTs (elevated)'],
    ddx: ['Crimean-Congo Hemorrhagic Fever', 'Q Fever', 'Brucellosis', 'Malaria'],
    positiveSigns: ['Fever, severe myalgia, and photophobia', 'Retinitis (vision loss) or hemorrhagic fever in severe cases'],
    negativeSigns: ['Absence of human-to-human transmission (usually)', 'Absence of chronic infection'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Ophthalmologic evaluation for retinitis, supportive care for hemorrhagic/encephalitic complications',
    redFlags: ['Acute febrile illness with macular retinal lesions following exposure to infected livestock/mosquitoes'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Electral', 'ORS', 'As needed', 'As needed', '5', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-183',
    label: 'Severe Acute Respiratory Syndrome (SARS)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Severe Acute Respiratory Syndrome (SARS)', 'SARS', 'Severe Acute Respiratory Syndrome'],
    pathognomonic: 'Atypical pneumonia progressing rapidly to ARDS with a specific epidemiological link to SARS-CoV-1',
    definitiveTest: 'SARS-CoV-1 RT-PCR',
    supportiveTests: ['Chest X-ray (ground-glass opacities)', 'CBC (Lymphopenia)'],
    ddx: ['COVID-19 (SARS-CoV-2)', 'MERS', 'Avian Influenza', 'Legionnaires\' Disease'],
    positiveSigns: ['High fever, dry cough, and shortness of breath', 'History of exposure during the 2002-2004 outbreak (currently no known natural transmission)'],
    negativeSigns: ['Absence of prominent upper respiratory symptoms (runny nose is rare)', 'Absence of response to standard antibiotics'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Mechanical ventilation, Corticosteroids for severe lung inflammation',
    redFlags: ['Mechanical ventilation'],
    cautions: [],
    meds: [
      mk('Wysolone 40', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '7-14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-184',
    label: 'Middle East Respiratory Syndrome (MERS)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Middle East Respiratory Syndrome (MERS)', 'MERS', 'Middle East Respiratory Syndrome'],
    pathognomonic: 'Severe atypical pneumonia with acute kidney injury and a history of contact with dromedary camels or travel to the Middle East',
    definitiveTest: 'MERS-CoV RT-PCR (lower respiratory tract specimens preferred)',
    supportiveTests: ['CMP (Elevated Creatinine/BUN)', 'Chest CT (bilateral infiltrates)'],
    ddx: ['COVID-19', 'SARS', 'Pneumococcal Pneumonia', 'Avian Influenza'],
    positiveSigns: ['Fever, cough, and severe shortness of breath', 'Acute renal failure (more common than in SARS/COVID-19)'],
    negativeSigns: ['Absence of widespread community transmission (mostly healthcare or camel-linked)', 'Absence of response to antibiotics'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Mechanical ventilation, hemodialysis for renal failure, ECMO',
    redFlags: ['Mechanical ventilation', 'hemodialysis for renal failure'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Oxygen Therapy', 'Oxygen', 'Continuous', 'Continuous', 'As needed', 'ICU'),
    ],
  },
  {
    id: 'ac-185',
    label: 'Avian Influenza (H5N1)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Avian Influenza (H5N1)', 'H5N1', 'Avian Influenza'],
    pathognomonic: 'Rapidly progressive primary viral pneumonia with ARDS after handling infected poultry',
    definitiveTest: 'RT-PCR specific for H5N1 from respiratory secretions',
    supportiveTests: ['Chest X-ray (diffuse, multifocal infiltrates)', 'CBC (Leukopenia, lymphopenia)'],
    ddx: ['Seasonal Influenza', 'COVID-19', 'SARS/MERS', 'Mycoplasma Pneumonia'],
    positiveSigns: ['High fever, cough, and rapid progression to severe pneumonia', 'History of exposure to sick/dead poultry or birds'],
    negativeSigns: ['Absence of sustained human-to-human transmission', 'Absence of response to Amantadine (high resistance)'],
    definitiveTreatment: 'Oseltamivir (Tamiflu) or Zanamivir (start as early as possible)',
    supportiveTreatment: 'Mechanical ventilation, broad-spectrum antibiotics for secondary bacterial pneumonia',
    redFlags: ['Mechanical ventilation'],
    cautions: [],
    meds: [
      mk('Antiflu 75', 'Oseltamivir', '1 - 0 - 1', '1 - 0 - 1', '5-10', 'जेवणानंतर'),
      mk('Fluvir 75', 'Oseltamivir', '1 - 0 - 1', '1 - 0 - 1', '5-10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-186',
    label: 'Human Metapneumovirus (hMPV) Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Human Metapneumovirus (hMPV) Infection', 'hMPV', 'Human Metapneumovirus Infection'],
    pathognomonic: 'RSV-like illness (bronchiolitis/pneumonia) that tests negative for RSV and Influenza',
    definitiveTest: 'Multiplex respiratory viral PCR panel',
    supportiveTests: ['Chest X-ray (hyperinflation, patchy infiltrates)'],
    ddx: ['Respiratory Syncytial Virus (RSV)', 'Influenza', 'Rhinovirus', 'Asthma exacerbation'],
    positiveSigns: ['Cough, fever, nasal congestion, and wheezing', 'Bronchiolitis or pneumonia, especially in young children and older adults'],
    negativeSigns: ['Absence of response to bronchodilators (often)', 'Clinically indistinguishable from RSV without testing'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Oxygen therapy, hydration, antipyretics. (Ribavirin is rarely used, only in severe immunocompromised cases).',
    redFlags: ['RSV-like illness (bronchiolitis/pneumonia) that tests negative for RSV and Influenza'],
    cautions: [],
    meds: [
      mk('Dolo 250 Syrup', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
      mk('Asthalin Respules', 'Salbutamol', 'Nebulization SOS', 'Nebulization SOS', '3', 'श्वास घेण्यास त्रास झाल्यास'),
    ],
  },
  {
    id: 'ac-187',
    label: 'Parainfluenza Virus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Parainfluenza Virus Infection'],
    pathognomonic: '"Steeple sign" on neck X-ray with a characteristic barking (seal-like) cough',
    definitiveTest: 'Respiratory viral PCR panel',
    supportiveTests: ['Neck X-ray (AP view showing subglottic narrowing - Steeple sign)'],
    ddx: ['Epiglottitis (Haemophilus influenzae type b)', 'RSV Bronchiolitis', 'Foreign body aspiration', 'Bacterial tracheitis'],
    positiveSigns: ['Barking cough, hoarseness, and inspiratory stridor (Croup)', 'Fever and coryza'],
    negativeSigns: ['Absence of drooling or "tripod" positioning (which suggests Epiglottitis)', 'Absence of severe systemic toxicity in mild cases'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Single dose of oral/IM Dexamethasone for Croup. Nebulized racemic epinephrine for severe stridor at rest.',
    redFlags: ['"Steeple sign" on neck X-ray with a characteristic barking (seal-like) cough'],
    cautions: [],
    meds: [
      mk('Dexona', 'Dexamethasone', '0.6 mg/kg single dose', '0.6 mg/kg single dose', '1', 'Stat'),
      mk('Budecort Respules', 'Budesonide', 'Nebulization BD', 'Nebulization BD', '3', 'खोकल्यासाठी'),
    ],
  },
  {
    id: 'ac-188',
    label: 'Rhinovirus Infection (Common Cold)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Rhinovirus Infection (Common Cold)', 'Common Cold', 'Rhinovirus Infection'],
    pathognomonic: 'Mild, self-limiting upper respiratory symptoms peaking in 2-3 days without severe systemic signs',
    definitiveTest: 'Clinical diagnosis (PCR available but rarely needed)',
    supportiveTests: ['None usually required'],
    ddx: ['Allergic Rhinitis', 'Influenza', 'COVID-19', 'Acute Bacterial Sinusitis'],
    positiveSigns: ['Rhinorrhea (runny nose), nasal congestion, and sneezing', 'Sore throat and mild cough'],
    negativeSigns: ['Absence of high fever (usually mild or absent)', 'Absence of severe myalgia/prostration (unlike Influenza)'],
    definitiveTreatment: 'Symptomatic relief only',
    supportiveTreatment: 'Decongestants, antihistamines, saline nasal drops, adequate hydration',
    redFlags: ['Mild, self-limiting upper respiratory symptoms peaking in 2-3 days without severe systemic signs'],
    cautions: [],
    meds: [
      mk('Cheston Cold', 'Cetirizine + Phenylephrine + Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '3-5', 'जेवणानंतर'),
      mk('Otrivin Adult', 'Xylometazoline', '2 drops BD', '2 drops BD', '5', 'नाकात टाकण्यासाठी'),
    ],
  },
  {
    id: 'ac-189',
    label: 'Human Bocavirus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Human Bocavirus Infection'],
    pathognomonic: 'Simultaneous upper/lower respiratory tract infection and gastroenteritis in a toddler',
    definitiveTest: 'Multiplex respiratory viral PCR panel',
    supportiveTests: ['Chest X-ray (interstitial infiltrates if pneumonia is present)'],
    ddx: ['RSV', 'Rotavirus (if GI symptoms predominate)', 'Adenovirus', 'hMPV'],
    positiveSigns: ['Cough, wheezing, and fever in young children', 'Often co-occurs with GI symptoms (diarrhea/vomiting)'],
    negativeSigns: ['Absence of specific antiviral therapy', 'Rarely causes severe disease in healthy adults'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Oxygen therapy, bronchodilators for wheezing, oral rehydration for GI losses',
    redFlags: ['Simultaneous upper/lower respiratory tract infection and gastroenteritis in a toddler'],
    cautions: [],
    meds: [
      mk('Maxtra Syrup', 'Phenylephrine + Chlorpheniramine', '2.5ml BD', '2.5ml BD', '3', 'जेवणानंतर'),
      mk('Electral', 'ORS', 'As needed', 'As needed', '3', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-190',
    label: 'Enterovirus D68 Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Enterovirus D68 Infection'],
    pathognomonic: 'Severe asthma-like exacerbation followed by acute asymmetric flaccid paralysis (AFM)',
    definitiveTest: 'Enterovirus PCR from respiratory secretions or CSF',
    supportiveTests: ['MRI Spine (gray matter lesions in the anterior horn cells)'],
    ddx: ['Asthma Exacerbation', 'Poliomyelitis', 'Guillain-Barré Syndrome', 'Transverse Myelitis'],
    positiveSigns: ['Severe respiratory illness (wheezing, hypoxia) in children, especially those with asthma', 'Acute Flaccid Myelitis (AFM) - sudden limb weakness'],
    negativeSigns: ['Absence of sensory loss in AFM (purely motor)', 'Absence of response to steroids in AFM'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Bronchodilators/oxygen for respiratory symptoms. Physical therapy and neurology consult for AFM.',
    redFlags: ['Severe asthma-like exacerbation followed by acute asymmetric flaccid paralysis (AFM)'],
    cautions: [],
    meds: [
      mk('Asthalin Inhaler', 'Salbutamol', '2 puffs SOS', '2 puffs SOS', 'As needed', 'श्वास घेण्यास त्रास झाल्यास'),
      mk('Dolo 250 Syrup', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-191',
    label: 'Human Parechovirus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Human Parechovirus Infection'],
    pathognomonic: 'Severe sepsis-like syndrome with meningoencephalitis in a neonate with negative bacterial cultures (especially PeV-A3)',
    definitiveTest: 'Parechovirus PCR (CSF, blood, or stool)',
    supportiveTests: ['CSF analysis (often normal WBC count despite encephalitis), MRI Brain (white matter changes)'],
    ddx: ['Neonatal Bacterial Sepsis (Group B Strep, E. coli)', 'Herpes Simplex Encephalitis', 'Enterovirus Infection', 'Listeriosis'],
    positiveSigns: ['Fever, irritability, and maculopapular rash in infants', 'Sepsis-like illness or meningoencephalitis in neonates'],
    negativeSigns: ['Absence of bacterial growth in blood/CSF cultures', 'Absence of response to broad-spectrum antibiotics'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'ICU monitoring, IV fluids, seizure management. (No specific antiviral available).',
    redFlags: ['ICU monitoring', 'seizure management'],
    cautions: [],
    meds: [
      mk('Dolo Drops', 'Paracetamol', 'SOS', 'SOS', '3', 'तापासाठी'),
      mk('Eptoin', 'Phenytoin', 'IV', 'IV', 'As needed', 'Hospital Use (for seizures) (Inj.)'),
    ],
  },
  {
    id: 'ac-192',
    label: 'BK Virus Nephropathy',
    group: 'Viral',
    category: 'Viral',
    aliases: ['BK Virus Nephropathy'],
    pathognomonic: 'Decoy cells in urine cytology and positive SV40 stain on renal transplant biopsy',
    definitiveTest: 'Quantitative BK Virus DNA PCR in blood/urine and Renal Biopsy',
    supportiveTests: ['Urine cytology (Decoy cells)', 'CMP (Elevated Creatinine)'],
    ddx: ['Acute Cellular Rejection', 'Calcineurin Inhibitor Toxicity', 'Cytomegalovirus Nephritis', 'Urinary Tract Infection'],
    positiveSigns: ['Asymptomatic gradual rise in serum creatinine in a renal transplant recipient', 'Tubulointerstitial nephritis on biopsy'],
    negativeSigns: ['Absence of fever or systemic signs of infection', 'Absence of response to standard acute rejection treatments (steroids worsen it)'],
    definitiveTreatment: 'Reduction of immunosuppression (primary treatment)',
    supportiveTreatment: 'Off-label use of Cidofovir, Leflunomide, or IVIG if reduction of immunosuppression fails',
    redFlags: ['Decoy cells in urine cytology and positive SV40 stain on renal transplant biopsy'],
    cautions: [],
    meds: [
      mk('Lefno 20', 'Leflunomide', '1 - 0 - 0', '1 - 0 - 0', 'Months', 'जेवणानंतर'),
      mk('Cidofovir', 'Cidofovir', 'IV Protocol', 'IV Protocol', 'As directed', 'Hospital Use (Inj.)'),
    ],
  },
  {
    id: 'ac-193',
    label: 'Progressive Multifocal Leukoencephalopathy (JC Virus)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Progressive Multifocal Leukoencephalopathy (JC Virus)', 'JC Virus', 'Progressive Multifocal Leukoencephalopathy'],
    pathognomonic: 'Non-enhancing, asymmetric white matter lesions on MRI without mass effect in an HIV+ patient',
    definitiveTest: 'JC Virus DNA PCR in CSF or Brain Biopsy',
    supportiveTests: ['MRI Brain (T2/FLAIR hyperintensities in subcortical white matter)'],
    ddx: ['Toxoplasmosis (ring-enhancing)', 'Primary CNS Lymphoma (ring-enhancing)', 'HIV Encephalopathy', 'Multiple Sclerosis flare'],
    positiveSigns: ['Progressive focal neurologic deficits (clumsiness, weakness, visual changes)', 'Occurs in severely immunocompromised patients (HIV, Natalizumab use)'],
    negativeSigns: ['Absence of fever or signs of systemic infection', 'Absence of mass effect or ring enhancement on MRI (usually)'],
    definitiveTreatment: 'Reversal of immunosuppression (e.g., start ART in HIV, stop Natalizumab)',
    supportiveTreatment: 'Plasma exchange (if drug-induced), off-label Mirtazapine or Pembrolizumab (experimental)',
    redFlags: ['Non-enhancing, asymmetric white matter lesions on MRI without mass effect in an HIV+ patient'],
    cautions: [],
    meds: [
      mk('Instgra', 'Dolutegravir (ART component)', '1 - 0 - 0', '1 - 0 - 0', 'Lifelong', 'जेवणानंतर'),
      mk('Mirazep 15', 'Mirtazapine', '0 - 0 - 1', '0 - 0 - 1', 'Months', 'झोपण्यापूर्वी'),
    ],
  },
  {
    id: 'ac-194',
    label: 'HTLV-1 Associated Myelopathy (HAM/TSP)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['HTLV-1 Associated Myelopathy (HAM/TSP)', 'HAM/TSP', 'HTLV-1 Associated Myelopathy'],
    pathognomonic: 'Chronic spastic paraparesis in a patient from an endemic area (Caribbean, Japan) with positive HTLV-1 serology',
    definitiveTest: 'HTLV-1 antibodies in serum and CSF (Western blot confirmation)',
    supportiveTests: ['MRI Spine (thoracic cord atrophy in late stages)', 'CSF analysis (mild lymphocytic pleocytosis)'],
    ddx: ['Multiple Sclerosis', 'Vitamin B12 Deficiency', 'Primary Lateral Sclerosis', 'Spinal Cord Compression'],
    positiveSigns: ['Slowly progressive spastic paraparesis (weakness/stiffness in legs)', 'Bladder dysfunction and hyperreflexia'],
    negativeSigns: ['Absence of sensory level (unlike transverse myelitis)', 'Absence of upper extremity involvement initially'],
    definitiveTreatment: 'Symptomatic treatment (No curative antiviral)',
    supportiveTreatment: 'Baclofen or Tizanidine for spasticity, Corticosteroids for acute flares, management of neurogenic bladder',
    redFlags: ['Chronic spastic paraparesis in a patient from an endemic area (Caribbean, Japan) with positive HTLV-1 serology'],
    cautions: [],
    meds: [
      mk('Liofen 10', 'Baclofen', '1 - 1 - 1', '1 - 1 - 1', 'Long term', 'जेवणानंतर'),
      mk('Wysolone 20', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', 'During flares', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-195',
    label: 'Colorado Tick Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Colorado Tick Fever'],
    pathognomonic: 'Biphasic fever and leukopenia after a tick bite at high altitude in the Rocky Mountains',
    definitiveTest: 'RT-PCR for Colorado Tick Fever virus or Serology',
    supportiveTests: ['CBC (Leukopenia, thrombocytopenia)', 'Peripheral smear (virus can sometimes be seen in RBCs)'],
    ddx: ['Rocky Mountain Spotted Fever', 'Tick-Borne Relapsing Fever', 'Tularemia', 'Influenza'],
    positiveSigns: ['Biphasic (saddleback) fever, chills, and severe myalgia', 'History of tick bite (Dermacentor andersoni) in western US/Canada mountains'],
    negativeSigns: ['Absence of rash (usually, unlike RMSF)', 'Absence of severe respiratory symptoms'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Antipyretics (Paracetamol), hydration, rest. Avoid Aspirin/NSAIDs due to bleeding risk from thrombocytopenia.',
    redFlags: ['Biphasic fever and leukopenia after a tick bite at high altitude in the Rocky Mountains'],
    cautions: ['Avoid Aspirin/NSAIDs due to bleeding risk from thrombocytopenia'],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Electral', 'ORS', 'As needed', 'As needed', '3', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-196',
    label: 'Ross River Virus Infection',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Ross River Virus Infection'],
    pathognomonic: 'Prolonged, debilitating polyarthritis and rash following mosquito exposure in Australia/South Pacific',
    definitiveTest: 'Ross River Virus Serology (IgM or rising IgG)',
    supportiveTests: ['CBC (normal or mild leukopenia)', 'ESR/CRP (mildly elevated)'],
    ddx: ['Chikungunya', 'Dengue Fever', 'Rheumatoid Arthritis', 'Barmah Forest Virus'],
    positiveSigns: ['Polyarthralgia/polyarthritis (often debilitating and prolonged)', 'Maculopapular rash and fatigue'],
    negativeSigns: ['Absence of hemorrhagic manifestations', 'Absence of long-term joint destruction (non-erosive)'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'NSAIDs for joint pain and inflammation, rest. (Symptoms can last for months).',
    redFlags: ['Prolonged, debilitating polyarthritis and rash following mosquito exposure in Australia/South Pacific'],
    cautions: [],
    meds: [
      mk('Brufen 400', 'Ibuprofen', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', 'As needed', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-197',
    label: 'Mayaro Virus Disease',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Mayaro Virus Disease'],
    pathognomonic: 'Chikungunya-like illness (fever, severe joint pain, rash) in a traveler returning from the Amazon',
    definitiveTest: 'Mayaro Virus RT-PCR (early) or Serology (IgM)',
    supportiveTests: ['CBC (Leukopenia, mild thrombocytopenia)'],
    ddx: ['Chikungunya', 'Dengue Fever', 'Zika Virus', 'Malaria'],
    positiveSigns: ['Sudden onset of fever, severe arthralgia, and maculopapular rash', 'History of travel to the Amazon basin or South America'],
    negativeSigns: ['Absence of severe hemorrhagic signs', 'Clinically indistinguishable from Chikungunya'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'NSAIDs for severe arthralgia (after ruling out Dengue to avoid bleeding risk), rest, hydration',
    redFlags: ['Chikungunya-like illness (fever, severe joint pain, rash) in a traveler returning from the Amazon'],
    cautions: ['NSAIDs for severe arthralgia (after ruling out Dengue to avoid bleeding risk)'],
    meds: [
      mk('Voveran 50', 'Diclofenac', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
    ],
  },
  {
    id: 'ac-198',
    label: 'Oropouche Fever',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Oropouche Fever'],
    pathognomonic: 'Sloth-associated or midge-borne acute febrile illness in South/Central America, often with a biphasic fever pattern',
    definitiveTest: 'Oropouche Virus RT-PCR or Serology',
    supportiveTests: ['CBC (Leukopenia)', 'CSF analysis (if aseptic meningitis develops)'],
    ddx: ['Dengue Fever', 'Chikungunya', 'Zika Virus', 'Malaria'],
    positiveSigns: ['Abrupt high fever, severe headache, and photophobia', 'Myalgia and joint pain, often with a maculopapular rash'],
    negativeSigns: ['Absence of severe hemorrhagic complications', 'Absence of prolonged arthritis (unlike Chikungunya/Mayaro)'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Antipyretics, analgesics, and adequate hydration. Symptoms typically resolve in 1-2 weeks.',
    redFlags: ['Sloth-associated or midge-borne acute febrile illness in South/Central America, often with a biphasic fever pattern'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Electral', 'ORS', 'As needed', 'As needed', '3', 'तहान लागेल तेव्हा'),
    ],
  },
  {
    id: 'ac-199',
    label: 'Tick-Borne Encephalitis (TBE)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Tick-Borne Encephalitis (TBE)', 'TBE', 'Tick-Borne Encephalitis'],
    pathognomonic: 'Biphasic febrile illness culminating in meningoencephalitis after a tick bite in endemic Eurasian regions',
    definitiveTest: 'TBE Virus IgM in serum or CSF',
    supportiveTests: ['CSF analysis (lymphocytic pleocytosis)', 'MRI Brain (thalamic/basal ganglia hyperintensities)'],
    ddx: ['Lyme neuroborreliosis', 'Herpes Simplex Encephalitis', 'West Nile Virus', 'Enterovirus Encephalitis'],
    positiveSigns: ['Biphasic illness: Initial flu-like phase, followed by neurologic phase (meningitis/encephalitis)', 'History of tick bite or consuming unpasteurized dairy in Europe/Asia'],
    negativeSigns: ['Absence of rash (unlike Lyme disease)', 'Absence of response to antibiotics'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'ICU monitoring for severe encephalitis, mechanical ventilation if bulbar palsy occurs, anti-seizure meds',
    redFlags: ['ICU monitoring for severe encephalitis', 'mechanical ventilation if bulbar palsy occurs', 'anti-seizure meds'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', 'SOS', 'SOS', '5', 'तापासाठी'),
      mk('Eptoin', 'Phenytoin', 'IV', 'IV', 'As needed', 'Hospital Use (for seizures) (Inj.)'),
    ],
  },
  {
    id: 'ac-200',
    label: 'Eastern Equine Encephalitis (EEE)',
    group: 'Viral',
    category: 'Viral',
    aliases: ['Eastern Equine Encephalitis (EEE)', 'EEE', 'Eastern Equine Encephalitis'],
    pathognomonic: 'Rapidly progressive, highly fatal mosquito-borne encephalitis in the Eastern US/Gulf Coast with focal MRI lesions',
    definitiveTest: 'EEE Virus IgM in CSF',
    supportiveTests: ['MRI Brain (focal lesions in basal ganglia and thalami)', 'CSF analysis (neutrophilic or lymphocytic pleocytosis)'],
    ddx: ['Herpes Simplex Encephalitis', 'West Nile Virus', 'Bacterial Meningitis', 'Subarachnoid Hemorrhage'],
    positiveSigns: ['Abrupt onset of high fever, severe headache, and vomiting', 'Rapid progression to altered mental status, seizures, and coma'],
    negativeSigns: ['Absence of purulent CSF', 'Absence of slow progression (it is fulminant and highly fatal)'],
    definitiveTreatment: 'Supportive care',
    supportiveTreatment: 'Aggressive ICU care, management of elevated intracranial pressure, anticonvulsants',
    redFlags: ['Aggressive ICU care'],
    cautions: [],
    meds: [
      mk('Mannitol', 'Mannitol 20%', 'IV', 'IV', 'As needed', 'Hospital Use (for ICP) (Inj.)'),
      mk('Levipil 500', 'Levetiracetam', '1 - 0 - 1', '1 - 0 - 1', 'As needed', 'Hospital Use (for seizures)'),
    ],
  },
  {
    id: 'ac-201',
    label: 'Acute Bronchitis',
    group: 'Viral/Bacterial',
    category: 'Viral/Bacterial',
    aliases: ['Acute Bronchitis'],
    pathognomonic: 'Cough persisting >5 days without pneumonia signs',
    definitiveTest: 'Clinical diagnosis (CXR to rule out pneumonia)',
    supportiveTests: ['CBC (usually normal)', 'Sputum culture (rarely needed)'],
    ddx: ['Pneumonia', 'Asthma exacerbation', 'Pertussis', 'GERD'],
    positiveSigns: ['Productive or dry cough lasting 1-3 weeks', 'Mild wheezing or rhonchi on auscultation'],
    negativeSigns: ['Absence of high fever', 'Absence of focal consolidation on chest X-ray'],
    definitiveTreatment: 'Symptomatic (Antitussives, bronchodilators if wheezing); Antibiotics ONLY if suspected bacterial (e.g., Azithromycin)',
    supportiveTreatment: 'Hydration, steam inhalation, throat lozenges',
    redFlags: ['Cough persisting >5 days without pneumonia signs'],
    cautions: [],
    meds: [
      mk('Ascoril LS', 'Levosalbutamol + Ambroxol + Guaiphenesin', '10ml - 10ml - 10ml', '10ml - 10ml - 10ml', '5', 'जेवणानंतर'),
      mk('Azee 500', 'Azithromycin', '0 - 0 - 1', '0 - 0 - 1', '3', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-202',
    label: 'Infective Exacerbation of COPD',
    group: 'Bacterial/Viral',
    category: 'Bacterial/Viral',
    aliases: ['Infective Exacerbation of COPD'],
    pathognomonic: 'Anthonisen criteria (increased dyspnea, sputum volume, sputum purulence)',
    definitiveTest: 'Sputum Culture and Sensitivity',
    supportiveTests: ['ABG (check for hypercapnia)', 'CXR', 'CBC (Leucocytosis)'],
    ddx: ['Pneumonia', 'Heart Failure', 'Pulmonary Embolism', 'Pneumothorax'],
    positiveSigns: ['Increased sputum purulence and volume', 'Worsening dyspnea and wheezing'],
    negativeSigns: ['Absence of pneumothorax', 'Absence of new infiltrates on CXR'],
    definitiveTreatment: 'Amoxicillin-Clavulanate or Macrolide + Systemic Corticosteroids + Bronchodilators',
    supportiveTreatment: 'Oxygen therapy (target SpO2 88-92%), nebulization, chest physiotherapy',
    redFlags: ['Anthonisen criteria (increased dyspnea, sputum volume, sputum purulence)'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 0 - 1', '1 - 0 - 1', '5-7', 'जेवणानंतर'),
      mk('Wysolone 40', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '5', 'नाश्त्यानंतर'),
      mk('Duolin Respules', 'Levosalbutamol + Ipratropium', '1 - 1 - 1', '1 - 1 - 1', '5', 'Nebulization'),
    ],
  },
  {
    id: 'ac-203',
    label: 'Lung Abscess',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Lung Abscess'],
    pathognomonic: 'CXR/CT showing a cavity with an air-fluid level',
    definitiveTest: 'CT Thorax with contrast',
    supportiveTests: ['Sputum Culture (aerobic and anaerobic)', 'Blood Culture', 'Bronchoscopy'],
    ddx: ['Cavitating TB', 'Necrotizing Pneumonia', 'Infected Bulla', 'Wegener\'s Granulomatosis'],
    positiveSigns: ['Foul-smelling copious purulent sputum', 'Swinging high fever with chills'],
    negativeSigns: ['Absence of clear lung fields', 'Absence of rapid resolution with standard antibiotics'],
    definitiveTreatment: 'Clindamycin OR Amoxicillin-Clavulanate for 4-6 weeks',
    supportiveTreatment: 'Postural drainage, high protein diet, surgical drainage if non-responsive',
    redFlags: ['CXR/CT showing a cavity with an air-fluid level'],
    cautions: [],
    meds: [
      mk('Dalacin C 300', 'Clindamycin', '1 - 1 - 1', '1 - 1 - 1', '21-42', 'जेवणानंतर'),
      mk('Augmentin 1g', 'Amoxicillin + Clavulanic Acid', '1g', '1 - 0 - 1', '21-42', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-204',
    label: 'Empyema Thoracis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Empyema Thoracis'],
    pathognomonic: 'Frank pus on diagnostic thoracentesis',
    definitiveTest: 'Pleural fluid analysis (pH < 7.2, low glucose, high LDH, positive Gram stain/culture)',
    supportiveTests: ['USG Thorax', 'CT Thorax', 'Blood Culture'],
    ddx: ['Uncomplicated Parapneumonic Effusion', 'Tubercular Pleural Effusion', 'Malignant Effusion'],
    positiveSigns: ['Pleuritic chest pain', 'Stony dullness on percussion with decreased breath sounds'],
    negativeSigns: ['Absence of clear pleural fluid', 'Absence of normal tactile fremitus'],
    definitiveTreatment: 'Intercostal Tube Drainage (ICD) + IV Antibiotics (e.g., Piperacillin-Tazobactam)',
    supportiveTreatment: 'Intrapleural fibrinolytics (Streptokinase/Urokinase) if loculated, VATS decortication',
    redFlags: ['Frank pus on diagnostic thoracentesis'],
    cautions: [],
    meds: [
      mk('Tazar 4.5g', 'Piperacillin + Tazobactam', '4.5g', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Metrogyl 100mg/100ml', 'Metronidazole', '100mg', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-205',
    label: 'Acute Epiglottitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Acute Epiglottitis'],
    pathognomonic: 'Thumbprint sign on lateral neck X-ray',
    definitiveTest: 'Direct visualization (in OT setting) showing cherry-red, swollen epiglottis',
    supportiveTests: ['Lateral neck X-ray', 'Blood Culture'],
    ddx: ['Croup', 'Retropharyngeal Abscess', 'Foreign Body Aspiration', 'Anaphylaxis'],
    positiveSigns: ['Drooling, dysphagia, and distress (3 Ds)', 'Tripod or sniffing position'],
    negativeSigns: ['Absence of harsh barking cough (unlike croup)', 'Absence of normal epiglottis on visualization'],
    definitiveTreatment: 'Secure airway immediately + IV Ceftriaxone + IV Corticosteroids',
    supportiveTreatment: 'Humidified oxygen, keep patient calm, avoid throat examination in unsecure airway',
    redFlags: ['avoid throat examination in unsecure airway'],
    cautions: ['avoid throat examination in unsecure airway'],
    meds: [
      mk('Monocef 1g', 'Ceftriaxone', '1g', '1 - 0 - 1 (IV)', '7-10', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dexona', 'Dexamethasone', 'Stat (IV/IM)', 'Stat (IV/IM)', '1', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-206',
    label: 'Peritonsillar Abscess (Quinsy)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Peritonsillar Abscess (Quinsy)', 'Quinsy', 'Peritonsillar Abscess'],
    pathognomonic: 'Unilateral peritonsillar swelling pushing uvula contralaterally',
    definitiveTest: 'Needle aspiration of pus from peritonsillar space',
    supportiveTests: ['CT Neck with contrast (if deep spread suspected)', 'Throat swab culture'],
    ddx: ['Severe Tonsillitis', 'Retropharyngeal Abscess', 'Epiglottitis', 'Dental Abscess'],
    positiveSigns: ['Hot potato voice', 'Trismus and uvular deviation to opposite side'],
    negativeSigns: ['Absence of normal tonsillar symmetry', 'Absence of painless swallowing'],
    definitiveTreatment: 'Incision and Drainage (I&D) + Amoxicillin-Clavulanate or Clindamycin',
    supportiveTreatment: 'Warm saline gargles, IV hydration, strong analgesics',
    redFlags: ['Unilateral peritonsillar swelling pushing uvula contralaterally'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Zerodol-SP', 'Aceclofenac + Serratiopeptidase + Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-207',
    label: 'Ludwig\'s Angina',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Ludwig\'s Angina'],
    pathognomonic: 'Bull neck appearance with elevated tongue floor',
    definitiveTest: 'CT Neck with contrast',
    supportiveTests: ['Dental X-ray (OPG)', 'Blood Culture'],
    ddx: ['Submandibular Abscess', 'Peritonsillar Abscess', 'Angioedema', 'Salivary Gland Infection'],
    positiveSigns: ['Bilateral woody induration of submandibular space', 'Elevation and backward displacement of tongue'],
    negativeSigns: ['Absence of fluctuant abscess (initially)', 'Absence of normal neck contour'],
    definitiveTreatment: 'Airway protection + IV Ampicillin-Sulbactam or Clindamycin + Surgical decompression if needed',
    supportiveTreatment: 'Dental extraction of infected tooth, IV fluids, upright positioning',
    redFlags: ['Bull neck appearance with elevated tongue floor'],
    cautions: [],
    meds: [
      mk('Magnex 1.5g', 'Cefoperazone + Sulbactam', '1.5g', '1 - 0 - 1 (IV)', '7-14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dalacin C', 'Clindamycin', '1 - 1 - 1 (IV)', '1 - 1 - 1 (IV)', '7-14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-208',
    label: 'Acute Cholecystitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Acute Cholecystitis'],
    pathognomonic: 'Positive Murphy\'s sign (inspiratory arrest on RUQ palpation)',
    definitiveTest: 'USG Abdomen (thickened gallbladder wall, pericholecystic fluid, gallstones)',
    supportiveTests: ['CBC (Leucocytosis)', 'LFT (mildly elevated AST/ALT/ALP)', 'HIDA scan'],
    ddx: ['Peptic Ulcer Disease', 'Acute Pancreatitis', 'Acute Hepatitis', 'Right Lower Lobe Pneumonia'],
    positiveSigns: ['Right Upper Quadrant (RUQ) pain radiating to right shoulder', 'Fever and nausea'],
    negativeSigns: ['Absence of deep jaundice (usually)', 'Absence of painless abdomen'],
    definitiveTreatment: 'Laparoscopic Cholecystectomy + IV Ceftriaxone & Metronidazole',
    supportiveTreatment: 'NPO, IV fluids, analgesics (NSAIDs or Opioids)',
    redFlags: ['Positive Murphy\'s sign (inspiratory arrest on RUQ palpation)'],
    cautions: [],
    meds: [
      mk('Monocef 1g', 'Ceftriaxone', '1g', '1 - 0 - 1 (IV)', '5-7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Metrogyl', 'Metronidazole', '1 - 1 - 1 (IV)', '1 - 1 - 1 (IV)', '5-7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Voveran', 'Diclofenac', 'Stat (IM)', 'Stat (IM)', '1', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-209',
    label: 'Acute Cholangitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Acute Cholangitis'],
    pathognomonic: 'Charcot\'s triad in the presence of biliary dilatation',
    definitiveTest: 'ERCP (Diagnostic and Therapeutic)',
    supportiveTests: ['USG/MRCP (shows biliary obstruction)', 'LFT (high ALP, GGT, direct bilirubin)', 'Blood Culture'],
    ddx: ['Acute Cholecystitis', 'Liver Abscess', 'Acute Pancreatitis', 'Severe Viral Hepatitis'],
    positiveSigns: ['Charcot\'s Triad (Fever, RUQ pain, Jaundice)', 'Reynolds\' Pentad (+ Hypotension, Confusion)'],
    negativeSigns: ['Absence of normal LFTs', 'Absence of non-tender abdomen'],
    definitiveTreatment: 'Urgent Biliary Decompression (ERCP) + Broad-spectrum IV Antibiotics (Piperacillin-Tazobactam)',
    supportiveTreatment: 'Aggressive IV fluid resuscitation, vasopressors if in shock',
    redFlags: ['vasopressors if in shock'],
    cautions: [],
    meds: [
      mk('Tazar 4.5g', 'Piperacillin + Tazobactam', '4.5g', '1 - 1 - 1 (IV)', '7-10', 'Inj. (Hospital Use) (Inj.)'),
      mk('Meromac 1g', 'Meropenem', '1g', '1 - 1 - 1 (IV)', '7-10', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-210',
    label: 'Pyogenic Liver Abscess',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pyogenic Liver Abscess'],
    pathognomonic: 'USG/CT showing single/multiple hypoechoic hepatic lesions with positive bacterial culture',
    definitiveTest: 'USG/CT-guided aspiration and culture',
    supportiveTests: ['CBC (High Leucocytosis)', 'LFT (Elevated ALP)', 'Blood Culture'],
    ddx: ['Amoebic Liver Abscess', 'Hepatocellular Carcinoma', 'Hydatid Cyst', 'Acute Cholangitis'],
    positiveSigns: ['Spiking fever with chills', 'Tender hepatomegaly'],
    negativeSigns: ['Absence of "anchovy paste" pus (seen in amoebic)', 'Absence of negative blood cultures (often positive)'],
    definitiveTreatment: 'Percutaneous Pigtail Drainage + IV Ceftriaxone & Metronidazole',
    supportiveTreatment: 'IV fluids, antipyretics, nutritional support',
    redFlags: ['USG/CT showing single/multiple hypoechoic hepatic lesions with positive bacterial culture'],
    cautions: [],
    meds: [
      mk('Monocef 2g', 'Ceftriaxone', '2g', '1 - 0 - 0 (IV)', '14-28', 'Inj. (Hospital Use) (Inj.)'),
      mk('Metrogyl', 'Metronidazole', '1 - 1 - 1 (IV)', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-211',
    label: 'Spontaneous Bacterial Peritonitis (SBP)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Spontaneous Bacterial Peritonitis (SBP)', 'SBP', 'Spontaneous Bacterial Peritonitis'],
    pathognomonic: 'Ascitic fluid PMN count > 250 cells/mm3',
    definitiveTest: 'Diagnostic Paracentesis (Ascitic fluid analysis and culture)',
    supportiveTests: ['Blood Culture', 'Renal Function Tests', 'CBC'],
    ddx: ['Secondary Peritonitis', 'Tuberculous Peritonitis', 'Malignant Ascites', 'Acute Pancreatitis'],
    positiveSigns: ['Fever and diffuse abdominal pain in a cirrhotic patient', 'Worsening encephalopathy or renal failure'],
    negativeSigns: ['Absence of surgical source of infection (perforation)', 'Absence of rigid board-like abdomen (often subtle)'],
    definitiveTreatment: 'IV Cefotaxime or Ceftriaxone for 5-7 days',
    supportiveTreatment: 'IV Albumin (1.5g/kg day 1, 1g/kg day 3) to prevent hepatorenal syndrome, stop beta-blockers',
    redFlags: ['1g/kg day 3) to prevent hepatorenal syndrome'],
    cautions: [],
    meds: [
      mk('Omnatax 1g', 'Cefotaxime', '1g', '1 - 1 - 1 (IV)', '5-7', 'Inj. (Hospital Use) (Inj.)'),
      mk('Albudac 20%', 'Human Albumin', '20%', 'As per weight (IV)', 'Day 1 & 3', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-212',
    label: 'Epididymo-orchitis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Epididymo-orchitis'],
    pathognomonic: 'Positive Prehn\'s sign with increased blood flow on Doppler USG',
    definitiveTest: 'Color Doppler USG Scrotum (shows hypervascularity)',
    supportiveTests: ['Urine Routine & Culture', 'Urethral swab for GC/Chlamydia (if <35 yrs)'],
    ddx: ['Testicular Torsion', 'Testicular Tumor', 'Inguinal Hernia', 'Hydrocele'],
    positiveSigns: ['Unilateral painful swelling of scrotum', 'Relief of pain on elevating scrotum (Prehn\'s sign)'],
    negativeSigns: ['Absence of absent cremasteric reflex (present in torsion)', 'Absence of high-riding testis'],
    definitiveTreatment: 'Ceftriaxone IM stat + Doxycycline (if <35) OR Levofloxacin (if >35)',
    supportiveTreatment: 'Scrotal elevation, ice packs, NSAIDs for pain',
    redFlags: ['Positive Prehn\'s sign with increased blood flow on Doppler USG'],
    cautions: [],
    meds: [
      mk('Loxof 500', 'Levofloxacin', '1 - 0 - 0', '1 - 0 - 0', '10-14', 'जेवणानंतर'),
      mk('Doxiva 100', 'Doxycycline', '1 - 0 - 1', '1 - 0 - 1', '14', 'जेवणानंतर'),
      mk('Zerodol-SP', 'Aceclofenac + Serratiopeptidase + Paracetamol', '1 - 0 - 1', '1 - 0 - 1', '5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-213',
    label: 'Fournier\'s Gangrene',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Fournier\'s Gangrene'],
    pathognomonic: 'Necrotizing fasciitis of the perineum with subcutaneous gas',
    definitiveTest: 'Clinical diagnosis + CT Pelvis (shows subcutaneous gas)',
    supportiveTests: ['Blood Culture', 'Wound Culture', 'CBC, LFT, RFT, Blood Sugar'],
    ddx: ['Severe Cellulitis', 'Scrotal Abscess', 'Epididymo-orchitis'],
    positiveSigns: ['Rapidly progressive necrotic black eschar on perineum/scrotum', 'Crepitus on palpation'],
    negativeSigns: ['Absence of painless swelling', 'Absence of normal skin color'],
    definitiveTreatment: 'Aggressive Surgical Debridement + Broad-spectrum IV Antibiotics (Meropenem + Clindamycin)',
    supportiveTreatment: 'Hemodynamic resuscitation, strict glycemic control, hyperbaric oxygen therapy (adjunct)',
    redFlags: ['Necrotizing fasciitis of the perineum with subcutaneous gas'],
    cautions: [],
    meds: [
      mk('Meromac 1g', 'Meropenem', '1g', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Dalacin C', 'Clindamycin', '1 - 1 - 1 (IV)', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-214',
    label: 'Bartholin\'s Abscess',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Bartholin\'s Abscess'],
    pathognomonic: 'Tender, fluctuant mass at the 4 or 8 o\'clock position of the labia minora',
    definitiveTest: 'Clinical examination',
    supportiveTests: ['Swab culture of purulent discharge (for MRSA, GC, Chlamydia)'],
    ddx: ['Bartholin\'s Cyst', 'Sebaceous Cyst', 'Lipoma', 'Vulvar Carcinoma'],
    positiveSigns: ['Extremely painful, fluctuant swelling at the posterior introitus', 'Dyspareunia and difficulty walking'],
    negativeSigns: ['Absence of painless cyst', 'Absence of normal labial symmetry'],
    definitiveTreatment: 'Incision and Drainage (I&D) with Word catheter placement or Marsupialization',
    supportiveTreatment: 'Sitz baths, NSAIDs, Antibiotics (Amoxicillin-Clavulanate) if surrounding cellulitis',
    redFlags: ['Tender, fluctuant mass at the 4 or 8 o\'clock position of the labia minora'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 0 - 1', '1 - 0 - 1', '5-7', 'जेवणानंतर'),
      mk('Voveran SR 100', 'Diclofenac', '1 - 0 - 0', '1 - 0 - 0', '3-5', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-215',
    label: 'Puerperal Sepsis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Puerperal Sepsis'],
    pathognomonic: 'Postpartum fever with purulent vaginal discharge and subinvolution',
    definitiveTest: 'High vaginal swab and Blood Culture',
    supportiveTests: ['CBC (High Leucocytosis)', 'USG Pelvis (to rule out retained products)'],
    ddx: ['UTI', 'Mastitis', 'Wound Infection (CS or episiotomy)', 'Pelvic Vein Thrombophlebitis'],
    positiveSigns: ['Fever > 38°C within 24 hrs to 10 days postpartum', 'Foul-smelling lochia and uterine tenderness'],
    negativeSigns: ['Absence of normal uterine involution', 'Absence of clear lochia'],
    definitiveTreatment: 'IV Clindamycin + Gentamicin (Gold Standard)',
    supportiveTreatment: 'IV fluids, antipyretics, evacuation of retained products if present',
    redFlags: ['Postpartum fever with purulent vaginal discharge and subinvolution'],
    cautions: [],
    meds: [
      mk('Dalacin C', 'Clindamycin', '1 - 1 - 1 (IV)', '1 - 1 - 1 (IV)', '7-10', 'Inj. (Hospital Use) (Inj.)'),
      mk('Garamycin 80mg', 'Gentamicin', '80mg', '1 - 1 - 1 (IV)', '7-10', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-216',
    label: 'Erythrasma',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Erythrasma'],
    pathognomonic: 'Coral-red fluorescence under Wood\'s lamp',
    definitiveTest: 'Wood\'s lamp examination',
    supportiveTests: ['KOH mount (negative for hyphae)', 'Gram stain (shows Gram-positive bacilli - Corynebacterium minutissimum)'],
    ddx: ['Tinea Cruris', 'Candidal Intertrigo', 'Inverse Psoriasis', 'Contact Dermatitis'],
    positiveSigns: ['Well-demarcated, reddish-brown macular patches in intertriginous areas', 'Fine scaling and mild pruritus'],
    negativeSigns: ['Absence of central clearing (unlike Tinea)', 'Absence of satellite lesions (unlike Candida)'],
    definitiveTreatment: 'Topical Fusidic Acid or Clindamycin; Oral Erythromycin if widespread',
    supportiveTreatment: 'Keep area dry, use antibacterial soaps, weight loss if obese',
    redFlags: ['Coral-red fluorescence under Wood\'s lamp'],
    cautions: [],
    meds: [
      mk('Fucidin Cream', 'Fusidic Acid', 'Apply BD', 'Apply BD', '14', 'सकाळी आणि रात्री'),
      mk('Erythrocin 250', 'Erythromycin', '1 - 1 - 1 - 1', '1 - 1 - 1 - 1', '7-14', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-217',
    label: 'Pitted Keratolysis',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Pitted Keratolysis'],
    pathognomonic: 'Punched-out pits on the stratum corneum of sweaty feet',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Wood\'s lamp (may show coral-red fluorescence)', 'Skin scraping (Gram-positive bacteria)'],
    ddx: ['Tinea Pedis', 'Plantar Warts', 'Hyperhidrosis', 'Eczema'],
    positiveSigns: ['Crater-like pits on weight-bearing areas of soles', 'Foul foot odor (Bromhidrosis)'],
    negativeSigns: ['Absence of significant inflammation/erythema', 'Absence of vesicles'],
    definitiveTreatment: 'Topical Clindamycin or Erythromycin gel',
    supportiveTreatment: 'Keep feet dry, wear cotton socks, use antiperspirants (20% Aluminum chloride)',
    redFlags: ['Punched-out pits on the stratum corneum of sweaty feet'],
    cautions: [],
    meds: [
      mk('Clindac A Gel', 'Clindamycin 1%', 'Apply BD', 'Apply BD', '14-21', 'सकाळी आणि रात्री'),
      mk('Aldry Lotion', 'Aluminum Chloride 20%', 'Apply OD at night', 'Apply OD at night', 'Ongoing', 'रात्री झोपताना'),
    ],
  },
  {
    id: 'ac-218',
    label: 'Erythema Nodosum Leprosum (ENL / Type 2 Lepra Reaction)',
    group: 'Immunological',
    category: 'Immunological/Bacterial',
    aliases: ['Erythema Nodosum Leprosum (ENL / Type 2 Lepra Reaction)', 'ENL / Type 2 Lepra Reaction', 'Erythema Nodosum Leprosum'],
    pathognomonic: 'Tender subcutaneous nodules in a patient with Multibacillary Leprosy',
    definitiveTest: 'Clinical diagnosis in a known leprosy patient',
    supportiveTests: ['Slit Skin Smear (high Bacterial Index)', 'Biopsy (Leukocytoclastic vasculitis)'],
    ddx: ['Erythema Nodosum (other causes)', 'Sweet\'s Syndrome', 'Cellulitis', 'Type 1 Lepra Reaction'],
    positiveSigns: ['Sudden crop of tender, erythematous, evanescent nodules', 'High fever, neuritis, and joint pain'],
    negativeSigns: ['Absence of worsening of pre-existing skin lesions', 'Absence of negative slit skin smear (usually high BI)'],
    definitiveTreatment: 'Thalidomide OR Systemic Corticosteroids (Prednisolone)',
    supportiveTreatment: 'Continue MDT, NSAIDs for mild cases, bed rest',
    redFlags: ['Tender subcutaneous nodules in a patient with Multibacillary Leprosy'],
    cautions: [],
    meds: [
      mk('Thaangio 100', 'Thalidomide', '1 - 0 - 1', '1 - 0 - 1', 'Until resolved', 'जेवणानंतर (Strict Contraception)'),
      mk('Wysolone 40', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', 'Tapering dose', 'नाश्त्यानंतर'),
    ],
  },
  {
    id: 'ac-219',
    label: 'Type 1 Lepra Reaction (Reversal Reaction)',
    group: 'Immunological',
    category: 'Immunological/Bacterial',
    aliases: ['Type 1 Lepra Reaction (Reversal Reaction)', 'Reversal Reaction', 'Type 1 Lepra Reaction'],
    pathognomonic: 'Inflammation of existing lesions with acute neuritis',
    definitiveTest: 'Clinical diagnosis',
    supportiveTests: ['Nerve Conduction Studies', 'Slit Skin Smear (BI may decrease)'],
    ddx: ['Erysipelas', 'Cellulitis', 'Relapse of Leprosy', 'ENL'],
    positiveSigns: ['Sudden erythema and edema of pre-existing leprosy patches', 'Sudden onset severe nerve pain and new nerve function impairment'],
    negativeSigns: ['Absence of new systemic nodules (unlike ENL)', 'Absence of high fever (usually)'],
    definitiveTreatment: 'Systemic Corticosteroids (Prednisolone 40-60mg/day tapering over months)',
    supportiveTreatment: 'Continue MDT, resting the affected limb, analgesics',
    redFlags: ['Inflammation of existing lesions with acute neuritis'],
    cautions: [],
    meds: [
      mk('Wysolone 40', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', 'Months (Tapering)', 'नाश्त्यानंतर'),
      mk('Zerodol', 'Aceclofenac', '1 - 0 - 1', '1 - 0 - 1', '10', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-220',
    label: 'Jarisch-Herxheimer Reaction',
    group: 'Immunological',
    category: 'Immunological',
    aliases: ['Jarisch-Herxheimer Reaction'],
    pathognomonic: 'Acute febrile reaction shortly after initiating treatment for spirochetal infections',
    definitiveTest: 'Clinical diagnosis based on timing after antibiotic administration',
    supportiveTests: ['Vitals monitoring (transient tachycardia/mild hypotension)'],
    ddx: ['Drug Allergy/Anaphylaxis', 'Sepsis', 'Transfusion Reaction'],
    positiveSigns: ['Fever, chills, headache, and myalgia within 24 hours of starting antibiotics', 'Exacerbation of existing skin lesions (e.g., syphilitic rash)'],
    negativeSigns: ['Absence of anaphylaxis signs (no wheezing/hypotension usually)', 'Absence of delayed onset (>24 hrs)'],
    definitiveTreatment: 'Self-limiting; continue antibiotics',
    supportiveTreatment: 'Antipyretics (Paracetamol), NSAIDs, IV fluids if hypotensive',
    redFlags: ['Acute febrile reaction shortly after initiating treatment for spirochetal infections'],
    cautions: [],
    meds: [
      mk('Dolo 650', 'Paracetamol', '1 - 1 - 1', '1 - 1 - 1', '1-2', 'जेवणानंतर'),
      mk('Brufen 400', 'Ibuprofen', '1 - 0 - 1', '1 - 0 - 1', '1-2', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-221',
    label: 'Immune Reconstitution Inflammatory Syndrome (IRIS) - TB',
    group: 'Immunological',
    category: 'Immunological',
    aliases: ['Immune Reconstitution Inflammatory Syndrome (IRIS) - TB', 'IRIS', 'Immune Reconstitution Inflammatory Syndrome - TB'],
    pathognomonic: 'Clinical deterioration despite improving CD4 count and falling viral load',
    definitiveTest: 'Diagnosis of exclusion (rule out treatment failure/other OIs)',
    supportiveTests: ['CD4 count (shows increase)', 'HIV Viral Load (shows decrease)', 'Culture (negative for new pathogens)'],
    ddx: ['MDR-TB', 'Treatment Failure', 'New Opportunistic Infection', 'Drug Toxicity'],
    positiveSigns: ['Paradoxical worsening of TB symptoms (fever, lymphadenopathy) after starting ART', 'Occurs weeks to months after ART initiation'],
    negativeSigns: ['Absence of drug-resistant TB', 'Absence of non-compliance to ATT'],
    definitiveTreatment: 'Continue ART and ATT; add NSAIDs or Corticosteroids for severe inflammation',
    supportiveTreatment: 'Symptomatic management, aspiration of tense lymph nodes',
    redFlags: ['Clinical deterioration despite improving CD4 count and falling viral load'],
    cautions: [],
    meds: [
      mk('Wysolone 20', 'Prednisolone', '1 - 0 - 0', '1 - 0 - 0', '14-28 (Tapering)', 'नाश्त्यानंतर'),
      mk('Voveran SR 100', 'Diclofenac', '1 - 0 - 0', '1 - 0 - 0', '7', 'जेवणानंतर'),
    ],
  },
  {
    id: 'ac-222',
    label: 'Catheter-Associated Urinary Tract Infection (CAUTI)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Catheter-Associated Urinary Tract Infection (CAUTI)', 'CAUTI', 'Catheter-Associated Urinary Tract Infection'],
    pathognomonic: 'Significant bacteriuria (>10^3 CFU/mL) with symptoms in a patient with an indwelling catheter',
    definitiveTest: 'Urine Culture from a newly placed catheter or midstream after removal',
    supportiveTests: ['Urine Routine (Pyuria)', 'Blood Culture', 'CBC'],
    ddx: ['Asymptomatic Bacteriuria', 'Other Healthcare-Associated Infections', 'Prostatitis'],
    positiveSigns: ['Fever, suprapubic pain, or altered mental status in a catheterized patient', 'Purulent discharge around the catheter'],
    negativeSigns: ['Absence of other clear sources of infection', 'Absence of asymptomatic bacteriuria (which doesn\'t need treatment)'],
    definitiveTreatment: 'Remove/Replace Catheter + Targeted IV/Oral Antibiotics based on culture',
    supportiveTreatment: 'Hydration, antipyretics',
    redFlags: ['Significant bacteriuria (>10^3 CFU/mL) with symptoms in a patient with an indwelling catheter'],
    cautions: [],
    meds: [
      mk('Niftas 100', 'Nitrofurantoin', '1 - 0 - 1', '1 - 0 - 1', '7', 'जेवणानंतर'),
      mk('Mikacin 500', 'Amikacin', '1 - 0 - 1 (IV/IM)', '1 - 0 - 1 (IV/IM)', '7', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-223',
    label: 'Central Line-Associated Bloodstream Infection (CLABSI)',
    group: 'Fungal',
    category: 'Bacterial/Fungal',
    aliases: ['Central Line-Associated Bloodstream Infection (CLABSI)', 'CLABSI', 'Central Line-Associated Bloodstream Infection'],
    pathognomonic: 'Same organism grown from peripheral blood and catheter tip/hub with differential time to positivity',
    definitiveTest: 'Paired Blood Cultures (Peripheral and Central Line) showing Differential Time to Positivity > 2 hours',
    supportiveTests: ['Catheter tip culture', 'CBC', 'Procalcitonin'],
    ddx: ['Other sources of sepsis', 'Drug fever', 'DVT at catheter site'],
    positiveSigns: ['Fever, chills, or hypotension in a patient with a central line', 'Erythema or purulence at the catheter insertion site'],
    negativeSigns: ['Absence of infection at another site', 'Absence of negative blood cultures'],
    definitiveTreatment: 'Remove Central Line + Empirical IV Vancomycin + Cefepime/Meropenem (adjust per culture)',
    supportiveTreatment: 'Hemodynamic support, antipyretics',
    redFlags: ['Same organism grown from peripheral blood and catheter tip/hub with differential time to positivity'],
    cautions: [],
    meds: [
      mk('Vancogen 1g', 'Vancomycin', '1g', '1 - 0 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Meromac 1g', 'Meropenem', '1g', '1 - 1 - 1 (IV)', '14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-224',
    label: 'Ventilator-Associated Pneumonia (VAP)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Ventilator-Associated Pneumonia (VAP)', 'VAP', 'Ventilator-Associated Pneumonia'],
    pathognomonic: 'New infiltrate + purulent secretions + positive quantitative culture from lower respiratory tract',
    definitiveTest: 'Quantitative culture of Bronchoalveolar Lavage (BAL) or Endotracheal Aspirate',
    supportiveTests: ['CXR/CT Thorax', 'ABG (worsening oxygenation)', 'Procalcitonin'],
    ddx: ['ARDS', 'Pulmonary Edema', 'Pulmonary Embolism', 'Atelectasis'],
    positiveSigns: ['New or progressive lung infiltrate on CXR >48 hrs after intubation', 'Purulent endotracheal secretions and fever'],
    negativeSigns: ['Absence of clear lung fields', 'Absence of alternative cause for fever/hypoxemia'],
    definitiveTreatment: 'Broad-spectrum IV Antibiotics (e.g., Piperacillin-Tazobactam + Amikacin) tailored to ICU antibiogram',
    supportiveTreatment: 'Optimize ventilator settings, chest physiotherapy, head of bed elevation',
    redFlags: ['Optimize ventilator settings'],
    cautions: [],
    meds: [
      mk('Tazar 4.5g', 'Piperacillin + Tazobactam', '4.5g', '1 - 1 - 1 (IV)', '7-14', 'Inj. (Hospital Use) (Inj.)'),
      mk('Magnex Forte 3g', 'Cefoperazone + Sulbactam', '3g', '1 - 0 - 1 (IV)', '7-14', 'Inj. (Hospital Use) (Inj.)'),
    ],
  },
  {
    id: 'ac-225',
    label: 'Surgical Site Infection (SSI)',
    group: 'Bacterial',
    category: 'Bacterial',
    aliases: ['Surgical Site Infection (SSI)', 'SSI', 'Surgical Site Infection'],
    pathognomonic: 'Pus discharging from a recent surgical wound',
    definitiveTest: 'Wound swab/pus culture and sensitivity',
    supportiveTests: ['USG/CT of the site (to check for deep collection)', 'CBC', 'CRP'],
    ddx: ['Wound Dehiscence', 'Hematoma/Seroma', 'Suture Granuloma', 'Contact Dermatitis to dressings'],
    positiveSigns: ['Purulent drainage from the surgical incision', 'Localized pain, tenderness, swelling, and erythema'],
    negativeSigns: ['Absence of clean, healing wound edges', 'Absence of normal inflammatory phase (persists > 5-7 days)'],
    definitiveTreatment: 'Open the wound, drain pus, debride + Targeted Antibiotics (e.g., Amoxicillin-Clavulanate or Linezolid)',
    supportiveTreatment: 'Regular wound dressing, negative pressure wound therapy (VAC) if large',
    redFlags: ['Pus discharging from a recent surgical wound'],
    cautions: [],
    meds: [
      mk('Augmentin 625 Duo', 'Amoxicillin + Clavulanic Acid', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
      mk('Linid 600', 'Linezolid', '1 - 0 - 1', '1 - 0 - 1', '7-10', 'जेवणानंतर'),
    ],
  },
  // ========================================================================
  // GYNECOLOGY — 26 conditions curated from Dr. Shinde's published Gynec doc.
  // Each carries the same rich clinical fields as the acute-infection set:
  // pathognomonic sign, definitive test, supportive tests (labs + imaging),
  // DDx, positive/negative signs, treatment ladder, red flags, follow-up.
  // ========================================================================
  {
    id: 'gyn-1', label: 'Polycystic Ovary Syndrome (PCOS)', group: 'Gynecology', category: 'Endocrine',
    aliases: ['PCOS', 'PCOD', 'Stein-Leventhal'],
    pathognomonic: 'Rotterdam criteria — 2 of 3 (oligo/anovulation, hyperandrogenism, polycystic ovaries on USG)',
    definitiveTest: 'TVS — ≥12 follicles (2-9 mm) per ovary OR ovarian volume >10 cc',
    supportiveTests: ['TSH & Prolactin (to rule out mimics)', 'FSH, LH on Day 2/3 (LH:FSH > 2:1)', 'Serum Free Testosterone & DHEAS', '75 g OGTT + Fasting Insulin (HOMA-IR)', 'Lipid profile'],
    ddx: ['Thyroid dysfunction', 'Hyperprolactinemia', 'Non-classic CAH', 'Cushing syndrome', 'Androgen-secreting tumour'],
    positiveSigns: ['Irregular / infrequent menses (oligo-amenorrhea)', 'Hirsutism, acne or male-pattern hair loss', 'Central obesity + acanthosis nigricans'],
    negativeSigns: ['Normal TSH and prolactin', 'Absence of virilization (rapid onset, clitoromegaly)'],
    definitiveTreatment: 'Metformin 500 mg BD + lifestyle modification; add Cyproterone-Ethinyl Estradiol (Diane-35) if hirsutism/anti-androgen effect desired',
    supportiveTreatment: 'Weight reduction 5-10 %, Mediterranean/Maharashtrian low-carb high-protein diet, 150 min/wk moderate exercise, folate 400 μg/day if planning conception',
    redFlags: ['Sudden severe virilization → rule out ovarian/adrenal androgen-secreting tumour', 'Prolonged heavy bleeding → endometrial biopsy for hyperplasia'],
    cautions: ['Diane-35 contraindicated in smokers > 35 yrs, uncontrolled BP, migraine with aura, thrombophilia'],
    meds: [
      mk('Glycomet-SR 500', 'Metformin', '500 mg', '1 - 0 - 1', '90+', 'जेवणानंतर'),
      mk('Diane-35', 'Cyproterone Acetate 2 mg + Ethinyl Estradiol 35 μg', '1 tab', '0 - 0 - 1', '21', 'Day 1-21 of cycle × 3-6 cycles'),
      mk('Normoz', 'Myo-Inositol 550 mg + D-Chiro-Inositol 13.8 mg + Folic Acid 100 μg', '1 tab', '1 - 0 - 1', '90+', 'BD after meals × 3-6 months'),
    ],
  },
  {
    id: 'gyn-2', label: 'Bacterial Vaginosis', group: 'Gynecology', category: 'Gyn Infection',
    aliases: ['BV', 'Gardnerella vaginitis'],
    pathognomonic: 'Amsel criteria (≥3 of 4) — homogeneous discharge, clue cells, pH > 4.5, positive whiff test',
    definitiveTest: 'Nugent score 7-10 on Gram-stained vaginal smear',
    supportiveTests: ['Vaginal pH (> 4.5)', 'Wet-mount microscopy (clue cells)', 'Whiff test with 10 % KOH'],
    ddx: ['Trichomoniasis', 'Vulvovaginal candidiasis', 'Aerobic vaginitis', 'Cervicitis'],
    positiveSigns: ['Thin greyish-white discharge', 'Fishy odour worse after intercourse'],
    negativeSigns: ['No pruritus / erythema', 'No trichomonads on wet mount'],
    definitiveTreatment: 'Metronidazole 500 mg PO BD × 7 days',
    supportiveTreatment: 'Avoid douching, avoid intra-vaginal soap, screen pregnant women (preterm-labour risk)',
    redFlags: ['Pelvic pain + fever → suspect PID', 'BV in pregnancy → treat immediately (PROM/preterm risk)'],
    cautions: ['Avoid alcohol during metronidazole (disulfiram-like reaction)'],
    meds: [
      mk('Flagyl 400', 'Metronidazole', '400 mg', '1 - 0 - 1', '7', 'BD after meals; avoid alcohol'),
      mk('Dalacin-V 2%', 'Clindamycin 2 % vaginal cream', '5 g applicator', '0 - 0 - 1', '7', 'Intravaginal HS × 7 days'),
    ],
  },
  {
    id: 'gyn-3', label: 'Endometriosis', group: 'Gynecology', category: 'Menstrual',
    aliases: ['Chocolate cyst', 'Endometrioma'],
    pathognomonic: 'Cyclical pelvic pain + nodularity in pouch of Douglas + fixed retroverted uterus',
    definitiveTest: 'Laparoscopy with biopsy — endometrial glands & stroma outside uterus',
    supportiveTests: ['TVS / Pelvic MRI (ground-glass endometrioma, deep infiltrating nodules)', 'CA-125 (elevated but non-specific)', 'CBC'],
    ddx: ['Pelvic Inflammatory Disease', 'Adenomyosis', 'Ovarian cyst', 'IBS', 'Chronic pelvic pain syndrome'],
    positiveSigns: ['Progressive dysmenorrhea', 'Deep dyspareunia', 'Infertility'],
    negativeSigns: ['Negative pregnancy test', 'Normal vaginal discharge'],
    definitiveTreatment: 'Dienogest 2 mg OD × 6-12 months; add Leuprolide 3.75 mg IM monthly × 3-6 months for severe/recurrent',
    supportiveTreatment: 'NSAID + antispasmodic during menses, cyclical OCP for milder cases, laparoscopic excision if fertility desired',
    redFlags: ['Sudden severe abdominal pain — ruptured endometrioma', 'Bowel/bladder obstruction symptoms — deep infiltrating disease'],
    cautions: ['Leuprolide induces menopausal state — add-back HRT if > 6 months use'],
    meds: [
      mk('Visanne', 'Dienogest', '2 mg', '0 - 1 - 0', '180', 'OD × 6-12 months, continuous'),
      mk('Meftal-Spas', 'Mefenamic Acid 250 mg + Dicyclomine 10 mg', '1 tab', '1 - 1 - 1', '3', 'SOS during menses'),
      mk('Lupron Depot 3.75', 'Leuprolide Acetate', '3.75 mg', 'IM monthly', '90', 'IM once every 28 days × 3-6 months (severe)'),
    ],
  },
  {
    id: 'gyn-4', label: 'Adenomyosis', group: 'Gynecology', category: 'Menstrual',
    aliases: [],
    pathognomonic: 'Symmetrically enlarged (12-14 wk sized) globular, boggy, tender uterus',
    definitiveTest: 'Histopathology post-hysterectomy — endometrial tissue within myometrium',
    supportiveTests: ['TVS / Pelvic MRI (asymmetric myometrial thickening, myometrial cysts, ill-defined junctional zone)', 'CBC (anaemia)', 'TSH'],
    ddx: ['Uterine fibroids', 'Endometriosis', 'Endometrial hyperplasia', 'Pelvic congestion syndrome'],
    positiveSigns: ['Heavy menstrual bleeding', 'Severe dysmenorrhea', 'Chronic pelvic pain'],
    negativeSigns: ['Negative pregnancy test', 'No discrete fibroids on USG'],
    definitiveTreatment: 'Levonorgestrel-IUS (Mirena 52 mg) — most effective conservative option',
    supportiveTreatment: 'Tranexamic acid + NSAID during menses, iron supplementation for anaemia, hysterectomy if refractory + family complete',
    redFlags: ['Severe anaemia Hb < 7 g/dL — urgent transfusion + evaluation', 'Postmenopausal bleeding — endometrial biopsy mandatory'],
    cautions: ['Mirena insertion best in the first week of cycle'],
    meds: [
      mk('Mirena 52 mg', 'Levonorgestrel IUS', '52 mg', 'Intrauterine', '1825', 'Once every 5 years'),
      mk('Trenaxa 500', 'Tranexamic Acid', '500 mg', '1 - 1 - 1', '5', 'TDS during menses × up to 5 days'),
      mk('Visanne', 'Dienogest', '2 mg', '0 - 1 - 0', '180', 'OD × 6 months if IUS declined'),
    ],
  },
  {
    id: 'gyn-5', label: 'Uterine Fibroids (Leiomyoma)', group: 'Gynecology', category: 'Menstrual',
    aliases: ['Myoma', 'Fibromyoma', 'Leiomyoma'],
    pathognomonic: 'Firm, irregular, non-tender enlarged uterus with palpable mass continuous with uterus',
    definitiveTest: 'Histopathology (post-myomectomy/hysterectomy) — whorled smooth-muscle pattern',
    supportiveTests: ['TVS / Pelvic USG (well-defined hypoechoic mass)', 'CBC', 'Blood grouping & cross-match if surgery planned'],
    ddx: ['Adenomyosis', 'Ovarian tumour', 'Pregnancy', 'Uterine sarcoma'],
    positiveSigns: ['Heavy / prolonged menses', 'Pelvic pressure / urinary frequency', 'Firm mass on bimanual exam'],
    negativeSigns: ['Negative pregnancy test', 'Normal Pap smear'],
    definitiveTreatment: 'Tranexamic acid for symptomatic bleeding; Ulipristal 5 mg OD × 3 months pre-op; Myomectomy / Hysterectomy if refractory or fertility complete',
    supportiveTreatment: 'Iron correction for anaemia, GnRH analogue pre-op to shrink fibroid & minimise intra-op blood loss',
    redFlags: ['Rapid growth of fibroid — rule out sarcoma', 'Severe anaemia', 'Acute pain — red degeneration or pedunculated torsion'],
    cautions: ['Ulipristal — monitor LFTs; limit to 3-month blocks'],
    meds: [
      mk('Trenaxa 500', 'Tranexamic Acid', '500 mg', '1 - 1 - 1', '5', 'TDS during menses × up to 5 days'),
      mk('Fibroprist 5', 'Ulipristal Acetate', '5 mg', '1 - 0 - 0', '90', 'OD × 3 months (monitor LFTs)'),
      mk('Lupron Depot 3.75', 'Leuprolide Acetate', '3.75 mg', 'IM monthly', '90', 'IM once every 28 days pre-op × 3-6 months'),
    ],
  },
  {
    id: 'gyn-6', label: 'Vulvovaginal Candidiasis', group: 'Gynecology', category: 'Gyn Infection',
    aliases: ['Monilial vaginitis', 'Yeast infection', 'Thrush'],
    pathognomonic: 'Curdy white "cottage-cheese" discharge + intense vulvar pruritus + normal vaginal pH (4.0-4.5)',
    definitiveTest: 'Fungal culture — Candida species (usually C. albicans)',
    supportiveTests: ['10 % KOH wet mount (pseudohyphae/spores)', 'Vaginal pH', 'RBS / HbA1c if recurrent (screen diabetes)'],
    ddx: ['Bacterial vaginosis', 'Trichomoniasis', 'Contact dermatitis', 'Lichen sclerosus'],
    positiveSigns: ['Vulvar erythema/oedema', 'External dysuria', 'Curdy discharge'],
    negativeSigns: ['No fishy odour', 'Normal pH 4.0-4.5'],
    definitiveTreatment: 'Fluconazole 150 mg PO single dose OR Clotrimazole 200 mg pessary HS × 3 days',
    supportiveTreatment: 'Keep vulva dry, cotton underwear, control glycaemia, treat partner only if symptomatic',
    redFlags: ['≥ 4 episodes/year — screen for diabetes / HIV / immunosuppression', 'Non-albicans (C. glabrata) — needs boric-acid 600 mg × 14 days'],
    cautions: ['Fluconazole avoided in first trimester'],
    meds: [
      mk('Candid-V3', 'Clotrimazole vaginal tablet', '200 mg', '0 - 0 - 1', '3', 'Intravaginal HS × 3 days'),
      mk('AF-150', 'Fluconazole', '150 mg', '1 - 0 - 0', '1', 'Single dose PO'),
      mk('Candid Cream 1%', 'Clotrimazole 1 % cream', 'PRN', '1 - 0 - 1', '7', 'Local application BD × 7 days'),
    ],
  },
  {
    id: 'gyn-7', label: 'Trichomoniasis', group: 'Gynecology', category: 'Gyn Infection',
    aliases: ['Trich', 'T. vaginalis vaginitis'],
    pathognomonic: 'Frothy yellow-green vaginal discharge + strawberry cervix (colpitis macularis) + pH > 4.5',
    definitiveTest: 'NAAT (nucleic-acid amplification test) for Trichomonas vaginalis',
    supportiveTests: ['Saline wet mount (motile flagellated trichomonads)', 'Vaginal pH', 'Concurrent STI screen — HIV, VDRL, HBsAg, HCV, Chlamydia/Gonorrhea NAAT'],
    ddx: ['Bacterial vaginosis', 'Vulvovaginal candidiasis', 'Cervicitis (Chlamydia/Gonorrhea)'],
    positiveSigns: ['Foul-smelling frothy green discharge', 'Vulvar pruritus & soreness', 'Strawberry cervix'],
    negativeSigns: ['No curdy discharge', 'No clue cells'],
    definitiveTreatment: 'Tinidazole 2 g PO single dose OR Metronidazole 400 mg BD × 7 days — treat partner mandatorily',
    supportiveTreatment: 'Abstain from intercourse until both partners treated and asymptomatic, avoid alcohol × 72 h post-dose',
    redFlags: ['Co-infection with other STIs — always screen HIV/VDRL/HBsAg/HCV/Chlamydia/Gonorrhea', 'Pregnancy — increased PROM & preterm-delivery risk'],
    cautions: ['Disulfiram-like reaction with alcohol'],
    meds: [
      mk('Fasigyn 500', 'Tinidazole', '2 g', 'Stat', '1', 'Single dose 4 tablets PO'),
      mk('Flagyl 400', 'Metronidazole', '400 mg', '1 - 0 - 1', '7', 'BD × 7 days (alternative)'),
      mk('Secnil 1 g', 'Secnidazole', '2 g', 'Stat', '1', 'Single dose PO'),
    ],
  },
  {
    id: 'gyn-8', label: 'Pelvic Inflammatory Disease (PID)', group: 'Gynecology', category: 'Gyn Infection',
    aliases: ['PID', 'Salpingitis', 'Tubo-ovarian abscess'],
    pathognomonic: 'Cervical motion tenderness + adnexal tenderness + fever > 38.3 °C in a sexually active woman',
    definitiveTest: 'Laparoscopy — hyperemia, oedema, and purulent exudate on fallopian tubes',
    supportiveTests: ['TVS (thickened tubes, TOA)', 'CBC (leucocytosis), ESR/CRP elevated', 'Endocervical NAAT — Chlamydia + Gonorrhea', 'STI screen — HIV, VDRL, HBsAg, HCV'],
    ddx: ['Ectopic pregnancy', 'Appendicitis', 'Endometriosis', 'Ovarian cyst rupture'],
    positiveSigns: ['Lower abdominal pain', 'Cervical motion tenderness', 'Abnormal vaginal discharge', 'Fever'],
    negativeSigns: ['Negative pregnancy test', 'Normal appendix on USG'],
    definitiveTreatment: 'Ceftriaxone 500 mg IM stat + Doxycycline 100 mg BD × 14 days + Metronidazole 400 mg BD × 14 days',
    supportiveTreatment: 'Treat partner, remove IUCD only if no clinical improvement in 72 h, hospitalise if TOA/pregnancy/failed OPD therapy',
    redFlags: ['Tubo-ovarian abscess rupture → acute abdomen', 'PID in pregnancy — admit'],
    cautions: ['Doxycycline avoided in pregnancy/lactation — substitute Azithromycin 1 g/wk × 2'],
    meds: [
      mk('Monocef 500', 'Ceftriaxone', '500 mg', 'IM Stat', '1', 'IM single dose'),
      mk('Vibramycin 100', 'Doxycycline', '100 mg', '1 - 0 - 1', '14', 'BD × 14 days'),
      mk('Flagyl 400', 'Metronidazole', '400 mg', '1 - 0 - 1', '14', 'BD × 14 days'),
    ],
  },
  {
    id: 'gyn-9', label: 'Primary Dysmenorrhea', group: 'Gynecology', category: 'Menstrual',
    aliases: ['Menstrual cramps'],
    pathognomonic: 'Cyclical crampy lower-abdominal pain starting within 6-12 months of menarche + normal pelvic exam',
    definitiveTest: 'Clinical — normal pelvic anatomy on TVS',
    supportiveTests: ['TVS if pain severe/atypical', 'None routinely if history classic'],
    ddx: ['Secondary dysmenorrhea (endometriosis, adenomyosis)', 'PID', 'Ovarian cyst'],
    positiveSigns: ['Pain onset just before/with menses', 'Pain lasts 8-72 h', 'Associated nausea/vomiting/diarrhoea'],
    negativeSigns: ['No pelvic pathology on exam or imaging'],
    definitiveTreatment: 'Mefenamic + Dicyclomine (Meftal-Spas) TDS during pain; try OCP if NSAID fails',
    supportiveTreatment: 'Local heat, start NSAID 1-2 days before expected menses, regular exercise, magnesium supplementation',
    redFlags: ['Pain progressively worsening or not responding — suspect secondary dysmenorrhea'],
    cautions: ['Avoid NSAIDs in peptic ulcer, chronic kidney disease'],
    meds: [
      mk('Meftal-Spas', 'Mefenamic Acid + Dicyclomine', '1 tab', '1 - 1 - 1', '3', 'TDS during pain × 2-3 days'),
      mk('Brufen 400', 'Ibuprofen', '400 mg', '1 - 1 - 1', '3', 'TDS during pain'),
      mk('Overal L', 'Levonorgestrel + Ethinyl Estradiol', '1 tab', '0 - 0 - 1', '21', 'Day 1-21 of cycle × 3 cycles if NSAID fails'),
    ],
  },
  {
    id: 'gyn-10', label: 'Secondary Dysmenorrhea', group: 'Gynecology', category: 'Menstrual',
    aliases: [],
    pathognomonic: 'Cyclical pelvic pain beginning years after menarche + pelvic pathology on exam/imaging',
    definitiveTest: 'Laparoscopy / Hysteroscopy — identifies underlying cause',
    supportiveTests: ['TVS / Pelvic MRI', 'CBC', 'High-vaginal/endocervical swab if PID suspected'],
    ddx: ['Endometriosis', 'Adenomyosis', 'Uterine fibroids', 'PID', 'Pelvic congestion syndrome'],
    positiveSigns: ['Pain begins days before menses and lasts longer', 'Dyspareunia', 'Abnormal uterine bleeding'],
    negativeSigns: ['Onset years after menarche (unlike primary)'],
    definitiveTreatment: 'Targeted therapy for underlying cause (see individual conditions)',
    supportiveTreatment: 'Mefenamic-Dicyclomine for pain, iron supplementation if anaemic',
    redFlags: ['Severe acute exacerbation — torsion / rupture', 'Heavy bleeding causing anaemia'],
    cautions: [],
    meds: [
      mk('Meftal-Spas', 'Mefenamic Acid + Dicyclomine', '1 tab', '1 - 1 - 1', '5', 'TDS for symptomatic relief'),
    ],
  },
  {
    id: 'gyn-11', label: 'Abnormal Uterine Bleeding — Endometrial (AUB-E)', group: 'Gynecology', category: 'Menstrual',
    aliases: ['AUB-E', 'DUB'],
    pathognomonic: 'Predictable cyclic heavy bleeding with normal pelvic exam + normal TVS',
    definitiveTest: 'Endometrial biopsy — normal secretory endometrium',
    supportiveTests: ['TVS (normal uterus)', 'CBC', 'TSH', 'UPT'],
    ddx: ['AUB-L (Leiomyoma)', 'AUB-P (Polyp)', 'AUB-O (Ovulatory dysfunction)', 'AUB-C (Coagulopathy)'],
    positiveSigns: ['Ovulatory cycles', 'No structural abnormalities on imaging'],
    negativeSigns: ['No fibroids/polyps on USG', 'Normal coagulation profile'],
    definitiveTreatment: 'Tranexamic acid + Mefenamic acid during menses; add Mirena IUS if refractory',
    supportiveTreatment: 'Maintain menstrual calendar, iron supplementation, weight optimisation',
    redFlags: ['Severe anaemia', 'Bleeding unresponsive to medical therapy — endometrial biopsy', 'Postmenopausal bleeding'],
    cautions: [],
    meds: [
      mk('Trenaxa 500', 'Tranexamic Acid', '500 mg', '1 - 1 - 1', '5', 'TDS during menses × up to 5 days'),
      mk('Meftal 500', 'Mefenamic Acid', '500 mg', '1 - 1 - 1', '5', 'TDS during menses × up to 5 days'),
      mk('Mirena 52 mg', 'Levonorgestrel IUS', '52 mg', 'Intrauterine', '1825', 'Once every 5 years'),
    ],
  },
  {
    id: 'gyn-12', label: 'Abnormal Uterine Bleeding — Ovulatory (AUB-O)', group: 'Gynecology', category: 'Menstrual',
    aliases: ['AUB-O', 'Anovulatory bleeding'],
    pathognomonic: 'Irregular unpredictable bleeding — commonly in PCOS, obesity, perimenopause',
    definitiveTest: 'Endometrial biopsy in women > 35 y or high-risk — rules out hyperplasia',
    supportiveTests: ['TVS (thickened endometrium, polycystic ovaries)', 'TSH, Prolactin', 'CBC', 'UPT'],
    ddx: ['PCOS', 'Thyroid dysfunction', 'Hyperprolactinemia', 'Endometrial hyperplasia'],
    positiveSigns: ['Unpredictable timing and amount of bleeding', 'Anovulation'],
    negativeSigns: ['No structural causes on imaging'],
    definitiveTreatment: 'Cyclical progestogen (Medroxyprogesterone 10 mg BD Days 15-25) OR combined OCP',
    supportiveTreatment: 'Weight reduction if obese, menstrual calendar, treat underlying cause (thyroid/prolactin/PCOS)',
    redFlags: ['Thickened endometrium (> 12 mm) in > 45 y — endometrial biopsy', 'Failure of medical management — biopsy mandatory'],
    cautions: ['OCPs contraindicated in smokers > 35 y, uncontrolled BP, thrombophilia'],
    meds: [
      mk('Deviry 10', 'Medroxyprogesterone Acetate', '10 mg', '1 - 0 - 1', '21', 'BD × 21 days or Day 15-25 monthly × 3-6 cycles'),
      mk('Overal L', 'Levonorgestrel + Ethinyl Estradiol', '1 tab', '0 - 0 - 1', '21', 'Day 1-21 of cycle × 3-6 cycles'),
      mk('Mirena 52 mg', 'Levonorgestrel IUS', '52 mg', 'Intrauterine', '1825', 'Once every 5 years'),
    ],
  },
  {
    id: 'gyn-13', label: 'Menopause & Climacteric Symptoms', group: 'Gynecology', category: 'Endocrine',
    aliases: ['Perimenopause', 'Climacteric syndrome'],
    pathognomonic: 'Amenorrhea ≥ 12 months + vasomotor symptoms (hot flashes) in a woman aged 45-55',
    definitiveTest: 'Serum FSH > 40 mIU/mL (not required if clinical picture is clear)',
    supportiveTests: ['TSH', 'Fasting lipid profile', 'FBS/PPBS', 'DEXA scan for osteoporosis screen'],
    ddx: ['Thyroid dysfunction', 'Depression', 'Pheochromocytoma', 'Carcinoid syndrome'],
    positiveSigns: ['Hot flashes / night sweats', 'Vaginal dryness / dyspareunia', 'Mood swings, insomnia'],
    negativeSigns: ['Negative pregnancy test', 'Normal TSH, prolactin'],
    definitiveTreatment: 'Low-dose Conjugated Estrogens 0.3-0.625 mg OD (+ Progestogen if uterus intact) — lowest effective dose for shortest duration',
    supportiveTreatment: 'Calcium 500 mg + Vit-D 250 IU BD, weight-bearing exercise, SSRI (venlafaxine 75 mg) if HRT contraindicated, local Estriol cream for GSM',
    redFlags: ['🚨 POSTMENOPAUSAL BLEEDING → urgent endometrial biopsy to rule out cancer', 'Sudden severe headache/chest pain on HRT — thromboembolism'],
    cautions: ['HRT contraindicated in breast Ca history, undiagnosed vaginal bleeding, prior VTE, active liver disease'],
    meds: [
      mk('Premarin 0.625', 'Conjugated Estrogens', '0.625 mg', '1 - 0 - 0', '90', 'OD (+ progestogen if uterus intact) — lowest effective dose'),
      mk('Ovestin Cream', 'Estriol vaginal cream 0.1 %', '1 applicator', '0 - 0 - 1', '14', 'Nightly × 2 wk then twice weekly'),
      mk('Shelcal 500', 'Calcium Carbonate 500 mg + Vit D3 250 IU', '1 tab', '1 - 0 - 1', '90+', 'BD continuous'),
    ],
  },
  {
    id: 'gyn-14', label: 'Uterine Prolapse', group: 'Gynecology', category: 'Prolapse',
    aliases: ['Pelvic organ prolapse (POP-Q)', 'Descensus uteri'],
    pathognomonic: 'Descent of cervix/uterus into or beyond the vaginal introitus on Valsalva',
    definitiveTest: 'Clinical — POP-Q staging on speculum + Valsalva',
    supportiveTests: ['Pelvic USG (rule out concurrent fibroids/cysts)', 'Urine R/M + culture (rule out UTI)', 'RFT if severe (ureteric kinking)'],
    ddx: ['Cervical elongation', 'Isolated cystocele/rectocele', 'Uterine inversion'],
    positiveSigns: ['"Something coming down" sensation', 'Pelvic heaviness / dragging pain', 'Visible mass at introitus'],
    negativeSigns: [],
    definitiveTreatment: 'Vaginal hysterectomy with pelvic-floor repair (definitive); ring pessary if surgery declined/contraindicated',
    supportiveTreatment: 'Kegel exercises, weight reduction, treat chronic cough/constipation, topical Estrogen if postmenopausal atrophy',
    redFlags: ['Decubitus ulcer with foul discharge', 'Urinary retention / bilateral hydronephrosis'],
    cautions: ['Pessary needs 3-6 monthly follow-up + estrogen cream in postmenopausal'],
    meds: [
      mk('Ring Pessary', 'Silicone/Plastic Pessary', 'Sized to patient', 'Vaginal insertion', '180', 'Change every 3-6 months'),
      mk('Premarin Vaginal Cream', 'Conjugated Estrogens 0.625 mg/g', '0.5 g', '0 - 0 - 1', '14', 'Twice weekly'),
    ],
  },
  {
    id: 'gyn-15', label: 'Cystocele (Bladder Prolapse)', group: 'Gynecology', category: 'Prolapse',
    aliases: [],
    pathognomonic: 'Bulge in anterior vaginal wall descending with Valsalva',
    definitiveTest: 'Clinical — POP-Q anterior compartment staging',
    supportiveTests: ['Post-void residual USG (> 50-100 mL abnormal)', 'Urine R/M + culture'],
    ddx: ['Urethral diverticulum', 'Gartner duct cyst', 'Uterine prolapse'],
    positiveSigns: ['Anterior vaginal wall bulge', 'Incomplete bladder emptying / stress incontinence'],
    negativeSigns: [],
    definitiveTreatment: 'Anterior colporrhaphy — definitive; Kegel exercises + pessary as conservative options',
    supportiveTreatment: 'Avoid heavy lifting, treat constipation, weight reduction',
    redFlags: ['Recurrent UTIs', 'Complete urinary retention'],
    cautions: [],
    meds: [
      mk('Kegel Physiotherapy', 'Pelvic-floor muscle training', 'N/A', 'Daily', '90+', 'Continuous — 3 sets of 10 contractions daily'),
      mk('Vaginal Pessary', 'Ring or Gellhorn pessary', 'Sized to patient', 'Vaginal', '180', 'Change every 3-6 months'),
    ],
  },
  {
    id: 'gyn-16', label: 'Rectocele', group: 'Gynecology', category: 'Prolapse',
    aliases: [],
    pathognomonic: 'Bulge in posterior vaginal wall descending with Valsalva; patient splints vagina to defecate',
    definitiveTest: 'Clinical — POP-Q posterior compartment staging',
    supportiveTests: ['Defecography (rarely needed)', 'Anal-manometry if fecal incontinence'],
    ddx: ['Enterocele', 'Posterior vaginal wall cyst', 'Rectal prolapse'],
    positiveSigns: ['Posterior vaginal wall bulge', 'Difficulty passing stool without splinting'],
    negativeSigns: [],
    definitiveTreatment: 'Posterior colporrhaphy — definitive; stool bulking + laxatives + Kegel exercises for milder cases',
    supportiveTreatment: 'High-fibre diet, adequate hydration, avoid straining',
    redFlags: ['Fecal incontinence — anal sphincter defect'],
    cautions: [],
    meds: [
      mk('Cremaffin', 'Liquid Paraffin + Milk of Magnesia', '15-30 mL', '0 - 0 - 1', '30', 'HS as needed'),
      mk('Isabgol', 'Psyllium Husk', '1-2 scoops', '0 - 0 - 1', '30+', 'HS with a full glass of water'),
    ],
  },
  {
    id: 'gyn-17', label: 'Mittelschmerz (Ovulatory Pain)', group: 'Gynecology', category: 'Menstrual',
    aliases: ['Ovulation pain', 'Mid-cycle pain'],
    pathognomonic: 'Unilateral, sharp lower-abdominal pain occurring around day 14 of a regular cycle, lasting hours to 1-2 days',
    definitiveTest: 'Clinical — pain diary showing mid-cycle timing',
    supportiveTests: ['TVS to rule out ovarian cyst if pain atypical or persistent'],
    ddx: ['Ectopic pregnancy', 'Ovarian cyst rupture', 'Appendicitis', 'PID'],
    positiveSigns: ['Sharp pain alternating sides between cycles', 'Occasional light spotting'],
    negativeSigns: ['No fever, no discharge, no hemodynamic compromise'],
    definitiveTreatment: 'Reassurance + NSAID during pain; combined OCP suppresses ovulation if severe recurrent',
    supportiveTreatment: 'Local heat, pain diary to confirm mid-cycle timing',
    redFlags: ['Pain worsening / fever / hemodynamic instability — surgical emergency (rupture / torsion)'],
    cautions: [],
    meds: [
      mk('Brufen 400', 'Ibuprofen', '400 mg', '1 - 1 - 1', '2', 'TDS during episode'),
      mk('Overal L', 'Levonorgestrel + Ethinyl Estradiol', '1 tab', '0 - 0 - 1', '21', 'Day 1-21 × 3-6 cycles if severe recurrent'),
    ],
  },
  {
    id: 'gyn-18', label: 'Pelvic Congestion Syndrome', group: 'Gynecology', category: 'Pain',
    aliases: ['PCS'],
    pathognomonic: 'Chronic pelvic pain worse with prolonged standing + relieved lying down + vulvar/thigh varicosities',
    definitiveTest: 'Pelvic venography — dilated tortuous incompetent pelvic/ovarian veins (rarely done now; MR/CT venography preferred)',
    supportiveTests: ['TVS with Doppler — dilated pelvic veins > 5 mm, reversed ovarian-vein flow', 'Pelvic MRI / CT venography'],
    ddx: ['Endometriosis', 'Adenomyosis', 'Chronic PID', 'Pudendal neuralgia'],
    positiveSigns: ['Dull aching heaviness worsened by day-end/standing', 'Post-coital ache lasting hours-days'],
    negativeSigns: ['No infection markers'],
    definitiveTreatment: 'Ovarian vein embolization (interventional radiology) for refractory cases',
    supportiveTreatment: 'Medroxyprogesterone 30 mg OD suppresses ovarian venous engorgement; Micronized flavonoids as venotonic; leg elevation',
    redFlags: ['Sudden severe pain or unilateral leg swelling — rule out DVT / May-Thurner syndrome'],
    cautions: [],
    meds: [
      mk('Provera 10', 'Medroxyprogesterone Acetate', '30-50 mg', '1 - 0 - 1', '90', 'OD × 3 months (max 50 mg/day)'),
      mk('Daflon 500', 'Micronized Purified Flavonoid Fraction', '500 mg', '1 - 0 - 1', '90', 'BD × 3 months (venotonic)'),
    ],
  },
  {
    id: 'gyn-19', label: 'IUD Displacement', group: 'Gynecology', category: 'Contraception',
    aliases: ['IUCD malposition'],
    pathognomonic: 'IUD stem in lower uterine segment or cervical canal on TVS instead of fundus',
    definitiveTest: 'TVS — IUD position relative to fundus',
    supportiveTests: ['UPT to exclude contraceptive failure'],
    ddx: ['IUD expulsion', 'Uterine perforation', 'PID', 'Ectopic pregnancy'],
    positiveSigns: ['Pelvic pain/cramping', 'Partner feels IUD during intercourse', 'Hard plastic palpable at cervix'],
    negativeSigns: [],
    definitiveTreatment: 'Remove displaced IUD in OPD (gentle pull on strings) — replace immediately if patient desires continuation and pregnancy excluded',
    supportiveTreatment: 'Offer alternative contraception (OCP, implant) if patient declines re-insertion',
    redFlags: ['Severe abdominal pain / fever / peritonism — suspect uterine perforation / intra-abdominal IUD'],
    cautions: [],
    meds: [
      mk('IUD Removal', 'Office IUD removal procedure', 'N/A', 'OPD', '1', 'Gentle traction on strings'),
      mk('IUD Re-insertion', 'Copper-T 380A or Mirena 52 mg', 'N/A', 'OPD', '1', 'Immediately after removal if patient consents'),
    ],
  },
  {
    id: 'gyn-20', label: 'Lost IUD String', group: 'Gynecology', category: 'Contraception',
    aliases: ['Missing IUD strings'],
    pathognomonic: 'Strings not visualised at external os on speculum exam',
    definitiveTest: 'TVS (± abdominal X-ray if TVS negative) to locate IUD',
    supportiveTests: ['UPT is MANDATORY before probing cervix', 'X-ray abdomen if TVS negative'],
    ddx: ['Unnoticed expulsion', 'Uterine perforation (IUD intra-abdominal)', 'Strings retracted into canal', 'Pregnancy (uterus enlarges pulling strings up)'],
    positiveSigns: ['Strings not seen on speculum'],
    negativeSigns: ['Strings simply cut short (visible)'],
    definitiveTreatment: 'Cervical exploration with cytobrush / thread-retriever; hysteroscopic retrieval if in cavity; leave in situ if correctly placed and asymptomatic',
    supportiveTreatment: 'Chart note "strings missing" for future removal planning',
    redFlags: ['IUD not seen on TVS — abdominal X-ray mandatory to differentiate unrecognised expulsion vs uterine perforation'],
    cautions: ['NEVER probe cervix without excluding pregnancy first'],
    meds: [
      mk('Cervical Exploration', 'Cytobrush / thread retriever', 'N/A', 'OPD', '1', 'To tease out retracted strings'),
      mk('Hysteroscopic Retrieval', 'Operative hysteroscopy', 'N/A', 'OT', '1', 'If strings in cavity and removal desired'),
    ],
  },
  {
    id: 'gyn-21', label: 'Implanon / Nexplanon Complications', group: 'Gynecology', category: 'Contraception',
    aliases: ['Etonogestrel implant side-effects'],
    pathognomonic: 'Irregular/prolonged bleeding or amenorrhea + palpable subdermal implant in upper inner arm',
    definitiveTest: 'Clinical + high-frequency USG of arm (or MRI) to locate deep/migrated implant',
    supportiveTests: ['UPT (if amenorrhea + symptomatic)', 'Chlamydia/Gonorrhea NAAT if bleeding pattern changed'],
    ddx: ['AUB-O', 'Pregnancy (rare — inserted while pregnant)', 'STI / cervicitis'],
    positiveSigns: ['Symptoms temporally related to implant insertion', 'Weight gain, mood changes, acne'],
    negativeSigns: [],
    definitiveTreatment: 'Reassurance ± short-course COCP/NSAID for troublesome bleeding; remove implant if intolerable or expired (3 years)',
    supportiveTreatment: 'Explain bleeding usually improves after 3-6 months, keep insertion site clean',
    redFlags: ['Non-palpable implant — DO NOT attempt blind removal; refer for imaging-guided removal to avoid neurovascular injury'],
    cautions: [],
    meds: [
      mk('Brufen 400', 'Ibuprofen', '400 mg', '1 - 1 - 1', '7', 'TDS × 5-7 days for prolonged bleeding'),
      mk('Overal L', 'Levonorgestrel + Ethinyl Estradiol', '1 tab', '0 - 0 - 1', '30', 'OD × 1-3 months to stabilise endometrium'),
      mk('Implant Removal', 'Office implant removal', 'N/A', 'OPD', '1', 'If patient intolerant or implant expired'),
    ],
  },
  {
    id: 'gyn-22', label: 'Vulvar Hematoma', group: 'Gynecology', category: 'Trauma',
    aliases: [],
    pathognomonic: 'Rapidly expanding, tense, purplish vulvar swelling with exquisite pain following delivery/straddle injury/assault',
    definitiveTest: 'Clinical diagnosis; CT pelvis if retroperitoneal extension suspected',
    supportiveTests: ['CBC (blood loss)', 'Blood grouping & cross-match if large/expanding', 'Coagulation profile'],
    ddx: ['Bartholin abscess', 'Vulvar varicosity', 'Inguinal hernia'],
    positiveSigns: ['Tense tender fluctuant vulvar/perineal mass', 'Difficulty voiding'],
    negativeSigns: ['No history of trauma → suspect other diagnosis'],
    definitiveTreatment: 'Small (< 3-5 cm, non-expanding) — ice pack + pressure; Large (> 5 cm) or expanding or hemodynamic compromise — incision, evacuation, ligation of bleeders',
    supportiveTreatment: 'Foley catheter if urethral obstruction, sitz baths after 24-48 h, analgesia',
    redFlags: ['Hemodynamic instability (tachycardia + hypotension) — massive concealed retroperitoneal hemorrhage'],
    cautions: [],
    meds: [
      mk('Ice Pack + Pressure', 'Conservative management', 'N/A', 'Continuous', '2', 'For small non-expanding hematomas'),
      mk('Foley Catheter', 'Bladder drainage', 'N/A', 'Continuous', '3', 'If urethral obstruction / retention'),
      mk('Surgical Evacuation', 'Incision + ligation of bleeders', 'N/A', 'Emergency', '1', 'For large/expanding hematomas'),
    ],
  },
  {
    id: 'gyn-23', label: 'Cervical Stenosis', group: 'Gynecology', category: 'Structural',
    aliases: [],
    pathognomonic: 'Inability to pass a standard 1-2 mm cervical dilator through the internal os',
    definitiveTest: 'Clinical — attempted probing under anaesthesia',
    supportiveTests: ['TVS — hematometra/pyometra proximal to stenosis', 'UPT if premenopausal'],
    ddx: ['Asherman syndrome', 'Imperforate hymen', 'Cervical malignancy causing obstruction'],
    positiveSigns: ['Amenorrhea or severe dysmenorrhea in premenopausal', 'History of LEEP/cone biopsy/cryotherapy'],
    negativeSigns: [],
    definitiveTreatment: 'Cervical dilatation under USG guidance ± hysteroscopy; pre-treat with Misoprostol 200-400 μg vaginal/oral 2-4 h before',
    supportiveTreatment: 'Estrogen cream × 2 wk pre-procedure if postmenopausal (softens atrophic cervix)',
    redFlags: ['Pyometra — high sepsis + perforation risk; antibiotics + careful drainage', 'Postmenopausal hematometra — endometrial/cervical cancer suspicion'],
    cautions: [],
    meds: [
      mk('Cytolog 200', 'Misoprostol', '200 μg', 'Stat', '1', 'Vaginal or PO 2-4 h before procedure to soften cervix'),
      mk('Ovestin Cream', 'Estriol vaginal cream 0.1 %', '0.5 g', '0 - 0 - 1', '14', 'Nightly × 2 wk pre-procedure (postmenopausal)'),
    ],
  },
  {
    id: 'gyn-24', label: 'Nabothian Cyst', group: 'Gynecology', category: 'Structural',
    aliases: [],
    pathognomonic: 'Smooth, shiny, pale/yellow mucus-filled bumps on cervix (retention cysts of endocervical glands)',
    definitiveTest: 'Clinical diagnosis — biopsy only if atypical',
    supportiveTests: ['Routine Pap smear as per screening guidelines'],
    ddx: ['Cervical polyps', 'Cervical endometriosis', 'Cervical malignancy (rarely cystic)'],
    positiveSigns: ['Incidental finding on speculum / TVS'],
    negativeSigns: [],
    definitiveTreatment: 'Reassurance — no treatment required (benign physiological finding)',
    supportiveTreatment: 'Regular cervical cancer screening as per age-appropriate guidelines',
    redFlags: ['Complex, solid, or rapidly growing cervical mass — not a simple Nabothian cyst; biopsy required'],
    cautions: [],
    meds: [
      mk('Reassurance', 'No treatment required', 'N/A', 'N/A', '1', 'Benign physiological finding'),
    ],
  },
  {
    id: 'gyn-25', label: 'Fitz-Hugh-Curtis Syndrome', group: 'Gynecology', category: 'Gyn Infection',
    aliases: ['FHC', 'Perihepatitis'],
    pathognomonic: 'Right upper quadrant pleuritic pain in a young sexually active woman with signs of PID',
    definitiveTest: 'Laparoscopy — "violin-string" adhesions between liver capsule and anterior abdominal wall/diaphragm',
    supportiveTests: ['Endocervical NAAT — Chlamydia + Gonorrhea', 'LFT (usually normal / mildly elevated)', 'CBC, CRP', 'STI screen — HIV/VDRL/HBsAg/HCV'],
    ddx: ['Acute cholecystitis', 'Viral hepatitis', 'Right lower lobe pneumonia', 'PE', 'Acute PID without perihepatitis'],
    positiveSigns: ['RUQ pain worse with breathing/coughing', 'Concurrent PID symptoms (vaginal discharge, cervical motion tenderness)'],
    negativeSigns: ['Normal gallbladder on USG', 'Normal or mildly elevated LFTs'],
    definitiveTreatment: 'Full 14-day PID regimen — Ceftriaxone 500 mg IM stat + Doxycycline 100 mg BD × 14 days + Metronidazole 400 mg BD × 14 days',
    supportiveTreatment: 'NSAID for pleuritic pain, partner treatment mandatory',
    redFlags: ['Jaundice or markedly elevated LFTs — suspect primary hepatobiliary disease'],
    cautions: ['Doxycycline avoided in pregnancy'],
    meds: [
      mk('Monocef 500', 'Ceftriaxone', '500 mg', 'IM Stat', '1', 'Single dose'),
      mk('Vibramycin 100', 'Doxycycline', '100 mg', '1 - 0 - 1', '14', 'BD × 14 days'),
      mk('Flagyl 400', 'Metronidazole', '400 mg', '1 - 0 - 1', '14', 'BD × 14 days'),
      mk('Brufen 400', 'Ibuprofen', '400 mg', '1 - 1 - 1', '7', 'For pleuritic pain'),
    ],
  },
  {
    id: 'gyn-26', label: 'Gestational Trophoblastic Disease (Molar Pregnancy)', group: 'Gynecology', category: 'Obstetric',
    aliases: ['H-mole', 'Hydatidiform mole', 'GTD'],
    pathognomonic: '"Snowstorm" or "bunch of grapes" appearance on TVS + markedly elevated β-hCG (> 100 000 mIU/mL) + no fetus (complete mole)',
    definitiveTest: 'Histopathology of evacuated tissue — hydropic chorionic villi + trophoblastic proliferation',
    supportiveTests: ['Quantitative Beta-hCG (stat + serial)', 'TFT (hyperthyroid due to β-hCG cross-reactivity)', 'CBC, Blood group + Rh', 'Chest X-ray (rule out lung metastases)'],
    ddx: ['Threatened / missed abortion', 'Multiple gestation', 'Fibroid with pregnancy'],
    positiveSigns: ['First-trimester bleeding', 'Uterus larger than dates', 'Hyperemesis / passage of grape-like vesicles', 'Early-onset pre-eclampsia (< 20 wk)'],
    negativeSigns: ['No fetal heart tones (complete mole)'],
    definitiveTreatment: 'Urgent suction D&C for evacuation — avoid medical induction (bleeding/embolisation risk)',
    supportiveTreatment: 'Anti-D immunoglobulin 300 μg IM if Rh-negative, Methotrexate for post-molar GTN if β-hCG plateaus/rises',
    redFlags: ['Respiratory distress / hemoptysis — trophoblastic pulmonary embolisation or choriocarcinoma metastases', 'Thyroid storm'],
    cautions: ['Strict contraception (COCP preferred) for 6-12 months; NO pregnancy until β-hCG undetectable × 6 months'],
    meds: [
      mk('Suction D&C', 'Urgent uterine evacuation', 'N/A', 'OT', '1', 'Emergency evacuation — definitive'),
      mk('RhoGAM 300', 'Anti-D Immunoglobulin', '300 μg', 'IM Stat', '1', 'If patient is Rh-negative'),
      mk('Methotrexate', 'Methotrexate', 'Variable', 'IV/IM', '30', 'If β-hCG plateaus or rises post-evacuation (GTN)'),
    ],
  },
  {
    id: 'gyn-27', label: 'Sheehan Syndrome', group: 'Gynecology', category: 'Endocrine',
    aliases: ['Postpartum hypopituitarism'],
    pathognomonic: 'Failure to lactate postpartum (agalactorrhea) + postpartum amenorrhea + history of severe PPH',
    definitiveTest: 'Pituitary hormone panel — low Prolactin, FSH, LH, TSH, ACTH, GH',
    supportiveTests: ['Serum Prolactin (failure to rise on TRH stimulation)', 'TSH + Free T4', '8 AM Cortisol', 'FSH, LH, Estradiol', 'MRI Brain pituitary (empty sella)'],
    ddx: ['Autoimmune hypophysitis', 'Pituitary apoplexy', 'Primary hypothyroidism', 'Addison disease'],
    positiveSigns: ['Agalactorrhea (earliest sign)', 'Fatigue, weight loss, cold intolerance', 'Loss of pubic/axillary hair'],
    negativeSigns: [],
    definitiveTreatment: 'LIFELONG hormone replacement — Glucocorticoid FIRST (Hydrocortisone 15-25 mg/day divided) THEN Levothyroxine 50-100 μg OD; cyclical Estrogen + Progestogen HRT until age of natural menopause',
    supportiveTreatment: 'Medical-alert bracelet (adrenal insufficiency), stress-dose steroids for illness/surgery',
    redFlags: ['🚨 ADRENAL CRISIS — hypotension, hyponatremia, hypoglycemia, shock — immediate IV hydrocortisone 100 mg + IV fluids'],
    cautions: ['NEVER start Levothyroxine before Glucocorticoid — precipitates adrenal crisis'],
    meds: [
      mk('Wysolone 5', 'Prednisolone', '5-7.5 mg', '1 - 0 - 0', '365+', 'OD daily — lifelong'),
      mk('Thyronorm 50', 'Levothyroxine', '50-100 μg', '1 - 0 - 0', '365+', 'OD empty stomach 30 min before food — START ONLY AFTER GLUCOCORTICOID'),
      mk('Progynova 1 + Deviry 10', 'Estradiol Valerate + Medroxyprogesterone', 'Cyclical', 'Daily', '365+', 'Cyclical HRT until age 50-55'),
    ],
  },
  // ========================================================================
  // GASTROENTEROLOGY — 17 conditions curated from Dr. Shinde's published
  // GI Conditions doc. Covers esophagus, stomach, small bowel, colon,
  // hepatology (Wilson/PBC/PSC/Hemochromatosis) and nutritional (B12).
  // ========================================================================
  {
    id: 'gi-1', label: 'Gastroesophageal Reflux Disease (GERD)', group: 'Gastroenterology', category: 'Esophagus',
    aliases: ['GERD', 'Acid reflux', 'Reflux esophagitis (non-erosive)'],
    pathognomonic: 'Retrosternal burning + acid regurgitation worse post-meals + relief with antacids',
    definitiveTest: '24 h pH-impedance monitoring — DeMeester score > 14.7 OR acid-exposure time (AET) > 6 %',
    supportiveTests: ['UGI Endoscopy (rule out erosive disease / Barrett)', 'High-resolution manometry', 'Empiric PPI trial × 4-8 weeks'],
    ddx: ['Achalasia', 'Eosinophilic esophagitis', 'IHD / cardiac chest pain', 'Functional heartburn'],
    positiveSigns: ['Heartburn', 'Water brash', 'Postural regurgitation', 'Chronic cough / laryngitis'],
    negativeSigns: ['Exertional chest pain (suspect cardiac)', 'Normal pH study on strong PPI'],
    definitiveTreatment: 'PPI (Pantoprazole 40 mg or Esomeprazole 40 mg) OD pre-breakfast × 8 weeks; step-down to on-demand for maintenance',
    supportiveTreatment: 'Weight loss, head-end elevation 6 inches, no meals within 3 h of sleep, smoking + alcohol cessation, avoid trigger foods',
    redFlags: ['Dysphagia — endoscopy mandatory', 'Weight loss / anaemia / hematemesis — rule out malignancy'],
    cautions: ['Long-term PPI — check B12, magnesium, bone density'],
    meds: [
      mk('Pantocid 40', 'Pantoprazole', '40 mg', '1 - 0 - 0', '56', 'Empty stomach 30 min pre-breakfast × 8 weeks'),
      mk('Sompraz 40', 'Esomeprazole', '40 mg', '1 - 0 - 0', '56', 'Empty stomach 30 min pre-breakfast × 8 weeks (alternative)'),
      mk('Gelusil MPS', 'Aluminium/Magnesium Hydroxide + Simethicone', '10 mL', '0 - 0 - 1', '30', 'HS PRN for breakthrough symptoms'),
    ],
  },
  {
    id: 'gi-2', label: 'Erosive Esophagitis', group: 'Gastroenterology', category: 'Esophagus',
    aliases: ['LA-grade esophagitis'],
    pathognomonic: 'Visible mucosal breaks on UGI Endoscopy — LA Grade A/B/C/D',
    definitiveTest: 'UGI Endoscopy — visible mucosal breaks / erosions above GEJ',
    supportiveTests: ['Repeat UGIE after 8 weeks for Grade C/D to rule out Barrett', 'H. pylori testing if peptic-ulcer disease suspected'],
    ddx: ['Candida esophagitis', 'Pill-induced esophagitis (Doxycycline, NSAIDs, KCl)', 'Herpes / CMV in immunosuppressed'],
    positiveSigns: ['Odynophagia', 'Severe retrosternal burning', 'Hematemesis'],
    negativeSigns: ['Normal mucosa (that is NERD)', 'White plaques (Candida)'],
    definitiveTreatment: 'Esomeprazole 40 mg BD × 8-12 weeks (double dose for Grade C/D); repeat UGIE at 8-12 weeks to confirm healing',
    supportiveTreatment: 'GERD lifestyle bundle, sucralfate 1 g QID for symptom-relief add-on, treat underlying H. pylori if positive',
    redFlags: ['Stricture formation → dilation', 'Non-healing after adequate PPI — biopsy for dysplasia'],
    cautions: ['Grade C/D — biopsy at follow-up UGIE to rule out Barrett'],
    meds: [
      mk('Nexpro 40', 'Esomeprazole', '40 mg', '1 - 0 - 1', '56', 'BD (empty stomach) × 8-12 weeks'),
      mk('Sucral 1 g', 'Sucralfate', '1 g', '1 - 1 - 1 - 1', '28', 'QID 1 h before meals + HS × 4 weeks'),
    ],
  },
  {
    id: 'gi-3', label: 'Barrett\'s Esophagus', group: 'Gastroenterology', category: 'Esophagus',
    aliases: ['Barrett', 'Intestinal metaplasia of esophagus'],
    pathognomonic: 'Salmon-pink mucosa extending above GEJ + intestinal metaplasia with goblet cells on biopsy',
    definitiveTest: 'UGIE + Seattle protocol biopsy — intestinal metaplasia with goblet cells',
    supportiveTests: ['4-quadrant biopsies at every 1-2 cm (Seattle protocol)', 'Chromoendoscopy / NBI', 'Dysplasia grading (LGD / HGD)'],
    ddx: ['Hiatus hernia without metaplasia', 'Esophageal adenocarcinoma', 'Cardia-type gastric metaplasia'],
    positiveSigns: ['Chronic acid reflux > 5 years', 'Often asymptomatic (found on screening UGIE)'],
    negativeSigns: ['Normal squamous epithelium on biopsy'],
    definitiveTreatment: 'Lifelong Esomeprazole 40 mg OD as chemoprevention; endoscopic surveillance every 3-5 y for non-dysplastic BE',
    supportiveTreatment: 'For LGD — surveillance q6-12mo OR RFA/EMR. For HGD — endoscopic mucosal resection (EMR) or radiofrequency ablation (RFA)',
    redFlags: ['Progression to dysplasia / adenocarcinoma', 'New dysphagia — repeat UGIE'],
    cautions: ['Lifelong PPI — monitor B12 & magnesium'],
    meds: [
      mk('Sompraz 40', 'Esomeprazole', '40 mg', '1 - 0 - 0', '365+', 'OD lifelong for chemoprevention'),
      mk('Surveillance UGIE', 'Endoscopic surveillance', 'N/A', 'Every 3-5 y', '1', 'Non-dysplastic BE per ACG 2016; annual if LGD'),
    ],
  },
  {
    id: 'gi-4', label: 'Achalasia Cardia', group: 'Gastroenterology', category: 'Esophagus',
    aliases: ['Cardiospasm'],
    pathognomonic: 'Dysphagia to BOTH liquids AND solids from onset + failed LES relaxation on manometry',
    definitiveTest: 'High-Resolution Manometry (HRM) — Integrated Relaxation Pressure (IRP) > 15 mmHg + aperistalsis',
    supportiveTests: ['Timed barium swallow (bird-beak narrowing + dilated body)', 'UGIE — rule out pseudo-achalasia (malignancy)'],
    ddx: ['Esophageal stricture', 'Diffuse esophageal spasm', 'Pseudo-achalasia (elderly / malignancy)'],
    positiveSigns: ['Progressive dysphagia to liquids AND solids', 'Regurgitation of undigested food', 'Nocturnal cough / aspiration'],
    negativeSigns: ['Normal LES relaxation on HRM'],
    definitiveTreatment: 'POEM (Per-Oral Endoscopic Myotomy) — preferred, especially for Type III; Laparoscopic Heller myotomy with fundoplication as alternative',
    supportiveTreatment: 'Pneumatic dilation for Type II if surgery declined; Botulinum toxin injection for elderly/frail patients (temporary)',
    redFlags: ['Aspiration pneumonia', 'Rapid weight loss (rule out pseudo-achalasia in >55 y)'],
    cautions: ['Post-POEM/Heller — soft diet 2 weeks, PPI for reflux'],
    meds: [
      mk('POEM / Heller Myotomy', 'Surgical / endoscopic myotomy', 'N/A', 'OT', '1', 'Definitive procedure — refer to GI surgeon / advanced endoscopist'),
      mk('Pneumatic Dilation', 'Endoscopic balloon dilation', '30-40 mm', 'OT', '1', 'Alternative for Type II; series may be needed'),
    ],
  },
  {
    id: 'gi-5', label: 'Esophageal Candidiasis', group: 'Gastroenterology', category: 'Esophagus',
    aliases: ['Candida esophagitis'],
    pathognomonic: 'Odynophagia + oral thrush + white curd-like plaques on UGIE in an immunosuppressed patient',
    definitiveTest: 'UGIE + brush cytology — pseudohyphae and yeast cells',
    supportiveTests: ['HIV screening', 'HbA1c', 'CD4 count if HIV+', 'Fungal culture for non-albicans'],
    ddx: ['Herpetic esophagitis', 'CMV esophagitis', 'Pill-induced esophagitis'],
    positiveSigns: ['Odynophagia > dysphagia', 'Oral thrush', 'Retrosternal pain'],
    negativeSigns: ['Negative brush cytology → suspect viral etiology'],
    definitiveTreatment: 'Fluconazole 200-400 mg PO OD × 14-21 days (200 mg loading then 100 mg maintenance)',
    supportiveTreatment: 'Treat concurrent oral thrush with Clotrimazole troche or Nystatin swish-and-swallow; optimise diabetes / HIV therapy',
    redFlags: ['Inability to swallow fluids → hospital admission for IV Fluconazole', 'Fluconazole-refractory → non-albicans → Voriconazole/Caspofungin'],
    cautions: ['Fluconazole — check LFT, warfarin/CYP2C9 interactions'],
    meds: [
      mk('Forcan 200', 'Fluconazole', '200 mg', '1 - 0 - 0', '14', 'Loading 400 mg × 1 then 200 mg OD × 14-21 days'),
      mk('Candid Mouth Paint', 'Clotrimazole 1 % oral paint', 'PRN', '1 - 1 - 1', '14', 'Apply to oral thrush QID'),
    ],
  },
  {
    id: 'gi-6', label: 'H. Pylori Infection', group: 'Gastroenterology', category: 'Stomach',
    aliases: ['H. pylori gastritis', 'Helicobacter pylori'],
    pathognomonic: 'Epigastric pain + positive urea breath test (UBT) OR rapid urease test on antral biopsy',
    definitiveTest: '13C Urea Breath Test — positive isotope label (or stool H. pylori antigen)',
    supportiveTests: ['UGIE + rapid urease test on antral biopsy', 'Stool antigen (non-invasive)', 'Serology (limited use — persists after eradication)'],
    ddx: ['Functional dyspepsia', 'Non-H. pylori gastritis', 'GERD', 'Zollinger-Ellison'],
    positiveSigns: ['Epigastric pain / bloating', 'Early satiety', 'Nausea, occasional vomiting'],
    negativeSigns: ['Negative UBT or stool antigen (test off PPI × 2 weeks)'],
    definitiveTreatment: 'Triple therapy × 14 days — PPI (Pantoprazole 40 mg BD) + Clarithromycin 500 mg BD + Amoxicillin 1 g BD',
    supportiveTreatment: 'Confirm eradication with repeat UBT 4 weeks after therapy (off PPI ≥ 2 weeks); Bismuth-quadruple therapy if resistance suspected',
    redFlags: ['Weight loss / GI bleed / anaemia — endoscopy mandatory to rule out gastric malignancy', 'Recurrent infection'],
    cautions: ['Avoid Clarithromycin if prior macrolide exposure (resistance)'],
    meds: [
      mk('Pantocid-HP Kit', 'Pantoprazole 40 + Clarithromycin 500 + Amoxicillin 1000', '1 kit', '1 - 0 - 1', '14', 'BD × 14 days (standard triple therapy)'),
      mk('Pylokit', 'Bismuth-Quadruple: PPI + Bismuth + Metronidazole + Tetracycline', 'Combi-pack', '1 - 1 - 1 - 1', '14', 'QID × 10-14 days (resistance / failure)'),
    ],
  },
  {
    id: 'gi-7', label: 'Zollinger-Ellison Syndrome', group: 'Gastroenterology', category: 'Stomach',
    aliases: ['ZES', 'Gastrinoma'],
    pathognomonic: 'Multiple / post-bulbar peptic ulcers + chronic diarrhea + fasting gastrin > 1000 pg/mL',
    definitiveTest: 'Fasting serum gastrin > 1000 pg/mL AND secretin stimulation test — gastrin rise > 200 pg/mL',
    supportiveTests: ['68Ga-DOTATATE PET-CT (localise gastrinoma)', 'Endoscopic ultrasound (EUS)', 'MEN-1 screen (PTH, PRL, IGF-1)'],
    ddx: ['Refractory GERD', 'H. pylori-negative PUD', 'MEN-1 syndrome'],
    positiveSigns: ['Refractory / recurrent PUD despite PPI', 'Chronic secretory diarrhoea + steatorrhoea', 'Post-bulbar / jejunal ulcers'],
    negativeSigns: ['Normal fasting gastrin (< 100 pg/mL) off PPI'],
    definitiveTreatment: 'High-dose PPI — Pantoprazole 80-120 mg BD (titrate to keep basal acid output < 10 mEq/h)',
    supportiveTreatment: 'Surgical resection of localised gastrinoma (Whipple / enucleation); Somatostatin analogue (Octreotide LAR) for metastatic disease',
    redFlags: ['Perforation / bleeding', 'Distant metastasis (liver)'],
    cautions: ['Lifelong high-dose PPI — monitor B12, iron, magnesium'],
    meds: [
      mk('Pantocid 80', 'Pantoprazole', '80-120 mg', '1 - 0 - 1', '365+', 'BD (high-dose) lifelong — titrate to acid output'),
      mk('Octreotide LAR', 'Octreotide long-acting', '20-30 mg', 'IM monthly', '30', 'For unresectable / metastatic gastrinoma'),
    ],
  },
  {
    id: 'gi-8', label: 'Tropical Sprue', group: 'Gastroenterology', category: 'Intestine',
    aliases: [],
    pathognomonic: 'Chronic diarrhoea + megaloblastic anaemia + glossitis in a tropics resident + rapid response to Tetracycline + folate',
    definitiveTest: 'Duodenal biopsy — partial villous atrophy + rapid response to Tetracycline + folate',
    supportiveTests: ['Serum B12 & folate (both low)', 'D-xylose absorption test (abnormal)', 'Rule out celiac — tTG-IgA'],
    ddx: ['Celiac disease', 'Giardiasis', 'Intestinal TB', 'SIBO'],
    positiveSigns: ['Chronic watery diarrhoea', 'Megaloblastic anaemia', 'Glossitis, weight loss'],
    negativeSigns: ['Positive tTG-IgA (suggests celiac)', 'Negative response to antibiotics'],
    definitiveTreatment: 'Tetracycline 250 mg QID (or Doxycycline 100 mg BD) + Folic acid 5 mg OD + Vit B12 1000 μg IM/week × 3-6 months',
    supportiveTreatment: 'High-calorie high-protein diet, iron replacement, control secondary lactose intolerance',
    redFlags: ['Severe malnutrition / dehydration', 'No response after 3 months — reconsider diagnosis'],
    cautions: ['Doxycycline avoided in pregnancy / children — use Amoxicillin instead'],
    meds: [
      mk('Subamycin 250', 'Tetracycline', '250 mg', '1 - 1 - 1 - 1', '90', 'QID × 3-6 months'),
      mk('Folvite 5', 'Folic Acid', '5 mg', '1 - 0 - 0', '90', 'OD × 3-6 months'),
      mk('Mecoflow 1500', 'Methylcobalamin', '1500 μg', '1 - 0 - 0', '90', 'OD × 3-6 months (or 1000 μg IM/week)'),
    ],
  },
  {
    id: 'gi-9', label: 'Whipple\'s Disease', group: 'Gastroenterology', category: 'Intestine',
    aliases: ['Tropheryma whipplei infection'],
    pathognomonic: 'Migratory arthralgia + chronic diarrhoea + weight loss + hyperpigmentation + PAS-positive macrophages on duodenal biopsy',
    definitiveTest: 'Duodenal biopsy — PAS-positive macrophages with foamy cytoplasm + Tropheryma whipplei PCR positive',
    supportiveTests: ['T. whipplei PCR (biopsy / CSF / synovial fluid)', 'MRI brain if CNS symptoms', 'CBC — anaemia'],
    ddx: ['MAI (Mycobacterium avium) infection', 'Celiac disease', 'Seronegative arthritis', 'HIV enteropathy'],
    positiveSigns: ['Migratory arthralgia (often precedes GI symptoms by years)', 'Weight loss, diarrhoea', 'Cutaneous hyperpigmentation'],
    negativeSigns: ['PAS-negative biopsy'],
    definitiveTreatment: 'Induction: Ceftriaxone 2 g IV OD × 2 weeks → Maintenance: Trimethoprim-Sulfamethoxazole DS BD × 12 months',
    supportiveTreatment: 'Nutritional support, screen for CNS involvement (uveitis, dementia) which requires longer therapy',
    redFlags: ['CNS involvement — myoclonus, dementia, uveitis', 'IRIS (immune reconstitution) after starting therapy'],
    cautions: ['Never stop early — relapses are difficult to retreat and often fatal'],
    meds: [
      mk('Monocef 2 g', 'Ceftriaxone', '2 g', 'IV OD', '14', 'Induction × 2 weeks IV'),
      mk('Septran DS', 'Trimethoprim 160 + Sulfamethoxazole 800', '960 mg', '1 - 0 - 1', '365', 'BD × 12 months maintenance'),
    ],
  },
  {
    id: 'gi-10', label: 'Amoebic Colitis', group: 'Gastroenterology', category: 'Intestine',
    aliases: ['Intestinal amoebiasis', 'E. histolytica colitis'],
    pathognomonic: 'Bloody diarrhoea + tenesmus + flask-shaped ulcers on colonoscopy + positive E. histolytica PCR / serology',
    definitiveTest: 'Colonoscopy + stool PCR — E. histolytica DNA + flask-shaped ulcers on histology',
    supportiveTests: ['Stool microscopy (trophozoites with ingested RBCs)', 'Amoebic serology (ELISA)', 'USG abdomen (rule out liver abscess)'],
    ddx: ['Ulcerative colitis', 'Shigellosis', 'Enteroinvasive E. coli', 'Ischaemic colitis'],
    positiveSigns: ['Blood-and-mucus diarrhoea', 'Tenesmus, right iliac fossa pain', 'Weight loss'],
    negativeSigns: ['Negative stool PCR + normal colonoscopy'],
    definitiveTreatment: 'Metronidazole 800 mg TDS × 10 days FOLLOWED BY luminal amoebicide Diloxanide Furoate 500 mg TDS × 10 days',
    supportiveTreatment: 'Oral rehydration, iron replacement for anaemia, avoid alcohol during metronidazole',
    redFlags: ['Toxic megacolon', 'Perforation → surgical emergency', 'Liver abscess — USG at diagnosis'],
    cautions: ['Alcohol with metronidazole → disulfiram-like reaction'],
    meds: [
      mk('Metrogyl 400', 'Metronidazole', '800 mg', '1 - 1 - 1', '10', 'TDS × 10 days (or Tinidazole 2 g OD × 5)'),
      mk('Furamide 500', 'Diloxanide Furoate', '500 mg', '1 - 1 - 1', '10', 'TDS × 10 days AFTER metronidazole (luminal clearance)'),
    ],
  },
  {
    id: 'gi-11', label: 'Microscopic Colitis', group: 'Gastroenterology', category: 'Intestine',
    aliases: ['Collagenous colitis', 'Lymphocytic colitis'],
    pathognomonic: 'Watery non-bloody diarrhoea + normal-looking colon on colonoscopy + diagnostic biopsy findings',
    definitiveTest: 'Multi-level colonic biopsy — sub-epithelial collagen band > 10 μm (collagenous) OR > 20 IELs/100 epithelial cells (lymphocytic)',
    supportiveTests: ['Colonoscopy with biopsy (MANDATORY even if colon looks normal)', 'Rule out celiac (tTG-IgA)', 'Stool for bile-acid malabsorption'],
    ddx: ['IBS-D', 'Celiac disease', 'Bile-acid malabsorption', 'Lactose intolerance'],
    positiveSigns: ['Chronic watery diarrhoea 6-10× / day', 'Weight loss, cramping', 'Nocturnal diarrhoea'],
    negativeSigns: ['Blood in stools (points away)', 'Visible inflammation on colonoscopy'],
    definitiveTreatment: 'Budesonide 9 mg OD × 8 weeks, then taper (6 mg × 2 wk → 3 mg × 2 wk)',
    supportiveTreatment: 'Stop NSAIDs, PPIs, SSRIs (common triggers); Cholestyramine for bile-acid component',
    redFlags: ['Severe dehydration', 'Non-response to Budesonide — reconsider diagnosis'],
    cautions: ['Budesonide — monitor cortisol on long courses, tapered stop only'],
    meds: [
      mk('Budecort 3', 'Budesonide', '9 mg', '1 - 1 - 1', '56', 'TDS × 8 weeks then taper (6 mg × 2 wk → 3 mg × 2 wk)'),
      mk('Cholestagel 625', 'Colesevelam', '625 mg', '2 - 0 - 2', '30', 'For bile-acid malabsorption component'),
    ],
  },
  {
    id: 'gi-12', label: 'Wilson\'s Disease', group: 'Gastroenterology', category: 'Liver',
    aliases: ['Hepatolenticular degeneration'],
    pathognomonic: 'Kayser-Fleischer rings on slit-lamp + low serum ceruloplasmin (< 20 mg/dL) + high 24-h urine copper (> 100 μg)',
    definitiveTest: 'Liver biopsy hepatic copper > 250 μg/g dry weight OR biallelic ATP7B mutation',
    supportiveTests: ['Slit-lamp exam for KF rings', '24-h urine copper (baseline and post-penicillamine challenge)', 'Serum ceruloplasmin', 'MRI brain (basal ganglia)'],
    ddx: ['Autoimmune hepatitis', 'NASH', 'Parkinsonism', 'Drug-induced tremor'],
    positiveSigns: ['Age < 40 with liver disease + neuropsychiatric symptoms', 'Dysarthria, tremor, dystonia', 'Coombs-negative haemolytic anaemia'],
    negativeSigns: ['Normal urine copper', 'Absent KF rings (young — 50 % of hepatic presenters)'],
    definitiveTreatment: 'Symptomatic hepatic — D-Penicillamine 250-500 mg TDS + Pyridoxine 25 mg OD; Asymptomatic / maintenance — Zinc acetate 50 mg TDS',
    supportiveTreatment: 'Low-copper diet — NO chocolate, nuts, organ meat, shellfish; lifelong therapy; family screening (siblings)',
    redFlags: ['Acute liver failure with haemolysis (Coombs-negative) — LIVER TRANSPLANT indication', 'New / worsening neurological symptoms after starting Penicillamine'],
    cautions: ['Penicillamine — monitor CBC + urine protein monthly; risk of BM suppression + nephrotic syndrome'],
    meds: [
      mk('Cilamin 250', 'D-Penicillamine', '250-500 mg', '1 - 1 - 1', '365+', 'TDS 30 min before meals — lifelong'),
      mk('Zinconia 50', 'Zinc Acetate', '50 mg', '1 - 1 - 1', '365+', 'TDS 30 min before meals — for maintenance / asymptomatic'),
      mk('Pyridoxine 25', 'Pyridoxine (Vit B6)', '25 mg', '1 - 0 - 0', '365+', 'OD to prevent Penicillamine-induced deficiency'),
    ],
  },
  {
    id: 'gi-13', label: 'Primary Biliary Cholangitis (PBC)', group: 'Gastroenterology', category: 'Liver',
    aliases: ['PBC', 'Primary biliary cirrhosis (old term)'],
    pathognomonic: 'Middle-aged woman + pruritus + elevated ALP > 1.5× ULN + AMA positive at ≥ 1:40 titre',
    definitiveTest: 'AMA positive + elevated ALP + liver biopsy — non-suppurative destructive cholangitis (florid duct lesion)',
    supportiveTests: ['AMA (M2 subtype)', 'ALP, GGT, IgM (elevated)', 'USG abdomen', 'Fibroscan for staging', 'Anti-sp100 & anti-gp210 if AMA-negative'],
    ddx: ['PSC', 'Drug-induced cholestasis', 'Auto-immune hepatitis', 'Extrahepatic biliary obstruction'],
    positiveSigns: ['Progressive pruritus (often nocturnal)', 'Fatigue', 'Xanthelasma / xanthoma', 'Sicca syndrome'],
    negativeSigns: ['AMA negative + normal ALP'],
    definitiveTreatment: 'UDCA 13-15 mg/kg/day PO OD or divided BD — lifelong (POISE / Paris-II response criteria at 12 months)',
    supportiveTreatment: 'Obeticholic acid or Bezafibrate as second-line if inadequate response; Cholestyramine for pruritus; osteoporosis screen; screen for HCC every 6 mo if cirrhotic',
    redFlags: ['Development of cirrhosis + portal hypertension', 'HCC — 6-mo USG surveillance'],
    cautions: ['Obeticholic acid contraindicated in decompensated cirrhosis'],
    meds: [
      mk('Udiliv 300', 'Ursodeoxycholic Acid (UDCA)', '13-15 mg/kg', '1 - 0 - 1', '365+', 'Weight-based (~300 mg BD for 60 kg) — lifelong'),
      mk('Ocaliva 5', 'Obeticholic Acid', '5-10 mg', '1 - 0 - 0', '365+', 'OD add-on if inadequate UDCA response'),
      mk('Cholestyramine 4 g', 'Cholestyramine', '4 g', '1 - 0 - 1', '30', 'For pruritus — take 2-4 h apart from UDCA'),
    ],
  },
  {
    id: 'gi-14', label: 'Primary Sclerosing Cholangitis (PSC)', group: 'Gastroenterology', category: 'Liver',
    aliases: ['PSC'],
    pathognomonic: '"Beaded" appearance of intra-and-extrahepatic bile ducts on MRCP + strong association with IBD (UC > CD)',
    definitiveTest: 'MRCP (or ERCP) — multi-focal short-segment strictures and dilations ("beading")',
    supportiveTests: ['MRCP (non-invasive)', 'LFT — cholestatic pattern', 'p-ANCA (often positive)', 'Colonoscopy MANDATORY to rule out IBD', 'CA 19-9 (baseline)'],
    ddx: ['IgG4-related cholangitis (responds to steroids)', 'Secondary sclerosing cholangitis', 'Cholangiocarcinoma'],
    positiveSigns: ['Fatigue, pruritus', 'RUQ pain, episodic cholangitis', 'Known IBD (UC)'],
    negativeSigns: ['Normal MRCP → not PSC'],
    definitiveTreatment: 'UDCA 15-20 mg/kg/day (moderate dose — high dose 28-30 mg/kg is associated with worse outcomes); Endoscopic dilation for dominant strictures',
    supportiveTreatment: 'Colonoscopy at diagnosis + annually (IBD + colon cancer surveillance); MRCP + CA 19-9 annually (cholangiocarcinoma surveillance); liver transplant is definitive',
    redFlags: ['🚨 New-onset jaundice — rule out dominant stricture / cholangiocarcinoma', 'CA 19-9 > 130 U/mL', 'Colon cancer screening (higher risk in PSC + UC)'],
    cautions: ['NEVER exceed UDCA 28 mg/kg — worse outcomes shown'],
    meds: [
      mk('Udiliv 300', 'Ursodeoxycholic Acid (UDCA)', '15-20 mg/kg', '1 - 0 - 1', '365+', 'Moderate dose lifelong (do NOT exceed 28 mg/kg)'),
      mk('ERCP + Dilation', 'Endoscopic balloon dilation of dominant stricture', 'N/A', 'OT', '1', 'For dominant strictures (Sx-ic)'),
      mk('Cholestyramine 4 g', 'Cholestyramine', '4 g', '1 - 0 - 1', '30', 'For pruritus'),
    ],
  },
  {
    id: 'gi-15', label: 'Hereditary Hemochromatosis', group: 'Gastroenterology', category: 'Liver',
    aliases: ['HFE hemochromatosis', 'Iron overload disease'],
    pathognomonic: 'Bronze skin + diabetes ("bronze diabetes") + arthropathy + transferrin saturation > 45 % + Ferritin elevated + HFE gene mutation',
    definitiveTest: 'HFE genotype (C282Y / H63D) + Transferrin sat > 45 % + Ferritin elevated; MRI T2* / hepatic iron index > 1.9 if biopsy',
    supportiveTests: ['Fasting iron studies (transferrin sat + ferritin)', 'HFE genotype', 'MRI liver (T2*)', 'LFT + HbA1c + Echo (cardiomyopathy)'],
    ddx: ['Transfusional iron overload', 'NAFLD', 'Anaemia of chronic disease (elevated ferritin)'],
    positiveSigns: ['Fatigue, arthralgia (2nd + 3rd MCP joints)', 'Bronze/slate-grey skin', 'Diabetes + hepatomegaly + cardiomyopathy'],
    negativeSigns: ['Normal transferrin saturation'],
    definitiveTreatment: 'Therapeutic phlebotomy — remove 500 mL blood weekly until ferritin < 50 ng/mL, then maintenance 3-4×/year',
    supportiveTreatment: 'AVOID iron supplements + Vitamin C (increases iron absorption); reduce red meat; HCC surveillance every 6 mo if cirrhotic',
    redFlags: ['🚨 HCC development — 6-monthly USG + AFP if cirrhotic', 'Cardiomyopathy → arrhythmia'],
    cautions: ['NO iron supplements, NO high-dose Vit C', 'Family cascade genetic screening'],
    meds: [
      mk('Therapeutic Phlebotomy', 'Weekly blood removal 500 mL', 'N/A', 'Weekly', '30', 'Until Ferritin < 50; then 3-4× per year lifelong'),
      mk('Desferal', 'Deferoxamine (iron chelator)', 'Variable', 'SC infusion', '30', 'Alternative if phlebotomy contraindicated (anaemia / heart failure)'),
    ],
  },
  {
    id: 'gi-16', label: 'Diabetic Gastroparesis', group: 'Gastroenterology', category: 'Nutritional',
    aliases: ['Delayed gastric emptying'],
    pathognomonic: 'Long-standing diabetes + nausea + vomiting of undigested food + delayed gastric emptying on scintigraphy',
    definitiveTest: 'Gastric emptying scintigraphy (solid meal) — > 10 % retention at 4 h OR > 60 % at 2 h',
    supportiveTests: ['UGIE — rule out mechanical obstruction FIRST', 'HbA1c', 'Wireless motility capsule (SmartPill) if scintigraphy inconclusive'],
    ddx: ['Gastric outlet obstruction (peptic stricture / malignancy)', 'Functional dyspepsia', 'Cyclic vomiting syndrome', 'Superior mesenteric artery syndrome'],
    positiveSigns: ['Post-prandial nausea + vomiting of undigested food hours after meals', 'Early satiety', 'Post-prandial bloating'],
    negativeSigns: ['Mechanical obstruction on UGIE'],
    definitiveTreatment: 'Prokinetic — Itopride 50 mg TDS OR Domperidone 10 mg TDS 30 min before meals + tight glycaemic control',
    supportiveTreatment: 'Small (250 mL) low-fat low-fibre frequent meals × 6/day; blend / puree solids; walk after meals; consider Metoclopramide short-course if refractory (max 5 days per ANVISA warning)',
    redFlags: ['Severe weight loss / dehydration → hospitalisation for IV fluids + NG decompression', 'Bezoar formation'],
    cautions: ['Domperidone — check QTc if elderly / on other QT-prolonging drugs', 'Metoclopramide — extrapyramidal side-effects, max 5-day use'],
    meds: [
      mk('Ganaton 50', 'Itopride', '50 mg', '1 - 1 - 1', '30', 'TDS 30 min before meals'),
      mk('Domstal 10', 'Domperidone', '10 mg', '1 - 1 - 1', '30', 'TDS 30 min before meals (check QTc in elderly)'),
      mk('Erythrocin 250', 'Erythromycin', '250 mg', '1 - 1 - 1', '5', 'Short-course prokinetic for exacerbations (max 5-7 days — tachyphylaxis)'),
    ],
  },
  {
    id: 'gi-17', label: 'Vitamin B12 Deficiency', group: 'Gastroenterology', category: 'Nutritional',
    aliases: ['Cobalamin deficiency', 'Pernicious anaemia (if autoimmune)'],
    pathognomonic: 'Megaloblastic anaemia + peripheral paresthesias + low serum B12 (< 200 pg/mL) + elevated MMA/homocysteine',
    definitiveTest: 'Serum B12 < 200 pg/mL + elevated methylmalonic acid (MMA) + homocysteine',
    supportiveTests: ['CBC (macrocytic anaemia, MCV > 100)', 'Peripheral smear (hypersegmented neutrophils)', 'Anti-intrinsic-factor & anti-parietal-cell antibodies (pernicious anaemia)', 'Reticulocyte count Day 5-10 of therapy'],
    ddx: ['Folate deficiency', 'Myelodysplastic syndrome', 'Multiple sclerosis (neuro symptoms)', 'Alcohol use disorder'],
    positiveSigns: ['Fatigue, breathlessness', 'Symmetric distal paresthesias', 'Sore beefy tongue (glossitis)', 'Vegetarian diet history'],
    negativeSigns: ['Normal MMA / homocysteine → false-low B12'],
    definitiveTreatment: 'Loading — Methylcobalamin 1000 μg IM every alternate day × 2 weeks OR daily × 1 week; then weekly × 4 weeks; then monthly maintenance',
    supportiveTreatment: 'Oral Mecobalamin 1500 μg OD is EQUALLY EFFECTIVE (passive absorption 1 %); continue lifelong for vegetarians / pernicious anaemia; folate replacement if concurrent deficiency',
    redFlags: ['🚨 Subacute Combined Degeneration of spinal cord — dorsal + lateral column signs, urgent parenteral B12', 'Reticulocyte crisis at Day 5-10 without response — reconsider diagnosis'],
    cautions: ['NEVER give folate alone if B12 also low — worsens neurology', 'Nitrous oxide use → precipitates B12 deficiency neuropathy'],
    meds: [
      mk('Mecoflow 1500', 'Methylcobalamin', '1500 μg', '1 - 0 - 0', '90+', 'OD PO for 3 months then maintenance (equally effective as IM)'),
      mk('Neurobion Forte', 'Methylcobalamin 1000 μg + Thiamine + Pyridoxine', '1 amp', 'IM Weekly', '30', '1000 μg IM weekly × 5 weeks then monthly (parenteral loading)'),
      mk('Folvite 5', 'Folic Acid', '5 mg', '1 - 0 - 0', '90', 'OD IF folate also low (never alone if B12 low)'),
    ],
  },
  // ========================================================================
  // RHEUMATOLOGY — 20 conditions from Dr. Shinde's Rheumatic doc. Covers
  // inflammatory arthritis, crystal arthropathies, connective-tissue
  // diseases, vasculitides, autoinflammatory syndromes and hypermobility.
  // ========================================================================
  {
    id: 'rhe-1', label: 'Rheumatoid Arthritis (RA)', group: 'Rheumatology', category: 'Inflammatory Arthritis',
    aliases: ['RA', 'Rheumatoid'],
    pathognomonic: 'Symmetric polyarthritis of small joints (MCP/PIP/wrists) + morning stiffness > 1 h + high-titre Anti-CCP',
    definitiveTest: '2010 ACR/EULAR criteria ≥ 6/10 + high-titre Anti-CCP OR RF + erosions on hand/foot X-ray',
    supportiveTests: ['CRP, ESR', 'CBC, LFT, RFT', 'HBsAg + Anti-HCV (pre-DMARD)', 'Ultrasound synovitis / power-Doppler'],
    ddx: ['Viral polyarthritis (Chikungunya, Parvovirus B19)', 'SLE', 'Psoriatic arthritis', 'Erosive OA'],
    positiveSigns: ['Symmetric small-joint polyarthritis (MCP/PIP/wrists)', 'Morning stiffness > 60 min', 'Rheumatoid nodules'],
    negativeSigns: ['DIP joint involvement (suggests OA/PsA)', 'Absent inflammatory markers with active swelling'],
    definitiveTreatment: 'Methotrexate 15 mg PO once weekly + Folic Acid 5 mg next day + HCQ 200 mg BD; bridge with Prednisolone 5-10 mg OD × 4-8 weeks',
    supportiveTreatment: 'Aceclofenac + PPI for flare; escalate to biologic (Anti-TNF / JAK-inhibitor) if MTX + HCQ fail at 3 months',
    redFlags: ['New atlantoaxial subluxation → cord compression', 'Felty syndrome — splenomegaly + neutropenia + recurrent infections'],
    cautions: ['MTX contraindicated in pregnancy — stop 3 months pre-conception', 'HCQ — annual ophthalmology exam for maculopathy', 'Avoid MTX + Trimethoprim-Sulfa (pancytopenia)'],
    meds: [
      mk('Folitrax 15', 'Methotrexate', '15 mg', 'Once weekly', '90+', 'PO / SC once a week on a fixed day — lifelong'),
      mk('HCQS 200', 'Hydroxychloroquine', '200 mg', '1 - 0 - 1', '90+', 'BD with meals; annual eye exam'),
      mk('Folvite 5', 'Folic Acid', '5 mg', 'Once weekly', '90+', 'Once weekly next day after MTX'),
      mk('Wysolone 5', 'Prednisolone', '5-10 mg', '1 - 0 - 0', '30', 'OD × 4-8 weeks bridging — taper'),
      mk('Zerodol P', 'Aceclofenac + Paracetamol', '1 tab', '1 - 0 - 1', '7', 'BD PRN during flares'),
    ],
  },
  {
    id: 'rhe-2', label: 'Gout', group: 'Rheumatology', category: 'Crystal Arthropathy',
    aliases: ['Gouty arthritis', 'Hyperuricemia with arthritis'],
    pathognomonic: 'Sudden severe monoarticular arthritis of 1st MTP (podagra) + MSU crystals on aspirate',
    definitiveTest: 'Synovial fluid — negatively birefringent needle-shaped MSU crystals under polarised light',
    supportiveTests: ['Serum uric acid (may be normal in flare)', 'USG — double-contour sign', 'DECT for tophi', 'RFT'],
    ddx: ['Septic arthritis (co-existing possible)', 'Pseudogout (CPPD)', 'Cellulitis'],
    positiveSigns: ['Podagra with erythema + intolerable to touch', 'Peak pain < 24 h', 'Complete resolution in 7-14 d'],
    negativeSigns: ['Fever with joint warmth — must aspirate to exclude sepsis'],
    definitiveTreatment: 'Acute — Colchicine 1 mg stat + 0.5 mg 1 h later + 0.5 mg BD × 3-5 days OR Naproxen 500 mg BD × 5-7 d; Long-term — Febuxostat 40 mg OD (target sUA < 6)',
    supportiveTreatment: 'Purine-restricted diet, hydration, weight loss, stop thiazide/loop diuretics if possible, Rabeprazole cover with NSAID',
    redFlags: ['Fever + hot joint — septic arthritis must be excluded by aspiration', 'Tophaceous gout with renal involvement — CKD staging'],
    cautions: ['Do NOT start/stop urate-lowering therapy during a flare', 'Febuxostat contraindicated with Azathioprine (life-threatening pancytopenia)'],
    meds: [
      mk('Zycolchin 0.5', 'Colchicine', '0.5-1 mg', '1 - 0 - 1', '5', '1 mg stat + 0.5 mg after 1 h then BD × 3-5 days'),
      mk('Naprosyn 500', 'Naproxen', '500 mg', '1 - 0 - 1', '7', 'BD × 5-7 days with PPI'),
      mk('Rablet 20', 'Rabeprazole', '20 mg', '1 - 0 - 0', '7', 'OD while on NSAID'),
      mk('Febutaz 40', 'Febuxostat', '40 mg', '1 - 0 - 0', '365+', 'OD lifelong — start 2 weeks after flare settles'),
    ],
  },
  {
    id: 'rhe-3', label: 'Osteoarthritis (OA)', group: 'Rheumatology', category: 'Degenerative',
    aliases: ['OA', 'Degenerative joint disease'],
    pathognomonic: 'Age > 50 + activity-related joint pain + morning stiffness < 30 min + osteophytes on X-ray',
    definitiveTest: 'Weight-bearing X-ray — joint-space narrowing, osteophytes, subchondral sclerosis / cysts',
    supportiveTests: ['CRP/ESR (usually normal — rules out inflammatory)', 'Synovial fluid — non-inflammatory, WBC < 2000/mm³'],
    ddx: ['Rheumatoid arthritis', 'Psoriatic arthritis', 'Meniscal tear', 'Pes anserine bursitis'],
    positiveSigns: ['Pain worse with activity, relieved by rest', 'Crepitus, bony enlargement (Heberden/Bouchard nodes)', 'Reduced ROM'],
    negativeSigns: ['Prolonged morning stiffness > 60 min (suspect inflammatory)', 'Small-joint symmetrical involvement'],
    definitiveTreatment: 'Paracetamol 1 g QID PRN + topical Diclofenac gel TDS; add Etoricoxib 60 mg OD for flares (max 7-10 days); intra-articular steroid for severe flare',
    supportiveTreatment: 'Weight reduction (10 % → 50 % pain reduction), quadriceps strengthening, low-impact aerobic exercise, unloading knee brace, consider TKR/THR at end-stage',
    redFlags: ['Locking / true instability — meniscal/ligament tear needs MRI', 'Rapid destructive OA — septic or Charcot joint'],
    cautions: ['Etoricoxib contraindicated in IHD, stroke, uncontrolled HTN', 'Avoid glucosamine if shellfish allergy'],
    meds: [
      mk('Dolo 650', 'Paracetamol', '650 mg', '1 - 1 - 1 - 1', '30+', 'QID PRN (max 3 g/day)'),
      mk('Volini Gel', 'Diclofenac Gel 1 %', 'PRN', '1 - 1 - 1', '30', 'Topical TDS'),
      mk('Nucoxia 60', 'Etoricoxib', '60 mg', '1 - 0 - 0', '10', 'OD × up to 10 days for flare'),
      mk('IA Depo-Medrol 40', 'Methylprednisolone acetate intra-articular', '40 mg', 'IA once', '1', 'Single injection for severe knee flare (max 3-4 per year)'),
    ],
  },
  {
    id: 'rhe-4', label: 'Ankylosing Spondylitis (AS)', group: 'Rheumatology', category: 'Spondyloarthritis',
    aliases: ['AS', 'Axial spondyloarthritis'],
    pathognomonic: 'Inflammatory back pain in young adult + sacroiliitis on MRI + HLA-B27 positive',
    definitiveTest: 'MRI sacroiliac joints — active bone-marrow oedema OR X-ray SI bilateral grade 2 sacroiliitis',
    supportiveTests: ['HLA-B27', 'CRP/ESR', 'Modified Schober test', 'Ophthalmology for uveitis screening'],
    ddx: ['Mechanical back pain', 'Lumbar disc herniation', 'DISH', 'Psoriatic axial disease'],
    positiveSigns: ['Insidious back pain onset < age 45', 'Improves with exercise, NOT rest', 'Nocturnal pain waking patient', 'Alternating buttock pain'],
    negativeSigns: ['Normal MRI SI + negative HLA-B27 + normal CRP'],
    definitiveTreatment: 'Indomethacin 75 mg SR OD/BD continuous + PPI; Sulfasalazine 1 g BD if peripheral arthritis; TNF-inhibitor (Adalimumab / Etanercept) if NSAID-refractory ASDAS > 2.1',
    supportiveTreatment: 'Daily spine-extension exercises, deep breathing, firm mattress, physiotherapy, screen 6-monthly for uveitis and IBD',
    redFlags: ['New neurology — cauda equina syndrome (fracture through ankylosed spine)', 'Aortic regurgitation on echo'],
    cautions: ['Uveitis alerts — refer ophthalmology same day', 'Fracture risk on ankylosed "bamboo spine" is very high'],
    meds: [
      mk('Indocap SR 75', 'Indomethacin', '75 mg', '1 - 0 - 1', '90+', 'BD sustained-release; continuous therapy — reduces X-ray progression'),
      mk('Saaz 1 g', 'Sulfasalazine', '1000 mg', '1 - 0 - 1', '365+', 'BD for peripheral arthritis component'),
      mk('Pan 40', 'Pantoprazole', '40 mg', '1 - 0 - 0', '365+', 'OD while on NSAID'),
      mk('Exemptia 40', 'Adalimumab (biosimilar)', '40 mg', 'SC every 2 wk', '365', 'Refractory ASDAS > 2.1 — bio-naive first-line'),
    ],
  },
  {
    id: 'rhe-5', label: 'Systemic Lupus Erythematosus (SLE)', group: 'Rheumatology', category: 'Connective Tissue',
    aliases: ['SLE', 'Lupus'],
    pathognomonic: 'Malar rash + non-erosive arthritis + positive ANA ≥ 1:80 + anti-dsDNA / anti-Sm',
    definitiveTest: '2019 EULAR/ACR criteria ≥ 10 with ≥ 1 clinical + entry ANA ≥ 1:80',
    supportiveTests: ['Anti-dsDNA (correlates with activity)', 'Anti-Sm (highly specific)', 'C3 / C4 (low in active)', 'Urine R/M — proteinuria / casts', 'CBC — cytopenias'],
    ddx: ['Drug-induced lupus', 'MCTD', 'Sjögren', 'Parvovirus / EBV', 'Fibromyalgia'],
    positiveSigns: ['Photosensitive malar rash', 'Non-scarring alopecia + oral ulcers', 'Serositis', 'Cytopenias'],
    negativeSigns: ['ANA negative (< 1 % of SLE)', 'Isolated positive ANA with no clinical features'],
    definitiveTreatment: 'HCQ 5 mg/kg OD lifelong — cornerstone; Prednisolone 0.5-1 mg/kg for flares; Mycophenolate 1-1.5 g BD for lupus nephritis / severe disease',
    supportiveTreatment: 'Strict sun protection SPF 50+, monthly BP + urine dipstick, Ca+Vit D on steroid, screen for APLA in every SLE, cervical cancer screening',
    redFlags: ['🚨 Lupus nephritis Class III/IV — nephrology + urgent biopsy', 'Neuropsychiatric SLE (seizure/psychosis)', 'Diffuse alveolar haemorrhage', 'CAPS (catastrophic antiphospholipid syndrome)'],
    cautions: ['MMF teratogenic — stop 6 weeks pre-conception, switch to Azathioprine', 'Live vaccines contraindicated on immunosuppression'],
    meds: [
      mk('HCQS 200', 'Hydroxychloroquine', '200-400 mg', '1 - 0 - 1', '365+', 'OD or BD lifelong — annual retinal exam'),
      mk('Cellcept 500', 'Mycophenolate Mofetil', '1-1.5 g', '1 - 0 - 1', '365+', 'BD for LN / severe disease'),
      mk('Wysolone 10', 'Prednisolone', '5-60 mg', '1 - 0 - 0', '90', 'OD taper — pulse IV 500-1000 mg × 3 for severe flare'),
      mk('Shelcal 500', 'Calcium + Vit D3', '500 mg', '1 - 0 - 1', '365+', 'BD while on steroids'),
    ],
  },
  {
    id: 'rhe-6', label: 'Fibromyalgia', group: 'Rheumatology', category: 'Central Sensitisation',
    aliases: ['FM', 'Fibromyalgia syndrome'],
    pathognomonic: 'Widespread pain > 3 months + fatigue + unrefreshing sleep + fibro-fog + WPI/SSS meeting 2016 ACR criteria',
    definitiveTest: 'Clinical — 2016 ACR criteria (WPI ≥ 7 + SSS ≥ 5) OR (WPI 4-6 + SSS ≥ 9); no lab test',
    supportiveTests: ['TSH', 'Vit D', 'CBC + ESR/CRP (rule out inflammation)', 'RA / SLE panel if suspicious'],
    ddx: ['Hypothyroidism', 'Early RA', 'Polymyalgia Rheumatica', 'CFS / ME', 'Vit D deficiency'],
    positiveSigns: ['Widespread MSK pain > 3 mo', 'Sleep unrefreshed despite adequate hours', 'Cognitive dysfunction ("fibro-fog")'],
    negativeSigns: ['Joint swelling / synovitis (points away)', 'Elevated inflammatory markers'],
    definitiveTreatment: 'Pregabalin 75 mg OD titrate to BD OR Duloxetine 30-60 mg OD; Amitriptyline 10-25 mg HS as second option',
    supportiveTreatment: 'Aerobic exercise (walk + water aerobics), CBT, sleep hygiene, Vit D correction, AVOID opioids and strong NSAIDs',
    redFlags: ['New neurology, weight loss, night sweats — reconsider diagnosis'],
    cautions: ['Pregabalin — sedation, weight gain, dose-adjust in CKD', 'Duloxetine — MAOI interaction (serotonin syndrome)'],
    meds: [
      mk('Pregalin 75', 'Pregabalin', '75 mg', '1 - 0 - 1', '90+', 'OD to BD titrated slowly'),
      mk('Duvanta 30', 'Duloxetine', '30-60 mg', '1 - 0 - 0', '90+', 'OD in morning — long-term'),
      mk('Tryptomer 10', 'Amitriptyline', '10-25 mg', '0 - 0 - 1', '90+', 'HS as second-line for sleep + pain'),
    ],
  },
  {
    id: 'rhe-7', label: 'Psoriatic Arthritis (PsA)', group: 'Rheumatology', category: 'Spondyloarthritis',
    aliases: ['PsA'],
    pathognomonic: 'Inflammatory arthritis + psoriatic skin/nail changes + CASPAR score ≥ 3',
    definitiveTest: 'CASPAR criteria ≥ 3 in a patient with inflammatory articular disease + X-ray "pencil-in-cup" deformity',
    supportiveTests: ['RF / Anti-CCP (usually negative)', 'CRP/ESR', 'HLA-B27 (positive in axial PsA)', 'Full skin + nail exam including scalp / umbilicus / gluteal cleft'],
    ddx: ['RA', 'Reactive arthritis', 'Ankylosing spondylitis', 'Gout', 'Erosive OA'],
    positiveSigns: ['Dactylitis (sausage digits)', 'Nail pitting / onycholysis', 'DIP joint involvement', 'Asymmetric oligoarthritis'],
    negativeSigns: ['Positive high-titre RF (suggests RA)'],
    definitiveTreatment: 'Methotrexate 15 mg once weekly OR Sulfasalazine 1 g BD; escalate to Anti-TNF / IL-17 (Secukinumab) / IL-23 inhibitor if peripheral disease refractory or axial dominant',
    supportiveTreatment: 'Screen metabolic syndrome + CV risk (higher in PsA), dermatology co-management, AVOID oral steroids (rebound psoriasis flare on withdrawal)',
    redFlags: ['Arthritis mutilans', 'Uveitis flare'],
    cautions: ['Oral steroids — risk of psoriasis rebound'],
    meds: [
      mk('Folitrax 15', 'Methotrexate', '15 mg', 'Once weekly', '365+', 'PO / SC once weekly'),
      mk('Saaz 1 g', 'Sulfasalazine', '1000 mg', '1 - 0 - 1', '365+', 'BD long-term'),
      mk('Folvite 5', 'Folic Acid', '5 mg', 'Once weekly', '365+', 'Next day after MTX'),
      mk('Naprosyn 500', 'Naproxen', '500 mg', '1 - 0 - 1', '7', 'BD for flares'),
    ],
  },
  {
    id: 'rhe-8', label: "Sjögren's Syndrome", group: 'Rheumatology', category: 'Connective Tissue',
    aliases: ['Sicca syndrome'],
    pathognomonic: 'Dry eyes + dry mouth + Anti-Ro/SSA positive + focus score ≥ 1 on lip biopsy',
    definitiveTest: '2016 ACR/EULAR score ≥ 4 — labial gland biopsy focus score ≥ 1 (3) + Anti-Ro (3) + OSS/Schirmer/salivary flow',
    supportiveTests: ['Schirmer test ≤ 5 mm/5 min', 'Unstimulated salivary flow ≤ 0.1 mL/min', 'ANA, RF (often positive)', 'C3/C4, SPEP (rule out MGUS)'],
    ddx: ['Age-related sicca', 'Anticholinergic drug effect', 'IgG4-RD', 'Sarcoidosis', 'HCV', 'Prior head-neck radiation'],
    positiveSigns: ['Xerostomia + xerophthalmia', 'Parotid enlargement', 'Dental caries'],
    negativeSigns: ['Head-neck radiation history', 'Active HCV → exclusion'],
    definitiveTreatment: 'HCQ 200-400 mg OD for constitutional; Pilocarpine 5 mg TDS for xerostomia; Carboxymethylcellulose eye drops PRN',
    supportiveTreatment: 'Sugar-free lozenges, meticulous dental hygiene, avoid anticholinergics (TCA, antihistamines), lymphoma vigilance (44× risk)',
    redFlags: ['Persistent parotid swelling — MALT lymphoma work-up', 'Interstitial nephritis, ILD'],
    cautions: ['Pilocarpine contraindicated in narrow-angle glaucoma, asthma'],
    meds: [
      mk('HCQS 200', 'Hydroxychloroquine', '200-400 mg', '1 - 0 - 0', '365+', 'OD long-term'),
      mk('Salagen 5', 'Pilocarpine', '5 mg', '1 - 1 - 1', '90', 'TDS for xerostomia'),
      mk('Refresh Tears', 'Carboxymethylcellulose 0.5 %', '1-2 drops', 'PRN QID', '30+', 'Topical PRN each eye'),
    ],
  },
  {
    id: 'rhe-9', label: 'Systemic Sclerosis (Scleroderma)', group: 'Rheumatology', category: 'Connective Tissue',
    aliases: ['SSc', 'Scleroderma'],
    pathognomonic: 'Skin thickening proximal to MCPs + Raynaud + Anti-Scl-70 or Anti-centromere + abnormal nailfold capillaroscopy',
    definitiveTest: '2013 ACR/EULAR score ≥ 9 — skin thickening proximal to MCPs is sufficient',
    supportiveTests: ['ANA (nucleolar / centromeric pattern)', 'Anti-Scl-70 (diffuse SSc)', 'Anti-centromere (limited SSc)', 'HRCT chest for ILD', '2D-Echo for PAH', 'PFT with DLCO'],
    ddx: ['Eosinophilic fasciitis', 'Nephrogenic systemic fibrosis', 'Scleromyxedema', 'MCTD'],
    positiveSigns: ['Sclerodactyly, digital pits', 'Raynaud phenomenon', 'Telangiectasia, microstomia', 'Dysphagia'],
    negativeSigns: ['Localised skin (morphea) — different disease'],
    definitiveTreatment: 'Raynaud — Nifedipine SR 20 mg OD; ILD — Mycophenolate 1.5 g BD OR Nintedanib 150 mg BD; PAH — refer for endothelin-receptor antagonist; renal crisis — Captopril / Enalapril immediately',
    supportiveTreatment: 'Keep hands warm + gloves in winter, PPI for reflux, prokinetic for gastroparesis, annual echo + PFT surveillance',
    redFlags: ['🚨 Scleroderma renal crisis — new HTN + AKI → ACE-inhibitor STAT (do NOT stop even if creatinine rises)', 'ILD progression', 'PAH — right heart failure signs'],
    cautions: ['NEVER use high-dose steroids in SSc — precipitates renal crisis'],
    meds: [
      mk('Depin 20 SR', 'Nifedipine SR', '20 mg', '1 - 0 - 1', '365+', 'OD to BD for Raynaud'),
      mk('Cellcept 500', 'Mycophenolate Mofetil', '1-1.5 g', '1 - 0 - 1', '365+', 'BD for SSc-ILD'),
      mk('Ofev 150', 'Nintedanib', '150 mg', '1 - 0 - 1', '365+', 'BD for progressive fibrosing ILD'),
      mk('Aceten 25', 'Captopril', '25-50 mg', '1 - 1 - 1', '90+', 'TDS titrated for renal crisis'),
    ],
  },
  {
    id: 'rhe-10', label: 'Polymyalgia Rheumatica (PMR)', group: 'Rheumatology', category: 'Inflammatory',
    aliases: ['PMR'],
    pathognomonic: 'Age > 50 + bilateral shoulder/hip girdle pain + morning stiffness > 45 min + markedly elevated ESR + dramatic response to Prednisolone 15 mg',
    definitiveTest: '2012 EULAR/ACR PMR criteria + rapid symptom response to low-dose Prednisolone (< 1 week)',
    supportiveTests: ['ESR / CRP (usually markedly elevated)', 'CBC (anaemia of chronic disease)', 'CK (normal — rules out myositis)', 'Screen for GCA'],
    ddx: ['RA in elderly', 'Polymyositis (elevated CK)', 'Hypothyroidism', 'Fibromyalgia', 'Bilateral rotator cuff disease'],
    positiveSigns: ['Bilateral shoulder + hip girdle stiffness > 45 min', 'Difficulty rising from chair', 'Constitutional symptoms'],
    negativeSigns: ['Elevated CK (points to myositis)', 'Absent inflammatory markers'],
    definitiveTreatment: 'Prednisolone 15 mg OD × 2-4 weeks then taper by 2.5 mg every 2-4 weeks until 10 mg, then 1 mg every month; total treatment 1-2 years',
    supportiveTreatment: 'Ca 500 mg + Vit D 250 IU BD, bisphosphonate if T-score ≤ -1.5, screen every visit for GCA symptoms (headache, jaw claudication, visual loss)',
    redFlags: ['🚨 New headache / jaw claudication / visual loss — GCA co-existing; increase steroid to 40-60 mg + urgent temporal artery biopsy', 'Steroid-dependence — consider MTX steroid-sparing'],
    cautions: ['Rapid taper → relapse in 50 %'],
    meds: [
      mk('Wysolone 15', 'Prednisolone', '15 mg', '1 - 0 - 0', '365', 'OD × 2-4 wk then taper — total 1-2 years'),
      mk('Shelcal 500', 'Calcium + Vit D3', '500 mg', '1 - 0 - 1', '365+', 'BD while on steroids'),
      mk('Bonviva 150', 'Ibandronate', '150 mg', 'Once monthly', '365+', 'For steroid-induced osteoporosis prevention'),
    ],
  },
  {
    id: 'rhe-11', label: 'Reactive Arthritis (Reiter Syndrome)', group: 'Rheumatology', category: 'Spondyloarthritis',
    aliases: ['ReA', 'Reiter'],
    pathognomonic: 'Post-infectious asymmetric oligoarthritis + urethritis / conjunctivitis within 4 weeks of GI or GU infection + HLA-B27 positive in 50-80 %',
    definitiveTest: 'Clinical — arthritis onset within 1-4 weeks of confirmed GI (Salmonella/Shigella/Yersinia/Campylobacter) or GU (Chlamydia) infection',
    supportiveTests: ['Chlamydia NAAT (urine/urethral swab)', 'Stool culture', 'HLA-B27', 'HIV screen', 'CRP/ESR', 'Slit-lamp for uveitis'],
    ddx: ['Septic arthritis', 'Gonococcal arthritis', 'PsA', 'AS'],
    positiveSigns: ['Asymmetric large-joint oligoarthritis', 'Enthesitis (Achilles / plantar)', 'Circinate balanitis', 'Keratoderma blennorrhagicum'],
    negativeSigns: [],
    definitiveTreatment: 'NSAID first-line (Naproxen 500 mg BD); Doxycycline 100 mg BD × 7 days if Chlamydia trigger; Sulfasalazine 1 g BD if chronic > 3 mo',
    supportiveTreatment: 'Treat sexual partners for Chlamydia, physiotherapy, PPI cover with NSAID',
    redFlags: ['Uveitis flare — urgent ophthalmology', 'HIV co-infection — worse prognosis'],
    cautions: [],
    meds: [
      mk('Naprosyn 500', 'Naproxen', '500 mg', '1 - 0 - 1', '30+', 'BD until arthritis subsides'),
      mk('Vibramycin 100', 'Doxycycline', '100 mg', '1 - 0 - 1', '7', 'BD × 7 days for Chlamydia trigger'),
      mk('Saaz 1 g', 'Sulfasalazine', '1000 mg', '1 - 0 - 1', '365+', 'BD if chronic > 3 mo'),
    ],
  },
  {
    id: 'rhe-12', label: 'Sarcoidosis (Löfgren Syndrome)', group: 'Rheumatology', category: 'Granulomatous',
    aliases: ['Löfgren', 'Acute sarcoidosis'],
    pathognomonic: 'Bilateral hilar lymphadenopathy + erythema nodosum + bilateral ankle arthritis in a young adult',
    definitiveTest: 'Löfgren triad is 95 % specific — no biopsy needed; otherwise tissue biopsy showing non-caseating granulomas',
    supportiveTests: ['Chest X-ray / HRCT (BHL)', 'Serum ACE (supportive)', 'Ca (serum + 24-h urine)', 'Rule out TB (IGRA / sputum)', 'Slit-lamp for uveitis', 'ECG (cardiac sarcoid)'],
    ddx: ['TB', 'Lymphoma', 'Erythema nodosum from other causes (IBD, drugs, strep)'],
    positiveSigns: ['BHL', 'Erythema nodosum', 'Ankle periarticular inflammation', 'Fever, fatigue'],
    negativeSigns: ['Caseating granulomas (points to TB)', 'Positive AFB'],
    definitiveTreatment: 'Löfgren usually self-limiting — Naproxen 500 mg BD × 2-4 wk; Prednisolone 0.5 mg/kg for severe/systemic disease; Methotrexate as steroid-sparing for chronic',
    supportiveTreatment: 'Rule out TB before steroids, screen for cardiac + ocular involvement, monitor Ca (avoid Vit D supplements if hypercalcaemic)',
    redFlags: ['Cardiac sarcoid — arrhythmias, sudden cardiac death', 'Neurosarcoidosis', 'Uveitis'],
    cautions: ['Ensure TB excluded before immunosuppression'],
    meds: [
      mk('Naprosyn 500', 'Naproxen', '500 mg', '1 - 0 - 1', '28', 'BD × 2-4 weeks for Löfgren'),
      mk('Wysolone 20', 'Prednisolone', '0.5 mg/kg', '1 - 0 - 0', '90', 'OD taper over months for severe/systemic'),
      mk('Folitrax 15', 'Methotrexate', '10-20 mg', 'Once weekly', '365+', 'Steroid-sparing for chronic disease'),
    ],
  },
  {
    id: 'rhe-13', label: 'IgG4-Related Disease', group: 'Rheumatology', category: 'Immunological',
    aliases: ['IgG4-RD'],
    pathognomonic: 'Painless swelling of organs (pancreas, salivary/lacrimal glands) + serum IgG4 > 135 mg/dL + storiform fibrosis with > 10 IgG4+ plasma cells/HPF on biopsy',
    definitiveTest: 'Tissue biopsy — dense lymphoplasmacytic infiltrate + storiform fibrosis + obliterative phlebitis + IgG4/IgG ratio > 40 %',
    supportiveTests: ['Serum IgG4', 'CT / MRI ("sausage-shaped" pancreas)', 'PET-CT to map disease extent', 'CA 19-9, IgG subclasses'],
    ddx: ['Malignancy (pancreatic Ca, lymphoma)', "Sjögren's", 'Sarcoidosis', 'ANCA-associated vasculitis', 'Castleman disease'],
    positiveSigns: ['Painless organ enlargement', 'Multi-organ involvement', 'Obstructive jaundice from AIP'],
    negativeSigns: [],
    definitiveTreatment: 'Prednisolone 0.6 mg/kg (typically 30-40 mg) OD × 2-4 wk then taper over 3-6 months; Rituximab 1 g IV Day 0 + Day 15 for relapsing / refractory',
    supportiveTreatment: 'Biopsy MANDATORY to rule out malignancy before treatment, Azathioprine 2 mg/kg for steroid-sparing, monitor IgG4 every 3 months',
    redFlags: ['Missed pancreatic cancer', 'Aortic aneurysm from periaortitis'],
    cautions: [],
    meds: [
      mk('Wysolone 30', 'Prednisolone', '30-40 mg', '1 - 0 - 0', '180', 'OD taper over 3-6 months'),
      mk('Ristova 500', 'Rituximab', '1000 mg', 'IV Day 0 + Day 15', '2', 'For relapsing / refractory disease'),
      mk('Imuran 50', 'Azathioprine', '2 mg/kg', '1 - 0 - 1', '365+', 'Steroid-sparing maintenance'),
    ],
  },
  {
    id: 'rhe-14', label: 'Relapsing Polychondritis', group: 'Rheumatology', category: 'Immunological',
    aliases: [],
    pathognomonic: 'Recurrent bilateral auricular chondritis SPARING THE LOBULE + saddle-nose deformity + laryngotracheal chondritis',
    definitiveTest: 'McAdam criteria ≥ 3/6 clinical features OR ≥ 1 feature + cartilage biopsy showing inflammation',
    supportiveTests: ['CT neck / chest (airway narrowing, tracheomalacia)', 'ECHO (aortic regurgitation, root dilatation)', 'PFT with flow-volume loop', 'ANCA (exclude GPA)'],
    ddx: ['GPA (Wegener)', 'Infectious perichondritis', 'Syphilis', 'Leprosy', 'EGPA'],
    positiveSigns: ['Painful red swollen pinna sparing lobule', 'Saddle-nose', 'Hoarseness / stridor', 'Scleritis / episcleritis', 'Neurosensory hearing loss'],
    negativeSigns: ['Pinna erythema with lobule involvement (suggests infection)'],
    definitiveTreatment: 'Prednisolone 0.5-1 mg/kg (higher for airway) + Methotrexate 15-25 mg once weekly as steroid-sparing; Dapsone 50-100 mg OD for mild auricular disease',
    supportiveTreatment: 'IV pulse steroids for airway compromise, tracheostomy standby, screen G6PD before Dapsone',
    redFlags: ['🚨 Airway involvement — life-threatening; IV pulse methylprednisolone + cyclophosphamide + tracheostomy standby', 'Aortic aneurysm / regurgitation'],
    cautions: ['Dapsone contraindicated in G6PD deficiency'],
    meds: [
      mk('Wysolone 40', 'Prednisolone', '0.5-1 mg/kg', '1 - 0 - 0', '180', 'OD tapered'),
      mk('Folitrax 15', 'Methotrexate', '15-25 mg', 'Once weekly', '365+', 'Steroid-sparing'),
      mk('Dapsone 100', 'Dapsone', '50-100 mg', '1 - 0 - 0', '365+', 'OD for mild auricular/nasal disease (check G6PD first)'),
    ],
  },
  {
    id: 'rhe-15', label: 'Familial Mediterranean Fever (FMF)', group: 'Rheumatology', category: 'Autoinflammatory',
    aliases: ['FMF'],
    pathognomonic: 'Recurrent short (1-3 d) episodes of fever + peritonitis / pleuritis / synovitis + Mediterranean ancestry + MEFV gene mutation',
    definitiveTest: 'Genetic testing — biallelic MEFV mutations (M694V, V726A, M680I) + response to colchicine',
    supportiveTests: ['CRP, ESR, SAA (elevated in attacks, normalise between)', 'Urinalysis (screen AA amyloidosis)', 'Rule out infection during attack'],
    ddx: ['Appendicitis', 'TRAPS / CAPS (other autoinflammatory)', 'Systemic JIA', 'Porphyria'],
    positiveSigns: ['Recurrent brief febrile serositis', 'Erysipelas-like erythema on lower legs', 'Family history'],
    negativeSigns: [],
    definitiveTreatment: 'Colchicine 1-2 mg/day divided BD LIFELONG — prevents attacks AND AA amyloidosis; Canakinumab 150 mg SC monthly if colchicine-resistant',
    supportiveTreatment: 'Ibuprofen for acute attacks, urinalysis every 6 months (proteinuria = early amyloidosis), continue colchicine in pregnancy',
    redFlags: ['🚨 New proteinuria — AA amyloidosis, renal biopsy', 'Colchicine toxicity — pancytopenia, myopathy'],
    cautions: ['Colchicine dose reduction in CKD; avoid combining with strong CYP3A4 inhibitors (macrolides, ketoconazole) — lethal toxicity'],
    meds: [
      mk('Zycolchin 0.5', 'Colchicine', '1-2 mg', '1 - 0 - 1', '365+', 'Divided BD LIFELONG'),
      mk('Ilaris 150', 'Canakinumab', '150 mg', 'SC every 4 wk', '365+', 'Colchicine-resistant cases'),
      mk('Brufen 400', 'Ibuprofen', '400 mg', '1 - 1 - 1', '3', 'TDS PRN during acute attacks'),
    ],
  },
  {
    id: 'rhe-16', label: 'Undifferentiated Connective Tissue Disease (UCTD)', group: 'Rheumatology', category: 'Connective Tissue',
    aliases: ['UCTD'],
    pathognomonic: 'Features suggestive of CTD + positive ANA but not meeting any single CTD classification criteria; > 3 y stable = "stable UCTD"',
    definitiveTest: 'Clinical — diagnosis of exclusion after ruling out defined CTDs',
    supportiveTests: ['ANA (usually ≥ 1:160)', 'ENA panel (often single positive)', 'Anti-dsDNA / Anti-Sm negative', 'CRP, C3/C4, UA'],
    ddx: ['Early SLE', 'Early SSc', 'MCTD', 'Fibromyalgia'],
    positiveSigns: ['Raynaud', 'Arthralgia + puffy fingers', 'Sicca', 'Mild photosensitivity'],
    negativeSigns: ['Meets full criteria for a specific CTD'],
    definitiveTreatment: 'HCQ 200-400 mg OD (cornerstone — may prevent evolution to SLE); Prednisolone 5-10 mg OD short courses for flares',
    supportiveTreatment: 'Amlodipine 5 mg OD for Raynaud, sun protection, re-evaluate every 6-12 months (30-40 % evolve to defined CTD)',
    redFlags: ['New organ involvement — reclassify to specific CTD'],
    cautions: [],
    meds: [
      mk('HCQS 200', 'Hydroxychloroquine', '200-400 mg', '1 - 0 - 0', '365+', 'OD long-term'),
      mk('Wysolone 5', 'Prednisolone', '5-10 mg', '1 - 0 - 0', '30', 'OD short course for flares'),
      mk('Amlokind 5', 'Amlodipine', '5 mg', '1 - 0 - 0', '90+', 'OD for Raynaud'),
    ],
  },
  {
    id: 'rhe-17', label: 'Giant Cell Arteritis (GCA)', group: 'Rheumatology', category: 'Vasculitis',
    aliases: ['GCA', 'Temporal arteritis'],
    pathognomonic: 'Age ≥ 50 + new-onset temporal headache + jaw claudication + tender / thickened temporal artery + markedly elevated ESR',
    definitiveTest: 'Temporal artery biopsy — granulomatous inflammation with giant cells OR temporal artery ultrasound "halo sign"',
    supportiveTests: ['ESR (often > 50) and CRP', 'CBC (anaemia of chronic disease)', 'Temporal artery USG with halo sign', 'PET-CT for large-vessel involvement'],
    ddx: ['PMR (often co-existing)', 'Migraine / tension headache', 'NAION (non-arteritic)', 'Trigeminal neuralgia'],
    positiveSigns: ['New localised headache', 'Jaw claudication', 'Scalp tenderness', 'Sudden visual loss (AION)', 'PMR-type stiffness'],
    negativeSigns: ['Normal ESR + normal CRP + normal temporal arteries'],
    definitiveTreatment: 'START Prednisolone 40-60 mg OD IMMEDIATELY on clinical suspicion (do NOT wait for biopsy); IV Methylprednisolone 1 g × 3 days if visual involvement; taper over 1-2 y; Tocilizumab 162 mg SC weekly as steroid-sparing',
    supportiveTreatment: 'Low-dose Aspirin 75 mg OD (reduces ischaemic events), Ca + Vit D + bisphosphonate, PPI cover, screen for aortic aneurysm annually',
    redFlags: ['🚨 Sudden visual loss / diplopia — MEDICAL EMERGENCY, IV pulse steroids to save contralateral eye', 'Aortic aneurysm / dissection'],
    cautions: ['DO NOT delay steroids for biopsy — biopsy remains positive for 2-4 weeks after starting steroids'],
    meds: [
      mk('Wysolone 60', 'Prednisolone', '40-60 mg', '1 - 0 - 0', '365', 'OD (IV Methylpred 1 g × 3 d if visual loss); taper over 1-2 y'),
      mk('Actemra 162', 'Tocilizumab', '162 mg', 'SC weekly', '365+', 'Steroid-sparing biologic'),
      mk('Ecosprin 75', 'Aspirin low-dose', '75 mg', '0 - 1 - 0', '365+', 'OD long-term to prevent ischaemic events'),
    ],
  },
  {
    id: 'rhe-18', label: 'Polyarteritis Nodosa (PAN)', group: 'Rheumatology', category: 'Vasculitis',
    aliases: ['PAN'],
    pathognomonic: 'Necrotising medium-vessel arteritis + new HTN + mononeuritis multiplex + microaneurysms on mesenteric/renal angiography + ANCA NEGATIVE',
    definitiveTest: 'Tissue biopsy (skin/nerve/muscle) — necrotising arteritis; OR angiography — microaneurysms/occlusions',
    supportiveTests: ['HBsAg (HBV-associated PAN — treat differently)', 'ANCA (negative — distinguishes from GPA/MPA)', 'EMG/NCS for mononeuritis', 'RFT, urinalysis'],
    ddx: ['MPA', 'GPA', 'EGPA', 'Cryoglobulinemic vasculitis', 'Cholesterol embolisation syndrome'],
    positiveSigns: ['Weight loss > 4 kg', 'Livedo reticularis', 'Testicular pain', 'Foot drop / wrist drop', 'New-onset diastolic HTN'],
    negativeSigns: ['ANCA positive (points to MPA/GPA)', 'Glomerulonephritis (points to MPA)'],
    definitiveTreatment: 'Prednisolone 1 mg/kg + Cyclophosphamide IV pulse 500-1000 mg/m² monthly × 6 months (severe); Rituximab as alternative; HBV-PAN — antivirals + plasma exchange + shorter steroid',
    supportiveTreatment: 'Screen HBV in every PAN — HBV-PAN needs Entecavir + antivirals + plasma exchange, NOT prolonged immunosuppression',
    redFlags: ['Mesenteric infarction, renal infarction with severe HTN'],
    cautions: ['Cyclophosphamide — monitor for haemorrhagic cystitis (Mesna), leukopenia, gonadal toxicity (freeze gametes)'],
    meds: [
      mk('Wysolone 60', 'Prednisolone', '1 mg/kg', '1 - 0 - 0', '180', 'OD tapered'),
      mk('Endoxan 500', 'Cyclophosphamide', '500-1000 mg/m²', 'IV monthly', '180', 'IV pulse × 6 months (severe organ involvement)'),
      mk('Tenof 300', 'Tenofovir', '300 mg', '1 - 0 - 0', '365+', 'ONLY for HBV-associated PAN'),
    ],
  },
  {
    id: 'rhe-19', label: 'IgA Vasculitis (Henoch-Schönlein Purpura)', group: 'Rheumatology', category: 'Vasculitis',
    aliases: ['HSP', 'IgAV'],
    pathognomonic: 'Palpable purpura on lower limbs / buttocks + colicky abdominal pain + arthritis + IgA-dominant deposits on biopsy',
    definitiveTest: 'EULAR/PRINTO/PRES 2010 — mandatory purpura + ≥ 1 of abdominal pain / arthritis / renal / IgA biopsy',
    supportiveTests: ['Urinalysis (haematuria, proteinuria)', 'CBC (platelets normal — rules out ITP)', 'RFT', 'Abdominal USG (rule out intussusception)'],
    ddx: ['ITP', 'Meningococcemia', 'Acute abdomen (intussusception in children)', 'Hypersensitivity vasculitis'],
    positiveSigns: ['Palpable non-thrombocytopenic purpura lower limbs', 'Colicky abdominal pain', 'Arthritis (knees/ankles)', 'Haematuria'],
    negativeSigns: ['Thrombocytopenia (points to ITP/leukaemia)'],
    definitiveTreatment: 'Usually self-limiting — Paracetamol + Ibuprofen (if no GI bleed) for symptomatic; Prednisolone 1-2 mg/kg × 1-2 weeks then taper for severe abdominal pain or nephritis',
    supportiveTreatment: 'Follow-up urinalysis + BP for 6 months (delayed IgA nephropathy), surgical review for severe abdominal pain (intussusception risk in children)',
    redFlags: ['Intussusception (children — hospital admission)', 'IgA nephropathy — nephrotic-range proteinuria / RPGN'],
    cautions: [],
    meds: [
      mk('Brufen 400', 'Ibuprofen', '5-10 mg/kg', '1 - 1 - 1', '7', 'TDS PRN for joint pain (avoid if GI bleed)'),
      mk('Wysolone 40', 'Prednisolone', '1-2 mg/kg', '1 - 0 - 0', '14', 'OD × 1-2 wk then taper — for severe abdominal pain or nephritis'),
      mk('Dolo 500', 'Paracetamol', '10-15 mg/kg', '1 - 1 - 1', '7', 'QID PRN'),
    ],
  },
  {
    id: 'rhe-20', label: 'Hypermobility Spectrum Disorder (HSD) / EDS', group: 'Rheumatology', category: 'Connective Tissue',
    aliases: ['HSD', 'Ehlers-Danlos syndrome', 'Joint hypermobility syndrome'],
    pathognomonic: 'Beighton score ≥ 5/9 adult + chronic MSK pain + recurrent joint subluxations + skin hyperextensibility',
    definitiveTest: 'Clinical Beighton score ≥ 5/9 (adults) or ≥ 6/9 (children); genetic testing for specific EDS types (COL3A1 for Vascular EDS)',
    supportiveTests: ['ECHO (aortic root dilation, MVP)', 'Tilt-table test if POTS suspected', 'DEXA if concurrent osteoporosis'],
    ddx: ['Marfan Syndrome', 'Osteogenesis imperfecta', 'Loeys-Dietz', 'Fibromyalgia'],
    positiveSigns: ['Beighton positive maneuvers', 'Recurrent subluxations', 'Skin hyperextensibility', 'Easy bruising', 'Dysautonomia (POTS)'],
    negativeSigns: [],
    definitiveTreatment: 'Physiotherapy — core stability + proprioception + joint protection; Paracetamol 650 mg QID PRN; Meloxicam 7.5-15 mg OD for flares; Pregabalin 50-75 mg HS for neuropathic component',
    supportiveTreatment: 'AVOID high-impact sports and forced yoga stretches, low-dose beta-blocker for POTS component, dental precautions (fragile mucosa)',
    redFlags: ['🚨 Vascular EDS (COL3A1) — arterial rupture, uterine rupture in pregnancy — refer geneticist + vascular surgeon', 'Aortic root dilatation'],
    cautions: ['NSAIDs — GI bleed risk (fragile GI mucosa)'],
    meds: [
      mk('Dolo 650', 'Paracetamol', '650 mg', '1 - 1 - 1 - 1', '30+', 'QID PRN'),
      mk('Muvera 15', 'Meloxicam', '7.5-15 mg', '1 - 0 - 0', '10', 'OD for acute flares'),
      mk('Pregalin 75', 'Pregabalin', '50-75 mg', '0 - 0 - 1', '90+', 'HS PRN for neuropathic pain'),
    ],
  },
];
